(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function getJson(options) {
  options.url = util.toAbsoluteUrl(options.url);
  // return if no url exists or url matches a current request
  if (!options.url || currentRequests[options.url]) {
    return;
  }

  currentRequests[options.url] = true;

  // make the server call
  $.ajax({
    dataType: 'json',
    url: options.url,
    async: typeof options.async === 'undefined' || options.async === null ? true : options.async,
    data: options.data || {}
  })
  // success
  .done(function (response) {
    if (options.callback) {
      options.callback(response);
    }
  })
  // failed
  .fail(function (xhr, textStatus) {
    if (textStatus === 'parsererror') {
      window.alert(Resources.BAD_RESPONSE);
    }
    if (options.callback) {
      options.callback(null);
    }
  })
  // executed on success or fail
  .always(function () {
    // remove current request from hash
    if (currentRequests[options.url]) {
      delete currentRequests[options.url];
    }
  });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function load(options) {
  options.url = util.toAbsoluteUrl(options.url);
  // return if no url exists or url matches a current request
  if (!options.url || currentRequests[options.url]) {
    return;
  }

  currentRequests[options.url] = true;

  // make the server call
  $.ajax({
    dataType: 'html',
    url: util.appendParamToURL(options.url, 'format', 'ajax'),
    data: options.data,
    xhrFields: {
      withCredentials: true
    }
  }).done(function (response) {
    // success
    if (options.target) {
      $(options.target).empty().html(response);
    }
    if (options.callback) {
      options.callback(response);
    }
  }).fail(function (xhr, textStatus) {
    // failed
    if (textStatus === 'parsererror') {
      window.alert(Resources.BAD_RESPONSE);
    }
    options.callback(null, textStatus);
  }).always(function () {
    progress.hide();
    // remove current request from hash
    if (currentRequests[options.url]) {
      delete currentRequests[options.url];
    }
  });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":64,"./util":77}],2:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var util = require('./util');
var unbind = 0;
var unbindcarousel = 0;

var targetNode = document.getElementsByClassName('js-product-top-content')[0];
var config = { attributes: true, childList: true, subtree: true };
var initializationFlag = false;
var imageChangedFlag = true;

var pushChangeImageDatalayer = function pushChangeImageDatalayer(mutationsList, observer) {
  observer.disconnect();
  if (initializationFlag) {
    if (imageChangedFlag) {
      imageChangedFlag = false;
      pushToDataLayer({
        event: 'productInteraction',
        interactionType: 'Image Change',
        productCategory: window.productCache.catid,
        productSubCategory: window.productCache.subcategory,
        productName: window.productCache.name,
        productId: window.productCache.ID,
        pageCategory: getPageCategory(),
        productOutOfStock: window.productCache.productOutOfStock,
        productAutoReplen: window.productCache.productautoreplenish,
        productColor: window.productCache.productColor,
        collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
        productType: window.productCache.master ? 'master' : window.productCache.variant ? 'variant' : window.productCache.bundle ? 'bundle' : window.productCache.productSet ? 'productSet' : 'product'
      });
    } else {
      imageChangedFlag = true;
    }
  } else {
    initializationFlag = true;
  }
  observer.observe(targetNode, config);
};

// Function to confirm that slick.js has been loaded
var isSlickLoaded = function isSlickLoaded(mutationsList, observer) {
  observer.disconnect();

  var element = document.querySelector(".slick-slide.slick-current.slick-active");
  if (element) {
    // Activate tag submission observer as slick.js is completed
    observer = new MutationObserver(pushChangeImageDatalayer);
    config = { attributes: true, childList: false, subtree: false };
    targetNode = document.getElementsByClassName('slick-slide slick-current slick-active')[0];
    observer.observe(targetNode, config);
  } else {
    // Resume monitoring because slick.js is not finished
    observer.observe(targetNode, config);
  }
};

// Re-detect slick when color and variation changes are made
function initObserver() {
  initializationFlag = false;
  imageChangedFlag = true;
  observer.disconnect();
  observer = new MutationObserver(isSlickLoaded);
  config = { attributes: true, childList: true, subtree: true };
  targetNode = document.getElementsByClassName('js-product-top-content')[0];
  observer.observe(targetNode, config);
}

var observer = new MutationObserver(isSlickLoaded);

function getPageCategory() {
  //return window.pageContext.title || "Content"; ###### this throws product name
  switch (window.Resources.PAGE_CATEGORY) {
    case 'product-showincategory':
      return 'Product Page';
      break;
    case 'product-show':
      return 'Product Page';
      break;
    case 'search-show':
      return 'Category Page';
      break;
    case 'home-show':
      return 'Home Page';
      break;
    case 'cart-show':
      return 'Cart Page';
      break;
    case 'cart-addtowishlist':
      return 'Cart Page';
      break;
    case 'customerservice-contactus':
      return 'Contact Customer Care';
      break;
    case 'customerservice-concierge':
      return 'Ask An Expert';
      break;
    case 'account-startregister':
      return 'Account Creation';
      break;
    case 'account-editprofile':
      return 'My Account';
      break;
    case 'address-list':
      return 'My Account';
      break;
    case 'paymentinstruments-list':
      return 'My Account';
      break;
    case 'wishlist-show':
      return 'My Account';
      break;
    case 'order-history':
      return 'My Account';
      break;
    case 'orderreplenishment-show':
      return 'My Account';
      break;
    case 'login-show':
      return 'Account Registration';
      break;
    case 'coshipping-start':
      return 'Checkout';
      break;
    case 'coshipping-singleshipping':
      return 'Checkout';
      break;
    case 'cobilling-start':
      return 'Checkout';
      break;
    case 'cobilling-billing':
      return 'Checkout';
      break;
    case 'search-showcontent':
      return 'Site Search';
      break;
    case 'giftcert-purchase':
      return 'Gift Card Page';
      break;
    case 'cocustomer-loginform':
      return 'Customer Login';
      break;
    case 'default-start':
      return 'Home Page';
      break;
    case 'search-brandify':
      return 'Store Locator Page';
      break;
    default:
      return 'Content';
      break;
  }
}
// Specific for checkout and cart page only
function couponsubcategory() {
  switch (window.Resources.PAGE_CATEGORY) {
    case 'cart-show':
      return 'Cart';
      break;
    case 'coshipping-start':
      return 'Shipping';
      break;
    case 'coshipping-singleshipping':
      return 'Payment';
      break;
    case 'cobilling-start':
      return 'Payment';
      break;
    case 'cobilling-removegiftcertificate':
      return 'Payment';
      break;
    case 'cobilling-billing':
      return 'Review';
      break;
    case 'account-editprofile':
      return 'Profile';
      break;
    case 'address-list':
      return 'Addresses';
      break;
    case 'paymentinstruments-list':
      return 'Payment Methods';
      break;
    case 'wishlist-show':
      return 'Saved For Later';
      break;
    case 'order-history':
      return 'Order History';
      break;
    case 'orderreplenishment-show':
      return 'Replenishment';
      break;
    default:
      break;
  }
}

function isMobile() {
  return $(window).width() <= 640;
}
//Specific for PDP
function getProductName() {
  return $('.product-detail .product-name').text().trim();
}
//Specific for PDP
function getProductBrand() {
  return 'Shiseido'; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID() {
  return $('#pid').val();
}
//Specific for PDP
function getProductCategory() {
  return $('.breadcrumb').find('.breadcrumb-element:eq(1)').text().trim();
}
//Specific for PDP
function getProductsubCategory() {
  return $('.breadcrumb').find('.breadcrumb-element:eq(2)').text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
  return $('.breadcrumb').find('.breadcrumb-element:eq(3)').text().trim();
}
// Specific for PDP
function getProductOrederType() {
  var replen = $('.replenishmentCycle').val();
  if (replen > 0) {
    return 'Replenishment';
  } else {
    return 'Regular';
  }
}

function getPageSubcategory() {
  return window.pageContext.title || 'Content';
}

function getLanguage() {
  if (window.User.locale.indexOf('en') >= 0) {
    return 'English';
  } else if (window.User.locale.indexOf('cn') >= 0) {
    return 'Chinese';
  } else if (window.User.locale.indexOf('es') >= 0) {
    return 'Spanish';
  } else {
    return window.User.locale;
  }
}

// page-specific: Cart, Checkout
function getPageError() {
  var $errorMsg = $('.error-form');
  if ($errorMsg.length === 0) {
    return '';
  }

  return $errorMsg.html().trim();
}

function getActiveSortingRule() {
  var httpParams = util.getQueryStringParams(window.location.href);
  var sortParam = httpParams['srule'];

  if (!sortParam) {
    return null;
  }

  return sortParam.split('-').map(function (w) {
    return w[0].toUpperCase() + w.substr(1);
  }).join(' ');
}

function pushToDataLayer(o) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(util.filterObj(o));
  //alert(JSON.stringify(util.filterObj(o)));
}

function isScrolledIntoView(elem) {
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height() - 150;
  var elemTop = $(elem).offset().top;
  return elemTop <= docViewBottom && elemTop >= docViewTop;
}

function getpage() {
  var url = window.location.href;
  var splittedurl = url.split('?');
  var page = splittedurl[0].split('/');
  return page[page.length - 1];
}
//page-specific: PLP
function getRefinementsFromURL() {
  var str = '';
  if (window.location.href.split('?').length > 1) {
    var urlparam;
    if (window.location.href.split('?')[1].indexOf('&') > -1) {
      urlparam = window.location.href.split('?')[1].split('&');
      var length = urlparam.length;
      var prefnval, prefnkey, prefvval, prefvkey;
      for (var i = 0; i < length; i++) {
        var prefn = urlparam[i].indexOf('prefn');
        if (prefn > -1) {
          prefnkey = urlparam[i].split('=')[0];
          prefnval = urlparam[i].split('=')[1];
          console.log(prefnkey);
          var num = prefnkey.charAt(5);
          for (var a = 0; a < length; a++) {
            var prefv = urlparam[a].indexOf('prefv');
            prefvkey = urlparam[a].split('=')[0];
            if (prefvkey == 'prefv' + num) {
              prefvval = urlparam[a].split('=')[1];
              str += '[' + prefnval + ':' + prefvval + ']';
            }
          }
        }
      }
    }
  }
  return str;
}

function trackConsultationEvent(data) {
  var TOOL_TYPES = {
    skincareConsultation: 'Skincare Consultation'
  };

  pushToDataLayer({
    event: 'consultation' + data.element[0].toUpperCase() + data.element.substr(1),
    pageCategory: 'Consultation Tool',
    consultationToolType: TOOL_TYPES[data.toolname] || data.toolname,
    consultationQuestion: data.question,
    consultationResponse: data.answers[0]
  });
}

function trackConsultationPageview(data) {
  pushToDataLayer({
    event: 'consultationSteps',
    pageCategory: 'Consultation Tool',
    consultationToolType: data.toolname,
    consultationStep: data.pagename
  });
}

function trackInternalPromotionEvent(data) {
  var promotionURL = data.pageName;

  pushToDataLayer({
    event: 'eePromoClick',
    pageSubCategory: data.pageSubCategory,
    pageCategory: data.pageCategory,
    promotions: [{
      position: data.position,
      id: data.id,
      creative: data.creative,
      name: data.name
    }]
  }), function () {
    setTimeout(function () {
      if (promotionURL != undefined) {
        document.location = promotionURL;
      }
    }, 1000);
  }();
}

function trackInternalPromotionPageView(data) {
  pushToDataLayer({
    eeAction: 'eePromoView',
    event: 'eePromoView',
    pageSubCategory: data.pageSubCategory,
    pageCategory: data.pageCategory,
    promotions: [{
      position: data.position,
      id: data.id,
      creative: data.creative,
      name: data.name
    }]
  });
}

function initializeGlobalEvents() {
  var navctr = true;
  var gtmNavData = '';

  $(document)
  // add to wishlist in pdp and quickview
  .on('click', '#save-for-later', function (e) {
    var data = $(this).data('catid');
    var productCategory = data.length > 0 ? data[0] : '';
    var productSubCategory = data.length > 1 ? data[1] : '';
    pushToDataLayer({
      event: 'clickSaveForLater',
      productCategory: productCategory,
      productSubCategory: productSubCategory,
      productName: window.productCache.name,
      productId: getProductID(),
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.color ? window.productCache.color : 'null',
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: 'Product'
    });
  })

  // add to wishlist in cart
  .on('click', '.add-to-wishlist', function (e) {
    var index = $(this).parents('.cart-row').index();
    pushToDataLayer({
      event: 'clickSaveForLater',
      productCategory: basketConfirmation.productLineItems[index].category,
      productSubCategory: basketConfirmation.productLineItems[index].subCategory,
      productName: basketConfirmation.productLineItems[index].name,
      productId: basketConfirmation.productLineItems[index].id,
      pageCategory: getPageCategory(),
      productOutOfStock: $(this).data('instock'),
      productAutoReplen: $(this).data('replenishable'),
      productColor: $(this).parents('.c-list-products-full-item-text').first().find(".c-dlist_03-item[data-attribute='color']").length > 0 ? $(this).parents('.c-list-products-full-item-text').first().find(".c-dlist_03-item[data-attribute='color'] dd").text().trim() : 'null',
      collectionName: basketConfirmation.productLineItems[index].category.toLowerCase().search('synactif') > -1 ? 'Synactif' : 'null',
      productType: 'Product'
    });
  })

  // remove to wishlist PDP
  .on('click', '.remove-from-wishlist', function (e) {
    var data = $(this).data('catid');
    var productCategory = data.length > 0 ? data[0] : '';
    var productSubCategory = data.length > 1 ? data[1] : '';
    pushToDataLayer({
      event: 'removeFromWishlist',
      productCategory: productCategory,
      productSubCategory: productSubCategory,
      productName: window.productCache.name,
      productId: getProductID(),
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.color ? window.productCache.color : 'null',
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: 'Product'
    });
  })

  // remove to wishlist from my account
  .on('click', '.c-list-products-full-item .delete-item', function (e) {
    var $target = $(this);
    var data = $target.data('catid');
    var productCategory = data.length > 0 ? data[0] : '';
    var productSubCategory = data.length > 1 ? data[1] : '';
    var productName = $target.data('productname');
    var productId = $target.data('productid');
    var productOutOfStock = $target.data('instock');
    var productAutoReplen = $target.data('replenishable');
    var productColor = $target.data('productcolor');

    pushToDataLayer({
      event: 'removeFromWishlist',
      productCategory: productCategory,
      productSubCategory: productSubCategory,
      productName: productName,
      productId: productId,
      pageCategory: getPageCategory(),
      productOutOfStock: productOutOfStock,
      productAutoReplen: productAutoReplen,
      productColor: productColor ? productColor : 'null',
      collectionName: productCategory.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: 'Product'
    });
  })

  // newsletter in navigation;
  .on('clicknewsletter', function (e, data) {
    pushToDataLayer({
      event: 'newsletterSubscription',
      siteLocation: data.siteloc
    });
  })

  // click ask question in pdp
  .on('click', '.bv-ask-question', function (e) {
    pushToDataLayer({
      page: getpage(),
      event: 'askQuestion',
      productCategory: getProductCategory(),
      pageSubCategory: 'Ask a Question',
      productName: getProductName(),
      pageCategory: 'Product Page'
    });
  })

  // Scroll on reviews in pdp
  .scroll(function () {
    if ($('.bv-section-summary').length) {
      if (isScrolledIntoView('.bv-section-summary') && unbind < 1) {
        unbind = 1;
        pushToDataLayer({
          event: 'productReviewsView',
          page: getpage(),
          pageCategory: 'Product Page',
          productColor: window.productCache.productColor,
          productType: 'Product',
          collectionName: window.productCache.catid.toLowerCase().search('synactif') > -1 ? 'Synactif' : 'null'
        });
      }
    }

    // for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
    if ($('.pi .carousel-recommendations').length > 0 || $('.cross-sell .carousel-recommendations').length > 0) {
      if (isScrolledIntoView('.carousel-recommendations') && unbindcarousel < 1) {
        unbindcarousel = 1;
        pushToDataLayer({
          currencyCode: window.User.currencyCode,
          eeAction: 'eeListView',
          event: 'eeListView',
          pageCategory: getPageCategory(),
          products: window.forpageload.product
        });
      }
    }
  })

  // Click on Reviews in PDP
  .on('click', '.bv-inline-histogram-ratings-star-container', function () {
    pushToDataLayer({
      event: 'productReviewsView',
      page: getpage(),
      pageCategory: 'Product Page',
      productColor: window.productCache.productColor,
      productType: 'Product',
      collectionName: window.productCache.catid.toLowerCase().search('synactif') > -1 ? 'Synactif' : 'null'
    });
  })

  // Check balance giftcard in gift card page
  .on('click', '#CheckBalanceButton', function () {
    if ($('#dwfrm_giftcert_balance_giftCertID').val() != '' && $('#dwfrm_giftcert_balance_giftCertPIN').val() != '') {
      pushToDataLayer({
        event: 'checkBalance',
        giftCardNumber: $('#dwfrm_giftcert_balance_giftCertID').val()
        //					"pageSubCategory": "Gift Card",
        //					"pageCategory": "My Account"
      });
    }
  })

  // Check balance giftcard in checkout modal
  .on('click', '#check-giftcert-modal', function (e) {
    if ($('#giftcardbalancemodal #dwfrm_billing_giftCertCode').val() != '' && $('#giftcardbalancemodal #dwfrm_giftcert_balance_giftCertPIN').val() != '') {
      pushToDataLayer({
        event: 'checkBalance',
        giftCardNumber: $('#giftcardbalancemodal #dwfrm_billing_giftCertCode').val()
        //					"pageSubCategory": "Payment",
        //					"pageCategory": "Checkout"
      });
    }
  })

  // Redeem gift card in checkout page
  .on('click', '.pt_checkout #add-giftcert', function () {
    if ($('.gift-card-form #dwfrm_billing_giftCertCode').val() != '' && $('.gift-card-form #dwfrm_giftcert_balance_giftCertPIN').val() != '') {
      pushToDataLayer({
        event: 'redeemGiftCard',
        giftCardNumber: $('.gift-card-form #dwfrm_billing_giftCertCode').val()
      });
    }
  })

  // Redeem gift card in checkout modal
  .on('click', '#add-giftcert-modal', function () {
    if ($('#giftcardbalancemodal #dwfrm_billing_giftCertCode').val() != '' && $('#giftcardbalancemodal #dwfrm_giftcert_balance_giftCertPIN').val() != '') {
      pushToDataLayer({
        event: 'redeemGiftCard',
        giftCardNumber: $('#giftcardbalancemodal #dwfrm_billing_giftCertCode').val()
      });
    }
  })

  // add to cart from PDP
  .on('click', '#add-to-cart', function (e) {
    if (getPageCategory() == 'Cart Page') {
      if (sessionStorage.getItem('cartupdate')) {
        sessionStorage.setItem('productUpdate', '1');
      }
    } else {
      window.productCache = window.productCache || {};
      pushToDataLayer({
        event: 'addToCart',
        //"productOrderType": getProductOrederType(),
        currencyCode: window.Resources.CURRENCY,
        addToCartType: $(this).parents('.quick-view').length ? 'Quick Shop' : 'Product Page',
        //"pageCategory": getPageCategory(),
        products: [{
          name: getProductName(),
          id: getProductID(),
          price: Number($('#add-to-cart').data('price')),
          brand: getProductBrand(),
          category: window.productCache.category,
          variant: $('.c-block-shopingmodal-side-size .c-tileradio-input:checked').parent().find('.c-tileradio-label-text').first().text().trim(),
          quantity: Number($('.c-quantitySelection .c-select-current').text().trim()),
          productAutoReplen: $('#add-to-cart').data('replenishable'),
          productColor: $('.c-list-color .c-list-color-panel.is-current').data('description'),
          productOutOfStock: $('#add-to-cart').data('instock'),
          collectionName: window.productCache.catid.toLowerCase().search('synactif') > -1 ? 'Synactif' : 'null',
          productType: 'Product',
          productStarRating: '',
          productVariantID: $('.c-block-shopingmodal-side-size .c-tileradio-input:checked').parent().find('.c-tileradio-label-text').first().text().trim() != '' && $('.c-list-color .c-list-color-panel.is-current').data('description') != '' ? getProductID() : 'null',
          numberOfProductReview: ''
          //"subCategory" : window.productCache.subcategory,
          //"subSubCategory" : window.productCache.subsubcategory,
          //"productNumReviews":"",
        }]
      });
    }
  })

  //Click at '+' on cart page
  .on('click', '.c-list-products-full-item--cart .c-quantitySelection-btn-plus', function () {
    sessionStorage.setItem('productUpdate', '1');
    var index = $(this).parents('.cart-row').index();
    var product = basketConfirmation.productLineItems[index];

    pushToDataLayer({
      event: 'addToCart',
      addToCartType: 'Cart Page',
      currencyCode: basketConfirmation.currencyCode,
      products: [{
        name: product.name,
        id: product.id,
        price: product.price,
        brand: product.brand,
        category: product.category,
        variant: product.size,
        quantity: 1,
        productAutoReplen: product.productAutoReplen,
        productColor: product.color,
        productOutOfStock: product.productOutOfStock,
        collectionName: product.collectionName,
        productType: product.productType,
        productStarRating: product.productStarRating,
        productVariantID: product.productVariantID,
        numberOfProductReview: product.numberOfProductReview
      }]
    });
  })

  //Click at '-' on cart page
  .on('click', '.c-list-products-full-item--cart .c-quantitySelection-btn-minus', function () {
    sessionStorage.setItem('productUpdate', '1');
    var index = $(this).parents('.cart-row').index();
    var product = basketConfirmation.productLineItems[index];
    if (product.quantity > 1) {
      pushToDataLayer({
        event: 'removeFromCart',
        addToCartType: 'Cart Page',
        currencyCode: basketConfirmation.currencyCode,
        products: [{
          name: product.name,
          id: product.id,
          price: product.price,
          brand: product.brand,
          category: product.category,
          variant: product.size,
          quantity: 1,
          productAutoReplen: product.productAutoReplen,
          productColor: product.color,
          productOutOfStock: product.productOutOfStock,
          collectionName: product.collectionName,
          productType: product.productType,
          productStarRating: product.productStarRating,
          productVariantID: product.productVariantID,
          numberOfProductReview: product.numberOfProductReview
        }]
      });
    }
  })

  //Click change quantity on cart page
  .on('click', '.c-list-products-full-item--cart .c-quantitySelection .c-quantitySelection-num .c-select-list a', function () {
    sessionStorage.setItem('productUpdate', '1');
    var index = $(this).parents('.cart-row').index();
    var product = basketConfirmation.productLineItems[index];
    if ($(this).text() != '') {
      pushToDataLayer({
        event: Number($(this).text().trim()) - product.quantity > 0 ? 'addToCart' : 'removeFromCart',
        addToCartType: 'Cart Page',
        currencyCode: basketConfirmation.currencyCode,
        products: [{
          name: product.name,
          id: product.id,
          price: product.price,
          brand: product.brand,
          category: product.category,
          variant: product.size,
          quantity: Math.abs(Number($(this).text().trim()) - product.quantity),
          productAutoReplen: product.productAutoReplen,
          productColor: product.color,
          productOutOfStock: product.productOutOfStock,
          collectionName: product.collectionName,
          productType: product.productType,
          productStarRating: product.productStarRating,
          productVariantID: product.productVariantID,
          numberOfProductReview: product.numberOfProductReview
        }]
      });
    }
  })

  // Submit ask a question
  .on('click', ".bv-submission-section button:contains('Post Question')", function (e) {
    pushToDataLayer({
      //"page": getpage(),
      event: 'submitQuestion',
      //"productCategory": getProductCategory(),
      question: $('#bv-textarea-field-questionsummary').val(),
      //"productName": getProductName(),
      //"pageSubCategory": "Ask a Question",
      pageCategory: getPageCategory()
    });
  })

  // remove from cart
  .on('click', '.c-list-products-full-remove a', function (e) {
    var index = $(this).parents('.cart-row').index();
    pushToDataLayer({
      event: 'removeFromCart',
      currencyCode: window.Resources.CURRENCY,
      addToCartType: getPageCategory(),
      //"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
      //"pageCategory": getPageCategory(),
      products: [{
        name: basketConfirmation.productLineItems[index].name,
        id: basketConfirmation.productLineItems[index].id,
        price: basketConfirmation.productLineItems[index].price,
        brand: getProductBrand(),
        category: basketConfirmation.productLineItems[index].category,
        variant: basketConfirmation.productLineItems[index].size,
        quantity: basketConfirmation.productLineItems[index].quantity,
        productAutoReplen: basketConfirmation.productLineItems[index].productAutoReplen,
        productColor: basketConfirmation.productLineItems[index].productColor,
        productType: basketConfirmation.productLineItems[index].productType,
        productOutOfStock: basketConfirmation.productLineItems[index].productAutoReplen.productOutOfStock,
        collectionName: basketConfirmation.productLineItems[index].category == 'Synactif' ? 'Synactif' : 'null',
        productStarRating: '',
        productVariantID: '',
        numberOfProductReview: basketConfirmation.productLineItems[index].size != '' && basketConfirmation.productLineItems[index].productColor != '' ? basketConfirmation.productLineItems[index].id : 'null'
      }]
    });
  })
  // click zoom in pdp
  .on('click', '.c-block-shopingmodal-main-image .c-modal-img', function (e) {
    pushToDataLayer({
      event: 'productInteraction',
      interactionType: 'Zoom',
      productCategory: window.productCache.catid,
      productSubCategory: window.productCache.subcategory,
      productName: window.productCache.name,
      productId: window.productCache.ID,
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.productColor,
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: window.productCache.master ? 'master' : window.productCache.variant ? 'variant' : window.productCache.bundle ? 'bundle' : window.productCache.productSet ? 'productSet' : 'product'
    });
  })

  // click full ingredients in pdp
  .on('click', '.cpb-products-summary_cover .cpb-products-summary_tab_list a', function (e) {
    var interactionType = $(this).data('tab-target');
    switch (interactionType) {
      case 'content1':
        interactionType = 'About The Product';
        break;
      case 'content2':
        interactionType = 'Features';
        break;
      case 'content3':
        interactionType = 'How To Use';
        break;
      case 'content4':
        interactionType = 'View Full Product Ingredients';
        break;
      default:
        interactionType = 'Other Content';
        break;
    }
    pushToDataLayer({
      event: 'productInteraction',
      interactionType: interactionType,
      productCategory: window.productCache.catid,
      productSubCategory: window.productCache.subcategory,
      productName: window.productCache.name,
      productId: window.productCache.ID,
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.productColor,
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: window.productCache.master ? 'master' : window.productCache.variant ? 'variant' : window.productCache.bundle ? 'bundle' : window.productCache.productSet ? 'productSet' : 'product'
    });
  }).on('click', '.cart-promo-approaching', function () {
    pushToDataLayer({
      event: 'eePromoClick',
      pageSubCategory: 'Internal marketing',
      pageCategory: 'Cart Page',
      promotions: [{
        position: 'Cart',
        id: $('.cart-promo-approaching').data('promoid'),
        creative: 'Cart-Banner',
        name: $('.cart-promo-approaching').data('promoname')
      }]
    });
  }).on('click', '.cart-coupon-code #add-coupon', function () {
    localStorage.removeItem('couponvalidation');
  })

  // track share button on PDP
  .on('click', '.social-sharing-container .share-icon', function () {
    pushToDataLayer({
      socialAction: 'Share',
      event: 'socialShare',
      siteLocation: 'product page',
      pageCategory: getPageCategory(),
      socialNetwork: $(this).data('share')
    });
  })

  // Track Follow button on Footer
  .on('click', '.ge-footer-connectWithUs-icon li a', function () {
    pushToDataLayer({
      event: 'socialClick',
      socialNetwork: $(this).find('title').length > 0 ? $(this).find('title').text().trim() : 'null',
      socialAction: 'Follow',
      siteLocation: 'footer',
      pageCategory: getPageCategory()
    });
  })

  // Add to Cart in Save for later
  .on('click', '.wishlist-item .add-to-cart', function () {
    var index = $(this).parents('form').index();
    pushToDataLayer({
      currencyCode: window.Resources.CURRENCY,
      event: 'addToCart',
      //"productOrderType": getProductOrederType(),
      addToCartType: getPageCategory(),
      pageSubCategory: getProductsubCategory(),
      pageCategory: getPageCategory(),
      products: [{
        id: wishlistItem.product[index].id,
        category: wishlistItem.product[index].category,
        price: wishlistItem.product[index].price,
        name: wishlistItem.product[index].name,
        brand: wishlistItem.product[index].brand,
        quantity: wishlistItem.product[index].quantity,
        size: wishlistItem.product[index].size,
        subCategory: wishlistItem.product[index].subcategory,
        subSubCategory: wishlistItem.product[index].subcategory,
        productAutoReplen: wishlistItem.product[index].productAutoReplen,
        productOutOfStock: wishlistItem.product[index].productOutOfStock,
        productColor: wishlistItem.product[index].color,
        productType: 'Product',
        productNumReviews: '',
        productStarRating: ''
      }]
    });
  })

  // Add to all to Cart
  .on('click', '.add-all-to-cart', function () {
    pushToDataLayer({
      currencyCode: window.Resources.CURRENCY,
      event: 'addToCart',
      //"productOrderType": getProductOrederType(),
      addToCartType: getPageCategory(),
      pageSubCategory: getProductsubCategory(),
      pageCategory: getPageCategory(),
      products: wishlistItem.product
    });
  })

  // click email hyper link in navigation
  .on('click', '#header .emailcsr-nav', function () {
    if (window.Resources.PAGE_CATEGORY == 'page-show') {
      pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Email',
        siteLocation: 'Header',
        //					"pageSubCategory": couponsubcategory(),
        pageCategory: getProductCategory()
      });
    } else {
      pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Email',
        siteLocation: 'Header',
        pageSubCategory: window.Resources.PAGE_CATEGORY == 'cart-show' ? '' : couponsubcategory(),
        pageCategory: getPageCategory()
      });
    }
  })
  // Click email link in the customer care
  //		.on("click",".content-asset a:contains('customercare@cledepeaubeaute.com')",function(){
  //			pushToDataLayer({
  //				"event": "contactRequest",
  //				"contactType": "Email",
  //				"siteLocation": window.Resources.PAGE_CATEGORY=="cart-show" ? "Right Nav":"Body",
  ////				"pageSubCategory": couponsubcategory(),
  //				"pageCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? getPageCategory(): getProductCategory()
  //			});
  //		})

  .on('gtmcontactus', function () {
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Contact Customer Care Submission',
      siteLocation: 'Body',
      pageCategory: getPageCategory()
    });
  }).on('askanexpert', function () {
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Ask An Expert Submission',
      siteLocation: 'Body',
      pageSubCategory: couponsubcategory(),
      pageCategory: 'Ask An Expert'
    });
  }).on('click', '#header .live-chat', function () {
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Live Chat',
      siteLocation: 'Header',
      pageSubCategory: couponsubcategory(),
      pageCategory: getPageCategory()
    });
  }).on('click', '#header .call-us', function () {
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Call Us',
      siteLocation: 'Header',
      pageSubCategory: couponsubcategory(),
      pageCategory: getPageCategory()
    });
  }).on('click', '.LPMimage', function () {
    var id = $(this).attr('id');
    var chk = id.charAt(id.length - 1);
    if (chk == 1) {
      pushToDataLayer({
        event: 'contactRequest',
        contactType: 'Live Chat',
        siteLocation: 'Pop-up',
        pageSubCategory: couponsubcategory(),
        pageCategory: getPageCategory()
      });
    }
  }).on('click', '.footer-container .products ul li:nth-child(4)', function () {
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Phone',
      siteLocation: 'Footer',
      pageSubCategory: window.Resources.PAGE_CATEGORY == 'cart-show' ? '' : couponsubcategory(),
      pageCategory: getPageCategory()
    });
  })

  // click on recommendation
  .on('click', '.recommendation-item', function () {
    if (getPageCategory() == 'Product Page') {
      sessionStorage.setItem('listType', 'Recommended Product List');
      sessionStorage.setItem('listName', 'Product Page');
    } else if (getPageCategory() == 'Home Page') {
      sessionStorage.setItem('listType', 'Recently Viewed List');
      sessionStorage.setItem('listName', 'Home Page');
    }
  }).on('click', '.catalog-link', function (e) {
    if (navctr == true) {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData);
      sessionStorage.setItem('menuloc', 'topmenu');
      util.setCookie('navdata', gtmNavData, 0.2);
      navctr = false;
    }
  }).on('click', '.cmd-cross-nav_list a', function (e) {
    if (navctr == true) {
      gtmNavData = $(this).text().trim();
      sessionStorage.setItem('navlink', gtmNavData);
      sessionStorage.setItem('menuloc', 'topmenu');
      util.setCookie('navdata', gtmNavData, 0.2);
      navctr = false;
    }
  }).on('click', '.cpb-gnav_container .cpb-gnav_list a', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
    util.setCookie('navdata', gtmNavData, 0.2);
  }).on('click', '.cpb-gnav_container .cpb-gnav-utility_list a', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
    util.setCookie('navdata', gtmNavData, 0.2);
  }).on('click', '.cpb-modal_account .cpb-account_area a', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'myacountmenu');
    util.setCookie('navdata', gtmNavData, 0.2);
  }).on('click', '.refinement-header', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
  }).on('click', '.refinement-link', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
  }).on('click', '.breadcrumb-element', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('breadcrumbs', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
  }).on('change', '#quantity', function (e) {
    if (getPageCategory() == 'Cart Page') {
      if ($('.edit-modal').length > 0) {
        sessionStorage.setItem('cartupdate', '1');
      } else {
        sessionStorage.setItem('productUpdate', '1');
      }
    }
  }).on('change', '.quantity-select', function (e) {
    if (window.Resources.PAGE_CATEGORY == 'wishlist-show') {
      sessionStorage.setItem('productUpdate', '1');
    }
  }).on('click', '.c-list-sideNavi li', function (e) {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData);
    sessionStorage.setItem('menuloc', 'leftmenu');
  })

  // Remove uservalidation attribute for userlogin validation and product update
  .on('click', '.user-logout', function (e) {
    localStorage.removeItem('uservalidation');
    sessionStorage.removeItem('productUpdate');
  }).on('click', '#pdp-swatches.c-block-shopingmodal-side-color a, .c-block-shopingmodal-side-colorSelect .c-select-list-item', function () {
    if (getPageCategory() == 'Cart Page') {
      sessionStorage.setItem('cartupdate', '1');
    }
  }).on('click', '.mfp-close', function () {
    if (getPageCategory() == 'Cart Page') {
      sessionStorage.setItem('cartupdate', '');
    }
  }).on('click', '#save-for-later', function () {
    if (getPageCategory() == 'Cart Page') {
      sessionStorage.setItem('cartupdate', '');
    }
  }).on('click', '#pdp-swatches .selectable', function () {
    if (getPageCategory() == 'Cart Page') {
      if (!$(this).hasClass('selected')) {
        sessionStorage.setItem('cartupdate', '1');
      }
    }
  }).on('click', '.search-suggestion-wrapper .hit', function () {
    gtmNavData = $(this).text().trim();
    sessionStorage.setItem('navlink', gtmNavData.replace(/\s\s+/g, ' '));
    sessionStorage.setItem('menuloc', 'site search pop-in');
  }).on('click', '.search-suggestion-wrapper .product-suggestion', function () {
    gtmNavData = $(this).text().trim();
    var rep = gtmNavData.replace(/\n/g, ' ');
    sessionStorage.setItem('navlink', rep.replace(/ +/g, ' '));
    sessionStorage.setItem('menuloc', 'site search pop-in');
  })

  // PLP click in list
  .on('click', '.c-product-cards-list .c-product-cards-list-item a.c-product-cards-photo-img', function () {
    var index = $(this).parents('.c-product-cards-list-item').index('.c-product-cards-list-item');
    var url = $(this).attr('href');
    if (index >= 0) {
      if (productData.page >= 1) {
        pushToDataLayer({
          event: 'eeListClick',
          eeAction: 'eeListClick',
          pageCategory: searchItems.search ? 'Site Search' : 'Product List Page',
          page: url ? url : 'null',
          products: [prodholder[index]]
        }), function () {
          setTimeout(function () {
            if (url != undefined && url != null) {
              document.location = url;
            }
          }, 1000);
        }();
        sessionStorage.setItem('listType', prodholder[index].listType);
        sessionStorage.setItem('listName', prodholder[index].listName);
      } else {
        pushToDataLayer({
          event: 'eeListClick',
          eeAction: 'eeListClick',
          pageCategory: searchItems.search ? 'Site Search' : 'Product List Page',
          page: url ? url : 'null',
          products: [prodholder[0][index]]
        }), function () {
          setTimeout(function () {
            if (url != undefined && url != null) {
              document.location = url;
            }
          }, 1000);
        }();
        sessionStorage.setItem('listType', prodholder[0][index].listType);
        sessionStorage.setItem('listName', prodholder[0][index].listName);
      }
    }
  })

  // PLP click in list
  .on('click', '.c-product-cards-list .c-product-cards-list-item .c-product-cards-text a', function () {
    var index = $(this).parents('.c-product-cards-list-item').index('.c-product-cards-list-item');
    var url = $(this).attr('href');
    if (index >= 0) {
      if (productData.page > 0) {
        pushToDataLayer({
          event: 'eeListClick',
          eeAction: 'eeListClick',
          pageCategory: searchItems.search ? 'Site Search' : 'Product List Page',
          page: url ? url : 'null',
          products: [prodholder[index]]
        }), function () {
          setTimeout(function () {
            if (url != undefined && url != null) {
              document.location = url;
            }
          }, 1000);
        }();
        sessionStorage.setItem('listType', prodholder[index].listType);
        sessionStorage.setItem('listName', prodholder[index].listName);
      } else {
        pushToDataLayer({
          event: 'eeListClick',
          eeAction: 'eeListClick',
          pageCategory: searchItems.search ? 'Site Search' : 'Product List Page',
          page: url ? url : 'null',
          products: [prodholder[0][index]]
        }), function () {
          setTimeout(function () {
            if (url != undefined && url != null) {
              document.location = url;
            }
          }, 1000);
        }();
        sessionStorage.setItem('listType', prodholder[0][index].listType);
        sessionStorage.setItem('listName', prodholder[0][index].listName);
      }
    }
  })

  // Recommendation, bestseller eelistclick in homepage,pdp,cart
  .on('click', '.pi .carousel-recommendations .recommendation-item', function (e) {
    var index = $(this).index() - 3;
    if (_typeof(prodData.product[index]) != undefined && prodData.product[index] != null) {
      pushToDataLayer({
        event: 'eeListClick',
        pageSubCategory: '',
        pageCategory: getPageCategory(),
        filterChoice: '',
        dropDown: '',
        products: [{
          listType: prodData.product[index].listType,
          listName: prodData.product[index].listName,
          position: prodData.product[index].position,
          id: prodData.product[index].id,
          category: getProductCategory(),
          price: prodData.product[index].price,
          name: prodData.product[index].name,
          brand: getProductBrand(),
          quantity: prodData.product[index].quantity,
          size: prodData.product[index].size,
          subCategory: prodData.product[index].subCategory,
          subSubCategory: prodData.product[index].subSubCategory,
          productAutoReplen: prodData.product[index].productAutoReplen,
          productOutOfStock: prodData.product[index].productOutOfStock,
          productColor: prodData.product[index].productColor,
          productType: prodData.product[index].productType,
          productNumReviews: '',
          productStarRating: ''
        }]
      });
      sessionStorage.setItem('listType', prodData.product[index].listType);
      sessionStorage.setItem('listName', prodData.product[index].listName);
    }
  })

  // Recently viewed eelistclick in homepage
  .on('click', '.cross-sell .carousel-recommendations ul .recommendation-item', function (e) {
    var index = $(this).index() - 3;
    if (_typeof(prodData.product[index]) != undefined && prodData.product[index] != null) {
      pushToDataLayer({
        event: 'eeListClick',
        pageSubCategory: '',
        pageCategory: getPageCategory(),
        filterChoice: '',
        dropDown: '',
        products: [{
          listType: prodData.product[index].listType,
          listName: prodData.product[index].listName,
          position: prodData.product[index].position,
          id: prodData.product[index].id,
          category: getProductCategory(),
          price: prodData.product[index].price,
          name: prodData.product[index].name,
          brand: getProductBrand(),
          quantity: prodData.product[index].quantity,
          size: prodData.product[index].size,
          subCategory: prodData.product[index].subCategory,
          subSubCategory: prodData.product[index].subSubCategory,
          productAutoReplen: prodData.product[index].productAutoReplen,
          productOutOfStock: prodData.product[index].productOutOfStock,
          productColor: prodData.product[index].productColor,
          productType: prodData.product[index].productType,
          productNumReviews: '',
          productStarRating: ''
        }]
      });
      sessionStorage.setItem('listType', prodData.product[index].listType);
      sessionStorage.setItem('listName', prodData.product[index].listName);
    }
  })

  // click on viewmore button
  .on('plpviewmore', function (e) {
    if (getPageCategory() == 'Category Page') {
      if (prodholder && _typeof(productData.product) != undefined) {
        if (productData.page > 1) {
          prodholder = prodholder.concat(productData.product);
        } else {
          prodholder = prodholder[0].concat(productData.product);
        }

        for (var i = 0; i < prodholder.length; i++) {
          prodholder[i].position = i + 1;
        }
        for (var a = 0; a < productData.product.length; a++) {
          var diff = productData.product.length - a;
          productData.product[a].position = prodholder.length - diff + 1;
        }
        pushDtLayer({
          event: 'eeListView',
          eeAction: 'eeListView',
          pageCategory: searchItems.search ? 'Site Search' : 'Product List Page',
          dropDown: '',
          filterChoice: '',
          currencyCode: window.User.currencyCode,
          products: productData.product || new Array()
        });
      }
    }
  }).on('click', '.c-block-shopingmodal-main-thumbnail .slick-slide', function () {
    $(document).trigger('clickproductthumbnail');
  })
  // change color
  .on('click', '.cpb-products-color_list li a', function (e) {
    pushToDataLayer({
      event: 'productInteraction',
      interactionType: 'Color Change',
      productCategory: window.productCache.catid,
      productSubCategory: window.productCache.subcategory,
      productName: window.productCache.name,
      productId: window.productCache.ID,
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.productColor,
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: window.productCache.master ? 'master' : window.productCache.variant ? 'variant' : window.productCache.bundle ? 'bundle' : window.productCache.productSet ? 'productSet' : 'product'
    });
    initObserver();
  })
  // change variation
  .on('click', '.c-tileradio-list .c-tileradio-list-item label', function (e) {
    pushToDataLayer({
      event: 'productInteraction',
      interactionType: 'Variant Change',
      productCategory: window.productCache.catid,
      productSubCategory: window.productCache.subcategory,
      productName: window.productCache.name,
      productId: window.productCache.ID,
      pageCategory: getPageCategory(),
      productOutOfStock: window.productCache.productOutOfStock,
      productAutoReplen: window.productCache.productautoreplenish,
      productColor: window.productCache.productColor,
      collectionName: window.productCache.catid.toLowerCase().search('シナクティフ') > -1 ? 'Synactif' : 'null',
      productType: window.productCache.master ? 'master' : window.productCache.variant ? 'variant' : window.productCache.bundle ? 'bundle' : window.productCache.productSet ? 'productSet' : 'product'
    });
    initObserver();
  })

  // Click findstore button in PDP 「店舗を探す」クリック
  .on('click', '.cmd-button_box._wide._WHT.cpb-products-cart_submit.storelocator a', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: window.productCache.name,
      item_id: window.productCache.ID,
      price: pdpdata.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: pdpdata.color ? pdpdata.color : pdpdata.variant ? pdpdata.variant : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: this.innerText,
      next_page: this.href,
      section_name: '店舗を探す'
    });
  })

  // Click onlineshopguide button in PDP 「オンラインショップを探す」クリック
  .on('click', '.cmd-button_box._wide._WHT.cpb-products-cart_submit.onlineshopguide a', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: window.productCache.name,
      item_id: window.productCache.ID,
      price: pdpdata.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: pdpdata.color ? pdpdata.color : pdpdata.variant ? pdpdata.variant : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: this.innerText,
      next_page: this.href,
      section_name: 'オンラインショップ'
    });
  })

  // Click onlineshop button in onlineshopguide 「化粧品専門店」「総合スーパー」「デパート」「SHISEIDO ONLINE STORE」クリック
  .on('click', '.button.sppl10.sppr10.onlineshopguide', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: ProductData.name,
      item_id: ProductData.ID,
      price: ProductData.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: ProductData.productColor ? ProductData.productColor : ProductData.size ? ProductData.size : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: this.innerText,
      next_page: this.href,
      section_name: 'オンラインショップ' + ':' + this.innerText
    });
  })

  // Click tokuisaki button in onlineshopguidespecialty 化粧品専門店 >「得意先EC名」クリック
  .on('click', '.button.sppl10.sppr10.onlineshop-guid-specialty', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: ProductData.name,
      item_id: ProductData.ID,
      price: ProductData.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: ProductData.productColor ? ProductData.productColor : ProductData.size ? ProductData.size : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: this.innerText.replace("\n", " "),
      next_page: this.href,
      section_name: 'オンラインショップ:化粧品専門店'
    });
  })

  // Click omiseplus button in onlineshopguidespecialty 化粧品専門店 > Omise+「詳しくはこちらから」クリック
  .on('click', '.cmd-button_box._sizeS._WHT.omiseplus a', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: ProductData.name,
      item_id: ProductData.ID,
      price: ProductData.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: ProductData.productColor ? ProductData.productColor : ProductData.size ? ProductData.size : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: 'Omise+',
      next_page: this.href,
      section_name: 'オンラインショップ:化粧品専門店'
    });
  })

  // Click omiseplus button in onlineshopguidedepartment デパート >「得意先EC名」クリック
  .on('click', '.button.sppl10.sppr10.onlineshop-guide-department', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: ProductData.name,
      item_id: ProductData.ID,
      price: ProductData.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: ProductData.productColor ? ProductData.productColor : ProductData.size ? ProductData.size : 'null',
      item_category: ProductDataCat[2],
      item_category2: ProductDataCat[1],
      item_category3: ProductDataCat[0],
      button_text: this.innerText.replace("\n", " "),
      next_page: this.href,
      section_name: 'オンラインショップ:デパート'
    });
  })

  // Click omiseplus button in onlineshopguidegms 総合スーパー >「得意先EC名」クリック
  .on('click', '.button.sppl10.sppr10.onlineshop-guid-gms', function () {
    pushToDataLayer({
      event: 'ec_retail_button_click6',
      website_country: 'JP',
      language: 'jp',
      currency: 'JPY',
      item_name: ProductData.name,
      item_id: ProductData.ID,
      price: ProductData.pricing.sale,
      item_brand: 'Cle de Peau Beaute',
      item_variant: ProductData.productColor ? ProductData.productColor : ProductData.size ? ProductData.size : 'null',
      item_category: ProductData.subsubcategory,
      item_category2: ProductData.subcategory,
      item_category3: ProductData.catid,
      button_text: this.innerText.replace("\n", " "),
      next_page: this.href,
      section_name: 'オンラインショップ:総合スーパー'
    });
  })

  // click on next arrow recommendation carousel and best seller
  .on('click', '.pi .carousel-recommendations .slick-next', function (e) {
    if ((typeof prodData === 'undefined' ? 'undefined' : _typeof(prodData)) != undefined && prodData != null) {
      var array = new Array();
      var listholder = new Array();
      var listchecker = false;
      var listctr = 0;
      $('.recommendation-item').each(function (index) {
        if ($('.recommendation-item').filter('.slick-active').length == 3) {
          if (index > 2 && $(this).hasClass('slick-active')) {
            array.push(index - 3);
          }
        } else {
          if (index > 2 && ($(this).hasClass('slick-active') || $(this).hasClass('slick-current'))) {
            listctr = 2;
            if (prodData.product.length > 3) {
              listchecker = true;
              listctr = 0;
            }
            array.push(index - 3);
          } else {
            if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
              if (array[array.length] != index - 3) {
                listctr += 1;
                array.push(index - 3);
              }
            } else {
              listchecker = false;
            }
          }
        }
      });
      for (var i = 0; i < prodData.product.length; i++) {
        for (var a = 0; a < array.length; a++) {
          if (i == array[a]) {
            listholder.push(prodData.product[i]);
          }
        }
      }
      pushToDataLayer({
        currencyCode: window.User.currencyCode,
        eeAction: 'eeListView',
        event: 'eeListView',
        pageCategory: getPageCategory(),
        products: listholder
      });
    }
  })

  // click on next arrow recommendation carousel and best seller
  .on('click', '.pi .carousel-recommendations .slick-prev', function (e) {
    if ((typeof prodData === 'undefined' ? 'undefined' : _typeof(prodData)) != undefined && prodData != null) {
      var array = new Array();
      var listholder = new Array();
      var listchecker = false;
      var listctr = 0;
      $('.recommendation-item').each(function (index) {
        if ($('.recommendation-item').filter('.slick-active').length == 3) {
          if (index > 2 && $(this).hasClass('slick-active')) {
            array.push(index - 3);
          }
        } else {
          if (index > 2 && ($(this).hasClass('slick-active') || $(this).hasClass('slick-current'))) {
            listctr = 2;
            if (prodData.product.length > 3) {
              listchecker = true;
              listctr = 0;
            }
            array.push(index - 3);
          } else {
            if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
              if (array[array.length] != index - 3) {
                listctr += 1;
                array.push(index - 3);
              }
            } else {
              listchecker = false;
            }
          }
        }
      });
      for (var i = 0; i < prodData.product.length; i++) {
        for (var a = 0; a < array.length; a++) {
          if (i == array[a]) {
            listholder.push(prodData.product[i]);
          }
        }
      }
      pushToDataLayer({
        currencyCode: window.User.currencyCode,
        eeAction: 'eeListView',
        event: 'eeListView',
        pageCategory: getPageCategory(),
        products: listholder
      });
    }
  })

  // click on next arrow recently viewed
  .on('click', '.cross-sell .carousel-recommendations .slick-next', function (e) {
    if ((typeof prodData === 'undefined' ? 'undefined' : _typeof(prodData)) != undefined && prodData != null) {
      var array = new Array();
      var listholder = new Array();
      $('.recommendation-item').each(function (index) {
        if (index > 2 && $(this).hasClass('slick-active')) {
          array.push(index - 3);
        }
      });
      for (var i = 0; i < prodData.product.length; i++) {
        for (var a = 0; a < array.length; a++) {
          if (i == array[a]) {
            listholder.push(prodData.product[i]);
          }
        }
      }
      pushToDataLayer({
        currencyCode: window.User.currencyCode,
        eeAction: 'eeListView',
        event: 'eeListView',
        pageCategory: getPageCategory(),
        products: listholder
      });
    }
  })

  // click on next arrow recently viewed
  .on('click', '.cross-sell .carousel-recommendations .slick-prev', function (e) {
    if ((typeof prodData === 'undefined' ? 'undefined' : _typeof(prodData)) != undefined && prodData != null) {
      var array = new Array();
      var listholder = new Array();
      $('.recommendation-item').each(function (index) {
        if (index > 2 && $(this).hasClass('slick-active')) {
          array.push(index - 3);
        }
      });
      for (var i = 0; i < prodData.product.length; i++) {
        for (var a = 0; a < array.length; a++) {
          if (i == array[a]) {
            listholder.push(prodData.product[i]);
          }
        }
      }
      pushToDataLayer({
        currencyCode: window.User.currencyCode,
        eeAction: 'eeListView',
        event: 'eeListView',
        pageCategory: getPageCategory(),
        products: listholder
      });
    }
  })

  // pdp fire when variation was change
  .on('gtvariationchange', function (e) {
    if (getPageCategory() == 'Product Page') {
      pushToDataLayer({
        eeAction: 'eeProductDetail',
        event: 'eeProductDetail',
        pageCategory: 'Product Page',
        products: [{
          listType: sessionStorage.getItem('listType'),
          listName: sessionStorage.getItem('listName'),
          id: pdpdata.defalutvariant ? pdpdata.defalutvariant : pdpdata.ID,
          category: pdpdata.category,
          price: pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice,
          name: pdpdata.name,
          brand: pdpdata.brand,
          quantity: pdpdata.quantity,
          size: pdpdata.size,
          subCategory: pdpdata.subcategory,
          subSubCategory: pdpdata.subsubcategory,
          productAutoReplen: pdpdata.productautoreplenish,
          productOutOfStock: pdpdata.productOutOfStock,
          productColor: pdpdata.productColor,
          productType: 'Product',
          productNumReviews: '',
          productStarRating: ''
        }]
      });
    }
  })

  // quickview action
  .on('click', '.c-product-cards-quickshop-toggle', function () {
    var index = $(this).parents('.c-product-cards-list-item').index('.c-product-cards-list-item');
    if (productData.product.length > 0 && prodholder[0].length > index) {
      pushToDataLayer({
        eeAction: 'eeProductDetail',
        event: 'eeProductDetail',
        pageCategory: 'Category Page',
        products: [prodholder[0][index]]
      });
    }
  })

  // filter
  .on('click', '.c-block-products-search-panel--filter .c-select .c-select-list-item a', function () {
    pushToDataLayer({
      event: 'dropDownChoice',
      dropDownType: 'Filter',
      listType: 'product category list',
      listName: $('.c-title-pageHeading-title').length > 0 ? $('.c-title-pageHeading-title').text().trim() : 'null',
      filterChoice: $(this).length > 0 ? $(this).text().trim() : 'null'
    });
  })

  // sort
  .on('click', '.c-block-products-search-panel--sort .c-select .c-select-list-item a', function () {
    pushToDataLayer({
      event: 'dropDownChoice',
      dropDownType: 'Sort',
      listType: 'product category list',
      listName: $('.c-title-pageHeading-title').length > 0 ? $('.c-title-pageHeading-title').text().trim() : 'null',
      filterChoice: $(this).length > 0 ? $(this).text().trim() : 'null'
    });
  })

  // Transaction funnel steps - shipping to payment
  .on('click', 'button[name="dwfrm_singleshipping_shippingAddress_save"]', function () {
    pushToDataLayer({
      event: 'eeCheckoutOption',
      checkoutStep: '1',
      checkoutOption: sessionStorage.getItem('productUpdate') != '' ? sessionStorage.getItem('productUpdate') : '0'
    });
  })

  // Transaction funnel step - payment to review
  .on('click', 'button[name="dwfrm_billing_save"]', function () {
    pushToDataLayer({
      event: 'eeCheckoutOption',
      checkoutStep: '2',
      checkoutOption: basketConfirmation.defaultShipping
    });
  })

  // Transaction funnel step - review to confirmation
  .on('click', '.pt_checkout #summary-place-order', function () {
    pushToDataLayer({
      event: 'eeCheckoutOption',
      checkoutStep: '3',
      checkoutOption: basketConfirmation.paymentMethod
    });

    sessionStorage.setItem('productUpdate', '');
  })

  // subscription on account registration page
  .on('click', '.pt_account #register-new-account', function () {
    if ($('input[name="dwfrm_profile_customer_addtoemaillist"]').prop('checked')) {
      $(document).trigger('clicknewsletter', {
        siteloc: 'account registration page'
      });
      sessionStorage.setItem('subscription', true);
    } else {
      sessionStorage.setItem('subscription', false);
    }
  })

  // subscription on profile page
  .on('click', '.pt_account #profile-save-changes', function () {
    if ($('input[name="dwfrm_profile_customer_addtoemaillist"]').prop('checked') && sessionStorage.getItem('subscription') == 'false') {
      $(document).trigger('clicknewsletter', { siteloc: 'profile page' });
      sessionStorage.setItem('subscription', true);
    }
  }).on('click', '.c-block-languagselection li a', function () {
    pushToDataLayer({
      event: 'changeLanguage',
      language: $(this).length > 0 ? $(this).text().trim() : 'null'
    });
  })

  // Store locator interaction rate. click header
  .on('click', '.header-shop_btn a', function () {
    pushToDataLayer({
      event: 'storeLocator',
      pageCategory: getPageCategory()
    });
  })

  // Store locator interaction rate in pdp
  .on('click', '.cpb-products-shop .cpb-products-cart_submit:first-child', function () {
    pushToDataLayer({
      event: 'storeLocator',
      pageCategory: getPageCategory()
    });
  })

  // Store locator interaction rate in toppage header navigation
  .on('click', '.cmd-cross-nav_list li:nth-child(6)', function () {
    pushToDataLayer({
      event: 'storeLocator',
      pageCategory: getPageCategory()
    });
  })

  // Contact form submission rate in footer
  .on('click', '.cpb-footer-nav_container .cpb-footer-nav_list .contactus', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Email',
      siteLocation: 'Body',
      pageCategory: getPageCategory()
    });
  })
  // Contact form submission rate in contact us page
  .on('click', '.cmd-button_box .contactus', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Email',
      siteLocation: 'Body',
      pageCategory: getPageCategory()
    });
  })
  // Contact form submission rate in global account menu
  .on('click', '.account-menu_list .contactus', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Email',
      siteLocation: 'Body',
      pageCategory: getPageCategory()
    });
  })
  // Contact form submission rate account page menu
  .on('click', '.c-list-sideNavi .contactus', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'contactRequest',
      contactType: 'Email',
      siteLocation: 'Body',
      pageCategory: getPageCategory()
    });
  })

  // Social attractivity(PDP)
  .on('click', '.item-link_sns_box .item-link_sns_list li a', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'socialClick',
      socialNetwork: socialNetwork,
      socialAction: 'shere',
      siteLocation: 'product page',
      pageCategory: getPageCategory()
    });
  })

  // Social attractivity(footer)
  .on('click', '.cpb-footer-sns_wrapper .cpb-footer-sns_list .list-item:not(.cpb-app) a', function () {
    var socialNetwork = $(this).text().trim();
    pushToDataLayer({
      event: 'socialClick',
      socialNetwork: socialNetwork,
      socialAction: 'shere',
      siteLocation: 'footer',
      pageCategory: getPageCategory()
    });
  })

  // change product shade
  .on('click', '#ymk-modal_right a.swatchanchor', function () {
    var childThatHasColorText = $(this).find('.c-list-color-panel');
    if (childThatHasColorText == null) return;

    pushToDataLayer({
      event: "youCamTryOnInteraction",
      tryOnInteraction: "change product shade",
      productName: productCache.name,
      productColor: childThatHasColorText.attr('data-description')
    });
  });

  if (targetNode) {
    observer.observe(targetNode, config);
  }
}

switch (gtCurPage) {
  case 'page-show':
    var contentsAssetID = window.location.href.split('/').pop().split('.')[0];
    if (contentsAssetID == 'synactif-top') {
      var products = [];
      $(document).find('.cmd-section_products .cmd-col-card_link').each(function (index) {
        products.push({
          name: $(this).data('name'),
          id: $(this).data('id'),
          price: $(this).data('price'),
          brand: getProductBrand(),
          category: 'Synactif',
          variant: $(this).data('variant'),
          list: 'product category list > Synactif',
          position: index + 1,
          collectionName: 'Synactif'
        });
      });
    }
    pushDtLayer({
      event: 'eeListView',
      eeAction: 'eeListView',
      currencyCode: window.User.currencyCode,
      pageCategory: 'Product List Page',
      pageSubCategory: 'Product Search Results',
      products: products
    });
    break;
}

module.exports = {
  init: function init() {
    initializeGlobalEvents();
  },
  tagmanager: {
    click: function click(data) {
      return trackConsultationEvent(data);
    },

    pageview: function pageview(data) {
      return trackConsultationPageview(data);
    }
  },
  gtmInternalPromotion: {
    click: function click(data) {
      return trackInternalPromotionEvent(data);
    },

    pageview: function pageview(data) {
      return trackInternalPromotionPageView(data);
    }
  }
};

},{"./util":77}],3:[function(require,module,exports){
'use strict';

var analytics = require('./analytics'),
    countries = require('./countries'),
    dialog = require('./dialog'),
    quickview = require('./quickview'),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    searchplaceholder = require('./searchplaceholder'),

//searchsuggest = require('./searchsuggest'),
tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    slick = require('./slick'),
    tls = require('./tls'),
    video = require('./video'),
    headerMenu = require('./header-menu'),
    footerSelector = require('./footer-selector'),
    newsletter = require('./newsletter'),
    orderreplenishment = require('./order-replenishment'),
    inputEntry = require('./input-entry'),
    producttile = require('./product-tile'),
    design = require('./design'),
    newDesign = require('./new-design'),
    login = require('./login'),
    hanatsubaki_club_member_id_edit = require('./hanatsubaki_club_member_id_edit'),
    loading = require('./loading'),
    ajax = require('./ajax'),
    dd = require('./dd');

//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
  var s = document.createElement('script');

  s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
  s.setAttribute('type', 'text/javascript');

  document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
//require('./captcha')();

function initializeEvents() {
  var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

  $('body').on('keydown', 'textarea[data-character-limit]', function (e) {
    var text = $.trim($(this).val()),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length;

    if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString()) < 0) {
      e.preventDefault();
    }
  }).on('change keyup mouseup', 'textarea[data-character-limit]', function () {
    var text = $(this).val(),
        charsLimit = $(this).data('character-limit'),
        charsUsed = text.length,
        charsRemain = charsLimit - charsUsed;

    if (charsRemain < 0) {
      $(this).val(text.slice(0, charsRemain));
      charsRemain = 0;
    }

    $(this).closest('.field-wrapper').find('.char-remain-count').html(charsRemain);
  });

  /**
   * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
   * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
   * */
  var $searchContainer = $('.utility-nav .header-search');

  //searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

  // add show/hide navigation elements
  $('.secondary-navigation .toggle').click(function () {
    $(this).toggleClass('expanded').next('ul').toggle();
  });

  // add generic toggle functionality
  $('.toggle').next('.toggle-content').hide();
  $('.toggle').click(function () {
    $(this).toggleClass('expanded').next('.toggle-content').toggle();
  });

  // subscribe email box
  var $subscribeEmail = $('.subscribe-email');

  if ($subscribeEmail.length > 0) {
    $subscribeEmail.focus(function () {
      var val = $(this.val());

      if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
        return; // do not animate when contains non-default value
      }

      $(this).animate({
        color: '#999999'
      }, 500, 'linear', function () {
        $(this).val('').css('color', '#333333');
      });
    }).blur(function () {
      var val = $.trim($(this.val()));

      if (val.length > 0) {
        return; // do not animate when contains value
      }

      $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT).css('color', '#999999').animate({
        color: '#333333'
      }, 500, 'linear');
    });
  }

  if (SitePreferences.MOTIONPOINT_ENABLED) {
    $('#chooseLanguage').on('click', function (e) {
      e.preventDefault();

      var script = document.createElement('script');

      //MP.SrcUrl = unescape('mp_js_orgin_url'); - commented out per MotionPoint
      MP.UrlLang = 'mp_js_current_lang';
      MP.oSite = decodeURIComponent('mp_js_origin_baseUrl');
      MP.tSite = decodeURIComponent('mp_js_translated_baseUrl');

      MP.init();

      script.src = 'https://shiseidoamericas.mpeasylink.com/mpel/mpel_chooser.js';

      document.body.appendChild(script);

      return false;
    });
  }

  $('.privacy-policy').on('click', function (e) {
    e.preventDefault();

    dialog.open({
      url: $(e.target).attr('href'),
      options: {
        height: 600
      }
    });
  });

  if ($('.order-confirmation-details').length) {
    sessionStorage.removeItem('isGift');
    sessionStorage.removeItem('giftMessage');
  }

  var url = Urls.passwordReset;

  if ($('.reset-password-link').length) {
    if (location.protocol === 'https:') {
      url = Urls.securePasswordReset;
    }

    $('.reset-password-link').each(function () {
      $(this).find('a').attr('href', url);
    });
  }

  if ($('.user-recognized').length) {
    if (location.protocol === 'https:') {
      url = Urls.securePasswordReset;
    }

    $('.user-recognized').find('a').attr('href', url);
  }

  // checkout checkout minicart on right side event handling
  addSummaryScrollbar();
  //quick view
  producttile.initQuickViewButtons();
  producttile.initColorChange();

  $(document).on('click', '.js-modal-c_close, .js-modal-c_overlay', function (e) {
    var skinCheckModal = $(this).parents('#skin-trouble-check-modal');
    if (skinCheckModal.length === 0) {
      return;
    }
    //クイックビュー用一時確保formを削除する。
    $('.quickview-form').remove();
  });

  // For product set
  if ($('#product-set').length > 0) {
    setTotalPrice();
  }
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
  // add class to html for css targeting
  $('html').addClass('js');

  if (SitePreferences.LISTING_INFINITE_SCROLL) {
    $('html').addClass('infinite-scroll');
  }

  // load js specific styles
  util.limitCharacters();
}

function backToTopHandler() {
  $(document).on('scroll', function () {
    if ($(window).scrollTop() > 100) {
      $('.scroll-top-wrapper').addClass('show');
    } else {
      $('.scroll-top-wrapper').removeClass('show');
    }
  });

  $('.scroll-top-wrapper').on('click', scrollToTop);
}

function scrollToTop(e) {}
//  e.preventDefault();
//  var verticalOffset =
//    typeof verticalOffset != 'undefined' ? verticalOffset : 0;
//  var element = $('body');
//  var offset = element.offset();
//  var offsetTop = offset.top;

//  $('html, body').animate(
//    {
//      scrollTop: offsetTop
//    },
//    500,
//    'linear'
//  );


// Minimize header and make it stick to the top
function minimizedHeaderHandler() {
  checkScrolledDown();

  $(window).scroll(function () {
    checkScrolledDown();
  });
}

function checkScrolledDown() {
  var $stickyHeader = $('#minimized-header-container');
  var $headerScrollOffset = $('.header-banner').outerHeight();
  var $wrapper = $('#wrapper');

  if ($('body').hasClass('is-reveal-open')) {
    return false;
  }

  if ($(window).scrollTop() > $headerScrollOffset) {
    $stickyHeader.addClass('sticky-header');
    $wrapper.css('padding-top', $stickyHeader.outerHeight());
  } else {
    $stickyHeader.removeClass('sticky-header');
    $wrapper.css('padding-top', 0);
  }
}

function responsiveMegaMenu() {
  var $dropdowns = $('.level-1 li.has-sub-menu');

  $dropdowns.on('keydown', function (e) {
    var $this = $(this);

    if (e.keyCode === 13) {
      if (!$this.hasClass('hover')) {
        e.preventDefault();

        $dropdowns.removeClass('hover');
        $this.addClass('hover');
      }
    }

    if (e.keyCode === 32) {
      e.preventDefault();
      $dropdowns.removeClass('hover');
    }
  });

  $dropdowns.hover(function () {
    var $this = $(this);
    if ($this.prop('hoverTimeout')) {
      $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
    }
    $this.prop('hoverIntent', setTimeout(function () {
      $this.addClass('hover');
    }, 200));
  }, function () {
    var $this = $(this);
    if ($this.prop('hoverIntent')) {
      $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
    }
    $this.prop('hoverTimeout', setTimeout(function () {
      $this.removeClass('hover');
    }, 200));
  });

  if ('ontouchstart' in document.documentElement && window.innerWidth >= 640) {
    $dropdowns.each(function () {
      var $this = $(this);

      this.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) {
          e.stopPropagation();

          if (!$this.hasClass('hover')) {
            if (e.target === this || e.target.parentNode === this) {
              e.preventDefault();
            }

            $dropdowns.removeClass('hover');
            $this.addClass('hover');

            document.addEventListener('touchstart', function closeDropdown(e) {
              e.stopPropagation();

              $this.removeClass('hover');
              document.removeEventListener('touchstart', closeDropdown);
            });
          }
        }
      }, false);
    });
  }

  $('a.no-link, span.category-header').on('click', function (e) {
    if (window.innerWidth < 640) {
      $(this).next($('.menu-item-toggle')).trigger('click');
    } else {
      e.preventDefault();
    }
  });

  var ogMenuHeight = $('ul.level-1').height();
  // main menu toggle
  $('.menu-toggle').on('click', function () {
    $('#wrapper').toggleClass('menu-active');
    ogMenuHeight = $('ul.level-1').height();
  });

  $('.main-nav li .menu-item-toggle').on('click', function (e) {
    e.preventDefault();

    var $parentLi = $(e.target).closest('li');
    var menuHeight = $parentLi.find('.sub-level-wrapper').height();

    if (ogMenuHeight <= menuHeight) {
      $('ul.level-1').css('height', menuHeight);
    }

    $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle');
    $parentLi.toggleClass('active');

    $(e.target).toggleClass('active');
  });

  $('.mobile-menu-back').on('click', function () {
    var $closestActiveMenu = $(this).closest('.active');
    var prevMenuHeight = $closestActiveMenu.parent().parent().height();

    $closestActiveMenu.removeClass('active');

    if (ogMenuHeight <= prevMenuHeight) {
      $('ul.level-1').css('height', prevMenuHeight);
    }
  });

  $('.user-account').on('click', function (e) {
    e.preventDefault();

    $(this).parent('.user-info').toggleClass('active');
  });
}

function searchMenuEvent() {
  // Search for mobile view
  $('.quick-access-menu [title="Search"]').on('click', function (e) {
    e.preventDefault();

    $('.header-search').slideToggle(200);
  });

  // show the search button when the user switches to desktop view
  $(window).on('resize', function (e) {
    if (window.innerWidth > 639) {
      $('.header-search').show();
    }
  });
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar() {
  var itemCount = $('.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product').length;

  if (itemCount > 4) {
    $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
  }
}

function playVideoHandler() {
  var MAIN_VIDEO_SELECTOR = '.main-video';
  var CAROUSEL_VIDEO_SELECTOR = '.modal-video';
  $(document)
  // main video (inline)
  .on('click', MAIN_VIDEO_SELECTOR, function () {
    var $this = $(this);

    var $inlineEle = $this.parent('div'),
        videoId = $this.data('video-id');

    video.playInline($inlineEle, videoId);
  })

  // carousel videos (launched in modal)
  .on('click', CAROUSEL_VIDEO_SELECTOR, function () {
    var videoId = $(this).data('video-id');

    video.playInModal(videoId);
  });
}

function resetFooterError() {
  $('.store-locator-form input[type="text"]').val('');

  if ($('.store-locator-form .field-button-container div').hasClass('error')) {
    $('.store-locator-form .field-button-container div').removeClass('error');
    $('.store-locator-form .field-button-container .error-message').remove();
  }
}

/**
 * Dropdown event for quantity change
 * @returns
 */
function dropDownEvents() {
  $(document).on('click', '.js-num-drop_up', function (e) {
    e.preventDefault();
    var $box = $(this).closest('.js-num-drop_container');
    var limit = $box.find('.js-num-drop_select').children().length;
    var currentNum = $box.find('.js-num-drop_cnt').html();

    if (currentNum < limit - 1) {
      currentNum++;
      $box.find('.js-num-drop_cnt').html(currentNum);
      $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
      if ($(this).closest('#product-set').length > 0) {
        $box.find('.js-num-drop_select').children().eq(currentNum).find('a').addClass('is-current');
      } else {
        $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
      }
      $box.find('.js-num-drop_input').val(currentNum);
    }

    if ($(this).parents('.cpb-products_list_box').length > 0) {
      $(this).trigger('dropUpMinicart');
    } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
      $(this).trigger('dropUpCart');
    } else if ($(this).parents('.cpb-products-conut').length > 0) {
      $(this).trigger('dropUpProduct');
    }

    // For product set
    if ($('#product-set').length > 0) {
      updateAddToCartButton();
      setTotalPrice();
    }
  });
  $(document).on('click', '.js-num-drop_down', function (e) {
    e.preventDefault();
    var $box = $(this).closest('.js-num-drop_container');
    var limit = $box.find('.js-num-drop_select').children().length;
    var currentNum = $box.find('.js-num-drop_cnt').html();
    var isMiniCart = function (element) {
      if ($(element).closest('.cpb-modal_minicart').length > 0) {
        return true;
      } else {
        return false;
      }
    }(this);
    // ミニカートはカウントが０にならないようにする
    var minNum = isMiniCart ? 1 : 0;
    if (currentNum > minNum) {
      currentNum--;
      $box.find('.js-num-drop_cnt').html(currentNum);
      $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
      if ($(this).closest('#product-set').length > 0) {
        $box.find('.js-num-drop_select').children().eq(currentNum).find('a').addClass('is-current');
      } else {
        $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
      }
      $box.find('.js-num-drop_input').val(currentNum);
    }

    if ($(this).parents('.cpb-products_list_box').length > 0) {
      $(this).trigger('dropDownMinicart');
    } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
      $(this).trigger('dropDownCart');
    } else if ($(this).parents('.cpb-products-conut').length > 0) {
      $(this).trigger('dropDownProduct');
    }

    // For product set
    if ($('#product-set').length > 0) {
      // all check product count
      var products = $('.cpb-products-conut .js-num-drop_input');
      var count = 0;
      for (var i = 0; i < products.length; i++) {
        if ($(products).eq(i).val() == 0) count++;
      }
      if (count == products.length) {
        $('#add-all-to-cart').prop('disabled', 'disabled');
      }
      updateAddToCartButton();
      setTotalPrice();
    }
  });
  $(document).on('click', '.js-num-drop_select a', function (e) {
    e.preventDefault();
    var $box = $(this).closest('.js-num-drop_container');
    var num = $(this).html();
    $box.find('.js-num-drop_cnt').html(num);
    $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
    if ($(this).closest('#product-set').length > 0) {
      $box.find('.js-num-drop_select').children().eq(num).find('a').addClass('is-current');
    } else {
      $box.find('.js-num-drop_select').children().eq(num - 1).find('a').addClass('is-current');
    }
    $box.find('.js-num-drop_input').val(num);
    $box.find('.js-num-drop_select').removeClass('is-active');

    if ($(this).parents('.cpb-products_list_box').length > 0) {
      $(this).trigger('dropSelectMinicart');
    } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
      $(this).trigger('dropSelectCart');
    } else if ($(this).parents('.cpb-products-conut').length > 0) {
      $(this).trigger('dropSelectProduct');
    }

    // For product set
    if ($('#product-set').length > 0) {
      // all check product count
      var products = $('.cpb-products-conut .js-num-drop_input');
      var count = 0;
      for (var i = 0; i < products.length; i++) {
        if ($(products).eq(i).val() == 0) count++;
      }
      if (count == products.length) {
        $('#add-all-to-cart').prop('disabled', 'disabled');
      } else {
        $('#add-all-to-cart').prop('disabled', '');
      }
      updateAddToCartButton();
      setTotalPrice();
    }
  });
  $(document).on('click', '.js-num-drop_drop', function (e) {
    e.preventDefault();
    var $box = $(this).closest('.js-num-drop_container');
    var eventName = '.event' + new Date().getTime();

    if ($box.find('.js-num-drop_select').hasClass('is-active')) {
      $box.find('.js-num-drop_select').removeClass('is-active');
      $(document).off(eventName);
    } else {
      var offset = $(this).offset();
      var posY = offset.top - $(window).scrollTop();
      var height = $(window).height();
      if (posY * 2 > height) {
        $box.find('.js-num-drop_select').addClass('is-up');
      } else {
        $box.find('.js-num-drop_select').removeClass('is-up');
      }

      $box.find('.js-num-drop_select').addClass('is-active');

      $(document).on('click' + eventName + ' touchend' + eventName, function (e) {
        if (!$.contains($box[0], e.target)) {
          $box.find('.js-num-drop_select').removeClass('is-active');
          $(document).off(eventName);
        }
      });
    }

    if ($(this).parents('.cpb-products_list_box').length > 0) {
      $(this).trigger('dropDropMinicart');
    } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
      $(this).trigger('dropDropCart');
    } else if ($(this).parents('.cpb-products-conut').length > 0) {
      $(this).trigger('dropDropProduct');
    }
  });
}

function setTotalPrice() {
  $('.cpb-products-variety_area').siblings('.cpb-products-conut').find('.item-price span').text(productSetCalcPrice().toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,'));
}

function productSetCalcPrice() {
  return $('.cpb-products-variety_area .cpb-products-variety_box').toArray().reduce(function (totalPrice, currentValue) {
    var count = Number($(currentValue).find('.cpb-products-conut .js-num-drop_input').val()) || 0;
    var price = Number($(currentValue).find('.item-price .num').data().value) || 0;
    return totalPrice + count * price;
  }, 0);
}

function updateAddToCartButton() {
  var elementList = $('.cpb-products-variety_area .cpb-products-variety_box').toArray();
  // 一つでも在庫切れ、オフライン、店舗限定の商品が有った場合、true
  var checkProduct = function checkProduct() {
    return elementList.some(function (element) {
      return 'none' === $(element).find('.cmd-num_set').css('display');
    });
  };
  // すべての商品の購入個数が「0」の場合、true
  var checkNum = function checkNum() {
    return elementList.every(function (element) {
      return 0 < $(element).find('.cpb-products-conut .js-num-drop_input').length && 0 === Number($(element).find('.cpb-products-conut .js-num-drop_input').val());
    });
  };
  if (checkProduct() || checkNum()) {
    $('#add-all-to-cart').prop('disabled', 'disabled');
  } else {
    $('#add-all-to-cart').prop('disabled', '');
  }
}

var pages = {
  account: require('./pages/account'),
  cart: require('./pages/cart'),
  checkout: require('./pages/checkout'),
  compare: require('./pages/compare'),
  product: require('./pages/product'),
  registry: require('./pages/registry'),
  orderconfirmation: require('./pages/order-confirm'),
  search: require('./pages/search'),
  tutorial: require('./pages/tutorial'),
  storefront: require('./pages/storefront'),
  wishlist: require('./pages/wishlist'),
  storelocator: require('./pages/storelocator'),
  checkorder: require('./pages/checkorder'),
  content: require('./pages/content'),
  promotionlanding: require('./pages/promotionlanding'),
  stocknotification: require('./pages/stocknotification')
};

var app = {
  init: function init() {
    $(document).foundation();

    // 「ajax」通信はパラメータに「isSkipOnHistory」を設定
    $.ajaxPrefilter(function (options) {
      var URI = require('urijs');
      var url = new URI(options.url);
      url.addQuery('isSkipOnHistory', true);
      options.url = url.toString();
    });

    if (document.cookie.length === 0) {
      $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
    }

    initializeDom();
    // init events for design
    design.init();
    initializeEvents();
    //backToTopHandler();
    // minimizedHeaderHandler();
    //resetFooterError();
    //responsiveMegaMenu();
    //searchMenuEvent();

    // init specific global components
    analytics.init();
    countries.init();
    tooltip.init();
    //minicart.init();
    validator.init();
    orderreplenishment.init();
    rating.init();
    slick.init();
    searchplaceholder.init();
    //headerMenu.init();
    video.init();
    //checkoutLogin.init();
    footerSelector.countrySelector();
    newsletter.newsletterHeader();
    newsletter.isNewsletterEnabled();
    inputEntry.entry();
    playVideoHandler();
    login.init();
    quickview.init();
    dropDownEvents();
    loading.init();
    dd.init();
    // execute page specific initializations
    $.extend(page, window.pageContext);

    var ns = page.ns;

    if (ns && pages[ns] && pages[ns].init) {
      pages[ns].init();
    }

    // Check TLS status if indicated by site preference
    if (SitePreferences.CHECK_TLS === true) {
      tls.getUserAgent();
    }
  }
};

//general extension functions
(function () {
  String.format = function () {
    var s = arguments[0];
    var i,
        len = arguments.length - 1;

    for (i = 0; i < len; i++) {
      var reg = new RegExp('\\{' + i + '\\}', 'gm');

      s = s.replace(reg, arguments[i + 1]);
    }

    return s;
  };
})();

// initialize app
$(document).ready(function () {
  app.init();
  // fixed button cart
  $('.cpb-cart-checkout_fixed .cpb-cart_submit .button').off('click.checkout_fixed').on('click.checkout_fixed', function (e) {
    e.preventDefault();
    $('.cpb-cart-side_submit .button').trigger('click');
  });
});

// expose global app obj for 3rd party integrations
window.app = {
  quickView: quickview,
  minicart: minicart,
  user: window.User,
  SCemailUrl: window.Urls.SCemailUrl,
  Product: {},
  tagmanager: analytics.tagmanager,
  gtmInternalPromotion: analytics.gtmInternalPromotion
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = addSummaryScrollbar;
window.scrollToTop = scrollToTop;

},{"./ajax":1,"./analytics":2,"./cookieprivacy":6,"./countries":7,"./dd":10,"./design":11,"./dialog":12,"./footer-selector":13,"./hanatsubaki_club_member_id_edit":17,"./header-menu":18,"./input-entry":19,"./jquery-ext":20,"./loading":21,"./login":22,"./minicart":23,"./new-design":25,"./newsletter":26,"./order-replenishment":27,"./page":28,"./pages/account":29,"./pages/cart":30,"./pages/checkorder":31,"./pages/checkout":37,"./pages/compare":41,"./pages/content":42,"./pages/order-confirm":43,"./pages/product":48,"./pages/promotionlanding":55,"./pages/registry":56,"./pages/search":57,"./pages/stocknotification":58,"./pages/storefront":59,"./pages/storelocator":60,"./pages/tutorial":61,"./pages/wishlist":62,"./product-tile":63,"./quickview":66,"./rating":67,"./searchplaceholder":70,"./slick":71,"./tls":75,"./tooltip":76,"./util":77,"./validator":78,"./video":79,"urijs":145}],4:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    modal = require('./modal').global;

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
  var bonusproducts = [];

  var i, len;
  for (i = 0, len = selectedList.length; i < len; i++) {
    var p = {
      pid: selectedList[i].pid,
      qty: selectedList[i].qty,
      options: {}
    };
    var a,
        alen,
        bp = selectedList[i];
    if (bp.options) {
      for (a = 0, alen = bp.options.length; a < alen; a++) {
        var opt = bp.options[a];
        p.options = { optionName: opt.name, optionValue: opt.value };
      }
    }
    bonusproducts.push({ product: p });
  }
  return { bonusproducts: bonusproducts };
}

var selectedItemTemplate = function selectedItemTemplate(data) {
  var attributes = '';
  for (var attrID in data.attributes) {
    var attr = data.attributes[attrID];
    attributes += '<li data-attribute-id="' + attrID + '">\n';
    attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
    attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
    attributes += '</li>';
  }
  attributes += '<li class="item-qty">\n';
  attributes += '<span class="display-name">Qty</span>: ';
  attributes += '<span class="display-value">' + data.qty + '</span>';
  return ['<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">', '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>', '<div class="item-name">' + data.name + '</div>', '<ul class="item-attributes">', attributes, '<ul>', '<li>'].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function hideSwatches() {
  $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
  // prevent unselecting the selected variant
  $('.bonus-product-item .swatches .selected').on('click', function () {
    return false;
  });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
  var $bonusProductList = $('#bonus-product-list');
  if (!selectedList.length) {
    $bonusProductList.find('li.selected-bonus-item').remove();
  } else {
    var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
      var item = selectedList[i];
      var li = selectedItemTemplate(item);
      $(li).appendTo(ulList);
    }
  }

  // get remaining item count
  var remain = maxItems - selectedList.length;
  $bonusProductList.find('.bonus-items-available').text(remain);
  if (remain <= 0) {
    $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
  } else {
    $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
  }
}

function initializeGrid() {
  var $bonusProduct = $('#bonus-product-dialog'),
      $bonusProductList = $('#bonus-product-list'),
      bliData = $bonusProductList.data('line-item-detail');
  maxItems = bliData.maxItems;
  bliUUID = bliData.uuid;

  if (bliData.itemCount >= maxItems) {
    $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
  }

  var cartItems = $bonusProductList.find('.selected-bonus-item');
  cartItems.each(function () {
    var ci = $(this);
    var product = {
      uuid: ci.data('uuid'),
      pid: ci.data('pid'),
      qty: ci.find('.item-qty').text(),
      name: ci.find('.item-name').html(),
      attributes: {}
    };
    var attributes = ci.find('ul.item-attributes li');
    attributes.each(function () {
      var li = $(this);
      product.attributes[li.data('attributeId')] = {
        displayName: li.children('.display-name').html(),
        displayValue: li.children('.display-value').html()
      };
    });
    selectedList.push(product);
  });

  $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
    e.preventDefault();
    var url = this.href,
        $this = $(this);
    url = util.appendParamsToUrl(url, {
      source: 'bonus',
      format: 'ajax'
    });
    $.ajax({
      url: url,
      success: function success(response) {
        $this.closest('.bonus-product-item').empty().html(response);
        hideSwatches();
      }
    });
  }).on('change', '.input-text', function () {
    $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    $(this).closest('.bonus-product-form').find('.quantity-error').text('');
  }).on('click', '.select-bonus-item', function (e) {
    e.preventDefault();
    if (selectedList.length >= maxItems) {
      $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
      $bonusProductList.find('.bonus-items-available').text('0');
      return;
    }

    var form = $(this).closest('.bonus-product-form'),
        detail = $(this).closest('.product-detail'),
        uuid = form.find('input[name="productUUID"]').val(),
        qtyVal = form.find('input[name="Quantity"]').val(),
        qty = isNaN(qtyVal) ? 1 : +qtyVal;

    if (qty > maxItems) {
      $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
      form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
      return;
    }

    var product = {
      uuid: uuid,
      pid: form.find('input[name="pid"]').val(),
      qty: qty,
      name: detail.find('.product-name').text(),
      attributes: detail.find('.product-variations').data('attributes'),
      options: []
    };

    var optionSelects = form.find('.product-option');

    optionSelects.each(function () {
      product.options.push({
        name: this.name,
        value: $(this).val(),
        display: $(this).children(':selected').first().html()
      });
    });
    selectedList.push(product);
    updateSummary();
  }).on('click', '.remove-link', function (e) {
    e.preventDefault();
    var container = $(this).closest('.selected-bonus-item');
    if (!container.data('uuid')) {
      return;
    }

    var uuid = container.data('uuid');
    var i,
        len = selectedList.length;
    for (i = 0; i < len; i++) {
      if (selectedList[i].uuid === uuid) {
        selectedList.splice(i, 1);
        break;
      }
    }
    updateSummary();
  }).on('click', '.add-to-cart-bonus', function (e) {
    e.preventDefault();
    var url = util.appendParamsToUrl(Urls.addBonusProduct, {
      bonusDiscountLineItemUUID: bliUUID
    });
    var bonusProducts = getBonusProducts();
    if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
      bonusProducts.bonusproducts[0].product.qty = maxItems;
    }
    // make the server call
    $.ajax({
      type: 'POST',
      dataType: 'json',
      cache: false,
      contentType: 'application/json',
      url: url,
      data: JSON.stringify(bonusProducts)
    }).done(function () {
      // success
      page.refresh();
    }).fail(function (xhr, textStatus) {
      // failed
      if (textStatus === 'parsererror') {
        window.alert(Resources.BAD_RESPONSE);
      } else {
        window.alert(Resources.SERVER_CONNECTION_ERROR);
      }
    }).always(function () {
      $bonusProduct.dialog('close');
    });
  }).on('click', '#more-bonus-products', function (e) {
    e.preventDefault();
    var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

    //get the next page of choice of bonus products
    var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
    lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
    $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

    var url = util.appendParamsToUrl(Urls.getBonusProducts, {
      bonusDiscountLineItemUUID: uuid,
      format: 'ajax',
      lazyLoad: 'true',
      pageStart: lineItemDetail.pageStart,
      pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
      bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
    });

    $.ajax({
      type: 'GET',
      cache: false,
      contentType: 'application/json',
      url: url
    }).done(function (data) {
      //add the new page to DOM and remove 'More' link if it is the last page of results
      $('#more-bonus-products').before(data);
      if (lineItemDetail.pageStart + lineItemDetail.pageSize >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
        $('#more-bonus-products').remove();
      }
    }).fail(function (xhr, textStatus) {
      if (textStatus === 'parsererror') {
        window.alert(Resources.BAD_RESPONSE);
      } else {
        window.alert(Resources.SERVER_CONNECTION_ERROR);
      }
    });
  });
}

var bonusProductsView = {
  /**
   * @function
   * @description Open the list of bonus products selection dialog
   */
  show: function show(url) {
    var $bonusProduct = $('#bonus-product-dialog');
    // create the dialog
    dialog.open({
      target: $bonusProduct,
      url: url,
      options: {
        width: 795,
        title: Resources.BONUS_PRODUCTS
      },
      callback: function callback() {
        initializeGrid();
        hideSwatches();
      }
    });
  },
  /**
   * @function
   * @description Open bonus product promo prompt dialog
   */
  loadBonusOption: function loadBonusOption() {
    var self = this,
        bonusDiscountContainer = document.querySelector('.bonus-discount-container');
    if (!bonusDiscountContainer) {
      return;
    }

    // get the html from minicart, then trash it
    var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
    bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

    dialog.open({
      html: bonusDiscountContainerHtml,
      options: {
        width: 'auto',
        title: Resources.BONUS_PRODUCT,
        dialogClass: 'bonus-eligibility-modal',
        buttons: [{
          text: Resources.SELECT_BONUS_PRODUCTS,
          click: function click() {
            var uuid = $('.bonus-product-promo').data('lineitemid'),
                url = util.appendParamsToUrl(Urls.showBonusProducts, {
              bonusDiscountLineItemUUID: uuid,
              source: 'bonus',
              format: 'ajax',
              lazyLoad: 'false',
              pageStart: 0,
              pageSize: 0,
              bonusProductsTotal: -1
            });
            $(this).dialog('close');
            //self.show(url);
            modal.addCustomClass('bonus-item-modal');
            modal.renderByUrl(url);
          }
        }, {
          text: Resources.NO_THANKS,
          click: function click() {
            $(this).dialog('close');
          }
        }]
      },
      callback: function callback() {
        // show hide promo details
        $('.show-promo-details').on('click', function () {
          $('.promo-details').toggleClass('visible');
        });
      }
    });
  },

  hasBonusOptions: function hasBonusOptions() {
    return $('.bonus-discount-container').length > 0;
  }
};

module.exports = bonusProductsView;

},{"./dialog":12,"./modal":24,"./page":28,"./util":77}],5:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
  var $compareContainer = $('.compare-items');
  var $compareItems = $compareContainer.find('.compare-item');
  var numActive = $compareItems.filter('.active').length;

  if (numActive < 2) {
    $('#compare-items-button').attr('disabled', 'disabled');
  } else {
    $('#compare-items-button').removeAttr('disabled');
  }

  $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
  // get the first compare-item not currently active
  var $item = $('.compare-items .compare-item').not('.active').first(),
      $productTile = $('#' + data.uuid);

  if ($item.length === 0) {
    if ($productTile.length > 0) {
      $productTile.find('.compare-check')[0].checked = false;
    }
    window.alert(Resources.COMPARE_ADD_FAIL);
    return;
  }

  // if already added somehow, return
  if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
    return;
  }
  // set as active item
  $item.addClass('active').attr('data-uuid', data.uuid).attr('data-itemid', data.itemid).data('uuid', data.uuid).data('itemid', data.itemid).append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
  if ($item.length === 0) {
    return;
  }
  // remove class, data and id from item
  $item.removeClass('active').removeAttr('data-uuid').removeAttr('data-itemid').data('uuid', '').data('itemid', '')
  // remove the image
  .find('.compare-item-image').remove();
}

function addProductAjax(args) {
  var promise = new TPromise(function (resolve, reject) {
    $.ajax({
      url: Urls.compareAdd,
      data: {
        pid: args.itemid,
        category: _currentCategory
      },
      dataType: 'json'
    }).done(function (response) {
      if (!response || !response.success) {
        reject(new Error(Resources.COMPARE_ADD_FAIL));
      } else {
        resolve(response);
      }
    }).fail(function (jqxhr, status, err) {
      reject(new Error(err));
    });
  });
  return promise;
}

function removeProductAjax(args) {
  var promise = new TPromise(function (resolve, reject) {
    $.ajax({
      url: Urls.compareRemove,
      data: {
        pid: args.itemid,
        category: _currentCategory
      },
      dataType: 'json'
    }).done(function (response) {
      if (!response || !response.success) {
        reject(new Error(Resources.COMPARE_REMOVE_FAIL));
      } else {
        resolve(response);
      }
    }).fail(function (jqxhr, status, err) {
      reject(new Error(err));
    });
  });
  return promise;
}

function shiftImages() {
  return new TPromise(function (resolve) {
    var $items = $('.compare-items .compare-item');
    $items.each(function (i, item) {
      var $item = $(item);
      // last item
      if (i === $items.length - 1) {
        return removeFromList($item);
      }
      var $next = $items.eq(i + 1);
      if ($next.hasClass('active')) {
        // remove its own image
        $next.find('.compare-item-image').detach().appendTo($item);
        $item.addClass('active').attr('data-uuid', $next.data('uuid')).attr('data-itemid', $next.data('itemid')).data('uuid', $next.data('uuid')).data('itemid', $next.data('itemid'));
      }
    });
    resolve();
  });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
  var promise;
  var $items = $('.compare-items .compare-item');
  var $cb = $(args.cb);
  var numActive = $items.filter('.active').length;
  if (numActive === MAX_ACTIVE) {
    if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
      $cb[0].checked = false;
      return;
    }

    // remove product using id
    var $firstItem = $items.first();
    promise = removeItem($firstItem).then(function () {
      return shiftImages();
    });
  } else {
    promise = TPromise.resolve(0);
  }
  return promise.then(function () {
    return addProductAjax(args).then(function () {
      addToList(args);
      if ($cb && $cb.length > 0) {
        $cb[0].checked = true;
      }
      refreshContainer();
    });
  }).then(null, function () {
    if ($cb && $cb.length > 0) {
      $cb[0].checked = false;
    }
  });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
  var $cb = args.cb ? $(args.cb) : null;
  return removeProductAjax(args).then(function () {
    var $item = $('[data-uuid="' + args.uuid + '"]');
    removeFromList($item);
    if ($cb && $cb.length > 0) {
      $cb[0].checked = false;
    }
    refreshContainer();
  }, function () {
    if ($cb && $cb.length > 0) {
      $cb[0].checked = true;
    }
  });
}

function removeItem($item) {
  var uuid = $item.data('uuid'),
      $productTile = $('#' + uuid);
  return removeProduct({
    itemid: $item.data('itemid'),
    uuid: uuid,
    cb: $productTile.length === 0 ? null : $productTile.find('.compare-check')
  });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
  var $compareContainer = $('.compare-items');
  _currentCategory = $compareContainer.data('category') || '';
  var $active = $compareContainer.find('.compare-item').filter('.active');
  $active.each(function () {
    var $productTile = $('#' + $(this).data('uuid'));
    if ($productTile.length === 0) {
      return;
    }
    $productTile.find('.compare-check')[0].checked = true;
  });
  // set container state
  refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
  // add event to buttons to remove products
  $('.compare-item').on('click', '.compare-item-remove', function () {
    removeItem($(this).closest('.compare-item'));
  });

  // Button to go to compare page
  $('#compare-items-button').on('click', function () {
    page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
  });

  // Button to clear all compared items
  // rely on refreshContainer to take care of hiding the container
  $('#clear-compared-items').on('click', function () {
    $('.compare-items .active').each(function () {
      removeItem($(this));
    });
  });
}

exports.init = function () {
  initializeDom();
  initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":28,"./util":77,"promise":121}],6:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
  /**
   * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
   * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
   */
  if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
    // check for privacy policy page
    if ($('.privacy-policy').length === 0) {
      dialog.open({
        url: Urls.cookieHint,
        options: {
          closeOnEscape: false,
          dialogClass: 'no-close',
          buttons: [{
            text: Resources.I_AGREE,
            click: function click() {
              $(this).dialog('close');
              enableCookies();
            }
          }]
        }
      });
    }
  } else {
    // Otherwise, we don't need to show the asset, just enable the cookies
    enableCookies();
  }

  function enableCookies() {
    if (document.cookie.indexOf('dw=1') < 0) {
      document.cookie = 'dw=1; path=/';
    }
    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
      document.cookie = 'dw_cookies_accepted=1; path=/';
    }
  }
};

},{"./dialog":12}],7:[function(require,module,exports){
'use strict';

exports.init = function init() {
  $('.country-selector .current-country').on('click', function () {
    $('.country-selector .selector').toggleClass('active');
    $(this).toggleClass('selector-active');
  });
  // set currency first before reload
  $('.country-selector .selector .locale').on('click', function (e) {
    e.preventDefault();
    var url = this.href;
    var currency = this.getAttribute('data-currency');
    $.ajax({
      dataType: 'json',
      url: Urls.setSessionCurrency,
      data: {
        format: 'ajax',
        currencyMnemonic: currency
      }
    }).done(function (response) {
      if (!response.success) {
        throw new Error('Unable to set currency');
      }
      window.location.href = url;
    });
  });
};

},{}],8:[function(require,module,exports){
'use strict';

module.exports = {
  init: function init() {
    $(function () {
      $('.c-modal-iframe-radiance-point').on('mfpOpen', function (e) {
        $('.mfp-content').addClass('iframe-radiance-point');
      });
      $('.c-modal-iframe-radiance-point').on('mfpAfterClose', function (e) {
        if ($('body').hasClass('is-noscroll')) {
          $('body').removeClass('is-noscroll');
          $('body').removeAttr('style');
          $('html, body').prop({ scrollTop: $('body').attr('data-scroll') });
        }
      });
    });
  }
};

},{}],9:[function(require,module,exports){
'use strict';

module.exports.init = function () {
  $(function () {
    $('.c-modal-inline-radiance-point').on('mfpOpen', function (e) {
      $('.mfp-content').addClass('inline-radiance-point');
    });
  });
};

},{}],10:[function(require,module,exports){
'use strict';

module.exports = {
  init: function init() {
    require('./app_diff-20200219').init();
    require('./app_diff-20200319').init();
  }
};

},{"./app_diff-20200219":8,"./app_diff-20200319":9}],11:[function(require,module,exports){
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var design = {
  init: function init() {
    //product search
    this.productSearchInit();

    //product list
    this.plpInit();

    //PDP
    this.pdpInit();

    //tmp_video
    this.tmpVideoInit();

    //tmp_recently
    this.tmpRecentlyInit();

    //tmp_image
    this.tmpImageInit();

    this.commonInit();

    this.clockInit();
  },
  tmpImageInit: function tmpImageInit() {
    $(function () {
      $('.c-block-template_02-slider-main').slick({
        asNavFor: '.c-block-template_02-slider-thumbnail',
        arrows: false,
        responsive: [{
          breakpoint: 991,
          settings: {
            arrows: false,
            dots: true
          }
        }, {
          breakpoint: 768,
          settings: {
            arrows: false,
            dots: false
          }
        }]
      });
      $('.c-block-template_02-slider-thumbnail').slick({
        asNavFor: '.c-block-template_02-slider-main',
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true
      });
    });
  },
  plpInit: function plpInit() {
    $(function () {
      $('.c-product-cards-color-more>a').off('click').on('click', function () {
        $(this).closest('.c-product-cards-color').addClass('is-active');
        $(this).closest('.c-product-cards-color').find('.c-list-color.is-hidden').removeClass('is-hidden');
        $(this).parent().addClass('is-hidden');
        // use library jquery.matchHeight.js
        $.fn.matchHeight._maintainScroll = true;
        matchHeightProducts();
        return false;
      });

      $(document).off('click.plp.swatch, mousehover.plp.swatch').on('click.plp.swatch, mousehover.plp.swatch', '.c-list-color li > a', function () {
        if (window.innerWidth > 767) {
          var thumbIndex = $(this).closest('.c-product-cards-color-list').find('a').index(this);
          $(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').stop().hide();
          $(this).closest('.c-product-cards').find('.c-list-color-panel').removeClass('is-current');
          if ($(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').eq(thumbIndex).is(':hidden')) {
            $(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').eq(thumbIndex).fadeIn('slow');
            $(this).children('.c-list-color-panel').addClass('is-current');
          }
          return false;
        }
      });

      // SP size When there is nothing to display on Filter "Filter" itself is not displayed.
      if (window.innerWidth < 991 && $('.c-block-products-search-panel--filter li').length == 0) {
        $('.c-block-products-search-tabs--filter').remove();
        $('.c-block-products-search-panel--filter').remove();
      }

      // $('.c-list-color li > a').hover(function(){
      // 	if(window.innerWidth>991) {
      // 		$(this).trigger('mousehover');
      // 	}
      // });
    });
  },
  selectGiftInit: function selectGiftInit() {
    $(function () {
      $('.c-block-shopingmodal .c-list-color a').on('colorSelect', function () {
        var element = $(this).closest('.c-list-color').find('a').index(this);
        $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-change-image').each(function () {
          $(this).children().stop().hide(), $(this).children().eq(element).fadeIn();
        });
        $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').removeClass('is-selected');
        $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').eq(element).addClass('is-selected');
        var text = $(this).closest('.c-block-shopingmodal').find('.c-select-list-item>a.is-selected .c-select-list-item-text').html();
        $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-current').html(text);
        $(this).closest('.c-list-color').find('.c-list-color-panel').removeClass('is-current');
        $(this).children('.c-list-color-panel').addClass('is-current');
      });

      $('.c-block-shopingmodal .c-list-color a').on('click', function () {
        if (767 < window.innerWidth) {
          var element = $(this).closest('.c-list-color').find('a').index(this);
          $('.c-block-shopingmodal .c-list-color a').eq(element).trigger('colorSelect');
        }
      });

      $('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').on('click', function () {
        var element = $(this).closest('.c-select-list').find('a').index(this);
        $('.c-block-shopingmodal .c-list-color a').eq(element).trigger('colorSelect');
        return false;
      });
    });
  },
  selectQuantityInit: function selectQuantityInit() {
    $(function () {
      //countup
      $('.c-quantitySelection-btn-plus').off('click').on('click', function () {
        var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
        var currentNum = current.html();
        var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
        var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();
        currentNum++;
        var qtyReal = limit;
        if (currentNum <= limit) {
          current.html(currentNum);
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
          qtyReal = currentNum;
        }

        $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);

        var isWishList = $('form[name^="dwfrm_wishlist_items"]').length > 0;
        var isStockNotification = $('main').data('pageName') === 'stocknotification';
        if (isWishList || isStockNotification) {
          var defaultPrice = $(this).closest('.quantity-column').find('input[name="default-price"]').val();

          var calcPrice = Number(defaultPrice) * qtyReal;
          var str = calcPrice.toLocaleString() + '円';

          if (isStockNotification) {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-dlist_03-item dd.c-text_06').text(str);
          } else {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-text-price').text(str);
          }
        }
        return false;
      });

      //countdown
      $('.c-quantitySelection-btn-minus').off('click').on('click', function () {
        var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
        var currentNum = current.html();
        var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
        var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();

        var qtyReal = 1;
        if (currentNum > 1) {
          currentNum--;
          current.html(currentNum);
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
          qtyReal = currentNum;
        } else if (currentNum == 0) {
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
        }

        $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);

        var isWishList = $('form[name^="dwfrm_wishlist_items"]').length > 0;
        var isStockNotification = $('main').data('pageName') === 'stocknotification';
        if (isWishList || isStockNotification) {
          var defaultPrice = $(this).closest('.quantity-column').find('input[name="default-price"]').val();

          var calcPrice = Number(defaultPrice) * qtyReal;
          var str = calcPrice.toLocaleString() + '円';

          if (isStockNotification) {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-dlist_03-item dd.c-text_06').text(str);
          } else {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-text-price').text(str);
          }
        }
        return false;
      });

      // Change quantity on cart
      $('.c-list-products-full-item--cart .c-quantitySelection-btn-plus').off('click').on('click', function () {
        var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
        var currentNum = current.html();
        var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
        var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();
        currentNum++;
        var qtyReal = limit;
        if (currentNum <= limit) {
          current.html(currentNum);
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
          qtyReal = currentNum;
        }

        $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
        $(this).parents('.c-quantitySelection').find('input[type="hidden"]').val(qtyReal);
        $('input[name$=_deleteGiftCertificate]').remove();
        $('input[name$=_deleteProduct]').remove();
        $(this).closest('form').submit();
      });

      $('.c-list-products-full-item--cart .c-quantitySelection-btn-minus').off('click').on('click', function () {
        var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
        var currentNum = current.html();
        var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
        var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();

        var qtyReal = 1;
        if (currentNum > 1) {
          currentNum--;
          current.html(currentNum);
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
          qtyReal = currentNum;
        } else if (currentNum == 0) {
          $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
        }

        $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
        $(this).parents('.c-quantitySelection').find('input[type="hidden"]').val(qtyReal);
        $('input[name$=_deleteGiftCertificate]').remove();
        $('input[name$=_deleteProduct]').remove();
        $(this).closest('form').submit();
      });
    });
  },
  toggleSelectInit: function toggleSelectInit(eventContinue) {
    $(function () {
      // select open
      $('.c-dropdown-toggle').off('click').on('click', function () {
        if (!$(this).parents('.c-block-review').length) {
          if ($(this).parents('.c-dropdown').find('.c-select-list').is(':hidden')) {
            $('.c-select-list').hide();
            $(this).parents('.c-dropdown').find('.c-select-list').show();
          } else {
            $(this).parents('.c-dropdown').find('.c-select-list').hide();
          }
          return false;
        }
      });
    });

    $(function () {
      eventContinue = eventContinue || false;
      $('.c-input-3column li').first().removeClass('is-half');
      // select
      $('.c-select-toggle').off('click').on('click', function () {
        if ($(this).next('.c-select-list').is(':hidden') && !$(this).hasClass('is-noselect')) {
          $('.c-select-list').hide();
          $(this).next('.c-select-list').show();

          // Auto up down display
          var offset = $(this).offset();
          var posY = offset.top - $(window).scrollTop();
          var heightS = $(window).height();
        } else {
          $(this).next('.c-select-list').hide();
        }
      });

      $('.c-select-list-item a').off('click').on('click', function (e) {
        e.preventDefault();
        var current = $(this).closest('.c-select').find('.c-select-current');
        var value = $(this).data('v') || $(this).find('span').data('num'); // form field and quantity selector
        var displayValue = $(this).children('.c-select-list-item-text').html();
        $(this).closest('.c-select-list').find('.c-select-list-item').children('a').removeClass('is-selected');
        $(this).addClass('is-selected');
        current.html(displayValue);
        $(this).closest('.c-select-list').hide();
        $(this).closest('.c-select').next().val(value);
        $(this).closest('.c-select').next().change();

        if ($(this).closest('.c-block-shopingmodal-side-colorSelect').length > 0 || $(this).closest('.c-block-shoppingDock').length > 0) {
          var index = $(this).closest('.c-select-list').find('a').index(this);
          if ($(this).closest('.c-block-shopingmodal-set-item').length > 0) {
            $(this).closest('.c-block-shopingmodal-set-item').find('.c-list-color a').eq(index).trigger('colorSelect');
          }

          if ($(this).closest('.product-variations').length > 0) {
            $(this).closest('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
          }

          if ($(this).closest('.c-block-shoppingDock').length > 0) {
            $('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
          }
        }

        var isWishList = $('form[name^="dwfrm_wishlist_items"]').length > 0;
        var isStockNotification = $('main').data('pageName') === 'stocknotification';
        if (isWishList || isStockNotification) {
          var defaultPrice = $(this).closest('.quantity-column').find('input[name="default-price"]').val();

          var calcPrice = Number(defaultPrice) * Number(displayValue);
          var str = calcPrice.toLocaleString() + '円';

          if (isStockNotification) {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-dlist_03-item dd.c-text_06').text(str);
          } else {
            $(this).closest('.c-list-products-full-item-text-parts').find('.c-text-price').text(str);
          }
        }
        return eventContinue;
      });

      $('.c-list-products-full-item--cart .c-select-list-item a').off('click').on('click', function (e) {
        e.preventDefault();
        var current = $(this).closest('.c-select').find('.c-select-current');
        var value = $(this).data('v') || $(this).find('span').data('num'); // form field and quantity selector
        var displayValue = $(this).children('.c-select-list-item-text').html();
        $(this).closest('.c-select-list').find('.c-select-list-item').children('a').removeClass('is-selected');
        $(this).addClass('is-selected');
        current.html(displayValue);
        $(this).closest('.c-select-list').hide();
        $(this).closest('.c-select').next().val(value);
        $(this).closest('.c-select').next().change();

        if ($(this).closest('.c-block-shopingmodal-side-colorSelect')) {
          var index = $(this).closest('.c-select-list').find('a').index(this);
          if ($(this).closest('.c-block-shopingmodal-set-item')) {
            $(this).closest('.c-block-shopingmodal-set-item').find('.c-list-color a').eq(index).trigger('colorSelect');
          }

          if ($(this).closest('.product-variations')) {
            $(this).closest('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
          }
        }
        var quantity = $(this).closest('.c-quantitySelection').find('.c-select-current').text();
        $(this).closest('.c-quantitySelection').find('input[type="hidden"]').val(quantity);
        $('input[name$=_deleteGiftCertificate]').remove();
        $('input[name$=_deleteProduct]').remove();
        $(this).closest('form').submit();
      });

      $(document).on('touchstart click', function (e) {
        if (!$(e.target).closest('.c-select').length && !$(e.target).closest('.c-dropdown').length) {
          $('.c-select-list').hide();
        }
      });
    });
  },
  productSearchInit: function productSearchInit() {
    $(window).on('load resize', function () {
      if (window.innerWidth > 767) {
        setTimeout(function () {
          matchHeightProducts();
        }, 50);
      }
    });

    $(function () {
      $('.c-block-products-search-tabs .tab').off('click').on('click', function () {
        if (window.innerWidth < 991) {
          var num = $(this).closest('.c-block-products-search-tabs').find('.tab').index(this);
          if ($(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).is(':hidden')) {
            $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').removeClass('is-active');
            $('.c-block-products-search-tabs .tab').removeClass('is-active');
            $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).addClass('is-active');
            $(this).addClass('is-active');
          } else {
            $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).removeClass('is-active');
            $(this).removeClass('is-active');
          }
          return false;
        }
      });
    });
  },
  modalInit: function modalInit() {
    $.extend(true, $.magnificPopup.defaults, {
      tClose: Resources.POPUP_CLOSE,
      tLoading: Resources.POPUP_LOADING,
      gallery: {
        tPrev: Resources.POPUP_PREVIOUS,
        tNext: Resources.POPUP_NEXT,
        tCounter: Resources.POPUP_COUNTER
      },
      image: {
        tError: Resources.POPUP_ERROR
      }
    });

    $('.c-modal-img').magnificPopup({
      type: 'image',
      removalDelay: 500,
      fixedContentPos: true,
      callbacks: {
        open: function open() {
          $('.mfp-container').addClass('row');
          $.magnificPopup.instance.close = function () {
            if (window.innerWidth < 992) {
              var scrollpos = $('body').attr('data-scroll');
              $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
            }
            $.magnificPopup.proto.close.call(this);
          };
        }
      }
    });

    $('.c-modal-video').each(function () {
      var link = $(this).attr('href');
      $(this).magnificPopup({
        type: 'iframe',
        removalDelay: 600,
        fixedContentPos: true,
        iframe: {
          patterns: {
            youtube: {
              src: link
            }
          }
        },
        callbacks: {
          open: function open() {
            $('.mfp-container').addClass('row');
            $.magnificPopup.instance.close = function () {
              if (window.innerWidth < 992) {
                var scrollpos = $('body').attr('data-scroll');
                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
              }
              $.magnificPopup.proto.close.call(this);
            };
          }
        }
      });
    });

    $('.c-modal-video-fullscreen').each(function () {
      var link = $(this).attr('href');
      $(this).magnificPopup({
        type: 'iframe',
        removalDelay: 600,
        fixedContentPos: true,
        iframe: {
          patterns: {
            youtube: {
              src: link
            }
          }
        },
        callbacks: {
          open: function open() {
            $('.mfp-container').addClass('row mfp-iframe-holder-fullscreen');
            $.magnificPopup.instance.close = function () {
              if (window.innerWidth < 992) {
                var scrollpos = $('body').attr('data-scroll');
                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
              }
              $.magnificPopup.proto.close.call(this);
            };
          }
        }
      });
    });

    $('.c-modal-inline').magnificPopup({
      type: 'inline',
      removalDelay: 500,
      preloader: false,
      fixedContentPos: true,
      callbacks: {
        open: function open() {
          $('.mfp-container').addClass('row');
          $('.mfp-content > div').addClass('row');
          $('.slick-slider').slick('setPosition');
          $('.c-slider-products-landscape').slick('setPosition');
          $('.c-slider-products-vertical').slick('setPosition');
          matchHeightProducts();
          if ($('.c-block-sampleselection-body').length) {
            $('.c-block-sampleselection-body').getNiceScroll().resize();
          }
          $.magnificPopup.instance.close = function () {
            if (window.innerWidth < 992) {
              var scrollpos = $('body').attr('data-scroll');
              $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
            }
            $.magnificPopup.proto.close.call(this);
          };
        }
      }
    });

    $('.c-modal-autoreplenishment').on('click', function (e) {
      if ($.magnificPopup.instance.st !== undefined) {
        e.stopPropagation();
        $.magnificPopup.instance.st.callbacks = {
          afterClose: function afterClose() {
            if ($('#shopingmodal').length > 0) {
              e.stopPropagation();
              $.magnificPopup.open({
                items: {
                  src: '#shopingmodal',
                  type: 'inline',
                  removalDelay: 500
                }
              });
            }
          }
        };
      }

      $.magnificPopup.open({
        items: {
          src: '#autoreplenishmentmodal',
          type: 'inline',
          removalDelay: 500
        }
      });
    });

    $(document).on('click', '.c-block-share-toggle.c-modal', function (e) {
      if ($.magnificPopup.instance.st !== undefined) {
        e.stopPropagation();
        $.magnificPopup.instance.st.callbacks = {
          afterClose: function afterClose() {
            if ($('#shopingmodal').length > 0) {
              e.stopPropagation();
              $.magnificPopup.open({
                items: {
                  src: '#shopingmodal',
                  type: 'inline',
                  removalDelay: 500
                }
              });
            }
          }
        };
      }

      $.magnificPopup.open({
        items: {
          src: '#sharemodal',
          type: 'inline',
          removalDelay: 500
        }
      });
    });

    $('.c-modal-inline--noclose').magnificPopup({
      type: 'inline',
      removalDelay: 500,
      preloader: false,
      fixedContentPos: true,
      showCloseBtn: false,
      closeOnBgClick: false,
      callbacks: {
        open: function open() {
          $('.mfp-container').addClass('row');
          $('.mfp-content > div').addClass('row');
          matchHeightProducts();
          $.magnificPopup.instance.close = function () {
            if (window.innerWidth < 992) {
              var scrollpos = $('body').attr('data-scroll');
              $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
            }
            $.magnificPopup.proto.close.call(this);
          };
        }
      }
    });

    $('.c-modal-finish').click(function (e) {
      $.magnificPopup.open({
        items: {
          src: $('#finishmodal')
        },
        type: 'inline',
        removalDelay: 500,
        preloader: false,
        fixedContentPos: true,
        showCloseBtn: false,
        closeOnBgClick: false,
        callbacks: {
          open: function open() {
            $('.mfp-container').addClass('row');
            $('.mfp-content > div').addClass('row');
            matchHeightProducts();
            $.magnificPopup.instance.close = function () {
              if (window.innerWidth < 992) {
                var scrollpos = $('body').attr('data-scroll');
                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
              }
              $.magnificPopup.proto.close.call(this);
            };
          }
        }
      });
      return e.preventDefault();
    });

    $('.c-modal-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      removalDelay: 500,
      fixedContentPos: true,
      gallery: {
        enabled: true
      },
      image: {
        titleSrc: function titleSrc(item) {
          return item.el.attr('title') || item.el.find('img').attr('alt');
        }
      },
      callbacks: {
        open: function open() {
          $('.mfp-container').addClass('row');
          $.magnificPopup.instance.close = function () {
            if (window.innerWidth < 992) {
              var scrollpos = $('body').attr('data-scroll');
              $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
            }
            $.magnificPopup.proto.close.call(this);
          };
        }
      }
    });

    $('.c-modal-iframe').magnificPopup({
      type: 'iframe',
      removalDelay: 500,
      fixedContentPos: true,
      preloader: false
    });

    $('.c-modal-cart-alert').magnificPopup({
      type: 'inline',
      removalDelay: 500,
      fixedContentPos: true,
      preloader: false
    });

    // $(document)
    //   .off('click', '.c-modal')
    //   .on('click', '.c-modal', function (e) {
    //     if (window.innerWidth < 992) {
    //       var scrollpos = $(window).scrollTop();
    //       $('body').attr('data-scroll', scrollpos);
    //       $('body').addClass('is-noscroll').css({ top: -scrollpos });
    //     }
    //   });
    $('.c-modal-close').off('click').on('click', function (e) {
      e.preventDefault();
      $.magnificPopup.instance.close = function () {
        if (window.innerWidth < 992) {
          var scrollpos = $('body').attr('data-scroll');
          $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
        }
        $.magnificPopup.proto.close.call(this);
      };
      var magnificPopup = $.magnificPopup.instance;
      magnificPopup.close();
    });
    $('.c-modal-cart-alert-close').off('click').on('click', function (e) {
      e.preventDefault();
      $.magnificPopup.instance.close = function () {
        if (window.innerWidth < 992) {
          var scrollpos = $('body').attr('data-scroll');
          $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
        }
        $.magnificPopup.proto.close.call(this);
      };
    });
  },
  footerInit: function footerInit() {
    $(function () {
      $('.ge-changeregion-toggle').off('click').on('click', function () {
        var scrollpos;
        if ($('.ge-changeregion').is(':hidden')) {
          var scroll_bar = window.innerWidth - $(window).width();
          if ($('.ge-navi-list').is(':visible') || window.innerWidth < 992) {
            var scrollpos = $('body').attr('data-scroll');
            $('body').attr('data-scroll', scrollpos);
            $('body').addClass('is-noscroll').css({ top: -scrollpos });
          } else {
            var scrollpos = $(window).scrollTop();
            $('body').attr('data-scroll', scrollpos);
            $('body').addClass('is-noscroll').css({ top: -scrollpos });
          }

          $('.ge-changeregion').fadeIn();
          $('.slick-slider').slick('setPosition');
          $('.ge-changeregion-close').css('padding-right', scroll_bar);
          if ($('.ge-changeregion-results-list').length) {
            $('.ge-changeregion').addClass('is-result');
          } else {
            $('.ge-changeregion').removeClass('is-result');
          }
          if (window.innerWidth < 992) {
            $('.ge-naviSpToggle').removeClass('is-active');
            $('.ge-header').removeClass('is-active');
            $('.ge-navi').fadeOut();
          }
        }
        return false;
      });
      $('.ge-changeregion-close a').off('click').on('click', function () {
        var scrollpos = $('body').attr('data-scroll');
        $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
        $('.ge-changeregion').fadeOut();
        $('.ge-changeregion').removeClass('is-result');
        return false;
      });
    });
  },
  headerInit: function headerInit() {
    $(function () {
      $('.js-navi-toggle a').off('click').on('click', function (e) {
        $('.ge-header').toggleClass('is-naviOpen');
        $(this).parent().toggleClass('is-active');
        $('.js-navi-list').slideToggle();
        return false;
      });

      //PC MEGA MENU item hover
      $('.ge-navi-list-first-text > a').hover(function () {
        if (window.innerWidth > 992) {
          //          $('.ge-navi-list-first-panel').not(this).stop().fadeOut();
          //          $('.ge-navi-list-first-text > a').not(this).removeClass('is-active');
          //          $(this).addClass('is-active');
          //          $(this)
          //            .parent('.ge-navi-list-first-text ')
          //            .next('.ge-navi-list-first-panel')
          //            .stop()
          //            .fadeIn();
        }
      });

      //TABLET, MOBILE Navi open
      $('.ge-naviSpToggle > a').off('click').on('click', function () {
        var scrollpos = 0;
        if ($('.ge-navi').is(':hidden')) {
          $('.ge-navi').fadeIn();
          $('.ge-header').addClass('is-active');
          if (window.innerWidth < 992 || $('body').hasClass('is-noscroll')) {
            var scrollpos = $(window).scrollTop();
            $('body').attr('data-scroll', scrollpos);
            $(this).parent().addClass('is-active');
            $('body').addClass('is-noscroll').css({ top: -scrollpos });
          }
        } else {
          $('.ge-navi').fadeOut();
          $('.ge-header').removeClass('is-active');
          if (window.innerWidth < 992) {
            var scrollpos = $('body').attr('data-scroll');
            $(this).parent().removeClass('is-active');
            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
          }
        }
        return false;
      });

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.ge-header').length) {
          $('.js-navi-toggle').removeClass('is-active');
          $('.ge-header').removeClass('is-naviOpen');
          $('.ge-navi-gather>li').removeClass('is-active');
          $('.ge-naviSpToggle').removeClass('is-active');
          if (window.innerWidth > 992) {
            //            $('.js-navi-list').slideUp();
          } else {
            $('.ge-navi').slideUp();
          }
        }
      });
    });

    this.dropdownToggleInit();

    $(function () {
      $('.ge-navi-list-dropdown-toggle,.ge-navi-list-dropdown-toggleText').off('click').on('click', function () {
        if (window.innerWidth < 992) {
          if ($(this).parent().next('.ge-navi-list-dropdown-panel').is(':hidden')) {
            $(this).parent().next('.ge-navi-list-dropdown-panel').slideDown();
            $(this).parent().addClass('is-active');
          } else {
            $(this).parent().next('.ge-navi-list-dropdown-panel').slideUp();
            $(this).parent().removeClass('is-active');
          }
        }
      });
      //TABLET, MOBILE Navi item open
      $('.ge-naviSp-dropdown-toggle').off('click').on('click', function () {
        if ($(this).next('.ge-naviSp-dropdown-panel').is(':hidden')) {
          $(this).next('.ge-naviSp-dropdown-panel').slideDown();
          $(this).parent().addClass('is-active');
        } else {
          $(this).next('.ge-naviSp-dropdown-panel').slideUp();
          $(this).parent().removeClass('is-active');
        }
      });

      //public header scroll
      geHeaderScroll();
      $(document).on('scroll', function () {
        geHeaderScroll();
      });
      function geHeaderScroll() {
        var scroll = $(window).scrollTop();
        if (scroll >= 1) {
          $('.ge-header').addClass('is-scroll');
        } else {
          if (!$('body').hasClass('is-noscroll')) {
            $('.ge-header').removeClass('is-scroll');
          }
        }
      }
    });
  },
  dropdownToggleInit: function dropdownToggleInit() {
    function headerNavScroll() {
      $('.ge-dropdown-cart-list').niceScroll({
        cursorcolor: '#D7D7D7',
        cursoropacitymin: 0.3,
        cursorwidth: 6,
        autohidemode: false
      });
      $(document).ready(function () {
        setTimeout(function () {
          if ($('.c-block-sampleselection-body').length) {
            $('.c-block-sampleselection-body').niceScroll('ul', {
              cursorcolor: '#D7D7D7',
              cursoropacitymin: 0.3,
              cursorwidth: 6,
              autohidemode: false
            });
          }
        }, 50);
      });
    }
    headerNavScroll();
    $(window).on('resize', function () {
      headerNavScroll();
    });
    $(function () {
      $('.ge-dropdown:not(.ge-dropdown--cart) > a').off('click').on('click', function () {
        if (window.innerWidth > 767) {
          if ($(this).next('.ge-dropdown-box').is(':hidden')) {
            $('.ge-dropdown').removeClass('is-active');
            $('.ge-dropdown-box').fadeOut();
            $(this).next('.ge-dropdown-box').fadeIn();
            $(this).parent().addClass('is-active');
            if ($(this).closest('.ge-dropdown').find('.ge-dropdown-cart-list').length) {
              $('.ge-dropdown-cart-list').getNiceScroll().resize();
            }
          } else {
            $(this).next('.ge-dropdown-box').fadeOut(0);
            $(this).parent().removeClass('is-active');
          }
          return false;
        } else {
          if ($(this).parent()[0].id === 'mini-cart') {
            location.href = $(this).next('div').children('.ge-dropdown-cart-button').children('ul').children('li').children('a')[0].href;
          }
        }
      });
      var getDevice = function () {
        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
          return 'sp';
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
          return 'tab';
        } else {
          return 'other';
        }
      }();
      $('.ge-dropdown--cart').mouseenter(function () {
        if (window.innerWidth > 992 && getDevice == 'other') {
          //          if ($(this).find('.ge-dropdown-box').is(':hidden')) {
          //            $('.ge-dropdown').stop().removeClass('is-active');
          //            $('.ge-dropdown-box').stop().fadeOut();
          //            $(this).stop().addClass('is-active');
          //            $(this).find('.ge-dropdown-box').stop().fadeIn(0);
          //            $('.ge-dropdown-cart-list').niceScroll({
          //              cursorcolor: '#D7D7D7',
          //              cursoropacitymin: 0.3,
          //              cursorwidth: 6,
          //              autohidemode: false
          //            });
          //            $('.ge-dropdown-cart-list').getNiceScroll().resize();
          //            headerNavScroll();
          //          }
        }
      });
      $('.ge-dropdown--cart').mouseleave(function () {
        //        if (window.innerWidth > 992 && getDevice == 'other') {
        //          if (!$(this).find('.ge-dropdown-box').is(':hidden')) {
        //            $(this).find('.ge-dropdown-box').stop('true', 'true').fadeOut(0);
        //            $(this).stop().removeClass('is-active');
        //            headerNavScroll();
        //          }
        //        }
      });
      $(document).on('click', function (e) {
        if (!$(e.target).closest('.ge-dropdown').length && !$(e.target).closest('.ge-search').length && !$(e.target).hasClass('.c-modal') && !$(e.target).closest('.mfp-wrap').length) {
          if (window.innerWidth > 992) {
            //            var scrollpos = $('body').attr('data-scroll');
            //            $('html,body')
            //              .removeAttr('data-scroll')
            //              .removeClass('is-noscroll')
            //              .css({ top: 0 })
            //              .scrollTop(scrollpos);
          }
          $('.ge-dropdown').removeClass('is-active');
          $('.ge-dropdown-box').fadeOut();
        }
      });
    });
  },
  searchInit: function searchInit() {
    $(function () {
      //search open
      $('.ge-search-toggle').off('click').on('click', function () {
        var scrollpos;
        if ($('.ge-search').is(':hidden')) {
          var scrollpos = $(window).scrollTop();
          var scroll_bar = window.innerWidth - $(window).width();
          $('body').attr('data-scroll', scrollpos);
          $('body').addClass('is-noscroll').css({ top: -scrollpos });
          $('.ge-search').fadeIn();
          $('.slick-slider').slick('setPosition');
          $('.ge-search-close').css('padding-right', scroll_bar);
          if ($('.ge-search-results-list').length) {
            $('.ge-search').addClass('is-result');
          } else {
            $('.ge-search').removeClass('is-result');
          }
        }
        return false;
      });

      //search close
      $('.ge-search-close a').off('click').on('click', function () {
        var scrollpos = $('body').attr('data-scroll');
        $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
        $('.ge-search').fadeOut();
        $('.ge-search').removeClass('is-result');
        return false;
      });

      //search reset
      $('.ge-search-input .c-input-btn-reset').off('click').on('click', function () {
        $(this).closest('.ge-search-input').find('.c-input-box').attr('value', '');
        $(this).closest('.ge-search-input').find('.c-input-btn-search').prop('disabled', true);
        $(this).fadeOut();
        $(this).closest('.ge-search-input').find('.c-input-btn-search').fadeIn();
        return false;
      });

      $(window).on('load', function () {
        $('.ge-search-input').each(function () {
          var value = $(this).find('.c-input-box').val();
          if (value == '' && value != value) {
            $(this).find('.c-input-btn-reset').fadeOut();
            $(this).find('.c-input-btn-search').fadeIn();
          }
        });
      });
      $('.ge-search-input .c-input-box').on('change keypress keyup', function () {
        $('.ge-search-input').each(function () {
          var value = $(this).find('.c-input-box').val();
          $(this).find('.c-input-btn-reset').fadeOut();
          $(this).find('.c-input-btn-search').fadeIn();
        });
      });
      //search disabled
      $('input[type="search"]').on('change keypress keyup', function () {
        if ($(this).val() == '') {
          $(this).parent().find('.c-input-btn-search').prop('disabled', true);
        } else {
          $(this).parent().find('.c-input-btn-search').prop('disabled', false);
        }
      });
      matchHeightProducts();
    });
  },
  tmpRecentlyInit: function tmpRecentlyInit() {
    $(function () {
      $('.c-slider-recently').on('init', function () {
        $('.c-modal-inline').magnificPopup({
          type: 'inline',
          removalDelay: 500,
          preloader: false,
          fixedContentPos: true,
          callbacks: {
            open: function open() {
              $('.mfp-container').addClass('row');
              $('.mfp-content > div').addClass('row');
              $('.slick-slider').slick('setPosition');
              $('.c-slider-products-landscape').slick('setPosition');
              $('.c-slider-products-vertical').slick('setPosition');
              matchHeightProducts();
              $.magnificPopup.instance.close = function () {
                if (window.innerWidth < 992) {
                  var scrollpos = $('body').attr('data-scroll');
                  $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
                }
                $.magnificPopup.proto.close.call(this);
              };
            }
          }
        });
      });

      $('.c-slider-recently').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }]
      });
    });
  },
  tmpVideoInit: function tmpVideoInit() {
    $(function () {
      $('.c-slider-videocarousel').on('init', function () {
        $('.c-modal-video-fullscreen').each(function () {
          var link = $(this).attr('href');
          $(this).magnificPopup({
            type: 'iframe',
            removalDelay: 600,
            fixedContentPos: true,
            iframe: {
              patterns: {
                youtube: {
                  src: link
                }
              }
            },
            callbacks: {
              open: function open() {
                $('.mfp-container').addClass('row mfp-iframe-holder-fullscreen');
              }
            }
          });
        });
      });
      $('.c-slider-videocarousel').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        pauseOnHover: false,
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: true
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        }]
      });
    });
  },

  //WOW init
  wowInit: function wowInit() {
    $('template').each(function () {
      var $t = $(this),
          toId = $t.attr('data-forid'),
          inHtml = $t.html(),
          $box = $('#' + toId);

      if ($box.length) {
        $box.html(inHtml);
      }
    });

    $(function () {
      function wowstart() {
        if (window.innerWidth > 992) {
          //          new WOW().init();
        }
      }
      wowstart();
      var timer = false;
      var windowW = window.innerWidth;
      $(window).on('resize', function (e) {
        if (windowW != window.innerWidth) {
          if (timer !== false) {
            clearTimeout(timer);
          }
          timer = setTimeout(function () {
            wowstart();
          }, 200);
          windowW = window.innerWidth;
        }
      });
    });
  },

  commonInit: function commonInit() {
    //search
    this.searchInit();

    //header
    this.headerInit();

    //footer
    this.footerInit();

    //modal
    this.modalInit();

    //toggle select
    this.toggleSelectInit();

    //WOW init
    this.wowInit();

    if ($('.c-list-instagram01').length) {
      var accessToken = '2680730803.d5ced9a.da86b2583a87427e8818b35ad0b3af39';
      var count = 7; // 取得件数

      $.ajax({
        url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + accessToken + '&count=' + count,
        dataType: 'jsonp',
        success: function success(data) {
          var insert = '';
          for (var i = 0; i < data['data'].length; i++) {
            insert += "<li class='c-list-instagram01-item'>";
            insert += '<a  href="' + data['data'][i]['link'] + '" title="' + data['data'][i]['caption']['text'] + '" target="_blank">';
            insert += '<span style="background-image:url(' + data['data'][i]['images']['standard_resolution']['url'] + ')"></span>';
            insert += '</a>';

            insert += '</li>';
          }
          $('.c-list-instagram01').append(insert);
        }
      });
    }
    if ($('.c-list-instagram02').length) {
      var accessToken = '2680730803.d5ced9a.da86b2583a87427e8818b35ad0b3af39';
      var count = 3; // 取得件数

      $.ajax({
        url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + accessToken + '&count=' + count,
        dataType: 'jsonp',
        success: function success(data) {
          var insert = '';
          for (var i = 0; i < data['data'].length; i++) {
            insert += "<li class='c-list-instagram02-item'>";
            insert += '<a  href="' + data['data'][i]['link'] + '" title="' + data['data'][i]['caption']['text'] + '" target="_blank">';
            insert += '<span style="background-image:url(' + data['data'][i]['images']['standard_resolution']['url'] + ')"></span>';
            insert += '</a>';

            insert += '</li>';
          }
          $('.c-list-instagram02').append(insert);
        }
      });
    }

    $(function () {
      $('.c-underColumn-toggle >a ').off('click').on('click', function () {
        var main = $(this).closest('.c-underColumn').find('.c-underColumn-main'),
            side = $(this).closest('.c-underColumn').find('.c-underColumn-side');
        if (window.innerWidth < 767 || side.is(':hidden')) {
          main.hide();
          side.show();
        } else {
          main.show();
          side.hide();
        }
        return false;
      });
    });

    $(function () {
      //textarea count
      $('.c-textarea').keyup(function () {
        var txtcount = $(this).val().length,
            txtlimit = $(this).maxlength;
        $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtcount);
        if (txtcount == 0) {
          $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text('0');
        }
        if (txtcount >= txtlimit) {
          $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtlimit);
        }
      });

      $('.c-dlist-dropdown-link-toggle').off('click').on('click', function () {
        if ($(this).parent().next('dd').is(':hidden')) {
          $(this).parent().addClass('is-active');
          $(this).parent().next('dd').slideDown();
        } else {
          $(this).parent().removeClass('is-active');
          $(this).parent().next('dd').slideUp();
        }
        return false;
      });
      $('.c-dlist-dropdown > dt').off('click').on('click', function () {
        if ($(this).next('dd').is(':hidden')) {
          $(this).addClass('is-active');
          $(this).next('dd').slideDown();
          if ($(this).next('dd').find('.ge-dropdown-cart-list').length) {
            $('.ge-dropdown-cart-list').getNiceScroll().resize();
            $('.ge-dropdown-cart-list').niceScroll({
              cursorcolor: '#D7D7D7',
              cursoropacitymin: 0.3,
              cursorwidth: 6,
              autohidemode: false
            });
          }
        } else {
          $(this).removeClass('is-active');
          $(this).next('dd').slideUp();
          if ($(this).next('dd').find('.ge-dropdown-cart-list').length) {
            $('.ge-dropdown-cart-list').getNiceScroll().remove();
          }
        }
        return false;
      });
    });

    this.selectQuantityInit();

    // JavaScript Document
    var getDevice = function () {
      var ua = navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        return 'sp';
      } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
        return 'tab';
      } else {
        return 'other';
      }
    }();
    $(function () {
      $(document).on('click', "[href^='#']:not(.c-modal)" + "[href!='#']", scroll_func);
      $(document).on('click', '#pageTop', function () {
        scroll_func('top');
      });
    });

    $(function () {
      $("[href^='#']:not(.c-modal)" + "[href!='#']").off('click').on('click', function () {
        var headerH = $('.ge-header').height();
        var messageH = $('.ge-header-fixedMessage').height();
        var headerHight = headerH && messageH ? headerH + messageH : 0;
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = target.offset().top - headerHight;
        $('html, body').animate({ scrollTop: position }, 550, 'swing');
        return false;
      });
    });

    /* ページTOPへスクロール */
    var scroll_func = function scroll_func(top) {
      //      if (top == 'top') {
      //        $('html,body')
      //          .scrollTop(800)
      //          .stop()
      //          .animate({ scrollTop: 0 }, 'slow', 'easeOutQuart');
      //      } else {
      //        $('html,body').animate(
      //          { scrollTop: $($(this).attr('href')).offset().top },
      //          'slow',
      //          'easeOutQuart'
      //        );
      //      }
      return false;
    };
    /* /ページTOPへスクロール */

    var loading_func = function loading_func(mode) {
      if (mode == 'on') {
        $('.modLoading').remove();
        $('body').append('<div class="modLoading"><i class="fa fa-spinner fa-spin"></i></div>');
      }
      if (mode == 'off') {
        $('.modLoading').fadeOut(function () {
          $(this).remove();
        });
      }
    };

    //modLoadingに対するBack Forward Cache 対策
    window.onpageshow = function (event) {
      if (event.persisted) {
        var elements = document.getElementsByClassName('modLoading');
        var length = elements.length;
        if (length) {
          window.location.reload();
        }
      }
    };

    //    $(function () {
    //      $(window).on('load resize', function () {
    //        matchHeightAction();
    //      });
    //    });
    function matchHeightAction() {
      $('.js-height_01').matchHeight();
      $('.js-height_02').matchHeight();
      $('.js-height_03').matchHeight();
      $('.js-height_04').matchHeight();
      $('.js-height_05').matchHeight();
      $('.js-height_06').matchHeight();
      $('.js-height_07').matchHeight();
      $('.js-height_08').matchHeight();
      $('.js-height_09').matchHeight();
      $('.js-height_10').matchHeight();
    }

    $(function () {
      if ($('.js-top-carousel')[0]) {
        var isPC = function isPC() {
          return matchMediaPC.matches;
        };

        // sliderInit
        // YouTubeの埋め込み
        var onPlayerReady = function onPlayerReady(event) {
          event.target.mute();
          event.target.getPlaybackQuality('highres');
          sliderReady(event);
        };

        var onPlayerStateChange = function onPlayerStateChange(event) {
          if (event.data === YT.PlayerState.ENDED) {
            // $('.js-top-carousel').slick('slickNext');
          }
        };

        var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
          $('.js-top-carousel').find('.c-topCarousel-item').each(function (index) {
            var $el = $(this).find('.c-topCarousel-iframe-wrap');
            if ($el[0]) {
              $('.js-top-carousel').removeClass('is-loading');
              $el.attr('id', 'c-topCarousel-movieid' + index);
              movieList.push({
                index: index,
                videoId: $el.attr('data-yt-id')
              });
              ytPlayers.push('');
            }
          });

          if (movieList.length) {
            for (var i = 0; i < movieList.length; i++) {
              var playerVars = {
                // 'autoplay': 1,
                controls: 0,
                // 'loop': 1,
                // 'playlist': movieList[i].videoId,
                disablekb: 1,
                rel: 0,
                playsinline: 1
              };

              isSingleAndMovie = $('.js-top-carousel').find('.c-topCarousel-item').length === 1;

              if (isSingleAndMovie) {
                playerVars.playlist = movieList[i].videoId;
                playerVars.loop = 1;
              }

              var ytPlayer = new YT.Player('c-topCarousel-movieid' + movieList[i].index, {
                width: 640,
                height: 480,
                videoId: movieList[i].videoId,
                playerVars: playerVars,
                events: {
                  onReady: onPlayerReady,
                  onStateChange: onPlayerStateChange
                }
              });
              ytPlayers[movieList[i].index] = ytPlayer;
            }
          } else {
            sliderReady();
          }
        };

        var sliderReady = function sliderReady(event) {
          if (event && $(event.target.getIframe()).attr('id') === 'c-topCarousel-movieid0') {
            if (isPC() && ytPlayers[0] && ytPlayers[0].playVideo) {
              ytPlayers[0].playVideo();

              setTimeout(function () {
                $('.js-top-carousel').removeClass('is-loading');
                $('.js-top-carousel').addClass('is-loaded');
              }, 100);
            }
          } else {
            setTimeout(function () {
              $('.js-top-carousel').removeClass('is-loading');

              setTimeout(function () {
                $('.js-top-carousel').addClass('is-loaded');
              }, 2500);
            }, 500);
          }
          slideStart(null, 0);
        };

        var getBgMovieSize = function getBgMovieSize() {
          var aspectW = 16;
          var aspectH = 9;
          var videoRatio = (aspectW / aspectH).toFixed(2);
          var minWidth = window.innerWidth ? window.innerWidth : $(window).width();
          var minHeight = $(window).height() + 100;
          var widthRatio = minWidth / aspectW;
          var heightRatio = minHeight / aspectH;
          var size = {};
          if (widthRatio > heightRatio) {
            size.width = minWidth;
            size.height = Math.ceil(minWidth / videoRatio);
          } else {
            size.height = minHeight;
            size.width = Math.ceil(minHeight * videoRatio);
          }
          return size;
        };

        var sliderInit = function sliderInit() {
          $('.js-top-carousel').on('init', function (event, slick) {
            if (!$(slick.$slides[0]).find('.type-video')[0]) {
              $('.js-top-carousel').removeClass('is-loading');
            }
            if ($(slick.$slides[0]).find('.type-video')[0]) {
              $(slick.$slides[0]).addClass('is-wait');
            }

            matchMediaPC.addListener(function (e) {
              if (e.matches) {
                var index = $('.js-top-carousel').find('.slick-active').attr('data-slick-index');
                if (ytPlayers[index] && ytPlayers[index].playVideo) {
                  ytPlayers[index].playVideo();
                }
              } else {
                for (var i = 0; i < ytPlayers.length; i++) {
                  if (ytPlayers[i].stopVideo) {
                    ytPlayers[i].stopVideo();
                  }
                }
              }
            });
          });

          $('.js-top-carousel').slick({
            fade: true,
            infinite: true,
            dots: true,
            arrows: false
          });

          $('.js-top-carousel').find('.slick-dots').find('button').append('<span class="bar"></span>');

          $('.js-top-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {});

          $('.js-top-carousel').on('afterChange', function (event, slick, currentSlide) {
            slideStart(slick, currentSlide);
          });
        };

        var slideStart = function slideStart(slick, currentSlide) {
          clearTimeout(nextTimer);
          clearInterval(seekbarTimer);
          clearTimeout(loadingTimer);

          for (var i = 0; i < ytPlayers.length; i++) {
            if (ytPlayers[i].stopVideo) {
              ytPlayers[i].stopVideo();
            }
          }

          var $currentSlide = $('.js-top-carousel').find('.slick-slide[data-slick-index="' + currentSlide + '"]');

          // 動画コンテンツはすべてwait
          $('.js-top-carousel').find('.slick-slide').each(function () {
            if ($(this).find('.type-video')[0]) {
              if (isPC()) {
                $(this).addClass('is-wait');
              }
            }
          });

          // 動画が再生開始したらwait解除
          var loop = function loop() {
            if (ytPlayers[currentSlide] && ytPlayers[currentSlide].getPlayerState() === YT.PlayerState.PLAYING) {
              clearTimeout(loadingTimer);
              $currentSlide.removeClass('is-wait');
            }
            loadingTimer = setTimeout(loop, 50);
          };
          if (isPC()) {
            loop();
          } else {
            $currentSlide.removeClass('is-wait');
          }

          $('.js-top-carousel').find('.slick-dots').find('.bar').css('width', 0);

          if (ytPlayers[currentSlide] && isPC()) {
            ytPlayers[currentSlide].playVideo();
          }

          seekbarPlay($currentSlide, currentSlide);
        };

        var seekbarPlay = function seekbarPlay($currentSlide, currentSlide) {
          var cnt = 0;
          var step = 10;
          var subtract = 500;
          var $dotsBar = $('.js-top-carousel').find('.slick-dots').find('li').eq(currentSlide).find('.bar');

          seekbarTimer = setInterval(function () {
            var duration = carouselDuration;

            if (!$currentSlide.find('.type-video')[0] || !isPC()) {
              cnt += 10;
            } else {
              var movieDuration = ytPlayers[currentSlide].getDuration() * 1000 - subtract;
              duration = carouselDuration > movieDuration ? movieDuration : carouselDuration;
              cnt = ytPlayers[currentSlide].getCurrentTime() * 1000;
            }

            $dotsBar.css('width', cnt / duration * 100 + '%');

            if (duration > 0 && duration < cnt) {
              // 再生終了0.5秒前に次ぎスライドへ移動
              // 関連動画表示対処
              clearInterval(seekbarTimer);

              if (isSingleAndMovie) {
                slideStart(null, 0);
              } else {
                $('.js-top-carousel').slick('slickNext');
              }
            }
          }, 10);
        };

        var carouselDuration = 15000;
        var movieList = [];
        var ytPlayers = [];
        var nextTimer;
        var seekbarTimer;
        var loadingTimer;
        var isSingleAndMovie = false;
        window.ytPlayers = ytPlayers;

        var matchMediaPC = window.matchMedia('screen and (min-width: 1025px)');

        if (!isPC()) {
          $('.js-top-carousel').removeClass('is-loading');
        }

        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

        $(function () {
          var movieSize = getBgMovieSize();
          $('.type-video').each(function () {
            $(this).css(movieSize);
          });
          $(window).on('resize', function (e) {
            var movieSize = getBgMovieSize();
            $('.type-video').each(function () {
              $(this).css(movieSize);
            });
          });

          sliderInit();
        });
      }

      /*
      if ($('.js-fullscreen')[0] && $('.js-top-carousel')[0]) {
      	var interval = 200;
      	var last_time = 0;
      	var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
      	var isMoving = false;
      			$('.js-fullscreen').on(mousewheelevent, function(e) {
      		if (isMoving) {
      			return false;
      }
      				if(window.innerWidth > 1024 && $('.ge-search').is(':hidden')) {
      			var now = new Date().getTime();
      			if (now - last_time < interval) return;
      					var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
      			var scrollTop = $(window).scrollTop();
      			var mvHeight = $('.js-top-carousel').innerHeight();
      			var hHeight = $('#header').innerHeight();
      			var mHeight = 0;
      			var fixHeight = mvHeight - hHeight;
      			if($('.ge-header-fixedMessage')[0]) {
      				mHeight = $('.ge-header-fixedMessage').innerHeight();
      }
      					fixHeight = fixHeight - mHeight;
      					if (delta < 0){
      				if (scrollTop + 10 < fixHeight) {
      					isMoving = true;
      					if (scrollTop >= 5) {
      						$('html, body').stop().animate({scrollTop: fixHeight}, 1000, 'easeOutQuad', function() {
      							isMoving = false;
      			});
      		} else {
      			$('html, body').stop().animate({scrollTop: 5}, 450, 'easeOutQuad', function() {
      				hHeight = $('#header').innerHeight();
      				fixHeight = mvHeight - hHeight - mHeight;
      				$('html, body').stop().animate({scrollTop: fixHeight}, 1000, 'easeOutQuad', function() {
      					isMoving = false;
      				});
      			});
      		}
      		last_time = now;
      		return false;
      	}
      } else {
      	if (scrollTop <= fixHeight) {
      		isMoving = true;
      		$('html, body').stop().animate({scrollTop: 0}, 1000, 'easeOutQuad', function() {
      			isMoving = false;
      		});
      		last_time = now;
      		return false;
      	}
      }
      }
      });
      }
      */
    });

    $(function () {
      $('.c-block-fullscreenModules--overlay .img source').each(function () {
        var srcset = $(this).attr('srcset');
        $(this).closest('.img').css('background-image', 'url(' + srcset + ')').addClass('isFinish');
      });

      if ($('.js-fullscreen')[0] && $('.c-block-fullscreenModules--overlay')[0] && $('.c-block-fullscreenModules--overlay-blanc-block')[0]) {
        var timer;
        var index = 0;
        var interval = 200;
        var last_time = 0;
        var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
        var isMoving = false;

        $('.js-fullscreen').on(mousewheelevent, function (e) {
          if (isMoving) {
            return;
          }

          //          if (window.innerWidth > 992 && $('.ge-search').is(':hidden')) {
          //            var now = new Date().getTime();
          //            if (now - last_time > interval) {
          //              var delta = e.originalEvent.deltaY
          //                ? -e.originalEvent.deltaY
          //                : e.originalEvent.wheelDelta
          //                ? e.originalEvent.wheelDelta
          //                : -e.originalEvent.detail;
          //              var scrollTop = $(window).scrollTop();
          //              var wHeight = window.innerHeight;
          //              var vHeight = $(
          //                '.c-block-fullscreenModules--overlay'
          //              ).innerHeight();
          //              var hHeight = $('#header').innerHeight();
          //              var vTop = $('.c-block-fullscreenModules--overlay').offset().top;
          ////              var nTop = $('.c-block-fullscreenModules--overlay-blanc-block')
          ////                .next()
          ////                .offset().top;
          //              if ($('.ge-header-fixedMessage').length) {
          //                var mHeight = $('.ge-header-fixedMessage').innerHeight();
          //                var pos = nTop + hHeight + mHeight;
          //              } else {
          //                var pos = nTop + hHeight;
          //              }

          /*
          if (delta < 0){
          if(scrollTop < nTop ) {
          isMoving = true;
          $("html,body").stop().animate({scrollTop:nTop + 5},1000,"easeOutQuad", function() {
          isMoving = false;
          });
          return false;
          }
          } else {
          if(1 < scrollTop && scrollTop < pos ) {
          isMoving = true;
          $("html,body").stop().animate({scrollTop:0},1000,"easeOutQuad", function() {
          isMoving = false;
          });
          return false;
          }
          }
          */
          //              if (scrollTop > nTop) {
          //                $('.c-block-fullscreenModules--overlay')
          //                  .css({
          //                    'z-index': -2,
          //                    opacity: 0,
          //                    display: 'none'
          //                  })
          //                  .addClass('is-hidden');
          //              } else {
          //                $('.c-block-fullscreenModules--overlay')
          //                  .css({
          //                    'z-index': 0,
          //                    opacity: 1,
          //                    display: 'block'
          //                  })
          //                  .removeClass('is-hidden');
          //              }
          //            }
          //            last_time = now;
          //          }
        });

        $(window).on('load scroll resize', function (e) {
          if ($('.js-fullscreen').length) {
            if (window.innerWidth > 992) {
              //              var scrollTop = $(window).scrollTop();
              //              var wHeight = window.innerHeight;
              //              var vHeight = $(
              //                '.c-block-fullscreenModules--overlay'
              //              ).innerHeight();
              //              var hHeight = $('#header').innerHeight();
              //              var vTop = $('.c-block-fullscreenModules--overlay').offset().top;
              //              var nTop = $('.c-block-fullscreenModules--overlay-blanc-block')
              //                .next()
              //                .offset().top;
              //              if ($('.ge-header-fixedMessage').length) {
              //                var mHeight = $('.ge-header-fixedMessage').innerHeight();
              //                var pos = nTop + hHeight + mHeight;
              //              } else {
              //                var pos = nTop + hHeight;
              //              }
              //              if (scrollTop > nTop) {
              //                $('.c-block-fullscreenModules--overlay')
              //                  .css({
              //                    'z-index': -2,
              //                    opacity: 0,
              //                    display: 'none'
              //                  })
              //                  .addClass('is-hidden');
              //              } else {
              //                $('.c-block-fullscreenModules--overlay')
              //                  .css({
              //                    'z-index': 0,
              //                    opacity: 1,
              //                    display: 'block'
              //                  })
              //                  .removeClass('is-hidden');
              //              }
            }
          }
        });
      }
    });

    $(function () {
      var targetList, list, visiblelist;

      function btnCheck() {
        list = $('.js-order-list .js-order-list-item').length, visiblelist = $('.js-order-list .js-order-list-item:visible').length;
        if (visiblelist >= list) {
          $('.js-order-btn').hide();
        }
      }
      $('.js-order-btn-more').off('click').on('click', function () {
        var i = 0,
            list = $('.js-order-list .js-order-list-item').length,
            visiblelist = $('.js-order-list .js-order-list-item:visible').length,
            btnT = $('.js-order-btn').offset().top,
            winT = $(window).scrollTop();
        console.log(winT);
        $('.js-order-list .js-order-list-item:hidden').eq(i).fadeIn();
        i++;
        btnCheck();
        $('html, body').animate({ scrollTop: winT }, 0, 'swing');
        return false;
      });

      $('.js-order-btn-all').off('click').on('click', function () {
        var i = 0,
            list = $('.js-order-list .js-order-list-item').length,
            visiblelist = $('.js-order-list .js-order-list-item:visible').length,
            btnT = $('.js-order-btn').offset().top,
            winT = $(window).scrollTop();
        $('.js-order-list .js-order-list-item:hidden').fadeIn();
        btnCheck();
        var listH = $('.js-order-list'),
            position = btnT + listH;
        if (window.innerWidth > 767) {
          $('html, body').animate({ scrollTop: position }, 0, 'swing');
        }
        $('html, body').animate({ scrollTop: winT }, 0, 'swing');
        return false;
      });
    });

    $(function () {
      function scrollbarStyleChange() {
        $(document).ready(function () {
          if (getDevice == 'other') {
            setTimeout(function () {
              $('.c-textarea--smartScroll').niceScroll({
                cursorcolor: '#D7D7D7',
                cursoropacitymin: 0.3,
                cursorwidth: 6,
                autohidemode: false
              });
            }, 50);
          } else {
            $('.c-textarea--smartScroll').attr('style', 'overflow-y: auto;');
          }
        });
      }

      scrollbarStyleChange();
      $(window).on('resize', function () {
        if (getDevice == 'other') {
          scrollbarStyleChange();
        }
      });
    });
  },
  pdpInit: function pdpInit() {
    $(function () {
      //AUTO-REPLENISHMENT
      $('.js-autoreplenishment').change(function () {
        if ($(this).is(':checked')) {
          $(this).closest('li').find('.js-autoreplenishment-text').fadeIn();
        } else {
          $(this).closest('li').find('.js-autoreplenishment-text').fadeOut();
        }
      });
    });

    $(function () {
      function videoControl(action, target) {
        if ($('.c-slider-rich-video').find('iframe').length) {
          var currentSlide = target.find('.slick-current');
          var iframe = $('iframe', currentSlide);
          var $playerWindow = iframe[0].contentWindow;
          $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
        }
      }

      $('.c-slider-rich-video').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        slick = $(slick.$slider);
        videoControl('playVideo', slick);
      });

      $('.c-slider-rich-video').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        slick = $(slick.$slider);
        videoControl('stopVideo', slick);
      });

      $('.c-slider-rich-video').each(function (i) {
        $(this).addClass('c-slider-rich-video' + i);
        $('.c-slider-rich-video' + i).on('init', function () {
          $(this).find('.c-modal-video').each(function () {
            var link = $(this).attr('href');
            console.log(link);
            $(this).find('.c-modal-video').magnificPopup({
              type: 'iframe',
              removalDelay: 600,
              fixedContentPos: true,
              iframe: {
                patterns: {
                  youtube: {
                    src: link
                  }
                }
              },
              callbacks: {
                open: function open() {
                  $('.mfp-container').addClass('row');
                  $.magnificPopup.instance.close = function () {
                    if (window.innerWidth < 992) {
                      var scrollpos = $('body').attr('data-scroll');
                      $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
                    }
                    $.magnificPopup.proto.close.call(this);
                  };
                }
              }
            });
          });
        });
        $('.c-slider-rich-video' + i).not('.slick-initialized').slick({
          centerMode: true,
          centerPadding: '17.5%',
          arrows: false,
          slidesToShow: 1,
          asNavFor: '.c-slider-rich-description' + i,
          variableWidth: true,
          responsive: [{
            breakpoint: 992,
            settings: {
              centerPadding: '20%',
              variableWidth: false
            }
          }, {
            breakpoint: 767,
            settings: {
              centerPadding: '10%',
              variableWidth: false
            }
          }]
        });
      });
      $('.c-slider-rich-description').each(function (i) {
        $(this).addClass('c-slider-rich-description' + i);
        $('.c-slider-rich-description' + i).not('.slick-initialized').slick({
          asNavFor: '.c-slider-rich-video' + i,
          touchMove: false
        });
      });
    });

    $(function () {
      if ($('.c-block-shoppingDock').length) {
        var shoppingDockHide = function shoppingDockHide() {
          $('.c-block-shoppingDock').hide();
        };

        var shoppingDockShow = function shoppingDockShow() {
          $('.c-block-shoppingDock').fadeIn();
        };

        shoppingDockHide();
        $(window).scroll(function () {
          var winT = $(window).scrollTop();
          var winH = $(window).height();
          var varH = $('.c-block-shoppingDock').innerHeight();
          var varTop = $('.c-block-shoppingDock').offset().top;
          var varPos = varH + varTop;
          var footT = $('#footer').offset().top;
          if (winT > 100) {
            shoppingDockShow();
          } else {
            shoppingDockHide();
          }
          if (varPos >= footT) {
            $('.c-block-shoppingDock').addClass('nofixed');
          } else {
            $('.c-block-shoppingDock').removeClass('nofixed');
          }
        });
      }
    });

    $(function () {
      function sliderMobile() {
        var width = window.innerWidth;
        if (width <= 767) {
          $('.c-slider-mobile').not('.slick-initialized').slick({
            arrows: false,
            dots: true
          });
        } else {
          $('.c-slider-mobile.slick-initialized').slick('unslick');
        }
      }
      sliderMobile();
      $(window).resize(function () {
        sliderMobile();
      });

      var timer;
      function sliderMobileArrow() {
        var width = window.innerWidth;
        if (width <= 767) {
          $('.c-block-richcontent01-content-list').not('.slick-initialized').slick({
            arrows: true
          });
          sliderArrowPositionSet();
        } else {
          $('.c-block-richcontent01-content-list.slick-initialized').slick('unslick');
        }
      }
      function sliderArrowPositionSet() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          $('.c-block-richcontent01-content-list').each(function () {
            var $_t = $(this);
            var $photo = $_t.find('.slick-active').find('.c-block-richcontent01-content-list-item').find('.photo');
            var $arrow = $_t.find('.slick-arrow');
            if ($arrow[0] && $photo[0]) {
              var top = $photo.position().top;
              var height = $photo.height();
              var center = top + height / 2;
              $arrow.css({
                top: center
              });
            }
          });
        }, 100);
      }
      sliderMobileArrow();
      $(window).on('load', function () {
        if (window.innerWidth <= 767) {
          sliderArrowPositionSet();
        }
      });
      $(window).on('resize', function () {
        sliderMobileArrow();
      });
    });
    $(function () {
      $('.c-slider-fullscreenModulesImage').not('.slick-initialized').slick({
        asNavFor: '.c-slider-fullscreenModulesList',
        arrows: false
      });
      $('.c-slider-fullscreenModulesList').not('.slick-initialized').slick({
        asNavFor: '.c-slider-fullscreenModulesImage'
      });

      if ($('.c-slider-products-vertical').length > 0) {
        $('.c-slider-products-landscape').not('.slick-initialized').slick({
          asNavFor: '.c-slider-products-vertical',
          arrows: false,
          responsive: [{
            breakpoint: 991,
            settings: {
              dots: true
            }
          }]
        });
      } else {
        $('.c-slider-products-landscape').not('.slick-initialized').slick();
      }
    });
    $(function () {
      $('.c-slider-products-vertical').on('init', function () {
        $('.c-modal-img').magnificPopup({
          type: 'image',
          removalDelay: 500,
          fixedContentPos: true,
          callbacks: {
            open: function open() {
              $('.mfp-container').addClass('row');
              $.magnificPopup.instance.close = function () {
                if (window.innerWidth < 992) {
                  var scrollpos = $('body').attr('data-scroll');
                  $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ top: 0 }).scrollTop(scrollpos);
                }
                $.magnificPopup.proto.close.call(this);
              };
            }
          }
        });
        if ($(this).find('.c-block-shopingmodal-change-image').length < 5) {
          $(this).addClass('is-nobutton');
        }
      });
      if ($('.c-slider-products-vertical').hasClass('is-standard')) {
        var thumbnail = 3;
      } else {
        var thumbnail = 5;
      }
      $('.c-slider-products-vertical').not('.slick-initialized').slick({
        asNavFor: '.c-slider-products-landscape',
        vertical: true,
        verticalSwiping: true,
        slidesToShow: thumbnail,
        focusOnSelect: true
      });
      $('.c-slider-products-landscape').on('afterChange', function (event, slick, currentSlide) {
        $('.c-slider-products-vertical').find('.slick-current').removeClass('slick-current');
        $('.c-slider-products-vertical').find('.slick-slide').eq(currentSlide).addClass('slick-current');
      });
    });

    $(function () {
      //SHARE
      $('.c-block-share-toggle').off('click').on('click', function () {
        if ($(this).closest('.c-block-share').find('.c-block-share-box').is(':hidden')) {
          $(this).closest('.c-block-share').find('.c-block-share-box').fadeIn().removeClass('mfp-hide');
        } else {
          $(this).closest('.c-block-share').find('.c-block-share-box').fadeOut(function () {
            $(this).addClass('mfp-hide');
          });
        }
        if (window.innerWidth >= 767) {
          return false;
        }
      });
      $('.c-block-share-close').off('click').on('click', function () {
        $(this).closest('.c-block-share').find('.c-block-share-box').fadeOut(function () {
          $(this).addClass('mfp-hide');
        });
        return false;
      });
      $(document).on('click touchstart', function (e) {
        if (!$(e.target).closest('.c-block-share-box').length) {
          if (window.innerWidth >= 767) {
            if ($('.c-block-share-box').is(':visible')) {
              $('.c-block-share-box').fadeOut(function () {
                $(this).addClass('mfp-hide');
              });
            }
          }
        }
      });
      //textarea count
      $('.c-textarea').keyup(function () {
        var txtcount = $(this).val().length,
            txtlimit = $(this).attr('maxlength'),
            txtDown = txtlimit - txtcount;
        $(this).closest('.c-textarea-box').find('.c-textarea-count:not(.js-countDown) .countnow').text(txtcount);
        $(this).closest('.c-textarea-box').find('.c-textarea-count.js-countDown .countlimit').text(txtDown);
        if (txtcount == 0) {
          $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text('0');
        }
        if (txtcount >= txtlimit) {
          $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtlimit);
        }
      });
      // Cut out character string of textarea when above limitting text is submited.
      $('button#sendBtn').on('mousedown', function () {
        var textareaElm = $('.c-textarea');
        if (textareaElm.length > 0 && textareaElm.val().length > textareaElm[0].dataset.characterLimit) {
          textareaElm.val(textareaElm.val().substr(0, textareaElm[0].dataset.characterLimit));
        }
      });

      //AUTO-REPLENISHMENT
      $('.js-autoreplenishment').change(function () {
        if ($(this).is(':checked')) {
          $(this).closest('li').find('.js-autoreplenishment-text').fadeIn();
        } else {
          $(this).closest('li').find('.js-autoreplenishment-text').fadeOut();
        }
      });
    });
    $(function () {
      $('.c-underColumn-toggle >a ').on('click', function () {
        var main = $(this).closest('.c-underColumn').find('.c-underColumn-main'),
            side = $(this).closest('.c-underColumn').find('.c-underColumn-side');
        if (window.innerWidth < 767 || side.is(':hidden')) {
          main.hide();
          side.show();
        } else {
          main.show();
          side.hide();
        }
        return false;
      });
    });
    $(function () {
      $('.c-dlist_01 dt').off('click').on('click', function () {
        if (window.innerWidth < 991) {
          if ($(this).next('dd').is(':hidden')) {
            $(this).addClass('is-active');
            $(this).next('dd').slideDown();
          } else {
            $(this).removeClass('is-active');
            $(this).next('dd').slideUp();
          }
        }
        return false;
      });
      $('.c-dlist-dropdown-link-toggle').on('click', function () {
        if ($(this).parent().next('dd').is(':hidden')) {
          $(this).parent().addClass('is-active');
          $(this).parent().next('dd').slideDown();
        } else {
          $(this).parent().removeClass('is-active');
          $(this).parent().next('dd').slideUp();
        }
        return false;
      });
      $('.c-dlist-dropdown > dt').on('click', function () {
        if ($(this).next('dd').is(':hidden')) {
          $(this).addClass('is-active');
          $(this).next('dd').slideDown();
        } else {
          $(this).removeClass('is-active');
          $(this).next('dd').slideUp();
        }
        return false;
      });
    });
    $(function () {
      if ($('.c-block-shoppingDock').length) {
        var shoppingDockHide = function shoppingDockHide() {
          $('.c-block-shoppingDock').hide();
        };

        var shoppingDockShow = function shoppingDockShow() {
          $('.c-block-shoppingDock').fadeIn();
        };

        shoppingDockHide();
        $(window).scroll(function () {
          var winT = $(window).scrollTop();
          var winH = $(window).height();
          var varH = $('.c-block-shoppingDock').innerHeight();
          var varTop = $('.c-block-shoppingDock').offset().top;
          var varPos = varH + varTop;
          var footT = $('#footer').offset().top;
          if (winT > 100) {
            shoppingDockShow();
          } else {
            shoppingDockHide();
          }
          if (varPos >= footT) {
            $('.c-block-shoppingDock').addClass('nofixed');
          } else {
            $('.c-block-shoppingDock').removeClass('nofixed');
          }
        });
      }
    });

    $(function () {
      if ($('.c-block-lineBox').length) {
        var t = function t() {
          $('.c-block-lineBox-wrapper').find('.c-block-lineBox').each(function (e) {
            var t = $(this).offset().top,
                i = ($(this).index(), $(this).children('.c-block-lineBox-circle').offset().top);
            o.push(t), n.push(i);
          }), $('.c-block-lineBox-circleMove').css('top', n[0] + 'px');
        };

        var e,
            o = [],
            n = [],
            s = $(window).scrollTop(),
            r = 0;

        t(), $(window).on('load resize', function () {
          t();
        }), $(window).on('scroll', function () {
          i();
        });
        var i = function i() {
          clearTimeout(e), e = setTimeout(function () {
            var e = $(window).scrollTop(),
                t = $(window).height(),
                i = ($('#header').innerHeight(), []);
            $('.c-block-lineBox').each(function (e) {
              var t = $(this);
              i[e] = t.find('.c-block-lineBox-circle').offset().top;
            }), e < s ? i[r - 1] >= e && ($('.c-block-lineBox-circleMove').stop().css('top', i[r - 1] + 'px'), $('.c-block-lineBox').children('.c-block-lineBox-circle').removeClass('is-active is-first'), $('.c-block-lineBox').eq(r - 1).children('.c-block-lineBox-circle').addClass('is-active'), 0 != r && r--) : i[r + 1] < e + t - t / 5 && ($('.c-block-lineBox-circleMove').stop().css('top', i[r + 1] + 'px'), $('.c-block-lineBox').children('.c-block-lineBox-circle').removeClass('is-active is-first'), $('.c-block-lineBox').eq(r + 1).children('.c-block-lineBox-circle').addClass('is-active'), r++), s = e;
          }, 30);
        };
      }
    }), $(function () {
      $('.js-giftcardbalancemodal-send').on('click', function () {
        if ($('.c-block-giftcardbalance-block-send').length) {
          $('.c-block-giftcardbalance-block-send').hide();
          $('.c-block-giftcardbalance-block-receive').show();
        }
        return false;
      });
    });

    // JavaScript Document
    $(function () {
      $(document).on('click', "[href^='#']:not(.c-modal)" + "[href!='#']", scroll_func);
      $(document).on('click', '#pageTop', function () {
        scroll_func('top');
      });
    });

    $(function () {
      $("[href^='#']:not(.c-modal)" + "[href!='#']").on('click', function () {
        var headerH = $('.ge-header').height();
        var messageH = $('.ge-header-fixedMessage').height();
        var headerHight = headerH + messageH;
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        if (target[0]) {
          var position = target.offset().top - headerHight;
          // $('html, body').animate({ scrollTop: position }, 550, 'swing');
          return false;
        }
      });
    });

    /* ページTOPへスクロール */
    var scroll_func = function scroll_func(top) {
      if (top == 'top') {
        $('html,body').scrollTop(800).stop().animate({ scrollTop: 0 }, 'slow', 'easeOutQuart');
      } else {
        var $target = $($(this).attr('href'));
        if ($target[0]) {
          $('html,body').animate({ scrollTop: $target.offset().top }, 'slow', 'easeOutQuart');
        }
      }
      return false;
    };
    /* /ページTOPへスクロール */

    var loading_func = function loading_func(mode) {
      if (mode == 'on') {
        $('.modLoading').remove();
        $('body').append('<div class="modLoading"><i class="fa fa-spinner fa-spin"></i></div>');
      }
      if (mode == 'off') {
        $('.modLoading').fadeOut(function () {
          $(this).remove();
        });
      }
    };

    //modLoadingに対するBack Forward Cache 対策
    window.onpageshow = function (event) {
      if (event.persisted) {
        var elements = document.getElementsByClassName('modLoading');
        var length = elements.length;
        if (length) {
          window.location.reload();
        }
      }
    };

    $(function () {
      function btnCheck() {
        list = $('.js-order-list .js-order-list-item').length, visiblelist = $('.js-order-list .js-order-list-item:visible').length;
        if (visiblelist >= list) {
          $('.js-order-btn').hide();
        }
      }
      $('.js-order-btn-more').on('click', function () {
        var i = 0,
            list = $('.js-order-list .js-order-list-item').length,
            visiblelist = $('.js-order-list .js-order-list-item:visible').length;
        $('.js-order-list .js-order-list-item:hidden').eq(i).fadeIn();
        i++;
        btnCheck();
        return false;
      });

      $('.js-order-btn-all').on('click', function () {
        var i = 0,
            list = $('.js-order-list .js-order-list-item').length,
            visiblelist = $('.js-order-list .js-order-list-item:visible').length;
        $('.js-order-list .js-order-list-item:hidden').fadeIn();
        btnCheck();
        return false;
      });
    });
    $(function () {
      if ($('#topics-video').length) {
        var resizeMovie = function resizeMovie() {
          var adjustWidth = $(window).width();
          var adjustHeight = $(window).height();
          if (adjustHeight > adjustWidth / movieRatio) {
            adjustWidth = adjustHeight * movieRatio;
          }
          $('#topics-video').css({
            width: adjustWidth * 1.4,
            height: adjustWidth / movieRatio * 1.4
          });
          // console.log(w, h, mw, mh);
        };

        var onPlayerReady = function onPlayerReady(event) {
          $('#topics-video').fadeIn(1000);
          player.setVolume(0);
        };

        var onPlayerStateChange = function onPlayerStateChange(event) {
          if (event.data == YT.PlayerState.ENDED) {
            player.playVideo();
            player.setVolume(0);
          }
        };

        $('body').append('<script src="https://www.youtube.com/iframe_api">');
        $('#topics-video').hide();
        $(window).on('load resize', function () {
          if (navigator.userAgent.indexOf(/iPhone/) > 0 || navigator.userAgent.indexOf(/iPad/) > 0 || navigator.userAgent.indexOf(/Android/) > 0 || navigator.userAgent.indexOf('Mobile') > 0) {
            $('#topics-video').remove();
          }
        });
        var player;
        var movieRatio = 16 / 9;

        resizeMovie();
        $(window).resize(resizeMovie);

        var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
          var _playerVars;

          player = new YT.Player('topics-video', {
            videoId: '2uK6I6R6yVw',
            playerVars: (_playerVars = {
              autoplay: 1,
              version: 3,
              controls: 0,
              playlist: 'Fm-DQAE5vWM',
              enablejsapi: 1,
              iv_load_policy: 3,
              modestbranding: 1,
              disablekb: 1,
              showinfo: 0,
              rel: 0,
              start: 0
            }, _defineProperty(_playerVars, 'iv_load_policy', 3), _defineProperty(_playerVars, 'start', 6), _playerVars),
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange
            }
          });
        };
        window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
      }
    });

    $(function () {
      $(document).on('load scroll', function () {
        if ($('.synactif-fixedNavi').length) {
          var scroll = $(window).scrollTop();
          if (scroll >= 1) {
            $('.synactif-fixedNavi').show();
          } else {
            $('.synactif-fixedNavi').hide();
          }
        }
      });
      $('.synactif-fixedNavi-list-item-dropdown-toggle').off('click').on('click', function () {
        if ($(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').is(':hidden')) {
          $(this).addClass('is-active');
          $(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').slideDown();
        } else {
          $(this).removeClass('is-active');
          $(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').slideUp();
        }
        return false;
      });
      $('.synactif-fixedNavi-toggle a').off().on('click', function () {
        if ($(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').is(':hidden')) {
          $(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').slideDown();
        } else {
          $(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').slideUp();
        }
        return false;
      });
      $(document).on('click', function (e) {
        if (!$(e.target).closest('.synactif-fixedNavi').length && window.innerWidth < 992) {
          $('.synactif-fixedNavi-list').fadeOut();
        }
      });
    });

    $(function () {
      $('.js-appointment-next').on('click', function () {
        if ($(this).closest('.appointment-block').next('.appointment-block').is(':hidden')) {
          $(this).closest('.appointment-block').hide();
          $(this).closest('.appointment-block').next('.appointment-block').show();
          var headerH = $('.ge-header').height();
          var position = $(this).closest('.appointment-block').next('.appointment-block').offset().top - headerH;
          $('html, body').animate({ scrollTop: position }, 550, 'swing');
        }
        return false;
      });
      $('.js-appointment-select').on('change click', function () {
        if ($(this).closest('.appointment-block').next('.appointment-block').is(':hidden')) {
          $(this).closest('.appointment-block').hide();
          $(this).closest('.appointment-block').next('.appointment-block').show();
          var headerH = $('.ge-header').height();
          var position = $(this).closest('.appointment-block').next('.appointment-block').offset().top - headerH;
          $('html, body').animate({ scrollTop: position }, 550, 'swing');
        }
      });
      $('.js-appointment-prev').on('click', function () {
        if ($(this).closest('.appointment-block').prev('.appointment-block').is(':hidden')) {
          $(this).closest('.appointment-block').hide();
          $(this).closest('.appointment-block').prev('.appointment-block').show();
          var headerH = $('.ge-header').height();
          var position = $(this).closest('.appointment-block').prev('.appointment-block').offset().top - headerH;
          $('html, body').animate({ scrollTop: position }, 550, 'swing');
        }
        return false;
      });

      $('.js-appointment-calendar .day:not(.dayOff)').on('click', function () {
        $('.js-appointment-calendar .day:not(.dayOff)').removeClass('is-active');
        $(this).addClass('is-active');
        if ($('.js-appointment-time').is(':hidden')) {
          $('.js-appointment-time').show();
        }
      });
    });

    $(function () {
      $('.js-checkout-ApplyGiftcard-toggle').on('click', function () {
        $(this).hide();
        $(this).next('a').show();
        $('.js-checkout-ApplyGiftcard-box').slideDown();
        return false;
      });
    });
  },
  clockInit: function clockInit() {
    $(function () {
      $('#clockArea').each(function () {
        function showClock() {
          var nowTime = new Date();
          var nowHour = nowTime.getHours();
          // padding 0
          var nowMin = ('0' + nowTime.getMinutes()).slice(-2);
          var nowSec = ('0' + nowTime.getSeconds()).slice(-2);
          $('#clockArea').text(nowHour + ':' + nowMin + ':' + nowSec);
        }

        setInterval(showClock, 1000);

        // do only once if selector exists.
        return false;
      });
    });
  }
};

function matchHeightProducts() {
  if ($('.c-product-cards-step-header').length) {
    $('.c-product-cards-list .c-product-cards-step-header').matchHeight();
  }
  if ($('.c-product-cards-list .c-product-cards-list-item').length) {
    $('.c-product-cards-list .c-product-cards-list-item').matchHeight();
  }
}

module.exports = design;

},{}],12:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
  /**
   * @function
   * @description Appends a dialog to a given container (target)
   * @param {Object} params  params.target can be an id selector or an jquery object
   */
  create: function create(params) {
    var $target, id;

    if (_.isString(params.target)) {
      if (params.target.charAt(0) === '#') {
        $target = $(params.target);
      } else {
        $target = $('#' + params.target);
      }
    } else if (params.target instanceof jQuery) {
      $target = params.target;
    } else {
      $target = $('#dialog-container');
    }

    // if no element found, create one
    if ($target.length === 0) {
      if ($target.selector && $target.selector.charAt(0) === '#') {
        id = $target.selector.substr(1);
        $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
      }
    }

    // create the dialog
    this.$container = $target;
    this.$container.dialog(_.merge({}, this.settings, params.options || {}));
  },
  /**
   * @function
   * @description Opens a dialog using the given url (params.url) or html (params.html)
   * @param {Object} params
   * @param {Object} params.url should contain the url
   * @param {String} params.html contains the html of the dialog content
   */
  open: function open(params) {
    // close any open dialog
    this.close();
    this.create(params);
    this.replace(params);
  },
  /**
   * @description populate the dialog with html content, then open it
   **/
  openWithContent: function openWithContent(params) {
    var content, position, callback;

    if (!this.$container) {
      return;
    }
    content = params.content || params.html;
    if (!content) {
      return;
    }
    this.$container.empty().html(content);
    if (!this.$container.dialog('isOpen')) {
      this.$container.dialog('open');
    }

    if (params.options) {
      position = params.options.position;
    }
    if (!position) {
      position = this.settings.position;
    }
    imagesLoaded(this.$container).on('done', function () {
      this.$container.dialog('option', 'position', position);
    }.bind(this));

    callback = typeof params.callback === 'function' ? params.callback : function () {};
    callback();
  },
  /**
   * @description Replace the content of current dialog
   * @param {object} params
   * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
   * @param {string} params.html - If no url property is provided, use html provided to replace
   */
  replace: function replace(params) {
    if (!this.$container) {
      return;
    }
    if (params.url) {
      params.url = util.appendParamToURL(params.url, 'format', 'ajax');
      ajax.load({
        url: params.url,
        data: params.data,
        callback: function (response) {
          params.content = response;
          this.openWithContent(params);
        }.bind(this)
      });
    } else if (params.html) {
      this.openWithContent(params);
    }
  },
  /**
   * @function
   * @description Closes the dialog
   */
  close: function close() {
    if (!this.$container) {
      return;
    }
    this.$container.dialog('close');
  },
  exists: function exists() {
    return this.$container && this.$container.length > 0;
  },
  isActive: function isActive() {
    return this.exists() && this.$container.children.length > 0;
  },
  settings: {
    autoOpen: false,
    height: 'auto',
    modal: true,
    overlay: {
      opacity: 0.5,
      background: 'black'
    },
    resizable: false,
    title: '',
    width: '800',
    close: function close() {
      $(this).dialog('close');
    },
    position: {
      my: 'center',
      at: 'center',
      of: window,
      collision: 'flipfit'
    }
  }
};

module.exports = dialog;

},{"./ajax":1,"./util":77,"imagesloaded":110,"lodash":111}],13:[function(require,module,exports){
'use strict';

var util = require('./util');

function countrySelector() {
  $('.countries-selector').on('change', function (e) {
    e.preventDefault();

    var countrySelected = $(this).find(':selected').text().toLowerCase();
    if (countrySelected == 'us' || countrySelected == 'united states') {
      return false;
    }

    var countryUrl = countrySelected.indexOf('other') >= 0 ? Urls.countrySelectorUrl : $(this).find(':selected').val();

    if (window.open(countryUrl, '_blank') == null) {
      document.location.href = countryUrl;
    }
  });
}

exports.countrySelector = countrySelector;

},{"./util":77}],14:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, pin, callback) {
  // load gift certificate details
  ajax.getJson({
    url: util.appendParamsToUrl(Urls.giftCardCheckBalance, {
      giftCertCode: id,
      giftCertPIN: pin
    }),
    callback: callback
  });
};

},{"./ajax":1,"./util":77}],15:[function(require,module,exports){
'use strict';

var util = require('./util');
var giftcert = require('./giftcert');
var modal = require('./modal').global;
var validator = require('./validator');

function updateCart() {
  $('#AddToBasketButton').on('click', function () {
    $('#GiftCertificateForm').submit();
  });
}

exports.init = function () {
  $('.gift-cert-edit').on('click', function (e) {
    e.preventDefault();

    modal.addCustomClass('edit-modal quickview-modal');
    modal.renderByUrl($(this).attr('href'));
    modal.setCallback(function () {
      updateCart();
      giftcert.init();
      util.limitCharacters();
      validator.initForm('form#GiftCertificateForm');
    });
  });
};

exports.initModal = function () {
  updateCart();
  giftcert.init();
  util.limitCharacters();
  validator.initForm('form#GiftCertificateForm');
};

},{"./giftcert":16,"./modal":24,"./util":77,"./validator":78}],16:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util'),
    design = require('./design');

var setAddToCartHandler = function setAddToCartHandler(e) {
  e.preventDefault();
  if ($('.termsandconditions').hasClass('error')) {
    return false;
  }

  if ($('input').hasClass('is-error') || $('textarea').hasClass('is-error')) {
    return false;
  }

  setGiftCard();

  var form = $(this).closest('form');
  var options = {
    url: util.ajaxUrl(form.attr('action')),
    method: 'POST',
    cache: false,
    data: form.serialize()
  };

  $.ajax(options).done(function (response) {
    if (response.success) {
      ajax.load({
        url: Urls.minicartGC,
        data: {
          lineItemId: response.result.lineItemId
        },
        callback: function callback(response) {
          minicart.show(response);
          form.find('input,textarea').val('');
          setGiftCard();
          design.dropdownToggleInit();
        }
      });

      if (response.result.device === 'mobile') {
        var popup = new Foundation.Reveal($('#giftcertpurchase-notification'));

        popup.open();

        setTimeout(function () {
          popup.close();
        }, 3000);
      }
    }
  }).fail(function (xhr, textStatus) {
    // failed
    if (textStatus === 'parsererror') {
      return window.alert(Resources.BAD_RESPONSE);
    }

    window.alert(Resources.SERVER_CONNECTION_ERROR);
  });
};

function initializeEvents() {
  design.selectGiftInit();

  $('.c-block-shopingmodal .c-list-color').on('colorSelect', function () {
    setGiftCard();
  });
}

function setGiftCard() {
  var imageSource = $('.c-block-shopingmodal .c-list-color a .is-current').find('img').attr('src') || $('.img-source input').val();
  var imageAlt = $('.c-block-shopingmodal .c-list-color a .is-current').find('img').attr('alt') || $('.img-alt input').val();

  setGiftCardImage(imageSource);
  setGiftCardName(imageAlt);
}

function setGiftCardImage(imageSource) {
  $('#GiftCertificateForm .imagesource').val(imageSource);
}

function setGiftCardName(imageAlt) {
  $('#GiftCertificateForm .imagealt').val(imageAlt);
}

exports.init = function () {
  $('#AddToBasketButton').on('click', setAddToCartHandler);

  initializeEvents();
};

},{"./ajax":1,"./design":11,"./minicart":23,"./util":77}],17:[function(require,module,exports){
'use strict';

(function ($) {
  var inputSelector = '.entry-mypage_member-edit input';
  var originalId = [];
  var registrationId = [];
  var cancellationId = [];
  $(function () {
    var rule = {
      hankaku: true,
      digits: true,
      length: 13,
      notDuplicate: inputSelector
    };

    $('.entry-mypage_member-input-field input[type="tel"]').each(function () {
      originalId.push($(this).val());
    });

    // validate
    var validatorForm = $('#editForm').validate({
      onkeyup: false,
      errorClass: 'is-error',
      errorElement: 'li',
      wrapper: 'ul',
      errorPlacement: function errorPlacement(error, element) {
        // insert error message
        if ($(element).parent('.c-input-group').length == 1) {
          if ($(element).parent().parent().find('.c-text-error').length == 0) {
            error.insertAfter($(element).parent());
          } else {
            $(element).parent().parent().find('.c-text-error').remove();
            error.insertAfter($(element).parent());
          }
        } else {
          if ($(element).parent().find('.c-text-error').length == 0) {
            if ($(element).parents('form.news-letter-form .ge-footer-connectWithUs-check').length) {
              error.insertAfter($(element).next());
            } else {
              error.insertAfter($(element));
            }
          } else {
            $(element).parent().find('.c-text-error').remove();
            error.insertAfter($(element));
          }
        }
        // add class error for ul tag
        if ($(element).closest($('form.news-letter-form')).length == 1) {
          error.addClass('c-text-error');
        } else {
          error.addClass('c-text-error c-text-error--simple');
        }
        // add class error for label
        error.parent().find('.c-input-label').first().addClass('is-error');
        // clear error message when has `no-display-error` attribute in the field
        if (error.parent().find('input[no-display-error]').length > 0) {
          error.remove();
        }
      },
      ignore: ':hidden, .ignore'
    });
    // add rule
    $(inputSelector).each(function (_, element) {
      $(element).rules('add', rule);
    });

    /**
     * add method
     */

    // 文字数
    jQuery.validator.addMethod('length', function (value, element, length) {
      return value.trim() === '' || value.length === length;
    }, '{0}文字で入力してください');

    // 半角
    function isHankaku(value) {
      return (/^[0-9a-zA-Z -/:-@\\[-~ｦ-ﾟｰ]+$/.test(value)
      );
    }
    jQuery.validator.addMethod('hankaku', function (value) {
      return value.trim() === '' || isHankaku(value);
    }, '半角文字で入力してください');

    // 重複
    jQuery.validator.addMethod('notDuplicate', function (value, element, param) {
      if ($(element).val() === '') {
        return true;
      }

      var that = this;
      var bool = true;
      $(param).each(function () {
        if (element === $(this).get(0)) {
          // 自身との同一チェックは行わない
          return true;
        }
        bool = bool && !$.validator.methods.equalTo.call(that, value, element, this);
      });

      return bool;
    }, '値が重複しています');

    // 登録解除
    $('.entry-mypage_member-edit').on('click', '.entry-formgroup_button--remove', function () {
      var input = $(this).closest('.entry-mypage_member_input').find('.entry-formgroup_input');
      var correctMemberIdRegex = new RegExp(/^[0-9]{13}$/);
      if (correctMemberIdRegex.test(input.val()) && cancellationId.indexOf(input.val()) == -1) {
        cancellationId.push(input.val());
        input.val('');
      } else {
        registrationId.length = 0;
        return false;
      }

      $('.entry-mypage_member-edit .entry-formgroup_input').each(function () {
        validatorForm.element(this);
      });
    });

    // 会員ID入力欄を追加
    //        var inputTemplate = $('#inputTemplate').html()
    //        $('.entry-mypgae_member-add')
    //            .click(function() {
    //                var id = $('.entry-mypage_confirm-title').length + 1
    //                    // 追加上限99個まで
    //                if (id > 99) {
    //                    return
    //                }
    //                $(inputTemplate.replace(/{{num}}/g, id))
    //                    .appendTo('.entry-mypage_member-edit')
    //                    .find('.entry-formgroup_input')
    //                    .focus()
    //                    .rules('add', rule)
    //            })
  });

  // Get registration and cancellation id
  $('#to-confirm').on('click', function () {
    $('.entry-mypage_member-input-field input[type="tel"]').each(function () {
      var id = $(this).val();
      if (id != '' && $.inArray(id, originalId) == -1) {
        var correctMemberIdRegex = new RegExp(/^[0-9]{13}$/);
        if (correctMemberIdRegex.test(id) && registrationId.indexOf(id) == -1) {
          registrationId.push($(this).val());
        } else {
          registrationId.length = 0;
          return false;
        }
      }
    });
    $('input[id$="memberinquiry_registrationid"]').val(JSON.stringify(registrationId));
    $('input[id$="memberinquiry_cancellationid"]').val(JSON.stringify(cancellationId));
  });
})(window.jQuery);

},{}],18:[function(require,module,exports){
'use strict';

var util = require('./util'),
    minicart = require('./minicart');

exports.init = function () {
  $('.menu-utility-user .contact, .menu-utility-user .newsletter').hover(function () {
    $(this).find('.menu-utility-content').show();
  });

  // 'tap' doesn't work as expected so using touchstart instead
  $(document).on('touchstart', function (e) {
    // the tapped element
    var $target = $(e.target);

    // check if it's not the menu or the dropdown itself
    if ($target.closest('.dropdown-menu').length == 0) {
      // check if some dropdown menu is open, otherwise foundation will return an error
      if ($('.dropdown-pane.is-open').length) {
        $('.dropdown-pane.is-open').foundation('close');
      }
    }
  });

  $('a.utility-link').click(function (evt) {
    evt.preventDefault();
  });

  // overwrite foundation Enter key event
  $('.menu-utility-user input').each(function (i, input) {
    var $input = $(input);

    // overwrite only on input type text, email and password
    if ($input.attr('type') == 'text' || $input.attr('type') == 'email' || $input.attr('type') == 'password') {
      $input.keydown(function (e) {
        Foundation.Keyboard.handleKey(e, 'DropdownMenu', {
          submit: function submit() {
            var $form = $input.closest('form');

            // simulate blur event to check if it has error or not
            $input.blur();

            // prevent submit if there are errors
            if ($form.find('span.error').length == 0) {
              // $form.submit() doesn't work on login so it has to be this *sigh*
              $form.find('button[type="submit"]').click();
            }
          }
        });
      });
    }
  });

  /** Search SP
   * Please make sure content asset `header-navigation` like
   * <a href="javascript:;" class="search-sp">サイト内検索</a>
   */
  $('.search-sp').on('click', function () {
    // close global navigation
    $('.js-gnav_close').trigger('click');
    // open search box
    $('.ge-search-toggle').trigger('click');
  });
};
Foundation.Keyboard.register('DropdownMenu', {
  ENTER: 'submit'
});

},{"./minicart":23,"./util":77}],19:[function(require,module,exports){
'use strict';

function entry() {
  $(document).on('keyup blur', '#q, .checkout-shoping-side-code input', function () {
    var $buttons = $(this).siblings('button').not('#cross-btn');
    if ($(this).val().trim().length) {
      return $buttons.prop('disabled', false);
    }
    $buttons.prop('disabled', true);
  });
}

exports.entry = entry;

},{}],20:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
  // params
  // toggleClass - required
  // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
  // eventName - optional. defaults to 'click'
  $.fn.toggledList = function (options) {
    if (!options.toggleClass) {
      return this;
    }
    var list = this;
    return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
      e.preventDefault();
      var classTarget = options.triggerSelector ? $(this).parent() : $(this);
      classTarget.toggleClass(options.toggleClass);
      // execute callback if exists
      if (options.callback) {
        options.callback();
      }
    });
  };

  $.fn.syncHeight = function () {
    var arr = $.makeArray(this);
    arr.sort(function (a, b) {
      return $(a).height() - $(b).height();
    });
    return this.height($(arr[arr.length - 1]).height());
  };
};

},{}],21:[function(require,module,exports){
'use strict';

function init() {
  $(function () {
    var timeoutId = null;
    var count = 0;
    $(document).ajaxSend(function (_, __, ajaxOptions) {
      if (ajaxOptions.loading) {
        count += 1;
        if (count === 1) {
          lockScreen();
          timeoutId = setTimeout(function () {
            timeoutId = null;
            $('html').addClass('cpb-is-loading');
          }, 500);
        }
      }
    });
    $(document).ajaxComplete(function (_, __, ajaxOptions) {
      if (ajaxOptions.loading) {
        count -= 1;
        if (count === 0) {
          $('html').removeClass('cpb-is-loading');
          unlockScreen();
          if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
          }
        }
      }
    });
  });
}

function lockScreen() {
  $('<div id="screen-lock"></div>').appendTo('body');
}

function unlockScreen() {
  $('#screen-lock').remove();
}

module.exports = {
  init: init
};

},{}],22:[function(require,module,exports){
'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    validator = require('./validator'),
    ajax = require('./ajax'),
    design = require('./design'),
    recaptcha = require('./recaptcha');

var login = {
  /**
   * @private
   * @function
   * @description init events for the loginPage
   */
  init: function init() {
    //o-auth binding for which icon is clicked
    $('.oAuthIcon').bind('click', function () {
      $('#OAuthProvider').val(this.id);
    });

    //toggle the value of the rememberme checkbox
    $('#dwfrm_login_rememberme').bind('change', function () {
      if ($('#dwfrm_login_rememberme').attr('checked')) {
        $('#rememberme').val('true');
      } else {
        $('#rememberme').val('false');
      }
    });

    //Reset Password Sidebar
    $('.password-reset').on('click', function (e) {
      e.preventDefault();

      ajax.load({
        url: $(e.target).attr('href'),
        callback: function callback(data) {
          $('.cpb-modal_reminder').html(data);

          validator.initForm($('#PasswordResetForm'));
          design.toggleSelectInit(true);
          var $requestPasswordForm = $('[name$="_requestpassword"]');
          var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
          $($submit).on('click', function (e) {
            var $form = $('#PasswordResetForm');
            e.preventDefault();

            if (Object.keys($form.data('error-fields')).length > 0 || $form.data('validator').errorList.length > 0) {
              e.stopPropagation();
              return false;
            }

            var dataToPost = $requestPasswordForm.serialize();
            // add form action to data
            dataToPost += '&' + $submit.attr('name') + '=';
            // make sure the server knows this is an ajax request
            if (dataToPost.indexOf('ajax') === -1) {
              dataToPost += '&format=ajax';
            }

            updateContentRightModal($('.cpb-modal_reminder_send'), $requestPasswordForm.attr('action'), dataToPost);
          });
        }
      });
    });

    //Reset Password Popup
    $('.js-password-reset').on('click', function (e) {
      e.preventDefault();

      ajax.load({
        url: util.ajaxUrl($(this).attr('href')),
        callback: function callback(data) {
          var $forgetPasswordModal = $('#forgetpasswordmodal');
          $forgetPasswordModal.html(data);
          var $passwordResetForm = $('#PasswordResetForm');
          validator.initForm($passwordResetForm);
          design.toggleSelectInit(true);
          $.magnificPopup.open({
            items: {
              src: $forgetPasswordModal, // can be a HTML string, jQuery object, or CSS selector
              type: 'inline'
            }
          });

          var $submit = $passwordResetForm.find('[name$="_requestpassword_send"]');
          $submit.on('click', function (e) {
            e.preventDefault();

            if (!$passwordResetForm.data('custom-validator')(e)) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }

            var dataToPost = $passwordResetForm.serialize();
            // add form action to data
            dataToPost += '&' + $submit.attr('name') + '=';
            // make sure the server knows this is an ajax request
            if (dataToPost.indexOf('ajax') === -1) {
              dataToPost += '&format=ajax';
            }

            updateContentPopup($forgetPasswordModal, $passwordResetForm.attr('action'), dataToPost);
          });
        }
      });
    });

    // W+アカウント連携時：ボタンクリック時にフラグを保存
    $(document).on('click', 'button[name$="_loginexternal"]', function () {
      var $form = $(this).closest('form');
      $form.data('clickedButtonName', $(this).attr('name'));
    });

    // Ajax Login
    $(document).on('submit', 'form[action*="Login-LoginForm"]', function (e) {
      var $form = $(this);
      var clickedButtonName = $form.data('clickedButtonName');
      var $btnLogin = $form.find('button[name$="_login"], button[name$="_loginexternal"]');

      // W+アカウント連携フラグ
      var isWplusInitiate = clickedButtonName && clickedButtonName.indexOf('loginexternal') > -1;

      // ログインボタンを非活性化
      $btnLogin.prop('disabled', true).addClass('c-btn--login_disabled');

      // 通常ログインの場合
      if (!isWplusInitiate) {
        e.preventDefault();

        var baseUrl = $form.attr('action');
        var ajaxUrl = baseUrl.replace('Login-LoginForm', 'Login-LoginAjax');

        $.ajax({
          url: ajaxUrl,
          data: $form.serialize(),
          type: 'POST'
        }).done(function (response) {
          // CSRF token error
          if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
            if (window.Urls && window.Urls.csrffailed) {
              page.redirect(window.Urls.csrffailed);
            } else {
              window.location.reload();
            }
            // ログインボタンを活性化
            $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
            return;
          }

          //　ログイン失敗時：エラー内容をURLパラメータに付与してリダイレクト
          if (response.success === false && response.postData) {
            var params = new URLSearchParams();
            Object.keys(response.postData).forEach(function (key) {
              if (response.postData[key] !== null && response.postData[key] !== undefined && response.postData[key] !== '') {
                params.append(key, response.postData[key]);
              }
            });
            var urlWithParams = response.targetUrl + (response.targetUrl.indexOf('?') > -1 ? '&' : '?') + params.toString();
            page.redirect(urlWithParams);
            // ログインボタンを活性化
            $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
            return;
          }

          var csrf_token = response && response.csrfToken || $form.find("input[name='csrf_token']").val();

          // MFA要否に応じた後続処理を実行
          login.loginSubsequent.forEach(function (item) {
            if (item.isMfaRequired === (response && response.isMfaRequired)) {
              item.subsequentProcess(response.targetUrl, response.isPostMethod, response && response.postData || {}, csrf_token);
            }
          });
          // ログインボタンを活性化
          $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
        }).fail(function (jqxhr, status, err) {
          if (jqxhr.responseJSON && jqxhr.responseJSON.error) {
            console.error('Error details:', jqxhr.responseJSON.error);
          }
          if (jqxhr.responseJSON && jqxhr.responseJSON.targetUrl) {
            page.redirect(jqxhr.responseJSON.targetUrl);
          }
          // ログインボタンを活性化
          $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
        });

        return;
      }

      // W+アカウント連携の場合
      e.preventDefault();

      var ajaxUrl = window.Urls && window.Urls.wplusInitiateSiteAccountAjax;

      if (!ajaxUrl) {
        console.error('[ERROR] W+ account linking Ajax URL not found');
        return;
      }

      $.ajax({
        url: ajaxUrl,
        data: $form.serialize(),
        type: 'POST'
      }).done(function (response) {
        // CSRF token error
        if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
          if (window.Urls && window.Urls.csrffailed) {
            page.redirect(window.Urls.csrffailed);
          } else {
            window.location.reload();
          }
          // ログインボタンを活性化
          $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
          return;
        }

        var csrf_token = response && response.csrfToken || $form.find("input[name='csrf_token']").val();

        // MFA要否に応じた後続処理を実行
        login.loginSubsequent.forEach(function (item) {
          if (item.isMfaRequired === (response && response.isMfaRequired)) {
            item.subsequentProcess(response.targetUrl, response.isPostMethod, response && response.postData || {}, csrf_token);
          }
        });
        // ログインボタンを活性化
        $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
      }).fail(function (jqxhr, status, err) {
        if (jqxhr.responseJSON && jqxhr.responseJSON.error) {
          console.error('Error details:', jqxhr.responseJSON.error);
        }
        if (jqxhr.responseJSON && jqxhr.responseJSON.targetUrl) {
          page.redirect(jqxhr.responseJSON.targetUrl);
        }
        // ログインボタンを活性化
        $btnLogin.prop('disabled', false).removeClass('c-btn--login_disabled');
      });
    });
  },

  submitOmotionVerify: function submitOmotionVerify(e) {
    e.preventDefault();
    var $form = $(this);
    var url = $form.attr('action');

    $.ajax({
      url: url,
      data: {
        authCode: $form.find('input[name*="_authCode"]').val() || $form.find('input[name="authCode"]').val(),
        email: $form.find('input[name="email"]').val(),
        rememberme: $form.find('input[name="rememberme"]').val(),
        verifyCategory: $form.find('input[name="verifyCategory"]').val(),
        csrf_token: $form.find("input[name='csrf_token']").val(),
        format: 'ajax'
      },
      type: 'POST'
    }).done(function (response) {
      // CSRF Token Error
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        page.redirect(window.Urls.csrffailed);
        return;
      }

      // authRedirect呼び出し
      $.ajax({
        url: response.redirectUrl,
        data: {
          email: $form.find('input[name="email"]').val(),
          rememberme: $form.find('input[name="rememberme"]').val() === 'true',
          verifyCategory: $form.find('input[name="verifyCategory"]').val(),
          isTokuisakiEC: $form.find('input[name="isTokuisakiEC"]').val(),
          accountCreation: $form.find('input[name="accountCreation"]').val(),
          isCustomerConnect: $form.find('input[name="isCustomerConnect"]').val(),
          format: 'ajax',
          csrf_token: $form.find("input[name='csrf_token']").val()
        },
        type: 'POST'
      }).done(function (response) {
        // POSTメソッドの場合：フォームを作成して送信
        if (response && response.isPostMethod) {
          var csrf_token = response && response.csrfToken || $form.find("input[name='csrf_token']").val();
          var postData = response && response.postData || {};
          var form = document.createElement('form');
          form.action = response.targetUrl;
          form.method = 'post';
          form.style.display = 'none';

          Object.entries(postData).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            if (Array.isArray(value)) {
              value.forEach(function (item) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = key + '[]';
                input.value = item;
                form.appendChild(input);
              });
            } else {
              var _input = document.createElement('input');
              _input.type = 'hidden';
              _input.name = key;
              _input.value = value;
              form.appendChild(_input);
            }
          });

          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'csrf_token';
          input.value = csrf_token;
          form.appendChild(input);

          document.body.appendChild(form);
          form.submit();
        } else {
          // GETメソッドの場合：リダイレクト
          page.redirect(response.targetUrl);
        }
      }).fail(function (jqxhr, status, err) {
        if (jqxhr.responseJSON && jqxhr.responseJSON.error) {
          console.error(jqxhr.responseJSON.error);
        }
        if (jqxhr.responseJSON && jqxhr.responseJSON.targetUrl) {
          page.redirect(jqxhr.responseJSON.targetUrl);
        }
      });
    }).fail(function (jqxhr, status, err) {
      if (jqxhr.responseJSON && jqxhr.responseJSON.redirectUrl) {
        // POSTメソッドの場合：フォームを作成して送信
        if (jqxhr.responseJSON && jqxhr.responseJSON.isPostMethod) {
          var csrf_token = $form.find("input[name='csrf_token']").val();
          var postData = jqxhr.responseJSON && jqxhr.responseJSON.postData || {};
          var form = document.createElement('form');
          form.action = jqxhr.responseJSON.redirectUrl;
          form.method = 'post';
          form.style.display = 'none';

          Object.entries(postData).forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            if (Array.isArray(value)) {
              value.forEach(function (item) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = key + '[]';
                input.value = item;
                form.appendChild(input);
              });
            } else {
              var _input2 = document.createElement('input');
              _input2.type = 'hidden';
              _input2.name = key;
              _input2.value = value;
              form.appendChild(_input2);
            }
          });

          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'csrf_token';
          input.value = csrf_token;
          form.appendChild(input);

          document.body.appendChild(form);
          form.submit();
        } else {
          // GETメソッドの場合：リダイレクト
          $.magnificPopup.close();
          page.redirect(jqxhr.responseJSON.redirectUrl);
        }
      } else {
        // サーバーサイドバリデーションエラー（期限切れ・上限超過・認証コード不一致）
        // コンテンツアセットからメッセージを取得
        var $serverErrorList = $form.closest('.c-block-forgetpassword-gather').find('.omotion-server-error');
        var errorMsg = jqxhr.responseJSON && jqxhr.responseJSON.errorMessageHtml;
        $serverErrorList.html('<li>' + errorMsg + '</li>').show();

        // 認証上限回数超過または有効期限切れの場合、送信ボタンを非活性化
        var errorStatus = jqxhr.responseJSON && jqxhr.responseJSON.status;

        if (errorStatus === 'EXPIRED' || errorStatus === 'MAX_ATTEMPTS_EXCEEDED') {
          var $submitButton = $form.find('button[type="submit"]');
          $submitButton.prop('disabled', true).addClass('is-disabled');
        }
      }
    });
  },

  loginSubsequent: [{
    // MFA必要
    isMfaRequired: true,
    subsequentProcess: function subsequentProcess(url, isPostMethod, postData, csrf_token) {
      // 既存のモーダルを閉じる
      if (typeof $.magnificPopup !== 'undefined') {
        $.magnificPopup.close();
      }

      // ajax.loadで直接HTMLを取得してbodyに追加
      ajax.load({
        url: url,
        callback: function callback(data) {
          if (!data) {
            console.error('[ERROR] No modal HTML received');
            return;
          }

          // モーダル要素の作成
          var $omotionAuthModal = $('#omotionAuthModal');
          if ($omotionAuthModal.length === 0) {
            $omotionAuthModal = $('<div id="omotionAuthModal" class="mfp-hide c-block-medium c-block-forgetpassword"></div>');
            $('body').append($omotionAuthModal);
          }

          // モーダル内容を更新
          $omotionAuthModal.html(data);

          $.magnificPopup.open({
            items: {
              src: $omotionAuthModal,
              type: 'inline'
            }
          });

          // フォーム送信イベントを登録
          validator.init();
          var $submit = $('#OmotionAuthForm');
          if ($submit.length > 0) {
            $submit.off('submit').on('submit', login.submitOmotionVerify);
          }
        }
      });
    }
  }, {
    // MFA不要
    isMfaRequired: false,
    subsequentProcess: function subsequentProcess(url, isPostMethod, postData, csrf_token) {
      // POSTメソッドの場合：フォームを作成して送信
      if (isPostMethod) {
        var form = document.createElement('form');
        form.action = url;
        form.method = 'post';
        form.style.display = 'none';

        // postDataの各キーと値をフォームに追加
        Object.entries(postData).forEach(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              key = _ref6[0],
              value = _ref6[1];

          if (Array.isArray(value)) {
            var _input3 = document.createElement('input');
            _input3.type = 'hidden';
            _input3.name = key;
            _input3.value = value.join(';');
            form.appendChild(_input3);
          } else {
            var _input4 = document.createElement('input');
            _input4.type = 'hidden';
            _input4.name = key;
            _input4.value = value;
            form.appendChild(_input4);
          }
        });

        // CSRFトークンをフォームに追加
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'csrf_token';
        input.value = csrf_token;
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
      } else {
        // GETメソッドの場合：リダイレクト
        page.redirect(url);
      }
    }
  }]
};

function updateContentRightModal($element, href, data) {
  $.ajax({
    type: 'POST',
    url: href,
    data: data,
    success: function success(response) {
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        page.redirect(Urls.csrffailed);
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.ErrorMsg) {
        var $modalReminder = $element.parent();
        var $errorPlacement = $modalReminder.find('.cmd-form_container>.cmd-form_err');
        if ($errorPlacement.length > 0) {
          $errorPlacement.remove();
        }
        $modalReminder.find('.cmd-form_container').prepend($('<p class="cmd-form_err"></p>').text(response.ErrorMsg));
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.location.href = Urls.generalError;
      } else if (typeof response === 'string') {
        ajax.load({
          url: $('#PasswordResetForm').find('[name$="_requestpassword_send"]').data('url'),
          callback: function callback(data) {
            $element.parent().find('.cpb-modal_reminder').addClass('is-hide');
            $element.removeClass('is-hide');
            $($element).html(data);
          }
        });
      }
    },
    failure: function failure() {
      $element.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
    }
  });
}

function updateContentPopup($element, href, data) {
  $.ajax({
    type: 'POST',
    url: href,
    data: data,
    success: function success(response) {
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        page.redirect(Urls.csrffailed);
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.ErrorMsg) {
        $element.find('form').parent().children('ul.c-text-error').remove();
        $('<ul></ul>').addClass('c-text-error').append($('<li></li>').text(response.ErrorMsg)).insertBefore($element.find('form'));
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.location.href = Urls.generalError;
      } else if (typeof response === 'string') {
        $element.html(response);
        $.magnificPopup.open({
          items: {
            src: $element, // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
        validator.initForm($('#PasswordResetForm'));
        design.toggleSelectInit(true);

        $('.c-block-forgetpassword-block-receive .js-modal-close').on('click', function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        });
      }
    },
    failure: function failure() {
      $element.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
    }
  });
}

module.exports = login;

///Login Greetings
if (window.User.isCustomerAuthenticated != false || window.User.isRegistered == true) {
  var myDate = new Date();
  var hrs = myDate.getHours();
  var mins = myDate.getMinutes();
  var time;
  var greeting;

  mins = ('0' + mins).slice(-2);
  time = hrs + mins;
  time = Number(time);

  if (time >= 300 && time <= 1159) {
    greeting = window.Resources.GREETINGS_MORNING;
  } else if (time >= 1200 && time <= 1700) {
    greeting = window.Resources.GREETINGS_AFTERNOON;
  } else {
    greeting = window.Resources.GREETINGS_EVENING;
  }

  $('#login-greetings').text(greeting);
  $('.menu-greeting #login-greetings').text(greeting);
}

},{"./ajax":1,"./design":11,"./dialog":12,"./page":28,"./recaptcha":68,"./util":77,"./validator":78}],23:[function(require,module,exports){
'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    samples = require('./samples'),
    design = require('./design');

var timer = {
  id: null,
  clear: function clear() {
    if (this.id) {
      window.clearTimeout(this.id);
      delete this.id;
    }
  },
  start: function start(duration, callback) {
    this.id = setTimeout(callback, duration);
  }
};

var setAddToCartError = function setAddToCartError(msg) {
  var $errEle = $('.cmd-form_err');
  $errEle.html(msg);
  $errEle.show();
};

var minicart = {
  init: function init() {
    initEvents();
  },

  addProduct: function addProduct(data) {
    var show = this.show.bind(this);

    return new Promise(function (resolve, reject) {
      if (data.hasOwnProperty('pid') === false) {
        return reject();
      }

      $.post(util.appendParamsToUrl(Urls.addProduct, {
        format: 'ajax',
        pid: encodeURIComponent(data.pid),
        Quantity: data.hasOwnProperty('Quantity') ? data.Quantity : '1'
      }), function (data) {
        if (data.success === false) {
          return reject(data.error);
        }

        show(data);
        resolve();
      }).fail(function (err) {
        reject(err.error);
      });
    });
  },

  addAllToWishlistFromContent: function addAllToWishlistFromContent(pids) {
    return window.location.href = Urls.addAllFromContent + '?pid=' + pids.join(':1,') + // pass qty of one
    '&cid=' + window.contentAssetID + '&hashparam=' + window.location.hash.split('#')[1];
  },

  addAllProducts: function addAllProducts(pids, to, currentTarget) {
    if (!pids || pids.length === 0) {
      return;
    }

    var isWishlist = to && to.toLowerCase() === 'wishlist';
    if (isWishlist && !window.User.isCustomerAuthenticated) {
      if (window.contentAssetID) {
        return this.addAllToWishlistFromContent(pids);
      } else {
        var footerURL = $('footer') ? $('footer').data('url') : null;
        window.location = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
        return;
      }
    }

    var show = this.show.bind(this);
    var updateMiniCartInfo = this.updateMiniCartInfo.bind(this);
    var showAddToCartPopup = this.showAddToCartPopup.bind(this);
    var urlName = Urls.addMultipleProducts;
    var csrf_token = $(currentTarget).closest('#product-set').find('input[name=csrf_token]').val();

    if (isWishlist) {
      urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
    }

    return $.when($.post(util.appendParamsToUrl(urlName, {
      format: 'ajax',
      pid: pids,
      csrf_token: csrf_token
    }))).then(function (data) {
      if (isWishlist) {
        window.location.href = window.location.href;
        return;
      }

      if (data) {
        $('form.pdpForm').find('.cmd-form_err').remove();
        if (data.success == false) {
          $('form.pdpForm').find('button#add-all-to-cart').parent().siblings('.cmd-form_err').remove();
          if (data.errorLst) {
            for (var i = 0; i < data.errorLst.length; i++) {
              $('form.pdpForm').find('div[data-pid="' + data.errorLst[i].pidError + '"]').find('.cpb-products-conut').before($("<div class='cmd-form_err _simple'></div>").text(data.errorLst[i].errorMsg));
            }
            window.scrollTo(0, $('form.pdpForm').find('div[data-pid="' + data.errorLst[0].pidError + '"]').offset().top);
            //refresh minicart
            return $.when($.post(util.appendParamsToUrl(Urls.miniCartShow, {
              format: 'ajax'
            }))).then(function (data) {
              return $.Deferred().reject(function () {
                // エラーがあった場合、ミニカートの情報のみ更新
                updateMiniCartInfo(data);
              }).progress();
            });
          } else if (!data.errorMsg) {
            window.location.href = window.location.href;
            return $.Deferred().reject().promise();
          } else {
            $('form.pdpForm').find('button#add-all-to-cart').parent().after($("<div class='cmd-form_err _simple'></div>").text(data.errorMsg));
            return $.Deferred().reject().promise();
          }
        }

        return function () {
          show(data);
          showAddToCartPopup('#minicart-notification');
        };
      }
    });
  },

  /**
   * @function
   * @description Shows the given content in the mini cart
   * @param {String} A HTML string with the content which will be shown
   */
  show: function show(html) {
    $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
    var quantity = $(html).find('.quantity_box').find('.num').data('quantity');
    if (quantity > 0) {
      $('.header-cart_btn .minicart-quantity').text(quantity);
      $('.header-cart_btn').prop('disabled', false);
      $('.header-cart_btn').css('cursor', 'pointer');
    }
    if (!$('.header-cart_btn').hasClass('_in') && quantity > 0) {
      $('.header-cart_btn').addClass('_in');
    }
    $('.js-modal-r_content[data-modal-type="cart"] .cpb-modalR_contents').html(html);
    this.init();

    this.slide();

    // identify if we can show the sample overlay
    var canShowSamples = false;
    $(document).find('[data-modal-type="cart"] input[name="eligible-for-sample"]').each(function () {
      if (!canShowSamples && $(this).val() == 'true') {
        canShowSamples = true;
      }
    });

    if (bonusProductsView.hasBonusOptions() === false && samples.canShowSelection() && canShowSamples) {
      setTimeout(function () {
        samples.showSelection();
      }, 1000);
    }

    bonusProductsView.loadBonusOption();
  },
  /**
   * 「show」のミニカート情報を更新だけ行う関数
   * @todo「show」の関数からのコピー関数のため時間があるときに関数化し「show」と合わせて修正したほうが良い
   * @param {*} html
   */
  updateMiniCartInfo: function updateMiniCartInfo(html) {
    $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
    var quantity = $(html).find('.quantity_box').find('.num').data('quantity');
    if (quantity > 0) {
      $('.header-cart_btn .minicart-quantity').text(quantity);
      $('.header-cart_btn').prop('disabled', false);
      $('.header-cart_btn').css('cursor', 'pointer');
    }
    if (!$('.header-cart_btn').hasClass('_in') && quantity > 0) {
      $('.header-cart_btn').addClass('_in');
    }
    $('.js-modal-r_content[data-modal-type="cart"] .cpb-modalR_contents').html(html);
    this.init();

    // identify if we can show the sample overlay
    var canShowSamples = false;
    $(document).find('[data-modal-type="cart"] input[name="eligible-for-sample"]').each(function () {
      if (!canShowSamples && $(this).val() == 'true') {
        canShowSamples = true;
      }
    });

    if (bonusProductsView.hasBonusOptions() === false && samples.canShowSelection() && canShowSamples) {
      setTimeout(function () {
        samples.showSelection();
      }, 1000);
    }

    bonusProductsView.loadBonusOption();
  },
  /**
   * @function
   * @description Slides down and show the contents of the mini cart
   */
  slide: function slide() {
    // show the item
    cpbUi.util.rightModalOpen.call($('.header-cart_btn'), undefined, function (target) {
      cpbUi.niceScroll.ready();
    });
  },
  /**
   * @function
   * @description Closes the mini cart with given delay
   * @param {Number} delay The delay in milliseconds
   */
  close: function close(delay) {
    // close modal
    cpbUi.util.rightModalClose.call($('.js-modal-r_content[data-modal-type="cart"] .js-modal-r_close'), undefined, function (target) {});
  },
  /**
   * @function
   * @description Show mini popup when add to cart in SP
   */
  showAddToCartPopup: function showAddToCartPopup(src) {
    if (window.innerWidth <= 768 && $(src).length) {
      $.magnificPopup.open({
        items: {
          src: src, // can be a HTML string, jQuery object, or CSS selector
          type: 'inline'
        }
      });
    }
  }
};

/**
 * Init events
 * @returns
 */
function initEvents() {
  //change quantity productlineItem
  $('.cpb-products_list_box .js-num-drop_select li').on('click', function (e) {
    var uuidProduct = $(this).closest('.cpb-products_list_box').find('.uuid-product').val();
    var current = $(this).find('a');
    var currentNum = current.html();
    var priceItem = $(this).closest('.cpb-products_list_box').find('.item-btm .item-price span');
    var dataSend = {
      uuid: uuidProduct,
      quantity: currentNum
    };
    $.ajax({
      url: Urls.updateQuantityProduct,
      type: 'GET',
      data: dataSend,
      success: function success(response) {
        if (response) {
          $('[data-modal-type="cart"]').find('.cpb-modalR_contents').html(response);
          var quantityTotal = $('#quantity-total-product').val();
          if (quantityTotal > 0) {
            $('.minicart-quantity').html(parseInt(quantityTotal));
          } else {
            $('.minicart-quantity').empty();
            $('.minicart-quantity').parent().removeClass('_in');
          }
          $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
          initEvents();
          cpbUi.niceScroll.ready();
        } else {
          console.log('error');
        }
      },
      error: function error(response) {
        return;
      },
      loading: true
    });
  });

  if ($('#quantity-total-product').val() > 0) {
    if ($('#error-kit').length > 0) {
      $('#error-kit').css({ display: 'block' });
    }
  } else {
    $('#error-kit').css({ display: 'none' });
  }

  $('.cpb-products_list_box .js-num-drop_down').off('click').on('click', function (e) {
    var uuidProduct = $(this).closest('.cpb-products_list_box').find('.uuid-product').val();
    var current = $(this).closest('.js-num-drop_container').find('.js-num-drop_cnt');
    var currentNum = current.html();
    if (currentNum > 1) {
      currentNum--;
    }
    var priceItem = $(this).closest('.cpb-products_list_box').find('.item-btm .item-price span');
    var dataSend = {
      uuid: uuidProduct,
      quantity: currentNum
    };
    $.ajax({
      url: Urls.updateQuantityProduct,
      type: 'GET',
      data: dataSend,
      success: function success(response) {
        if (response) {
          $('[data-modal-type="cart"]').find('.cpb-modalR_contents').html(response);
          var quantityTotal = $('#quantity-total-product').val();
          if (quantityTotal > 0) {
            $('.minicart-quantity').html(parseInt(quantityTotal));
          } else {
            $('.minicart-quantity').empty();
            $('.minicart-quantity').parent().removeClass('_in');
          }
          $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
          initEvents();
          cpbUi.niceScroll.ready();
        } else {
          console.log('error');
        }
      },
      error: function error(response) {
        return;
      },
      loading: true
    });
  });

  $('.cpb-products_list_box .js-num-drop_up').off('click').on('click', function (e) {
    var uuidProduct = $(this).closest('.cpb-products_list_box').find('.uuid-product').val();
    var current = $(this).closest('.js-num-drop_container').find('.js-num-drop_cnt');
    var currentNum = current.html();
    var limit = $(this).closest('.js-num-drop_container').find('.js-num-drop_select li a').length;
    if (currentNum < limit) {
      currentNum++;
    }
    var priceItem = $(this).closest('.cpb-products_list_box').find('.item-btm .item-price span');
    var dataSend = {
      uuid: uuidProduct,
      quantity: currentNum
    };
    $.ajax({
      url: Urls.updateQuantityProduct,
      type: 'GET',
      data: dataSend,
      success: function success(response) {
        if (response) {
          $('[data-modal-type="cart"]').find('.cpb-modalR_contents').html(response);
          var quantityTotal = $('#quantity-total-product').val();
          if (quantityTotal > 0) {
            $('.minicart-quantity').html(parseInt(quantityTotal));
          } else {
            $('.minicart-quantity').empty();
            $('.minicart-quantity').parent().removeClass('_in');
          }
          $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
          initEvents();
          cpbUi.niceScroll.ready();
        } else {
          console.log('error');
        }
      },
      error: function error(response) {
        return;
      },
      loading: true
    });
  });

  //remove productlineItem
  $('.cpb-products_list_box .item-remove a').on('click', function (e) {
    e.preventDefault();
    var uuidProduct = $(this).closest('.cpb-products_list_box').find('.uuid-product').val();
    var item = $(this).closest('.cpb-products_list_box');
    var dataSend = {
      uuid: uuidProduct
    };
    $.ajax({
      type: 'GET',
      data: dataSend,
      url: Urls.removeProduct,
      success: function success(response) {
        if (response) {
          $('[data-modal-type="cart"]').find('.cpb-modalR_contents').html(response);
          var quantityTotal = $('#quantity-total-product').val();
          if (quantityTotal > 0) {
            $('.minicart-quantity').html(parseInt(quantityTotal));
          } else {
            $('.minicart-quantity').empty();
            $('.minicart-quantity').parent().removeClass('_in');
            $('.header-cart_btn').prop('disabled', true);
            $('.header-cart_btn').css('cursor', 'auto');
          }
          $('[data-modal-type="cart"]').find('.nicescroll-rails').remove();
          initEvents();
          cpbUi.niceScroll.ready();
        } else {
          console.log('error:');
        }
      },
      loading: true
    });
  });
}

module.exports = minicart;

},{"./bonus-products-view":4,"./design":11,"./samples":69,"./util":77}],24:[function(require,module,exports){
'use strict';

var util = require('./util');

function Modal(modalCntr, modalBody, option) {
  this.$cntr = $(modalCntr);
  this.$body = $(modalBody);

  if ($.isEmptyObject(option) === false) {
    this.modal = new Foundation.Reveal($(modalCntr), option);
  } else {
    this.modal = new Foundation.Reveal($(modalCntr));
  }
  this.callbackFn = null;

  this.events = {
    onOpen: function onOpen(cb) {
      $(document).off('open.zf.reveal').on('open.zf.reveal', function () {
        cb();
        $(document).off('open.zf.reveal');
      });
    },

    onClose: function onClose(cb) {
      $(document).off('closed.zf.reveal').on('closed.zf.reveal', function () {
        cb();
        $(document).off('closed.zf.reveal');
      });
    }
  };
}

Modal.prototype.open = function () {
  this.modal.open();
};

Modal.prototype.close = function () {
  this.modal.close();
};

Modal.prototype.restoreDefaultClass = function () {
  this.$cntr.removeAttr('class');
  this.$cntr.attr('class', 'reveal');
};

Modal.prototype.addCustomClass = function (customClass) {
  this.restoreDefaultClass();
  this.$cntr.addClass(customClass);
};

Modal.prototype.setContent = function (content) {
  return this.$body.html(content);
};

Modal.prototype.renderContent = function (content, type) {
  var classType = type || '';

  this.$body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
  this.modal.open();

  if (typeof this.callbackFn === 'function') {
    this.callbackFn();
    this.callbackFn = null; // clear after each use
  }
};

Modal.prototype.renderByUrl = function (contentUrl) {
  return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent.bind(this));
};

Modal.prototype.setCallback = function (cb) {
  this.callbackFn = cb;
};

module.exports.global = new Modal('#modal-cntr', '.modal-body', {}); // global modal
module.exports.create = function (modalCntr, modalBody, option) {
  return new Modal(modalCntr, modalBody, option);
};

},{"./util":77}],25:[function(require,module,exports){
'use strict';

var cpbUi = cpbUi || {};
var product = require('./pages/product');

/**
 *
 * Variables
 *
 */
var transitionEndEvents = ['webkitTransitionEnd.transitionend', 'mozTransitionEnd.transitionend', 'oTransitionEnd.transitionend', 'transitionend.transitionend'].join(' ');

cpbUi.isDomReady = false;
cpbUi.isHeaderFixed = false;
cpbUi.isPdp = false;
cpbUi.scrollDirection = '';
cpbUi.scrollbarSize;

/**
 * Header
 */
var initHeader = function () {
  return {
    init: function init() {
      $(window).on('scroll', function (e) {
        if (!cpbUi.isDomReady) return;
        var ghH = $('.js-grobal-header').height();
        if (!cpbUi.isHeaderFixed && window.pageYOffset > ghH) {
          $('html').addClass('is-scroll');
          cpbUi.isHeaderFixed = true;
        } else if (cpbUi.isHeaderFixed && window.pageYOffset <= ghH) {
          $('html').removeClass('is-scroll');
          cpbUi.isHeaderFixed = false;
        }
      });
    },
    ready: function ready() {}
  };
}();

/**
 * Footer
 */
var initFooter = function () {
  return {
    init: function init() {},
    ready: function ready() {}
  };
}();

/**
 * Global Navigation Toggle
 */
var initGlobalNavigation = function () {
  var gnavOpen = function gnavOpen(e) {
    e.preventDefault();
    var targetName = $(this).attr('data-target');
    var $gnav = $('.cpb-gnav_container.is-' + targetName);
    $gnav.addClass('is-active');
    setTimeout(function () {
      util.setModalScrollbarFix();
      $('html').addClass('is-gnav-open');
      $gnav.find('.js-gnav_overlay').fadeIn(200, function () {
        $gnav.find('.js-gnav_close').eq(0).focus();
      });
      $gnav.find('.cpb-gnav_wrap').css({
        transform: 'translateX(0)'
      });
      cpbUi.niceScroll.resize($gnav);
    }, 10);
  };
  var gnavClose = function gnavClose(e) {
    e.preventDefault();
    var $gnav = $(this).closest('.cpb-gnav_container');
    var $gnavWrap = $gnav.find('.cpb-gnav_wrap');
    $gnavWrap.on(transitionEndEvents, function () {
      $gnav.find('.js-gnav_overlay').fadeOut(200, function () {
        util.removeModalScrollbarFix();
        $('html').removeClass('is-gnav-open');
        $gnav.removeClass('is-active');
        $gnav.find('.js-gnav_btn').eq(0).focus();
      });
      $gnavWrap.off('.transitionend');
    });
    $gnavWrap.css({
      transform: 'translateX(-100%)'
    });
  };

  var gnavChildOpen = function gnavChildOpen(e) {
    e.preventDefault();
    var $gnav = $(this).closest('.cpb-gnav_container');
    var $box = $(this).closest('.js-gnav-item_contents');
    var target = $(this).attr('data-gnav-target');
    var $target = $gnav.find('.js-gnav-item_contents').filter('[data-gnav-name="' + target + '"]');
    if ($target[0]) {
      $target.on(transitionEndEvents, function () {
        $box.removeClass('is-visible');
        $target.off('.transitionend');
      });
      $target.addClass('is-visible');
      setTimeout(function () {
        $target.css({
          transform: 'translateX(0)'
        });
      }, 10);
      cpbUi.niceScroll.resize($target);
    }
  };

  var gnavChildClose = function gnavChildClose(e) {
    e.preventDefault();
    var $gnav = $(this).closest('.cpb-gnav_container');
    var $box = $(this).closest('.js-gnav-item_contents');
    var target = $(this).attr('data-gnav-target');
    var $target = $gnav.find('.js-gnav-item_contents').filter('[data-gnav-name="' + target + '"]');
    if ($target[0]) {
      $box.on(transitionEndEvents, function () {
        $box.removeClass('is-visible');
        $box.off('.transitionend');
      });
      $box.css({
        transform: 'translateX(-100%)'
      });

      $target.addClass('is-visible');
      setTimeout(function () {
        $target.css({
          transform: 'translateX(0)'
        });
      }, 10);
    }
  };

  return {
    init: function init() {
      $(document).on('click', '.js-gnav_btn', gnavOpen);
      $(document).on('click', '.js-gnav_close', gnavClose);
      $(document).on('click', '.js-gnav_overlay', gnavClose);
      $(document).on('click', '.js-gnav-item_btn', gnavChildOpen);
      $(document).on('click', '.js-gnav_back', gnavChildClose);
    },
    ready: function ready() {}
  };
}();

/**
 * Right Modal
 */
var initRightModal = function () {
  var loginCallback = function loginCallback() {};
  var accountCallback = function accountCallback() {};
  var cartCallback = function cartCallback() {};

  return {
    init: function init() {
      $(document).on('click', '.js-modal-r_open', function (e) {
        e.preventDefault();
        util.rightModalOpen.call(this, undefined, function (target) {
          if (target === 'login') {
            loginCallback();
          }
          if (target === 'account') {
            accountCallback();
          }
          if (target === 'cart') {
            cartCallback();
          }
        });
      });
      $(document).on('click', '.js-modal-r_close', function (e) {
        e.preventDefault();
        util.rightModalClose.call(this, undefined, function (target) {});
      });
      $(document).on('click', '.js-modal-r_overlay', function (e) {
        e.preventDefault();
        util.rightModalClose.call(this, undefined, function (target) {});
      });
    },
    ready: function ready() {}
  };
}();

/**
 * Center Modal
 */
var initCenterModal = function () {
  return {
    init: function init() {
      $(document).on('click', '.js-modal-c_open', function (e) {
        e.preventDefault();
        util.centerModalOpen.call(this, undefined, function (target) {});
      });
      $(document).on('click', '.js-modal-c_close', function (e) {
        e.preventDefault();
        util.centerModalClose.call(this, undefined, function (target) {});
      });
      $(document).on('click', '.js-modal-c_overlay', function (e) {
        e.preventDefault();
        util.centerModalClose.call(this, undefined, function (target) {});
      });
    },
    ready: function ready() {}
  };
}();

/**
 * Right Modal Login
 */
var initRightModalLoginResetPassword = function () {
  return {
    init: function init() {
      $(document).on('click', '.js-reset-password-recerived', function (e) {
        e.preventDefault();
        util.rightModalScreenChange.call(this, undefined, function (target) {});
      });
      $(document).on('click', '.js-reset-password-request', function (e) {
        e.preventDefault();
        util.rightModalScreenChange.call(this, undefined, function (target) {});
      });
      $(document).on('click', '.js-reset-password-gotohome', function (e) {
        e.preventDefault();
        util.rightModalClose.call(this, undefined, function (target) {});
      });
    },
    ready: function ready() {}
  };
}();

/**
 * QuickView
 */
cpbUi.directQuickView = function (href, callback) {
  var modalHtml = '<div id="cpb-modal-quickview" class="cpb-modalR_container js-quickview_content" data-modal-type="quickview">\
        <div class="cpb-modalR_wrap">\
            <div class="cpb-modalR_contents cpb-cart_style">\
                <form action="#">\
                    <div class="cpb-modalR_scroll_cover">\
                        <div class="cpb-modalR_inner cpb-modal_scroll js-modal_scroll">\
                            <div class="cpb-modal_quickview">\
                                <button class="cpb-modalR_close js-quickview_close"><span class="invisible">CLOSE</span></button>\
                                <!-- pdp -->\
                                <div class="cpb-modal_quickview-inner"></div>\
                                <!-- /pdp -->\
                            </div><!-- / cpb-modal_quickview -->\
                        </div><!-- / cpb-modalR_inner -->\
                        <div class="cpb-modalR_bottom">\
                            <!-- price -->\
                            <div class="quantity_box"></div>\
                            <!-- /price -->\
                            <!-- button -->\
                            <div class="cmd-button_container"></div>\
                            <!-- /button -->\
                        </div><!-- / cpb-modalR_bottom -->\
                    </div><!-- / cpb-modalR_scroll_cover -->\
                </form>\
            </div><!-- / cpb-modalR_contents" -->\
        </div><!-- / cpb-modalR_wrap -->\
        <div class="cpb-modal_overlay js-quickview_overlay"></div>\
    </div><!-- / cpb-modalR_container -->';

  $.ajax({
    type: 'GET',
    url: href,
    dataType: 'html'
  }).done(function (data, textStatus, jqXHR) {
    var $pdpHtml = $(data);
    var $modal = $(modalHtml);

    $modal.find('.cpb-modalR_bottom .quantity_box').append($pdpHtml.find('#cpb-products_price').prop('outerHTML'));
    $modal.find('.cpb-modalR_bottom .cmd-button_container').append($pdpHtml.find('#cpb-products_submit').prop('outerHTML'));
    $modal.find('.cpb-modal_quickview-inner').append($pdpHtml.find('.cpb-products-details'));

    $('body').append($modal);

    if (typeof callback === 'function') callback();
  }).fail(function (jqXHR, textStatus, errorThrown) {});
};

var initQuickView = function () {
  var _init = function _init() {
    $(document).on('click', '.js-quickview-btn', function (e) {
      e.preventDefault();
      cpbUi.directQuickView($(this).attr('href'), function () {
        cpbUi.pdp.ready();

        util.rightModalOpen.call(this, 'quickview', function () {
          cpbUi.niceScroll.ready();
          cpbUi.sliderControl.resize();
          // init product's events
          product.initializeEvents();
        });
      });
    });
    $(document).on('click', '.js-quickview_close', function (e) {
      e.preventDefault();
      util.rightModalClose.call(this, 'quickview', function () {
        $('#cpb-modal-quickview').find('.js-modal_scroll').getNiceScroll().remove();
        $('#cpb-modal-quickview').remove();
      });
    });
    $(document).on('click', '.js-quickview_overlay', function (e) {
      e.preventDefault();
      util.rightModalClose.call(this, 'quickview', function () {
        $('#cpb-modal-quickview').find('.js-modal_scroll').getNiceScroll().remove();
        $('#cpb-modal-quickview').remove();
      });
    });
  };

  return {
    init: function init() {
      _init();
    },
    ready: function ready() {}
  };
}();

/**
 * PDP
 */
cpbUi.pdp = function () {
  var initPdpFooterNav = function initPdpFooterNav() {
    if (!$('.cpb-products_details_area')[0] || $('.cpb-products_details_area').hasClass('is-initialized')) return;

    var pdpFooterShow = false;

    $('.cpb-products_details_area').addClass('is-initialized');

    $(window).on('scroll', function (e) {
      if (!cpbUi.isDomReady) return;

      var pdpMainHeight = $('.cpb-products_details_area').offset().top + $('.cpb-products_details_area').height();
      var scrollTop = window.pageYOffset;

      if ($('#footer').offset().top <= scrollTop + $(window).height()) {
        $('.cpb-products-cart_fixed').removeClass('is-show');

        if (cpbUi.scrollDirection === 'up') {
          $('.cpb-grobal-header').removeClass('is-hide');
        }
      } else {
        if (cpbUi.scrollDirection === 'down') {
          if (!pdpFooterShow && pdpMainHeight <= scrollTop) {
            pdpFooterShow = true;
            $('.cpb-products-cart_fixed').addClass('is-show');
            $('.cpb-grobal-header').addClass('is-hide');
          } else if (pdpFooterShow && pdpMainHeight > scrollTop) {
            pdpFooterShow = false;
            $('.cpb-products-cart_fixed').removeClass('is-show');
            $('.cpb-grobal-header').removeClass('is-hide');
          }
        } else if (cpbUi.scrollDirection === 'up' && pdpFooterShow) {
          pdpFooterShow = false;
          $('.cpb-products-cart_fixed').removeClass('is-show');
          $('.cpb-grobal-header').removeClass('is-hide');
        }
      }
    });
  };

  var sliderOptions = {
    productsPhoto: {
      dots: true,
      infinite: false,
      slidesToScroll: 1
    },
    swatches: {
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 5,
      infinite: false,
      responsive: [{
        breakpoint: 1120,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }]
    }
  };

  var initSlider = function initSlider() {
    if (!$('.js-products-photo_slider').hasClass('slick-initialized')) {
      $('.js-products-photo_slider').slick(sliderOptions.productsPhoto);
    }
    if (!$('.js-swatches_slider').hasClass('slick-initialized')) {
      $('.js-swatches_slider').slick(sliderOptions.swatches);
    }
  };

  var productsColorSelect = function productsColorSelect(list) {
    var $pdp = $('.cpb-products-details');
    var $slider = $pdp.find('.js-products-photo_slider');
    $slider.slick('destroy');
    $slider.empty();

    var html = '';
    for (var i = 0; i < list.length; i++) {
      list[i];
      html += '<div class="cpb-products-photo_box cmd-slide">';
      html += '<img src="' + list[i] + '" alt="">';
      html += '</div>';
    }

    $slider.append(html);
    $slider.slick(sliderOptions.productsPhoto);
  };

  var initSelectColorChip = function initSelectColorChip() {
    $(document).on('click', '.cpb-products-color_list .selectable', function (e) {
      e.preventDefault();

      $('.cpb-products-color_list').find('.selectable').removeClass('selected');
      $('.cpb-products-color_list').find('.c-list-color-panel').removeClass('is-current');

      var $box = $(this).closest('.cpb-products-color_list');
      var index = $box.find('.selectable').index($(this));
      $('.cpb-products-color_list').each(function () {
        var $btn = $(this).find('.selectable').eq(index);
        $btn.addClass('selected');
        $btn.find('.c-list-color-panel').addClass('is-current');
      });

      /*
            画像リストを取得する処理
            */
      var tempList = ['https://www.cledepeau-beaute.com/dw/image/v2/BBSC_PRD/on/demandware.static/-/Sites-master-catalog-cpb/default/dw3ee84eec/products/images/rouge/product-detail-cmk-pic-99a-3-0003.png?sw=580&sh=580&sm=fit', 'https://www.cledepeau-beaute.com/dw/image/v2/BBSC_PRD/on/demandware.static/-/Sites-master-catalog-cpb/default/dwcd0dd4ef/products/images/rouge/product-detail-cmk-pic-99b-3-0003.png?sw=580&sh=580&sm=fit'];

      cpbUi.pdp.productsColorSelect(tempList);
    });
  };

  return {
    init: function init() {},
    productsColorSelect: productsColorSelect,
    ready: function ready() {
      initSlider();
      initPdpFooterNav();
      initSelectColorChip();
    }
  };
}();

/**
 * Nice Scroll
 */
cpbUi.niceScroll = function () {
  return {
    ready: function ready() {
      $('.js-modal_scroll').each(function () {
        var $ns = $(this);
        if (!$ns.hasClass('scroll-initialized')) {
          $ns.niceScroll({
            cursorcolor: 'rgba(0,0,0, .3)',
            cursoropacitymin: 0.3,
            cursorwidth: 3,
            autohidemode: false,
            zindex: '10000',
            cursorborder: 'none'
          });
          $ns.addClass('scroll-initialized');
        }
      });
    },
    resize: function resize($wrap) {
      var $target = $wrap && $wrap[0] ? $wrap.find('.js-modal_scroll') : $('.js-modal_scroll');
      return $target.getNiceScroll().resize();
    }
  };
}();

/**
 * Slider Control
 */
cpbUi.sliderControl = function () {
  return {
    ready: function ready() {},
    resize: function resize($wrap) {
      var $target = $wrap && $wrap[0] ? $wrap.find('.js-slider_control') : $('.js-slider_control');
      return $target.slick('setPosition');
    }
  };
}();

/**
 * Recommend Slider
 */
cpbUi.recommendSlider = function () {
  var sliderOption = {
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    infinite: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };

  return {
    init: function init() {},
    ready: function ready($slider) {
      if ($slider && $slider[0]) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(sliderOption);
        }
      } else {
        if (!$('.js-reco_slider').hasClass('slick-initialized')) {
          $('.js-reco_slider').slick(sliderOption);
        }
      }
    }
  };
}();

/**
 * Select Change Content
 */
var selectChangeContent = function () {
  return {
    init: function init() {
      $(document).on('change', '.js-select-change_tab', function (e) {
        var $box = $(this).closest('.js-select-change_tab_container');
        var val = $(this).val();
        var $target = $box.find('.js-select-change_tab_box').filter('[data-target="' + val + '"]');

        if ($target[0]) {
          /*$box.find('.js-select-change_tab_box').fadeOut(200, function() {
                      $target.fadeIn(200);
                    });*/
          $box.find('.js-select-change_tab_box').removeClass('is-active');
          $target.addClass('is-active');
        }
      });
    },
    ready: function ready() {
      $('.js-select-change_tab').trigger('change');
    }
  };
}();

/**
 * Standard Toggle
 */
var standardToggle = function () {
  var _init2 = function _init2() {
    $(document).on('click', '.js-toggle_btn', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-toggle_container');

      if ($box.hasClass('is-active')) {
        util.toggleClose($(this), $box, function () {});
      } else {
        util.toggleOpen($(this), $box, function () {});
      }
    });

    $(document).on('click', '.js-togge_close', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-toggle_container');
      var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'slide';
      if ($box.hasClass('is-active')) {
        util.toggleClose($(this), $box, function () {});
      }
    });
  };

  return {
    init: function init() {
      _init2();
    },
    ready: function ready() {}
  };
}();

/**
 * SNS Toggle
 */
var snsToggle = function () {
  var _init3 = function _init3() {
    $(document).on('click', '.js-toggle-sns_btn', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-toggle_container');
      var $this = $(this);

      if ($box.hasClass('is-active')) {
        util.toggleClose($this, $box, function () {});
      } else {
        util.toggleOpen($this, $box, function () {});
      }

      $(document).on('click.toggle-sns', function (e) {
        if (!$(e.target).closest('.js-toggle_container')[0]) {
          util.toggleClose($this, $box, function () {});
          $(document).off('.toggle-sns');
        }
      });
    });

    $(document).on('click', '.js-togge-sns_close', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-toggle_container');
      if ($box.hasClass('is-active')) {
        util.toggleClose($(this), $box, function () {});
        $(document).off('.toggle-sns');
      }
    });
  };

  return {
    init: function init() {
      _init3();
    },
    ready: function ready() {}
  };
}();

/**
 * Input Toggle
 */
var inputToggle = function () {
  var toggle = function toggle() {
    var type = $(this).attr('type');
    type = type ? type.toLowerCase() : '';
    var target = $(this).attr('data-target');
    var $target = $(target);

    if ($target[0]) {
      if (type === 'checkbox') {
        if ($(this).prop('checked')) {
          $target.addClass('is-active');
        } else {
          $target.removeClass('is-active');
        }
      } else if (type === 'radio') {}
    }
  };

  var _init4 = function _init4() {
    $(document).on('change', '.js-input-toggle_btn', function (e) {
      toggle.call(this);
    });
  };

  var initDisp = function initDisp() {
    $('.js-input-toggle_btn').each(function () {
      toggle.call(this);
    });
  };

  return {
    init: function init() {
      _init4();
    },
    ready: function ready() {
      initDisp();
    }
  };
}();

/**
 * Standard Tab
 */
var standardTab = function () {
  return {
    init: function init() {
      $(document).on('click', '.js-tab_btn', function (e) {
        e.preventDefault();
        var $box = $(this).closest('.js-tab_container');
        var target = $(this).attr('data-tab-target');
        util.tabOpen($(this), $box, target, function () {});
      });
    },
    ready: function ready() {}
  };
}();

/**
 * Tab Accordion
 */
var tabAccordion = function () {
  var initClickEvent = function initClickEvent() {
    $(document).on('click', '.js-tab-acc_btn', function (e) {
      e.preventDefault();
      var $container = $(this).closest('.js-tab-acc_container');
      var target = $(this).attr('data-tab-target');

      $container.find('.js-tab-acc_inner').removeClass('is-active');
      $container.find('.js-tab-acc_btn').removeClass('is-active');
      $container.find('.js-tab-acc_drawer_btn').removeClass('is-active');
      $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
      $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');

      $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').fadeIn(function () {
        $(this).addClass('is-active');
        $(this).css({
          display: ''
        });
      });
    });

    $(document).on('click', '.js-tab-acc_drawer_btn', function (e) {
      e.preventDefault();
      var $container = $(this).closest('.js-tab-acc_container');
      var target = $(this).attr('data-tab-target');

      if ($(this).hasClass('is-active')) {
        $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
        $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
        $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideUp(function () {
          $(this).removeClass('is-active');
          $(this).css({
            display: ''
          });
        });
      } else {
        $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
        $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');

        $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideDown(function () {
          $(this).addClass('is-active');
          $(this).css({
            display: ''
          });
        });

        // var $box = $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').closest('.js-tab-acc_box');
        // var position = $box.offset().top - $('.js-grobal-header').height();
        // $('html, body').animate({scrollTop:position}, 500);
      }
    });

    $(document).on('click', '.js-tab-acc_close', function (e) {
      e.preventDefault();
      var $container = $(this).closest('.js-tab-acc_container');
      var $box = $(this).closest('.js-tab-acc_box');
      var target = $box.find('.js-tab-acc_drawer_btn').attr('data-tab-target');

      $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
      $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
      $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideUp(function () {
        $(this).removeClass('is-active');
        $(this).css({
          display: ''
        });
      });
    });
  };

  var initMatchMedia = function initMatchMedia() {
    window.matchMedia('(min-width:769px)').addListener(function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        $('.js-tab-acc_container').each(function () {
          var $container = $(this);

          var $selectedBtns = $container.find('.js-tab-acc_drawer_btn.is-active');
          var $selectBtnFirst = $selectedBtns.length === 0 ? $container.find('.js-tab-acc_drawer_btn').eq(0) : $selectedBtns.first();

          if ($selectedBtns.length === 1) return;

          // reset
          $container.find('.js-tab-acc_drawer_btn').removeClass('is-active');
          $container.find('.js-tab-acc_btn').removeClass('is-active');
          $container.find('.js-tab-acc_inner').removeClass('is-active');

          // set
          var target = $selectBtnFirst.attr('data-tab-target');
          $selectBtnFirst.addClass('is-active');
          $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
          $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').addClass('is-active');
        });
      }
    });
  };

  return {
    init: function init() {
      initClickEvent();
      initMatchMedia();
    },
    ready: function ready() {}
  };
}();

/**
 * Number Drop Down
 */
var numDropDown = function () {
  var initClickEvent = function initClickEvent() {
    $(document).on('click', '.js-num-drop_up', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-num-drop_container');
      var limit = $box.find('.js-num-drop_select').children().length;
      var currentNum = $box.find('.js-num-drop_cnt').html();

      if (currentNum < limit) {
        currentNum++;
        $box.find('.js-num-drop_cnt').html(currentNum);
        $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
        $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
        $box.find('.js-num-drop_input').val(currentNum);
      }
    });
    $(document).on('click', '.js-num-drop_down', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-num-drop_container');
      var limit = $box.find('.js-num-drop_select').children().length;
      var currentNum = $box.find('.js-num-drop_cnt').html();

      if (currentNum > 1) {
        currentNum--;
        $box.find('.js-num-drop_cnt').html(currentNum);
        $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
        $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
        $box.find('.js-num-drop_input').val(currentNum);
      }
    });
    $(document).on('click', '.js-num-drop_select a', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-num-drop_container');
      var num = $(this).html();
      $box.find('.js-num-drop_cnt').html(num);
      $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
      $box.find('.js-num-drop_select').children().eq(num - 1).find('a').addClass('is-current');
      $box.find('.js-num-drop_input').val(num);
      $box.find('.js-num-drop_select').removeClass('is-active');
    });
    $(document).on('click', '.js-num-drop_drop', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-num-drop_container');
      var eventName = '.event' + new Date().getTime();

      if ($box.find('.js-num-drop_select').hasClass('is-active')) {
        $box.find('.js-num-drop_select').removeClass('is-active');
        $(document).off(eventName);
      } else {
        var offset = $(this).offset();
        var posY = offset.top - $(window).scrollTop();
        var height = $(window).height();
        if (posY * 2 > height) {
          $box.find('.js-num-drop_select').addClass('is-up');
        } else {
          $box.find('.js-num-drop_select').removeClass('is-up');
        }

        $box.find('.js-num-drop_select').addClass('is-active');

        $(document).on('click' + eventName + ' touchend' + eventName, function (e) {
          if (!$.contains($box[0], e.target)) {
            $box.find('.js-num-drop_select').removeClass('is-active');
            $(document).off(eventName);
          }
        });
      }
    });
  };

  return {
    init: function init() {
      initClickEvent();
    },
    ready: function ready() {}
  };
}();

/**
 * Cart
 */
var cart = function () {
  var initCartFooterNavNormal = function initCartFooterNavNormal() {
    if (!$('.cpb-cart-checkout_fixed')[0] || !$('.cpb-cart-side_submit')[0]) return;

    var cartFooterShow = false;

    $(window).on('scroll', function (e) {
      if (!cpbUi.isDomReady) return;

      // var targetHeight = $('.cpb-cart-side_submit').offset().top + $('.cpb-cart-side_submit').height();
      var ghHeight = $('.js-grobal-header').height();
      var scrollTop = window.pageYOffset;

      if (cpbUi.scrollDirection === 'down') {
        if (!cartFooterShow && ghHeight <= scrollTop) {
          cartFooterShow = true;
          $('.cpb-cart-checkout_fixed').addClass('is-show');
          $('.cpb-grobal-header').addClass('is-hide');
        } else if (cartFooterShow && ghHeight > scrollTop) {
          cartFooterShow = false;
          $('.cpb-cart-checkout_fixed').removeClass('is-show');
          $('.cpb-grobal-header').removeClass('is-hide');
        }
      } else if (cpbUi.scrollDirection === 'up' && cartFooterShow) {
        cartFooterShow = false;
        $('.cpb-cart-checkout_fixed').removeClass('is-show');
        $('.cpb-grobal-header').removeClass('is-hide');
      }

      if ($('#footer').offset().top <= scrollTop + $(window).height()) {
        $('.cpb-cart-checkout_fixed').removeClass('is-show');

        if (cpbUi.scrollDirection === 'up') {
          $('.cpb-grobal-header').removeClass('is-hide');
        }
      } else {}
    });
  };

  var initCartFooterNavSimple = function initCartFooterNavSimple() {
    if (!$('.cpb-cart-checkout_fixed')[0]) return;

    var cartFooterShow = false;

    $(window).on('scroll', function (e) {
      if (!cpbUi.isDomReady) return;

      var scrollTop = window.pageYOffset;

      if ($('#footer').offset().top <= scrollTop + $(window).height()) {
        $('.cpb-cart-checkout_fixed').addClass('is-bottom');
      } else {
        $('.cpb-cart-checkout_fixed').removeClass('is-bottom');
      }
    });
  };

  var initCreditCardSecurityInputCheck = function initCreditCardSecurityInputCheck() {
    $(document).on('focusin', '.js-security-code-check input[type="text"]', function (e) {
      var $box = $(this).closest('.js-security-code-check');
      $box.find('input[type="radio"]').prop('checked', true);
    });
  };

  var initInnerCheckboxTrigger = function initInnerCheckboxTrigger() {
    $(document).on('click', '.js-inner-checkbox-trigger', function (e) {
      var $checkbox = $(this).find('input[type="checkbox"]');
      var flg = $checkbox.prop('checked');
      $checkbox.prop('checked', !flg);
    });
  };

  var initCreditTypeSelectImage = function initCreditTypeSelectImage() {
    $(document).on('change', '.js-credit-type-select', function (e) {
      if ($(this).val()) {
        var path = $(this).find('option:selected').attr('data-image');
        var alt = $(this).find('option:selected').text();
        $('.js-credit-type-image').html('<img src="' + path + '" alt="' + alt + '">');
      } else {
        $('.js-credit-type-image').html('');
      }
    });
  };

  var initRadioTab = function initRadioTab() {
    $(document).on('change', '.js-tab_radio', function (e) {
      e.preventDefault();
      var $box = $(this).closest('.js-tab_container');
      var $contents = $box.find('.js-tab_contents');
      var target = $(this).attr('data-tab-target');
      var $target = $contents.filter('[data-tab-contents="' + target + '"]');

      $contents.removeClass('is-active');

      if ($target[0]) {
        $target.addClass('is-active');
      }

      cpbUi.niceScroll.resize();
    });
  };

  return {
    init: function init() {
      initCreditCardSecurityInputCheck();
      initRadioTab();
      initInnerCheckboxTrigger();
      initCreditTypeSelectImage();
    },
    ready: function ready() {
      if ($('.cpb-grobal-header').hasClass('is-simple')) {
        initCartFooterNavSimple();
      } else {
        initCartFooterNavNormal();
      }
    }
  };
}();

/**
 * Utility Functions
 */
var util = {
  toggleOpen: function toggleOpen($btn, $box, callback) {
    var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'fade';
    if (toggleType === 'fade') {
      $box.find('.js-toggle_contents').eq(0).fadeIn(200, function () {
        $box.addClass('is-active');
        $(this).css('display', '');
        if (typeof callback === 'function') callback();
      });
    } else if (toggleType === 'slide') {
      $box.find('.js-toggle_contents').eq(0).slideDown(200, function () {
        $box.addClass('is-active');
        $(this).css('display', '');
        if (typeof callback === 'function') callback();
      });
    }
  },
  toggleClose: function toggleClose($btn, $box, callback) {
    var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'fade';
    if (toggleType === 'fade') {
      $box.find('.js-toggle_contents').eq(0).fadeOut(200, function () {
        $box.removeClass('is-active');
        $(this).css('display', '');
        if (typeof callback === 'function') callback();
      });
    } else if (toggleType === 'slide') {
      $box.find('.js-toggle_contents').eq(0).slideUp(200, function () {
        $box.removeClass('is-active');
        $(this).css('display', '');
        if (typeof callback === 'function') callback();
      });
    }
  },
  tabOpen: function tabOpen($btn, $box, target, callback) {
    var $btns = $box.find('.js-tab_btn');
    var $contents = $box.find('.js-tab_contents');
    var $target = $contents.filter('[data-tab-contents="' + target + '"]');

    if ($target[0] && !$btn.hasClass('is-active')) {
      $btns.removeClass('is-active');
      $contents.removeClass('is-active');
      $btn.addClass('is-active');
      $target.addClass('is-active');

      // scrollbar & slider reset
      cpbUi.niceScroll.resize($target);
      cpbUi.sliderControl.resize($target);
    }
  },
  rightModalOpen: function rightModalOpen(target, callback) {
    var baseClass = target ? target : 'modal-r';
    target = target || $(this).attr('data-modal-target');

    var $modal = $('.js-' + baseClass + '_content[data-modal-type="' + target + '"]');
    if ($modal[0]) {
      util.setModalScrollbarFix();
      $modal.addClass('is-active');
      $('html').addClass('is-modal-open');
      setTimeout(function () {
        $modal.find('.js-' + baseClass + '_overlay').fadeIn(200, function () {
          if (typeof callback === 'function') {
            callback(target);
          }
        });
        $modal.find('.cpb-modalR_wrap').css({
          transform: 'translateX(0)'
        });
        cpbUi.niceScroll.resize($modal);
      }, 10);
    }
  },
  rightModalClose: function rightModalClose(target, callback) {
    var baseClass = target ? target : 'modal-r';
    var $modal = $(this).closest('.js-' + baseClass + '_content');
    if ($modal[0]) {
      var target = $modal.attr('data-modal-type');
      var $modalWrap = $modal.find('.cpb-modalR_wrap');
      $modalWrap.on(transitionEndEvents, function () {
        $modal.find('.js-' + baseClass + '_overlay').fadeOut(200, function () {
          $('html').removeClass('is-modal-open');
          util.removeModalScrollbarFix();
          $modal.removeClass('is-active');
          if (typeof callback === 'function') {
            callback(target);
          }
        });
        $modalWrap.off();
      });
      $modal.find('.cpb-modalR_wrap').css({
        transform: 'translateX(100%)'
      });
    }
  },
  centerModalOpen: function centerModalOpen(target, callback) {
    var baseClass = target ? target : 'modal-c';
    target = target || $(this).attr('data-modal-target');

    var $modal = $('.js-' + baseClass + '_content[data-modal-type="' + target + '"]');
    if ($modal[0]) {
      util.setModalScrollbarFix();
      $('html').addClass('is-modal-open');
      $modal.fadeIn(200, function () {
        $modal.addClass('is-active');
        $modal.css({
          display: ''
        });
        if (typeof callback === 'function') {
          callback(target);
        }
      });
      cpbUi.niceScroll.resize($modal);
    }
  },
  centerModalClose: function centerModalClose(target, callback) {
    var baseClass = target ? target : 'modal-c';
    var $modal = $(this).closest('.js-' + baseClass + '_content');
    if ($modal[0]) {
      var target = $modal.attr('data-modal-type');
      $modal.fadeOut(200, function () {
        $('html').removeClass('is-modal-open');
        util.removeModalScrollbarFix();
        $modal.removeClass('is-active');
        $modal.css({
          display: ''
        });
        if (typeof callback === 'function') {
          callback(target);
        }
      });
    }
  },
  rightModalScreenChange: function rightModalScreenChange(target, callback) {
    var baseClass = target ? target : 'modal-r';
    var $modal = $(this).closest('.js-' + baseClass + '_content');
    if ($modal[0]) {
      var targetName = $(this).attr('data-target');
      var $target = $modal.find('.js-screen[data-name="' + targetName + '"]');
      $modal.find('.js-screen').addClass('is-hide');
      $target.removeClass('is-hide');

      if (typeof callback === 'function') {
        callback(target);
      }
    }
  },
  hasScrollbar: function hasScrollbar(windowHeight) {
    return document.body.scrollHeight > (windowHeight || $(window).height());
  },
  getScrollbarSize: function getScrollbarSize() {
    if (cpbUi.scrollbarSize === undefined) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
      document.body.appendChild(scrollDiv);
      cpbUi.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
    return cpbUi.scrollbarSize;
  },
  setModalScrollbarFix: function setModalScrollbarFix(windowHeight) {
    if (util.hasScrollbar(windowHeight)) {
      var ss = util.getScrollbarSize();
      if (ss) {
        $('html').css({
          marginRight: ss + 'px'
        });
      }
    }
  },
  removeModalScrollbarFix: function removeModalScrollbarFix() {
    $('html').css({
      marginRight: ''
    });
  },
  getUniqueStr: function getUniqueStr(myStrong) {
    var strong = 1000;
    if (myStrong) strong = myStrong;
    return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
  }
};

cpbUi.util = util;

/**
 * Other
 */
var setDirectionCheck = function setDirectionCheck() {
  var defDirectionCheck = window.pageYOffset;
  var $html = $('html');
  $(window).on('scroll', function (e) {
    var scrollTop = window.pageYOffset;
    var flg = '';
    if (defDirectionCheck < scrollTop) {
      flg = 'down';
      if ($html.hasClass('is-up')) $html.removeClass('is-up');
    } else if (defDirectionCheck > scrollTop) {
      flg = 'up';
      if (!$html.hasClass('is-up')) $html.addClass('is-up');
    }

    if (scrollTop === 0 && !$html.hasClass('is-pos-top')) {
      $html.addClass('is-pos-top');
    } else if (scrollTop !== 0 && $html.hasClass('is-pos-top')) {
      $html.removeClass('is-pos-top');
    }

    cpbUi.scrollDirection = flg;
    defDirectionCheck = scrollTop;
  });
};

/**
 * PDP SKINCOLOR
 */
cpbUi.pdpSkinColor = function () {
  var itemSort = function itemSort(array) {
    array.sort(function (a, b) {
      return a[0].skincolor_num - b[0].skincolor_num;
    });
    for (var i = 0; i < array.length; i++) {
      array[i].sort(function (a, b) {
        return a.no - b.no;
      });
    }
    return array;
  };

  var getSkincolorDefaultNum = function getSkincolorDefaultNum(array) {
    var defaultNum;
    for (var i = 0; i < array.length; i++) {
      for (var j = 0; j < array[i].length; j++) {
        if (array[i][j].default && array[i][j].default === '1') {
          defaultNum = array[i][j].skincolor_num;
          break;
        }
      }
    }
    return defaultNum - 1;
  };

  var skinColorMount = function skinColorMount() {
    var SkinColorComponent = Vue.extend({
      props: ['skincolorData', 'skinColorDefaultNum', 'skinColorDefaultView'],
      template: '<div class="pdp-skincolor">\
                   <h3 class="pdp-skincolor_ttl"><span>EXAMPLE OF USE</span></h3>\
\
                   <div class="pdp-skincolor_container cmd-tabAcc_container">\
                     <ul class="pdp-skincolor_skincolor-tabs cpb-products-summary_tab_list cmd-tabAcc_list cmd-md-4">\
                       <li class="pdp-skincolor_skincolor-tab" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorTab\' + skinIndex">\
                         <a href="javascript:void(0);" class="pdp-skincolor_skincolor-btn cmd-tabAcc_btn js-skincolor_skincolor-btn" :class="[{\'is-active\': isDefault(skinIndex)}]" :data-skincolor-num="skinIndex" data-type="pc">\
                           <span v-text="\'SKIN TONE \' + skincolor[0].skincolor_num"></span>\
                         </a>\
                       </li>\
                     </ul>\
\
                     <div class="pdp-skincolor_view-tabs">\
                       <div class="pdp-skincolor_view-tab _image-view">\
                         <a href="javascript:void(0);" class="pdp-skincolor_view-btn icoset js-skincolor_view-btn" :class="[{\'is-active\': isDefaultView(\'image\')}]" data-view-type="image"><span>Image VIEW</span></a>\
                       </div>\
                       <div class="pdp-skincolor_view-tab _grid-view">\
                         <a href="javascript:void(0);" class="pdp-skincolor_view-btn icoset js-skincolor_view-btn" :class="[{\'is-active\': isDefaultView(\'grid\')}]" data-view-type="grid"><span>Grid VIEW</span></a>\
                       </div>\
                     </div>\
\
                     <div class="pdp-skincolor_contents">\
                       <ul class="pdp-skincolor_content _image-view cmd-tabAcc_contents" :class="[{\'is-active\': isDefaultView(\'image\')}]" data-view-type="image">\
                         <li class="pdp-skincolor_content-skincolor cmd-tabAcc_box" :class="[{\'is-active\': isDefault(skinIndex)}]" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorContent\' + skinIndex" :data-skincolor-num="skinIndex">\
\
                           <div class="pdp-skincolor_sp-toggle cmd-tabAcc-in_btn">\
                             <a href="javascript:void(0);" class="pdp-skincolor_skincolor-btn cmd-tabAcc_drawer_btn js-skincolor_skincolor-btn" :class="[{\'is-active\': isDefault(skinIndex)}]" :data-skincolor-num="skinIndex" data-type="sp"><span v-text="\'SKIN TONE \' + skincolor[0].skincolor_num"></span></a>\
                           </div>\
\
                           <div class="pdp-skincolor_items js-skincolor-slider">\
                             <div class="pdp-skincolor_item" v-for="(item, itemIndex) in skincolor" :key="\'skincolorItem\' + item.no">\
                               <div class="item-row">\
                                 <div class="item-column _image">\
                                   <div class="item_color-image">\
                                     <img :src="getImagePath(item)" alt="">\
                                   </div>\
                                 </div>\
                                 <div class="item-column _color">\
                                   <div class="item-column_inner">\
                                     <div class="item_name" v-text="item.name"></div>\
                                     <div class="item_colorchip"><img :src="item.colorchip_path" alt=""></div>\
                                     <div class="item_colorchip-name">\
                                       <span v-text="item.color_code"></span>\
                                       <span v-text="\' \' + item.color_name" v-if="item.color_name"></span>\
                                     </div>\
                                   </div>\
                                 </div>\
                               </div>\
                             </div>\
                           </div>\
                         </li>\
                       </ul>\
\
                       <ul class="pdp-skincolor_content _grid-view cmd-tabAcc_contents" :class="[{\'is-active\': isDefaultView(\'grid\')}]" data-view-type="grid">\
                         <li class="pdp-skincolor_content-skincolor" :class="[{\'is-active\': isDefault(skinIndex)}]" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorContent\' + skinIndex" :data-skincolor-num="skinIndex">\
                           <ul class="pdp-skincolor_items">\
                             <li class="pdp-skincolor_item" v-for="(item, itemIndex) in skincolor" :key="\'skincolorItem\' + item.no">\
                               <div class="item_color-image">\
                                 <img :src="getImagePath(item)" alt="">\
                               </div>\
                               <div class="item_colorchip-name">\
                                 <span v-text="item.color_code"></span>\
                                 <span v-text="\' \' + item.color_name" v-if="item.color_name"></span>\
                               </div>\
                             </li>\
                           </ul>\
                         </li>\
                       </ul>\
                     </div>\
                   </div>\
                 </div>'
    });

    var skinColorItemData = itemSort(skinColorData);
    var skinColorDefaultNum = getSkincolorDefaultNum(skinColorItemData);
    var skinColorDefaultView = $('#skincolor-app').attr('data-default-view') || 'image';
    var skinColorComponent = new SkinColorComponent({
      propsData: {
        skincolorData: skinColorItemData,
        skinColorDefaultNum: skinColorDefaultNum,
        skinColorDefaultView: skinColorDefaultView
      },
      methods: {
        getImagePath: function getImagePath(item) {
          return '/on/demandware.static/Sites-cpb_' + item.country + '-Site/pdp/skincolor/images/' + item.product_code + '/' + item.filename;
        },
        isDefault: function isDefault(skinIndex) {
          return skinIndex === this.skinColorDefaultNum;
        },
        isDefaultView: function isDefaultView(view) {
          return this.skinColorDefaultView === view;
        }
      }
    }).$mount();

    var $skincolorApp = $('#skincolor-app');
    $skincolorApp.html(skinColorComponent.$el.outerHTML);

    var $skincolor = $skincolorApp.find('.pdp-skincolor');
    $skincolor.addClass('initialize');
    $skincolor.find('.js-skincolor-slider').slick();

    var setSkincolorHandler = function setSkincolorHandler(e) {
      e.preventDefault();
      var skincolorNum = $(this).attr('data-skincolor-num');
      var $skincolorContent = $skincolor.find('.pdp-skincolor_content-skincolor');
      var $skincolorBtn = $skincolor.find('.js-skincolor_skincolor-btn');
      var $skincolorSelectBtn = $skincolorBtn.filter('[data-skincolor-num="' + skincolorNum + '"]');
      var $skincolorContentSelect = $skincolorContent.filter('[data-skincolor-num="' + skincolorNum + '"]');
      var $skincolorContentSelectItems = $skincolorContentSelect.find('.pdp-skincolor_items');
      var isActive = $(this).hasClass('is-active');

      if ($(this).attr('data-type') === 'sp') {
        if (isActive) {
          $skincolorSelectBtn.removeClass('is-active');
          $skincolorContentSelectItems.find('.slick-arrow').hide();
          $skincolorContentSelectItems.slideUp(300, function () {
            $skincolorContentSelect.removeClass('is-active');
            $skincolorContentSelectItems.css({
              display: ''
            });
            $skincolorContentSelectItems.find('.slick-arrow').css({
              display: ''
            });
          });
        } else {
          $skincolor.find('.js-skincolor_skincolor-btn').filter('[data-skincolor-num="' + skincolorNum + '"]').addClass('is-active');

          // slider setposition
          $skincolorContentSelectItems.show().height(0);
          $skincolorContentSelect.find('.js-skincolor-slider').slick('setPosition');
          $skincolorContentSelectItems.hide().css({
            height: ''
          });

          $skincolorContentSelect.find('.item-column_inner').css({
            opacity: 0
          });
          $skincolorContentSelect.find('.slick-arrow').css({
            opacity: 0
          });

          $skincolorContentSelectItems.slideDown(500, function () {
            $skincolorContentSelect.addClass('is-active');
            $skincolorContentSelectItems.css({
              display: ''
            });
          });

          setTimeout(function () {
            $skincolorContentSelect.find('.item-column_inner').animate({
              opacity: 1
            });
            $skincolorContentSelect.find('.slick-arrow').animate({
              opacity: 1
            }, function () {
              $skincolorContentSelect.find('.item-column_inner').css({
                display: ''
              });
              $skincolorContentSelect.find('.slick-arrow').css({
                display: ''
              });
            });
          }, 450);
        }
      } else {
        if (isActive) return;

        $skincolor.find('.js-skincolor_skincolor-btn').removeClass('is-active');
        $skincolor.find('.js-skincolor_skincolor-btn').filter('[data-skincolor-num="' + skincolorNum + '"]').addClass('is-active');

        $skincolorContent.css({
          opacity: 0
        });

        setTimeout(function () {
          $skincolorContent.removeClass('is-active');
          $skincolorContent.css({
            opacity: ''
          });
          $skincolorContentSelect.addClass('is-active').css({
            opacity: 0
          });

          setTimeout(function () {
            $skincolorContentSelect.css({
              opacity: ''
            });
            $skincolorContentSelect.find('.js-skincolor-slider').slick('setPosition');
          }, 50);
        }, 250);
      }
    };

    var setViewTypeHandler = function setViewTypeHandler(e) {
      e.preventDefault();
      if ($(this).hasClass('is-active')) return;

      var viewType = $(this).attr('data-view-type');

      $skincolor.find('.pdp-skincolor_view-btn').removeClass('is-active');
      $skincolor.find('.pdp-skincolor_view-btn').filter('[data-view-type="' + viewType + '"]').addClass('is-active');

      $skincolor.find('.pdp-skincolor_content').css({
        opacity: 0
      });

      setTimeout(function () {
        $skincolor.find('.pdp-skincolor_content').removeClass('is-active');
        $skincolor.find('.pdp-skincolor_content').filter('[data-view-type="' + viewType + '"]').addClass('is-active').css({
          opacity: 0
        });

        setTimeout(function () {
          $skincolor.find('.pdp-skincolor_content').css({
            opacity: ''
          });

          if (viewType === 'image') {
            $skincolor.find('.pdp-skincolor_content').filter('[data-view-type="' + viewType + '"]').find('.js-skincolor-slider').slick('setPosition');
          }
        }, 50);
      }, 250);
    };

    $(document).on('click', '.js-skincolor_skincolor-btn', setSkincolorHandler);
    $(document).on('click', '.js-skincolor_skincolor-btn-sp', setSkincolorHandler);
    $(document).on('click', '.js-skincolor_view-btn', setViewTypeHandler);
  };

  var initMatchMedia = function initMatchMedia() {
    window.matchMedia('(min-width:769px)').addListener(function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        var $skinColor = $('#skincolor-app');
        var $selectedBtns = $skinColor.find('.pdp-skincolor_skincolor-tabs').find('.js-skincolor_skincolor-btn.is-active');
        var $selectBtnFirst = $selectedBtns.length === 0 ? $skinColor.find('.pdp-skincolor_skincolor-tabs').find('.js-skincolor_skincolor-btn').eq(0) : $selectedBtns.first();

        if ($selectedBtns.length === 1) return;

        // reset
        $skinColor.find('.js-skincolor_skincolor-btn').removeClass('is-active');
        $skinColor.find('.pdp-skincolor_content-skincolor').removeClass('is-active');

        // set
        var targetNum = $selectBtnFirst.attr('data-skincolor-num');
        $selectBtnFirst.addClass('is-active');

        var $selectedImageContent = $skinColor.find('.pdp-skincolor_content._image-view').find('.pdp-skincolor_content-skincolor').filter('[data-skincolor-num="' + targetNum + '"]');
        $selectedImageContent.addClass('is-active');
        $selectedImageContent.find('.js-skincolor_skincolor-btn').addClass('is-active');

        var $selectedGridContent = $skinColor.find('.pdp-skincolor_content._grid-view').find('.pdp-skincolor_content-skincolor').filter('[data-skincolor-num="' + targetNum + '"]');
        $selectedGridContent.addClass('is-active');
      }
    });
  };

  return {
    init: function init() {},
    ready: function ready() {
      if (typeof window.skinColorData === 'undefined') return;
      if (!$('#skincolor-app')[0]) return;
      skinColorMount();
      initMatchMedia();
    }
  };
}();

/**
 * Naire Modal
 */
var naireModal = function () {
  var naireTransition = function naireTransition(callback) {
    var target = $(this).attr('data-target');
    var $box = $(this).closest('.js-modal-r_content');
    var $currentBox = $(this).closest('.cpb-modalR_scroll_cover');
    var $targetBox = $box.find('.cpb-modalR_scroll_cover').filter('[data-name="' + target + '"]');

    $currentBox.animate({
      opacity: 0
    }, 300, function () {
      $currentBox.addClass('is-hide').css({
        opacity: ''
      });
      $targetBox.removeClass('is-hide').css({
        opacity: 0
      }).animate({
        opacity: 1
      }, 300, function () {
        $targetBox.css({
          opacity: ''
        });
      });

      cpbUi.niceScroll.resize($box);

      if (typeof callback === 'function') callback();
    });
  };

  return {
    init: function init() {
      $(document).on('click', '.js-naire-product', function (e) {
        e.preventDefault();
        naireTransition.call(this, function () {});
      });
      $(document).on('click', '.js-naire-setting', function (e) {
        e.preventDefault();
        naireTransition.call(this, function () {});
      });
      $(document).on('click', '.js-naire-back', function (e) {
        e.preventDefault();
        naireTransition.call(this, function () {});
      });

      var textCheck = function textCheck() {
        var $box = $(this).closest('.js-modal-r_content');
        var text = $(this).val();

        text = text.replace(/[^a-zA-Z0-9 .&]/g, '');
        text = text.substr(0, 10);

        $(this).val(text);
        $box.find('.js-naire-preview').text(text);

        if (!text) {
          $box.find('.js-naire-preview').text($(this).attr('placeholder'));
        }
      };

      var composition = false;

      $(document).on('keyup', '.js-naire-input', function (e) {
        if (!composition) {
          textCheck.call(this);
        }
      });

      $(document).on('compositionstart', '.js-naire-input', function (e) {
        e.preventDefault();
        composition = true;
      });
      $(document).on('compositionend', '.js-naire-input', function (e) {
        composition = false;
        textCheck.call(this);
      });

      $(document).on('focusout', '.js-naire-input', function (e) {
        textCheck.call(this);
      });
    },
    ready: function ready() {}
  };
}();

/**
 * Movie Modal
 */
var movieModal = function () {
  var modalHtml = '\
 <div class="cpb-modalC_container cmd-modal-video js-modal-video_content">\
   <div class="cpb-modalC_wrap">\
     <div class="cpb-modalC_inner">\
       <div class="cmd-video_flex">\
         <iframe id="ytplayer" type="text/html" width="640" height="360" src="{{URL}}" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>\
       </div><!-- / cmd-video_flex-->\
     </div><!-- / cpb-modalC_inner -->\
   </div><!-- / cpb-modalC_wrap -->\
   <div class="cpb-modal_overlay js-modal-video_overlay"></div>\
 </div><!-- / cpb-modalC_container -->';

  return {
    init: function init() {
      $(document).on('click', '.js-modal-video', function (e) {
        e.preventDefault();
        var embedUrl = $(this).attr('href');
        var html = modalHtml.replace('{{URL}}', embedUrl);
        var $modal = $(html);
        var $wrapSlider = $(this).closest('.js-slider_container');

        $('html').addClass('is-modal-open');
        $('body').append($modal);

        if ($wrapSlider[0] && $wrapSlider.hasClass('slick-initialized')) {
          var isAutoPlay = cpbUi.sectionSlider.getAutoPlay($wrapSlider);
          if (isAutoPlay) {
            var unique = 'id' + cpbUi.util.getUniqueStr();
            $modal.attr('data-slider-autoplay', 'true');
            $modal.attr('data-original', unique);
            $wrapSlider.addClass(unique);
            cpbUi.sectionSlider.pause($wrapSlider);
          }
        }

        $modal.fadeIn();
      });

      var closeFunc = function closeFunc(e) {
        e.preventDefault();
        var $modal = $(this).closest('.js-modal-video_content');
        var unique = $modal.attr('data-original');
        var $original = $('.' + unique);
        $modal.animate({
          opacity: 0
        }, 300, function () {
          $modal.find('iframe').attr('src', '//about:blank');
          $modal.remove();
          cpbUi.sectionSlider.play($original);
          $original.removeClass(unique);
          $('html').removeClass('is-modal-open');
        });
      };

      $(document).on('click', '.js-modal-video_close', closeFunc);
      $(document).on('click', '.js-modal-video_overlay', closeFunc);
    },
    ready: function ready() {}
  };
}();

/**
 * section slider
 */
cpbUi.sectionSlider = function () {
  var ytPlayersMainSlider = {};
  var matchMediaPC = window.matchMedia('screen and (min-width: 993px)');
  var isPC = function isPC() {
    return matchMediaPC.matches;
  };

  var getBgMovieSize = function getBgMovieSize(aspectW, aspectH) {
    aspectW = aspectW || 16;
    aspectH = aspectH || 9;
    var videoRatio = (aspectW / aspectH).toFixed(2);
    var minWidth = window.innerWidth ? window.innerWidth : $(window).width();
    var minHeight = $(window).height() + 100;
    var widthRatio = minWidth / aspectW;
    var heightRatio = minHeight / aspectH;
    var size = {};
    if (widthRatio > heightRatio) {
      size.width = minWidth;
      size.height = Math.ceil(minWidth / videoRatio);
    } else {
      size.height = minHeight;
      size.width = Math.ceil(minHeight * videoRatio);
    }
    return size;
  };

  var mainSliderReady = function mainSliderReady() {
    var windowWidth = $(window).width();
    var windowDelay = 0;

    $('.js-slider_container[data-slider-type="main"]').each(function () {
      if ($(this).hasClass('slick-initialized')) return;

      var $slider = $(this);
      var $sliderWrap = $slider.parent('.cmd-section_slider');
      var uniqueId = 'id' + cpbUi.util.getUniqueStr();
      var carouselDuration = $(this).attr('data-slider-duration') || 15000;
      var videoList = [];
      var nextTimer;
      var seekbarTimer;
      var loadingTimer;
      var isSingleAndMovie = false;
      var hasVideoContent = $slider.find('.cmd-visual_video')[0];
      ytPlayersMainSlider[uniqueId] = [];

      $slider.addClass(uniqueId);
      if (hasVideoContent) $slider.addClass('has-video');

      if (!isPC()) {
        $slider.removeClass('is-loading');
      }

      // YouTubeの埋め込み
      function onPlayerReady(event) {
        event.target.mute();
        event.target.getPlaybackQuality('highres');
        sliderReady(event);
      }

      function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          // $slider.slick('slickNext');
        }
      }

      function getVideoList() {
        var videoList = [];

        $slider.find('.cmd-visual_container').each(function (index) {
          var $el = $(this).find('.cmd-visual_iframe-wrap');
          if ($el[0]) {
            $slider.removeClass('is-loading');
            $el.attr('id', 'visual-slider_movieid_' + uniqueId + '_' + index);
            videoList.push({
              index: index,
              videoId: $el.attr('data-yt-id')
            });
          }
        });

        return videoList;
      }

      function youtubeSetup() {
        for (var i = 0; i < videoList.length; i++) {
          var playerVars = {
            // 'autoplay': 1,
            controls: 0,
            // 'loop': 1,
            // 'playlist': videoList[i].videoId,
            disablekb: 1,
            rel: 0,
            playsinline: 1
          };

          // ytPlayersMainSlider[uniqueId].push('');

          isSingleAndMovie = $slider.find('.cmd-slide').length === 1;

          if (isSingleAndMovie) {
            playerVars.playlist = videoList[i].videoId;
            playerVars.loop = 1;
          }

          var ytPlayer = new YT.Player('visual-slider_movieid_' + uniqueId + '_' + videoList[i].index, {
            width: 640,
            height: 480,
            videoId: videoList[i].videoId,
            playerVars: playerVars,
            events: {
              onReady: onPlayerReady,
              onStateChange: onPlayerStateChange
            }
          });
          // ytPlayersMainSlider[uniqueId][videoList[i].index] = ytPlayer;
          ytPlayersMainSlider[uniqueId].push(ytPlayer);
        }
      }

      function sliderInit() {
        slickInit();

        videoList = getVideoList();

        if (videoList.length) {
          youtubeSetup();
        } else {
          sliderReady();
        }
      }

      function sliderReady(event) {
        if (event && $(event.target.getIframe()).attr('id') === 'visual-slider_movieid_' + uniqueId + '_0') {
          if (isPC() && ytPlayersMainSlider[uniqueId][0] && ytPlayersMainSlider[uniqueId][0].playVideo) {
            ytPlayersMainSlider[uniqueId][0].playVideo();

            setTimeout(function () {
              $slider.removeClass('is-loading');
              $slider.addClass('is-loaded');
            }, 100);
          }
        } else {
          setTimeout(function () {
            $slider.removeClass('is-loading');

            setTimeout(function () {
              $slider.addClass('is-loaded');
            }, 2500);
          }, 500);
        }
        slideStart(null, 0);
      }

      function slickInit() {
        $slider.on('init', function (event, slick) {
          if (!$(slick.$slides[0]).find('.cmd-visual_video')[0]) {
            $slider.removeClass('is-loading');
          }
          if ($(slick.$slides[0]).find('.cmd-visual_video')[0]) {
            $(slick.$slides[0]).addClass('is-wait');
          }

          matchMediaPC.addListener(function (e) {
            if (e.matches) {
              var index = $slider.find('.slick-active').attr('data-slick-index');
              if (ytPlayersMainSlider[uniqueId][index] && ytPlayersMainSlider[uniqueId][index].playVideo) {
                ytPlayersMainSlider[uniqueId][index].playVideo();
              }
            } else {
              for (var i = 0; i < ytPlayersMainSlider[uniqueId].length; i++) {
                if (ytPlayersMainSlider[uniqueId][i].stopVideo) {
                  ytPlayersMainSlider[uniqueId][i].stopVideo();
                }
              }
            }
          });
        });

        $slider.slick({
          fade: true,
          infinite: true,
          dots: true,
          appendDots: $slider.nextAll('.js-slider_dots'),
          arrows: true,
          appendArrows: $slider.nextAll('.js-slider_arrow')
        });

        $sliderWrap.find('.slick-dots').find('button').append('<span class="bar"></span>');

        $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {});

        $slider.on('afterChange', function (event, slick, currentSlide) {
          slideStart(slick, currentSlide);
        });

        centerSet_arrow_dots($slider);
      }

      function slideStart(slick, currentSlide) {
        clearTimeout(nextTimer);
        clearInterval(seekbarTimer);
        clearTimeout(loadingTimer);

        for (var i = 0; i < ytPlayersMainSlider[uniqueId].length; i++) {
          if (ytPlayersMainSlider[uniqueId][i].stopVideo) {
            ytPlayersMainSlider[uniqueId][i].stopVideo();
          }
        }

        var $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');

        // 動画コンテンツはすべてwait
        $slider.find('.slick-slide').each(function () {
          if ($(this).find('.cmd-visual_video')[0]) {
            if (isPC()) {
              $(this).addClass('is-wait');
            }
          }
        });

        // 動画が再生開始したらwait解除
        var loop = function loop() {
          if (ytPlayersMainSlider[uniqueId][currentSlide] && ytPlayersMainSlider[uniqueId][currentSlide].getPlayerState() === YT.PlayerState.PLAYING) {
            clearTimeout(loadingTimer);
            $currentSlide.removeClass('is-wait');
          }
          loadingTimer = setTimeout(loop, 50);
        };
        if (isPC()) {
          loop();
        } else {
          $currentSlide.removeClass('is-wait');
        }

        $sliderWrap.find('.slick-dots').find('.bar').css('width', 0);

        if (ytPlayersMainSlider[uniqueId][currentSlide] && isPC()) {
          ytPlayersMainSlider[uniqueId][currentSlide].playVideo();
        }
        seekbarPlay($currentSlide, currentSlide);
      }

      function videoStop() {
        clearTimeout(nextTimer);
        clearInterval(seekbarTimer);
        clearTimeout(loadingTimer);

        var currentSlideNum = $slider.slick('slickCurrentSlide');
        var $currentSlide = $slider.find('[data-slick-index="' + currentSlideNum + '"]');

        if ($currentSlide.find('.cmd-visual_video')[0]) {
          if (isPC()) {
            $currentSlide.addClass('is-wait');
          }
        }

        setTimeout(function () {
          ytPlayersMainSlider[uniqueId][currentSlideNum].stopVideo();
        }, 500);
      }

      function seekbarPlay($currentSlide, currentSlide) {
        var cnt = 0;
        var step = 10;
        var subtract = 500;
        var $dotsBar = $sliderWrap.find('.slick-dots').find('li').eq(currentSlide).find('.bar');

        seekbarTimer = setInterval(function () {
          var duration = carouselDuration;

          if (!$currentSlide.find('.cmd-visual_video')[0] || !isPC()) {
            cnt += 10;
          } else {
            var movieDuration = ytPlayersMainSlider[uniqueId][currentSlide].getDuration() * 1000 - subtract;
            duration = carouselDuration > movieDuration ? movieDuration : carouselDuration;
            cnt = ytPlayersMainSlider[uniqueId][currentSlide].getCurrentTime() * 1000;
          }

          $dotsBar.css('width', cnt / duration * 100 + '%');

          if (duration > 0 && duration < cnt) {
            // 再生終了0.5秒前に次ぎスライドへ移動
            // 関連動画表示対処
            clearInterval(seekbarTimer);
            if (isSingleAndMovie) {
              if (typeof $slider.attr('data-slider-video-loop') !== 'undefined' && $slider.attr('data-slider-video-loop') === 'false') {
                // $slider.find('.slick-slide.slick-active').find('.cmd-visual_video').css({opacity: 0});
                videoStop();
              } else {
                slideStart(null, 0);
              }
            } else {
              if (typeof $slider.attr('data-slider-autoplay') !== 'undefined' && $slider.attr('data-slider-autoplay') === 'false') {
                videoStop();
              } else {
                $slider.slick('slickNext');
              }
            }
          }
        }, 10);
      }

      sliderInit();
    });

    $(window).on('resize', function (e) {
      if ($(window).width() !== windowWidth) {
        clearTimeout(windowDelay);
        windowDelay = window.setTimeout(function () {
          windowWidth = $(window).width();

          $('.js-slider_container').filter('.has-video').each(function () {
            var movieSize = getBgMovieSize();
            $(this).find('.cmd-visual_video').each(function () {
              $(this).css(movieSize);
            });
          });
        }, 50);
      }
    }).trigger('resize');
  };

  var mainSliderInit = function mainSliderInit() {
    // youtube api の読み込みと同時に YT YT.Player をチェック
    // APIの読み込みが完了したらsliderの実行
    // window.onYouTubeIframeAPIReadyは他のjsから実行されれている場合があるためYTをチェックする
    var youtubeApiLoad = function youtubeApiLoad() {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    };

    youtubeApiLoad();

    var YTcheck = setInterval(function () {
      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        mainSliderReady();
        clearInterval(YTcheck);
      }
    }, 50);
  };

  var normalSliderInit = function normalSliderInit() {
    $('.js-slider_container').not('[data-slider-type="main"]').each(function () {
      var $slider = $(this);
      if (!$slider.hasClass('slick-initialized')) {
        var option = {
          arrows: true,
          appendArrows: $slider.nextAll('.js-slider_arrow'),
          dots: true,
          appendDots: $slider.nextAll('.js-slider_dots'),
          autoplay: $slider.attr('data-slider-autoplay') === 'true',
          autoplaySpeed: $slider.attr('data-slider-autoplay') === 'true' ? $slider.attr('data-slider-autoplayspeed') || 3000 : 0
        };

        $slider.slick(option);
        centerSet_arrow_dots($slider);
      }
    });
  };

  var centerSet_arrow_dots = function centerSet_arrow_dots($slider) {
    setTimeout(function () {
      if ($slider.hasClass('slick-initialized')) {
        var $arrow = $slider.nextAll('.js-slider_arrow');
        var $dots = $slider.nextAll('.js-slider_dots');
        var boxHeight = $slider.find('.slick-active').find('.cmd-visual_img').height();
        if ($slider.find('.slick-active').find('.cmd-visual_img')[0]) {
          if (boxHeight) {
            // $arrow.css({top: boxHeight/2});
            $dots.css({
              top: boxHeight
            });
          } else {
            centerSet_arrow_dots($slider);
          }
        }
      }
    }, 100);
  };

  var resizeCheckSliderParts = function resizeCheckSliderParts() {
    var windowDelay;
    var windowWidth = $(window).width();

    $(window).on('resize', function (e) {
      if ($(window).width() !== windowWidth) {
        clearTimeout(windowDelay);
        windowDelay = window.setTimeout(function () {
          windowWidth = $(window).width();

          $('.js-slider_container').each(function () {
            var $slider = $(this);
            centerSet_arrow_dots($slider);
          });
        }, 50);
      }
    });
  };

  return {
    init: function init() {},
    ready: function ready() {
      normalSliderInit();
      mainSliderInit();
      resizeCheckSliderParts();
    },
    reInit: function reInit($target, option) {
      if ($target[0] && typeof $target.slick !== 'undefined') {
        $target.slick('slickSetOption', option);
      }
    },
    getAutoPlay: function getAutoPlay($target) {
      if ($target[0] && typeof $target.slick !== 'undefined') {
        return $target.slick('slickGetOption', 'autoplay');
      } else {
        return undefined;
      }
    },
    playPause: function playPause($target) {
      if ($target[0] && typeof $target.slick !== 'undefined') {
        var nowPlay = $target.slick('slickGetOption', 'autoplay');
        if (nowPlay) {
          $target.slick('slickPause');
        } else {
          $target.slick('slickPlay');
        }
      }
    },
    pause: function pause($target) {
      if ($target[0] && typeof $target.slick !== 'undefined') {
        $target.slick('slickPause');
      }
    },
    play: function play($target) {
      if ($target[0] && typeof $target.slick !== 'undefined') {
        $target.slick('slickPlay');
      }
    }
  };
}();

/**
 * inview animation
 */
var inViewAnimation = function () {
  return {
    init: function init() {},
    ready: function ready() {
      $('.js-anim-inout').on('inview', function (event, isInView) {
        if (isInView) {
          $(this).addClass('is-anim-active');
        } else {
          $(this).removeClass('is-anim-active');
        }
      });
      $('.js-anim-in').one('inview', function (event, isInView) {
        if (isInView) {
          $(this).addClass('is-anim-active');
        }
      });
    }
  };
}();

var design = {
  init: function init() {
    setDirectionCheck();
    initHeader.init();
    initFooter.init();
    initGlobalNavigation.init();
    initRightModal.init();
    initRightModalLoginResetPassword.init();
    initCenterModal.init();
    initQuickView.init();
    standardTab.init();
    standardToggle.init();
    snsToggle.init();
    tabAccordion.init();
    selectChangeContent.init();
    numDropDown.init();
    inputToggle.init();
    cart.init();
    naireModal.init();
    movieModal.init();

    /**
     * page:DOMContent​Loaded
     */
    cpbUi.isDomReady = true;
    cpbUi.isPdp = $('#contents').hasClass('pdp-main');
    cpbUi.niceScroll.ready();
    cpbUi.recommendSlider.ready();
    selectChangeContent.ready();
    if (cpbUi.isPdp) {
      cpbUi.pdp.ready();
      cpbUi.pdpSkinColor.ready();
    }
    inputToggle.ready();
    cart.ready();
    cpbUi.sectionSlider.ready();
    inViewAnimation.ready();

    // scroll fix
    $(window).trigger('scroll');
    window.cpbUi = cpbUi;
  }
};

module.exports = design;

},{"./pages/product":48}],26:[function(require,module,exports){
'use strict';

var util = require('./util'),
    validator = require('./validator'),
    modal = require('./modal').global;

function showNewsletterModal() {
  modal.events.onClose(function () {
    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    util.setCookie(shouldDisplayNewsletter, false, 10);
  });

  modal.renderByUrl(Urls.showFullNewsletterForm).success(function (response) {
    modal.addCustomClass('newsletter-signup-modal');

    $('.modal-content button').prop('disabled', true);
    $('.modal-content button').css('color', '#FFFFFF');

    validator.initForm('.newsletter-signup-modal form');
  });
}

function isNewsletterEnabled() {
  $('.register-newsletter').removeClass('hide');
  $('.newsletter-success').addClass('hide');

  if (!enableNewsletter) {
    return;
  }

  var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
  var isViewedNewsletterValid = util.getCookieSelector(hasViewedNewsletter);

  if (isViewedNewsletterValid === 'true') {
    return;
  }

  var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
  var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

  if (isDisplayedNewsletterValid === 'false') {
    return;
  }

  util.setCookie(hasViewedNewsletter, false, newsletterCookieDuration);
  util.setCookie(shouldDisplayNewsletter, true, newsletterCookieDuration);

  setNewsletterCounterCookie();
  signUpEventListener();
}

function setNewsletterCounterCookie() {
  var pageViewCount = [siteId, 'pageViewCount'].join('-');
  var isCookieValid = util.getCookieSelector(pageViewCount);
  var counterCookie = Number(isCookieValid);

  if (!isCookieValid) {
    counterCookie = 0;
  } else {
    counterCookie += 1;
  }

  util.setCookie(pageViewCount, counterCookie, newsletterCookieDuration);

  var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
  var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

  if (counterCookie >= pageViewsToNewsletter && isDisplayedNewsletterValid === 'true') {
    showNewsletterModal();
  }
}

function signUpEventListener() {
  $(document).on('submit', '.modal-content .news-letter-form', function (e) {
    e.preventDefault();

    var emailAddress = $('.modal-content input').val();
    validateNewsletterEmail(true, emailAddress);
  }).on('keyup blur', '.modal-content input', function (e) {
    var emailAddress = $(this).val();

    $('.modal-content button').prop('disabled', false);
    $('.modal-content button').css('color', '');

    if (!emailAddress.length) {
      $('.modal-content button').prop('disabled', true);
      $('.modal-content button').css('color', '#FFFFFF');
    }
  });
}

function newsletterHeader() {
  $(document).on('submit', '.cpb-footer-connect_container .news-letter-form', function (e) {
    e.preventDefault();

    var emailAddress = $('.news-letter-form input').val();
    validateNewsletterEmail(false, emailAddress);
  });
}

function validateNewsletterEmail(isModal, emailAddress) {
  var validateClass = '.news-letter-form';

  if (isModal) {
    validateClass = '.modal-content';
  }

  $(validateClass + ' input').removeAttr('aria-invalid');
  $(validateClass + ' input').removeAttr('aria-describedby');
  $(validateClass + ' input').removeAttr('class');
  $(validateClass + ' span').remove();

  if (!util.validateEmail(emailAddress)) {
    var errorMessage;

    if (isModal) {
      errorMessage = ['<span id="-error" class="error">', Resources.VALIDATE_EMAIL, '</span>'].join('');

      $(validateClass + ' .promotions-container').after(errorMessage);
      $(validateClass + ' button').prop('disabled', true);
    } else {
      errorMessage = ['<span id="-error" class="error">', Resources.VALIDATE_EMAIL, '</span>'].join('');

      $(validateClass + ' input').before(errorMessage);
    }
  }

  var postData = ['dwfrm_newsletter_email=', emailAddress].join('');
  var formAction = $('.newsletter-container form').attr('action');

  if ($('.newsletter-container form').length > 0) {
    $.ajax({
      type: 'POST',
      url: formAction,
      async: false,
      data: postData,
      success: function success(textStatus) {
        $('.register-newsletter').addClass('hide');
        $('.newsletter-success').removeClass('hide');
        $('.newsletter-success').addClass('show');
        $('.newsletter-success .registered-email').html(emailAddress);
        if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')) {
          window.universal_variable.user.email = emailAddress;
        }
      }
    });
  }

  if (isModal) {
    setHasViewedNewsletterCookie(true);
  }

  if ($('.news-letter-form').length > 0) {
    $.ajax({
      type: 'POST',
      url: $('.news-letter-form').attr('action'),
      async: false,
      data: {
        email: emailAddress,
        source: isModal ? 'modal' : 'header'
      },
      success: function success(response) {
        if (isModal) {
          modal.renderContent(response);
          modal.addCustomClass('newsletter-signup-modal');
          $(document).trigger('clicknewsletter', { siteloc: 'pop-up' });
        } else {
          $('.cpb-footer-connect_container form').html(response);
          $(document).trigger('clicknewsletter', { siteloc: 'footer' });
        }
        if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')) {
          window.universal_variable.user.email = emailAddress;
        }
      }
    });
  }
}

function setHasViewedNewsletterCookie(val) {
  var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
  util.setCookie(hasViewedNewsletter, val, newsletterCookieDuration);
}

exports.isNewsletterEnabled = isNewsletterEnabled;
exports.newsletterHeader = newsletterHeader;

},{"./modal":24,"./util":77,"./validator":78}],27:[function(require,module,exports){
'use strict';

var modal = require('./modal').global,
    util = require('./util');

exports.init = function init() {
  //On Change Select in PDP
  $('.replenishmentCycle').change(function () {
    var footerURL = window.location.href;
    var selection = $(this).val();

    if (window.User.isCustomerAuthenticated == false && selection != 0) {
      $('.replenishmentCycle').val('0');

      // render content to modal by url
      modal.renderByUrl(Urls.replenishmentLogin);
      modal.setCallback(function () {
        $('.modal-btn-signin').click(function () {
          var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
          window.location = util.appendParamToURL(urlLink, 'replenishment', selection);
        });

        $('.modal-btn-register').click(function () {
          window.location = Urls.showCreateAccount;
        });
      });
    }

    $('.modal-btn-signin').click(function () {
      var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
      window.location = util.appendParamToURL(urlLink, 'replenishment', selection);
    });

    $('.modal-btn-register').click(function () {
      window.location = Urls.showCreateAccount;
    });
  });

  //Update the Order replenishment suggestion based on product variant sizeVariations
  $('input[name=size]').click(function () {
    //Get the recommendation from the input data-isreplenishable
    var replennumber = this.getAttribute('data-isreplenishable');

    //Construct the replenishment message
    var replenmsg = '';
    if (replennumber !== null && replennumber > 0) {
      var message = Resources.RECOMMENDED_REPLENISHMENT;

      replenmsg += message;
      replenmsg += replennumber;
      replenmsg += ' ';
      replenmsg += replennumber > 1 ? '${spanPlural}' : '${span}';
      replenmsg += '.';
    }

    //Assign it to replenreccomendation
    $('#replenrecommendation').text(replenmsg);
  });

  //My Account Replenishment Update Button
  $('.replenishmentupdate').click(function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var uuid = getQueryValue('rid', href);
    var rdays = $('.' + uuid.substring(0, 26) + '_days').val();
    var replenishmentQuantity = $('.' + uuid.substring(0, 26) + '_quantity').val();
    var updateReplenishment = href + '&rdays=' + rdays + '&qty=' + replenishmentQuantity;
    window.location = updateReplenishment;
  });

  //My Account Replenishment Cancel Button
  $('.replenishmentcancel').click(function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var popup = new Foundation.Reveal($('#cancel-replenishment'));
    popup.open();

    $('.modal-btn-confirm').click(function () {
      window.location = href;
    });

    $('.modal-btn-keep').click(function () {
      popup.close();
    });
  });

  // Gets the query string value if it exists, returns null if it does not.
  // Example: getQueryValue("reset") will return the value true if the URL is http://www.domain.com?reset=true
  function getQueryValue(str, href) {
    /*var queryString = window.location.search.substring(1);*/
    var queryString = href;
    var queries = queryString.split('?');
    for (var i = 0; i < queries.length; i++) {
      var ft = queries[i].split('=');
      if (ft[0] == str) {
        return ft[1];
      }
    }
    return null;
  }
};

},{"./modal":24,"./util":77}],28:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
  title: '',
  type: '',
  params: util.getQueryStringParams(window.location.search.substr(1)),
  redirect: function redirect(newURL) {
    setTimeout(function () {
      window.location.href = newURL;
    }, 0);
  },
  refresh: function refresh() {
    setTimeout(function () {
      window.location.assign(window.location.href);
    }, 500);
  }
};

module.exports = page;

},{"./util":77}],29:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    modal = require('../modal').global,

//cardValidation = require('./checkout/card-validation'),
validator = require('../validator'),
    search = require('./search'),
    ajax = require('../ajax'),
    design = require('../design');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
  var $form = $('#edit-address-form');

  $form.find('input[name="format"]').remove();
  tooltip.init();
  //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

  $form.on('click', '.apply-button', function (e) {
    /****
     * e.preventDefault();
     * if (!$form.valid()) {
     *     return false;
     * }
     * var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
     * var applyName = $form.find('.apply-button').attr('name');
     * var options = {
     *     url: url,
     *     data: $form.serialize() + '&' + applyName + '=x',
     *     type: 'POST'
     * };
     * $.ajax(options).done(function (data) {
     *     if (typeof(data) !== 'string') {
     *         if (data.success) {
     *             dialog.close();
     *             page.refresh();
     *         } else if (data.error) {
     *             page.redirect(Urls.csrffailed);
     *         } else {
     *             window.alert(data.message);
     *             return false;
     *         }
     *     } else {
     *         $('#dialog-container').html(data);
     *         account.init();
     *         tooltip.init();
     *     }
     * });
     ****/
  }).on('click', '.cancel-button, .close-button', function (e) {
    e.preventDefault();
    dialog.close();
  }).on('click', '.delete-button', function (e) {
    e.preventDefault();
    if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
      var url = util.appendParamsToUrl(Urls.deleteAddress, {
        AddressID: $form.find('#addressid').val(),
        format: 'ajax'
      });
      $.ajax({
        url: url,
        method: 'POST',
        dataType: 'json'
      }).done(function (data) {
        if (data.status.toLowerCase() === 'ok') {
          dialog.close();
          page.refresh();
        } else if (data.message.length > 0) {
          window.alert(data.message);
          return false;
        } else {
          dialog.close();
          page.refresh();
        }
      });
    }
  });
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
  $('.order-items').find('li.hidden:first').prev('li').append('<a class="toggle">View All</a>').children('.toggle').click(function () {
    $(this).parent().siblings('li.hidden').show();
    $(this).remove();
  });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
  var addresses = $('#addresses');
  if (addresses.length === 0) {
    return;
  }

  $(document).on('click', '.address-edit', function (evt) {
    evt.preventDefault();
    var element = document.getElementById(evt.currentTarget.id);

    // for w+ api
    var addressObject = '';
    if (element.dataset.address == 'wplus') {
      addressObject = element.dataset.addressObject;
    }

    var addressID = element.dataset.addressId;
    var url = Urls.checkoutEditAccountAddress + addressID + '&wplus=' + addressObject;

    ajax.load({
      url: url,
      callback: function callback(data) {
        $('#editaddressmodal').html(data);
        $.magnificPopup.open({
          items: {
            src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
        validator.initForm('form[id="EditAddressForm"]');
        if (addressID == 0) {
          $("form[name='EditAddressForm'] #dwfrm_billing_billingAddress_addressFields_addressname").attr('readonly', 'true');
        }
        design.toggleSelectInit();
      }
    });
  });

  $(document).on('click', '.address-delete', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var params = {
      wplus: $(this).attr('wplus'),
      format: 'ajax',
      csrf_token: this.dataset.csrfvalue
    };
    var url = util.appendParamsToUrl(href, params);
    var data = util.getQueryStringParams(util.getQueryString(url));

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json'
    }).done(function (data) {
      page.refresh();
    });
  });

  $(document).on('click', '.address-make-default', function (e) {
    e.preventDefault();
    var params = {
      wplus: $(this).attr('wplus'),
      format: 'ajax',
      csrf_token: this.dataset.csrfvalue
    };
    var href = $(this).attr('href');
    href = util.appendParamsToUrl(href, params);
    var data = util.getQueryStringParams(util.getQueryString(href));

    $.ajax({
      type: 'POST',
      url: href,
      data: data,
      dataType: 'json'
    }).done(function (data) {
      page.refresh();
    }).fail(function (jqXHR, textStatus, errorThrown) {
      console.log('error');
      console.log(jqXHR);
      console.log(textStatus);
      console.log(errorThrown);
    });
  });

  $(document).on('click', '.address-create', function (evt) {
    evt.preventDefault();

    ajax.load({
      url: Urls.checkoutAddAccountAddress,
      callback: function callback(data) {
        $('#editaddressmodal').html(data);
        $.magnificPopup.open({
          items: {
            src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
        validator.initForm('form[id="EditAddressForm"]');
        design.toggleSelectInit();
      }
    });
  });

  $(document).on('click', "form[name='EditAddressForm'] button[name='dwfrm_profile_address_create'], form[name='EditAddressForm'] button[name='dwfrm_profile_address_edit']", function (event) {
    event.preventDefault();
    var form = $(this).parents('form#EditAddressForm');
    var url = form.attr('action') + '&format=ajax';
    var dataSend = form.serialize() + '&dwfrm_profile_address_create=適用';
    $.ajax({
      type: 'POST',
      url: url,
      data: dataSend
    }).done(function (response) {
      var responseType = typeof response === 'undefined' ? 'undefined' : _typeof(response);

      if (responseType === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        window.location.href = Urls.csrffailed;
        return;
      }
      if (responseType === 'object' && (response.success || response.reload)) {
        window.location.reload();
        return;
      }
      if (responseType === 'object' && response.redirectToLogin) {
        window.location.href = Urls.showLogin;
        return;
      }
      if (responseType === 'object' && response.validationError) {
        response.errors.forEach(function (error) {
          var errorObj = {};
          errorObj[error.name] = error.message;
          form.data('validator').showErrors(errorObj);
          form.data('submitting', false);
        });
        return;
      }
      window.location.href = Urls.generalError;
    });
    return false;
  });
}

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
  $('.add-card').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href'),
      options: {
        open: initializePaymentForm
      }
    });
  });

  if ($('#CreditCardForm').is(':visible')) {
    creditCardTypeDetector();
    validator.initForm('form[id$="CreditCardForm"]');
  }

  $('.credit-card-create').on('click', function (e) {
    e.preventDefault();
    //validator.initForm('#CreditCardForm');
    resetForm($('#CreditCardForm'));
  });

  $('.remove-card, .set-default-card').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('form.remove-card-form');
    if ($form.data('submitting')) {
      e.stopPropagation();
      return false;
    }
    // Allow only one form to submit.
    $('.remove-card-form').data('submitting', true);
    $.ajax({
      type: 'POST',
      url: $(this).hasClass('remove-card') ? $form.attr('action') : Urls.setDefaultCreditCard,
      data: {
        CardId: $form.find('input[name="Card_id"]').val(),
        CardSeq: $form.find('input[name="CardSeq"]').val(),
        CardNumber: $form.find('input[name="CardNumber"]').val(),
        csrf_token: $form.find('#csrf-token-modal').val()
      }
    }).done(function (response) {
      var responseType = typeof response === 'undefined' ? 'undefined' : _typeof(response);

      if (responseType === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        window.location.href = Urls.csrffailed;
        return;
      }
      if (responseType === 'object' && response.success) {
        page.redirect(Urls.paymentsList);
        return;
      }
      page.redirect(Urls.generalError);
    });
  });

  $('#CreditCardForm .addCardSubmit').on('click', function (e) {
    var $form = $(this).closest('form');
    if (!$form.data('custom-validator')(e)) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    $('#CreditCardForm #applyBtn').trigger('click');
  });
}

function resetForm($form) {
  //remove all error
  $form[0].reset();
  $form.validate().resetForm();
  var $month = $('[name$="_expiration_month"]');
  var $year = $('[name$="_expiration_year"]');
  var $type = $('[name$="_newcreditcard_type"]');
  $form.find('p.c-input-label.is-error').removeClass('is-error');
  $form.find('p.jquery-validation').parent().remove();
  $form.find('p.jquery-validation').remove();
  $month.prev().removeClass('is-error');
  $year.prev().removeClass('is-error');
  $type.prevAll().removeClass('is-error');
  var $typeUl = $type.closest('ul');
  var $expiryUl = $month.closest('ul');
  $expiryUl.find('.card-expiry-error').remove();
  $typeUl.find('.card-type-error').remove();

  //reset value
  var resetValueField = [$type, $month, $year];
  var defaultMessage = [Resources.CREDIT_CARD_SELECT, Resources.CREDIT_CARD_MONTH, Resources.CREDIT_CARD_YEAR];
  resetValueField.forEach(function ($field, index) {
    var $selectField = $field.prev('.c-select');
    var $current = $selectField.find('.c-select-current');
    var $selectListItem = $selectField.find('ul.c-select-list>.c-select-list-item');
    var displayValue = defaultMessage[index];
    $selectListItem.children('a').removeClass('is-selected');
    $field.val('');
    $current.text(displayValue);
  });
}

function initializePaymentForm() {
  $('#CreditCardForm').on('click', '.cancel-button', function (e) {
    e.preventDefault();
    dialog.close();
  });
}

function mobileAccountMenu() {
  var pageContainer = $('#main');
  var primaryContent = $('#primary');
  var primaryContentHeight = $('#primary').outerHeight();
  var mobileNav = $('#secondary');
  var accountText = $('.account-text');
  var currentUrl = window.location.href;
  var cleanUrl = currentUrl.split('?')[0];

  $('.account-nav-asset a[href="' + cleanUrl + '"]').addClass('active-menu');

  $('.account-nav-asset a').on('click', function (e) {
    e.preventDefault();
    var url = $(this).attr('href');

    if (url != cleanUrl) {
      window.location = url;
    } else {
      mobileNav.css('min-height', primaryContentHeight);
      pageContainer.addClass('content-show');
    }
  });

  $('.back-to-account-btn a').on('click', function (e) {
    e.preventDefault();
    pageContainer.removeClass('content-show');
    mobileNav.css('min-height', 0);
  });
}

function initOrderHistoryEvents() {
  $(document).on('click', '.view-order-details', function (evt) {
    evt.preventDefault();

    $(this).prev().click();
  });
}

function registerAccountEvents() {
  // get the field elements
  var $gender = $('.registration-box #dwfrm_profile_customer_gender');
  var $newsletterCB = $('.registration-box #dwfrm_profile_customer_addtoemaillist');

  $gender.on('change', function (e) {
    $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
  });
  $newsletterCB.on('change', function (e) {
    $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
  });
}

function addressEvents() {
  function toggleBillingAddressFields(visible) {
    if (visible == true) {
      $('.country-dependent').each(function () {
        $(this).show();
      });
    } else {
      $('.country-dependent').each(function () {
        $(this).hide();
      });
    }

    if (window.User.isCustomerAuthenticated == false) {
      $('.checkout-billing').find('.set-default-cb').hide();
    }
  }

  $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country', function () {
    var selectContry = $(this).val();
    var $form = $(this).closest('form');

    if (selectContry == '') {
      toggleBillingAddressFields();
    } else if (selectContry == 'us') {
      toggleBillingAddressFields(true);
      $('.us-fields').show();
      $('.cn-fields').hide();
      $form.find('.postcode').removeClass('required');
      $form.find('.province').removeClass('required');
    } else {
      toggleBillingAddressFields(true);
      $('.cn-fields').show().css({ display: 'flex' });
      $('.us-fields').hide();

      $form.find('.postcode').addClass('required').rules('add', {
        required: true,
        postal: true,
        messages: {
          postal: Resources.INVALID_POSTAL
        }
      });
      $form.find('.province').addClass('required').rules('add', {
        required: true,
        simpletext: true,
        messages: {
          simpletext: Resources.VALIDATE_PROVINCE
        }
      });
    }
  });
}

function enableCountryField(status) {
  var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
  if (status) {
    countryField.removeAttr('disabled');
  } else {
    countryField.prop('disabled', true);
  }
}

function initContactUs() {
  var registrationForm = $('form#RegistrationForm');

  registrationForm.on('click', 'button#sendBtn', function (e) {
    e.preventDefault();

    $.ajax({
      url: util.appendParamToURL(Urls.customerServiceSubmit, 'format', 'ajax'),
      data: registrationForm.serialize(),
      method: 'POST'
    }).done(function (response) {
      if (response.status) {
        // contact modal
        var windowHeight = window.innerHeight - 130;
        $.magnificPopup.open({
          items: {
            src: '#contactmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });

        $('#contactmodal .contact-success-container .row').css('height', windowHeight);

        $(document).trigger('gtmcontactus');
        clearContactUsForm();
        registrationForm[0].reset();
      }
    });
  });
}

/**
 * Clear contact us form
 */
function clearContactUsForm() {
  $('input[name$="_contactus_firstname"]').val('');
  $('input[name$="_contactus_lastname"]').val('');
  $('input[name$="_contactus_email"]').val('');
  $('input[name$="_contactus_phone"]').val('');
  $('input[name$="_contactus_ordernumber"]').val('');
  $('textarea[name$="_contactus_comment"]').val('');
  //	$('form#RegistrationForm button[type="submit"]').prop('disabled', true);
}

function enableDisableSubmitButton(el) {
  var $saveBtn = $(el).closest('form').find('button[type="submit"]');

  var hasError = $saveBtn.closest('form').find('span.error');
  if (hasError.length) {
    //        $saveBtn.prop('disabled', true);
  } else {
    $saveBtn.prop('disabled', false);
  }
}

function setGender() {
  var gender = $('.gender select').data('gender');

  $('.gender select').val(gender);
}

function creditCardTypeDetector(options) {
  // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
  // Visa
  var visa_regex = new RegExp('^4[0-9]{0,15}$'),

  // MasterCard
  mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

  // American Express
  amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

  // Diners 300-305,3095,36,38-39
  diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),

  // UnionPay
  unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

  $('.cc-number input').focusout(function (e) {
    var cur_val = $(this).val();

    //Commenting this out since the event is handled on focusout
    // if ( cur_val.length == 16 ) {
    //     e.preventDefault();
    //     return;
    // }

    var $ccNumberContain = $(this).parents('.cc-number');

    // get rid of spaces and dashes before using the regular expression
    cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

    var $creditCard = $('[data-method="CREDIT_CARD"]');

    // checks per each, as their could be multiple hits
    if (cur_val.match(visa_regex)) {
      $ccNumberContain.addClass('is_visa');
      $creditCard.find('input[name$="_type"]').val('Visa').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="visa" src="' + Urls.staticPath + 'images/common/icn_visa.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_visa');
    }

    if (cur_val.match(mastercard_regex)) {
      $ccNumberContain.addClass('is_mastercard');
      $creditCard.find('input[name$="_type"]').val('MasterCard').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="mastercard" src="' + Urls.staticPath + 'images/common/icn_mastercard.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_mastercard');
    }

    if (cur_val.match(amex_regex)) {
      $ccNumberContain.addClass('is_amex');
      $creditCard.find('input[name$="_type"]').val('Amex').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="amex" src="' + Urls.staticPath + 'images/common/icn_amex.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_amex');
    }

    if (cur_val.match(diners_regex)) {
      $ccNumberContain.addClass('is_diners');
      $creditCard.find('input[name$="_type"]').val('Diners').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="diners" src="' + Urls.staticPath + 'images/common/icn_diners.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_diners');
    }

    if (cur_val.match(unionpay_regex)) {
      $ccNumberContain.addClass('is_unionpay');
      $creditCard.find('input[name$="_type"]').val('Union').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="unionpay" src="' + Urls.staticPath + 'images/common/icn_unionpay.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_unionpay');
    }

    // if nothing is a hit we add a class to fade them all out
    if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) && !cur_val.match(amex_regex) && !cur_val.match(diners_regex) && !cur_val.match(unionpay_regex)) {
      $ccNumberContain.addClass('is_nothing');
      clearCardIcon($creditCard);
    } else {
      $ccNumberContain.removeClass('is_nothing');
    }
  });
}

/**
 * Clear card icon
 * @returns
 */
function clearCardIcon($creditCard) {
  $creditCard.find('input[name*="_number"]').parent().find('.mastercard').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.visa').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.diners').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.amex').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.unionpay').remove();
}

function withdrawReasonsEvents() {
  var reasons = $('.c-c-input-checklist label input[name^="dwfrm_withdrawreason_choices_reason"]');
  var validator = reasons.closest('form').data('validator');
  reasons.find('ul').remove();
  var isValid;
  reasons.on('change', function () {
    var flg = false;
    reasons.each(function (_, element) {
      $(element).closest('li').find('ul').remove();
      if ($.validator.methods.requireWithdraw()) {
        flg = true;
      }
    });
    if (flg) {
      $('#checkbox-atleast-one-error').remove();
    } else {
      reasons.closest('ul').append('<p id="checkbox-atleast-one-error" class="jquery-validation is-error c-input-label" style="margin-top: 5px;">' + Resources.VALIDATE_REASONS + '</p>');
    }
    return isValid;
  });

  reasons.closest('form').submit(function () {
    var flg = false;
    reasons.each(function (_, element) {
      if ($.validator.methods.requireWithdraw()) {
        flg = true;
      }
    });
    if (flg) {
      $('#checkbox-atleast-one-error').remove();
    } else {
      reasons.closest('ul').append('<p id="checkbox-atleast-one-error" class="jquery-validation is-error c-input-label" style="margin-top: 5px;">' + Resources.VALIDATE_REASONS + '</p>');
    }
    return flg;
  });
}

function tempRegisterEvents() {
  var $tempRegister = $('button[name="dwfrm_profile_tempregister"]');
  if ($tempRegister.length === 0) {
    return;
  }
  var $form = $tempRegister.closest('form');
  $(document).on('submit', $form, function (event) {
    if ($tempRegister.data('disabled')) {
      return false;
    }
    $tempRegister.data('disabled', true);
    // cvタグを外すことになったためコメントアウト(20191003)
    // // cvタグ処理(components/cv/conversiontag.ismlで関数を定義)
    // // GDN
    // const url = $tempRegister.closest('form').prop('action');
    // gtag_report_conversion(url);
    // // YDN

    // // Facebook Pixel Code
    // fbq('track', 'CompleteRegistration');
  });
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
  //cardValidation.init();
  toggleFullOrder();
  initAddressEvents();
  initPaymentEvents();
  login.init();
  registerAccountEvents();
  addressEvents();
  initContactUs();
  mobileAccountMenu();
  setGender();
  search.viewMore();
  initOrderHistoryEvents();
  withdrawReasonsEvents();
  tempRegisterEvents();
}

var account = {
  init: function init() {
    initializeEvents();
    giftcert.init();
  },
  initCartLogin: function initCartLogin() {
    login.init();
  },
  initMobileMenu: function initMobileMenu() {
    mobileAccountMenu();
  }
};

module.exports = account;

},{"../ajax":1,"../design":11,"../dialog":12,"../giftcert":16,"../login":22,"../modal":24,"../page":28,"../tooltip":76,"../util":77,"../validator":78,"./search":57}],30:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    images = require('./product/image'),
    variant = require('./product/variant'),
    giftShipping = require('./checkout/shipping'),
    recommendations = require('./product/recommendations'),
    cartStoreInventory = require('../storeinventory/cart'),
    modal = require('../modal').global,
    samples = require('../samples'),
    giftCert = require('../giftcert-modal'),
    login = require('./checkout/login'),
    util = require('../util'),
    design = require('../design'),
    ajax = require('../ajax'),
    addToCart = require('./product/addToCart'),
    shipping = require('./checkout/shipping');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
  $('#cart-items-form .c-list-products-full-edit a').magnificPopup({
    type: 'ajax',
    ajax: {
      settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
      // For example:
      // settings: {cache:false, async:false}

      cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
      tError: '<a href="%url%">The content</a> could not be loaded.' //  Error message, can contain %curr% and %total% tags if gallery is enabled
    },
    callbacks: {
      parseAjax: function parseAjax(mfpResponse) {
        // mfpResponse.data is a "data" object from ajax "success" callback
        // for simple HTML file, it will be just String

        // mfpResponse.data must be a String or a DOM (jQuery) element
        mfpResponse.data = $(mfpResponse.data).find('.c-block-shopingmodal').first();
      },
      ajaxContentAdded: function ajaxContentAdded() {
        $('#shopingmodal').html(this.content[0].outerHTML);
        $.magnificPopup.open({
          items: {
            src: '#shopingmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });

        images();
        variant();
        addToCart();
        renderThumbnails();

        $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function () {
          window.location.href = url + '#reviews'; // redirect when rating star is clicked
        });

        $(document).on('click', '.bv-popup-in .bv-read-review', function () {
          window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
        });

        design.modalInit();
        design.pdpInit();
        design.selectQuantityInit();
        design.toggleSelectInit();
        giftCert.initModal();
      }
    }
  });

  $('#cart-table').on('click', '.item-edit-details a', function (e) {
    e.preventDefault();

    quickview.show({
      url: e.target.href,
      source: 'cart',
      callback: function callback() {
        variant();
        renderThumbnails();
      }
    });
  }).on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
    e.preventDefault();
    bonusProductsView.show(this.href);
  });

  // override enter key for coupon code entry
  $('input[name$="_couponCode"]').on('keydown', function (e) {
    if (e.which === 13 && $(this).val().length === 0) {
      return false;
    }
  });

  //to prevent multiple submissions of the form when removing a product from the cart
  var removeItemEvent = false;
  $('.cpb-cart-bag_box .item-remove a').on('click', function (e) {
    if (removeItemEvent) {
      e.preventDefault();
    } else {
      removeItemEvent = true;
      var deleteHtml = $(this).closest('.cpb-cart-bag_box').find('input[name$=_deleteProduct]')[0].outerHTML;
      $('input[name$=_deleteGiftCertificate]').remove();
      $('input[name$=_deleteProduct]').remove();
      $('input[name$=_deleteCoupon]').remove();
      $(this).parent().append(deleteHtml);
      $(this).closest('form').submit();
    }
  });

  $('.c-list-giftcard-full-remove a').on('click', function (e) {
    if (removeItemEvent) {
      e.preventDefault();
    } else {
      removeItemEvent = true;
      var deleteHtml = $(this).closest('.c-list-products-full-item-text-parts--short').find('input[name$=_deleteGiftCertificate]')[0].outerHTML;
      $('input[name$=_deleteGiftCertificate]').remove();
      $('input[name$=_deleteProduct]').remove();
      $('input[name$=_deleteCoupon]').remove();
      $(this).parent().append(deleteHtml);
      $(this).closest('form').submit();
    }
  });

  $('.c-list-sample-remove a').on('click', function (e) {
    if (removeItemEvent) {
      e.preventDefault();
    } else {
      removeItemEvent = true;
      var deleteHtml = $(this).closest('.c-block-productsItem--smbreak').find('input[name$=_deleteProduct]')[0].outerHTML;
      $('input[name$=_deleteGiftCertificate]').remove();
      $('input[name$=_deleteProduct]').remove();
      $('input[name$=_deleteCoupon]').remove();
      $(this).parent().append(deleteHtml);
      $(this).closest('form').submit();
    }
  });

  $('.c-list-coupon-remove a').on('click', function (e) {
    if (removeItemEvent) {
      e.preventDefault();
    } else {
      removeItemEvent = true;
      var deleteHtml = $(this).closest('.c-list-products-full-item-text-parts--short').find('input[name$=_deleteCoupon]')[0].outerHTML;
      $('input[name$=_deleteGiftCertificate]').remove();
      $('input[name$=_deleteProduct]').remove();
      $('input[name$=_deleteCoupon]').remove();
      $(this).parent().append(deleteHtml);
      $(this).closest('form').submit();
    }
  });

  // product level bonus modal
  $('div.bonus-item-promo').on('click', 'a.select-bonus', function (e) {
    e.preventDefault();

    var urlToRender = $(this).attr('href');
    if (urlToRender) {
      modal.addCustomClass('bonus-item-modal');
      modal.renderByUrl(urlToRender);
    }
  });

  $(document).on('click', '#item-sample .cpb-cart_add_btn a.button[data-modal-target="sample"]', function (e) {
    samples.showSelectionInCart();
  }).on('click', '.paypal-container a', function (e) {
    e.preventDefault();

    var cartCheckoutForm = $('.cart-action-checkout');
    if (cartCheckoutForm.length > 0) {
      cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
      cartCheckoutForm.submit();
    }
  });

  reloadWishlistButtonEvent();

  $('.add-to-wishlist').on('click', function (ev) {
    var form = document.createElement('form');
    form.setAttribute('action', this.dataset.posturl);
    form.setAttribute('method', 'post');
    form.style.display = 'none';
    document.body.appendChild(form);

    $('.post-params').each(function (index, element) {
      var input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', element.name);
      input.setAttribute('value', element.value);
      form.appendChild(input);
    });
    form.submit();
    ev.preventDefault();
    ev.stopPropagation();
    return false;
  });

  $('.apply-points').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    var totalPoint = 0;
    var errListPoint = false;
    $form.find('._used input.point_value').each(function () {
      if ($(this).siblings('input[name*="_point_to_use"]').val() >= Number($(this).val())) {
        totalPoint += Number($(this).val());
      } else {
        errListPoint = true;
      }
    });
    $.ajax({
      url: Urls.validatePoint,
      data: {
        totalPoint: totalPoint,
        errListPoint: errListPoint
      }
    }).done(function (response) {
      if (response.error) {
        $form.find('.cpb-modalR_bottom').find('p.is-error').remove();
        $form.find('.cpb-modalR_bottom').find('.button.apply-points').attr('disabled', true);
        $form.find('.cpb-modalR_bottom').find('.point-use_box').before('<p class="is-error">' + response.errMsg + '<p>');
      } else {
        var formdata = $form.serialize();
        ajax.load({
          url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
          data: formdata + '&totalPoint=' + totalPoint,
          target: $('.cart-use-point'),
          callback: function callback(data) {
            var sidebarItemPrice = $(data).find('.cpb-cart-side_total .item-price strong');
            if (sidebarItemPrice.length > 0) {
              var footerItemPrice = $('.cpb-cart-checkout_fixed .item-price');
              if (footerItemPrice.length > 0) {
                footerItemPrice.html(sidebarItemPrice[0]);
              }
            }
            usePointInit();
            shipping.initCouponCodeField();
            var isBilling = $('.cpb-template-paymentmethodsoptions').length !== 0;
            if (isBilling) {
              $.ajax({
                url: Urls.paymentmethodsoptions + '?checkedId=' + $('[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val() + '&format=ajax'
              }).then(function (response) {
                if (typeof response !== 'string') {
                  throw response;
                }
                return response;
              }).then(function (response) {
                $('.cpb-template-paymentmethodsoptions').html(response);
                var $form = $('#add-use-point');
                var totalPoint = 0;
                $form.find('._used input.point_value').each(function () {
                  totalPoint += Number($(this).val());
                });
                var totalprice = Number($('.cpb-modalR_bottom').find('input[name="orderTotalValue"]').val());
                var radioChecked = $('[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val();
                $('.payment-method-expanded').removeClass('is-active');
                $('.cpb-cart-input[data-tab-contents^="content-"]').removeClass('is-active');
                if (radioChecked === 'CREDIT_CARD') {
                  if (Number(totalPoint) !== totalprice) {
                    $('.payment-method-expanded').addClass('is-active');
                  }
                } else {
                  $('[data-tab-contents="content-' + radioChecked + '"]').addClass('is-active');
                }
                $form.find('.js-modal-r_close').click();
              }).fail(function (response) {
                if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && response.redirectToLogin) {
                  window.location.href = Urls.showLogin;
                  return;
                }
                window.location.href = Urls.generalError;
              });
            } else {
              $form.find('.js-modal-r_close').click();
            }
          }
        });
      }
    });
  });

  $('#add-use-point').find('._used input.point_value').on('keydown', function (event) {
    if (event.keyCode == 13) {
      event.preventDefault();
      $('.apply-points').click();
    }
  });

  usePointInit();

  $('.js-edging-item-edit').on('click', function (e) {
    e.preventDefault();

    var data = {
      uuid: $(this).closest('.cart-row').data('uuid'),
      edgingText: $(this).data('edging-text')
    };
    var url = util.appendParamToURL(Urls.showProductServiceForm, 'pid', $(this).data('product-id'));
    var target = '.product-service';
    $(target).empty();

    ajax.load({
      url: url,
      target: target,
      data: { isCart: true },
      callback: function callback() {
        initProductServiceEvents(data);
      }
    });
  });

  $(document).on('click', '.js-naire-setting-button', function (e) {
    e.preventDefault();
    $('#naire-data').siblings('p.is-error').remove();
    if ($('#naire-data').val() == '') {
      $('#naire-data').after($('<p class="c-input-label is-error"></p>').append(Resources.ENGRAVING_DATA_EMPTY));
    } else {
      $('.js-naire-setting').click();
    }
  });
}

function usePointInit() {
  $('.delete-use-point').on('click', function (e) {
    e.preventDefault();
    ajax.load({
      url: util.appendParamToURL($(this).data('href'), 'format', 'ajax'),
      target: $('.cart-use-point'),
      callback: function callback(data) {
        shipping.initCouponCodeField();
        var isBilling = $('.cpb-template-paymentmethodsoptions').length !== 0 ? true : false;
        if (isBilling) {
          $.ajax({
            url: Urls.paymentmethodsoptions + '?checkedId=' + $('[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val() + '&format=ajax'
          }).then(function (response) {
            if (typeof response !== 'string') {
              throw response;
            }
            return response;
          }).then(function (response) {
            $('.cpb-template-paymentmethodsoptions').html(response);
            var radioChecked = $('[name=dwfrm_billing_paymentMethods_selectedPaymentMethodID]:checked').val();
            if (radioChecked === 'CREDIT_CARD') {
              $('.payment-method-expanded').addClass('is-active');
            } else {
              $('[data-tab-contents="content-' + radioChecked + '"]').addClass('is-active');
            }
          }).fail(function (response) {
            if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && response.redirectToLogin) {
              window.location.href = Urls.showLogin;
              return;
            }
            window.location.href = Urls.generalError;
          });
        }
      }
    });
  });
  $('.wplus-point_box._used input').on('keyup', applyPoint);
  applyPoint();
}

function applyPoint(e) {
  if (e) {
    e.preventDefault();
  }
  var $form = $('#add-use-point');
  var totalPoint = 0;
  var totalPointCanUse = 0;
  var isValidPoint = true,
      isValidPointTotal = true;

  $form.find('._used input.point_value').each(function () {
    totalPointCanUse = $(this).parent().find('input[name$="_point_to_use"]').val();
    if (totalPointCanUse >= Number($(this).val())) {
      totalPoint += Number($(this).val());
    } else {
      totalPoint = 0;
      isValidPoint = false;
      return false;
    }
  });

  var totalprice = Number($('.cpb-modalR_bottom').find('input[name="orderTotalValue"]').val());
  if (Number(totalPoint) > totalprice) {
    isValidPointTotal = false;
  }
  if (!isValidPoint) {
    $form.find('.cpb-modalR_bottom').find('p.is-error').remove();
    $form.find('.cpb-modalR_bottom').find('.button.apply-points').attr('disabled', true);
    $form.find('.cpb-modalR_bottom').find('.point-use_box').before('<p class="is-error">' + Resources.INVALID_POINT + '<p>');
  } else if (!isValidPointTotal) {
    $form.find('.cpb-modalR_bottom').find('p.is-error').remove();
    $form.find('.cpb-modalR_bottom').find('.button.apply-points').attr('disabled', true);
    $form.find('.cpb-modalR_bottom').find('.point-use_box').before('<p class="is-error">' + Resources.INVALID_POINT_TOTAL + '<p>');
  } else {
    $form.find('.cpb-modalR_bottom').find('p.is-error').remove();
    $form.find('.cpb-modalR_bottom').find('.button.apply-points').attr('disabled', false);
    $('span[name="total-point-value"]').html(totalPoint.toLocaleString());
    $('span[name="total-price-value"]').html((totalprice - totalPoint).toLocaleString());
  }
}

function reloadWishlistButtonEvent() {
  $('.cpb-cart-bag_box #save-for-later').on('click', function (e) {
    if (!window.User.isCustomerAuthenticated) {
      return;
    }

    e.preventDefault();
    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    });
  });

  $('.cpb-cart-bag_box .remove-from-wishlist').on('click', function (e) {
    e.preventDefault();

    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    }).fail(function (xhr, textStatus) {
      if (textStatus === 'parsererror') {
        window.alert(Resources.BAD_RESPONSE);
      } else {
        window.alert(Resources.SERVER_CONNECTION_ERROR);
      }
    });
  });
}

function renderThumbnails() {
  if ($('#thumbnails').length > 0) {
    $('#thumbnails').empty(); // clear the list
    images(); // populate the thumbnails
  }
}

function isGift() {
  var isGift = sessionStorage.getItem('isGift') === 'true';
  var isGiftName = [$('#cart-items-form').attr('name'), 'isGift'].join('_');

  $('#checkout-form .is-gift').val(isGift);
  $('#checkout-form .is-gift').attr('name', isGiftName);
  $('.gift-container .input-checkbox').attr('checked', isGift);
  $('.gift-container .input-checkbox').change(function () {
    isGift = $(this).is(':checked');

    if (!isGift) {
      $('.c-block-cartmessage .input-textarea').val('');
      $('#checkout-form .gift-message').val('');
      $('#checkout-form button').prop('disabled', false); // Added by ADe to enable Checkout button
      $('.third-party-container').css('opacity', 1);
      $('.third-party-container').css('pointer-events', 'all');
      //Ade
      if ($('.gift-message-textarea span.error:visible').length > 0) {
        $('.gift-message-textarea span.error').remove();
      }
      sessionStorage.removeItem('isGift');
      sessionStorage.removeItem('giftMessage');
    } else {
      $('.gift-container .input-textarea').keyup();
      sessionStorage.setItem('isGift', isGift);
    }

    $('#checkout-form .is-gift').val(isGift);
  });
}

function giftMessage() {
  var giftMessage = sessionStorage.getItem('giftMessage') ? sessionStorage.getItem('giftMessage') : '';
  var giftMessageName = [$('#cart-items-form').attr('name'), 'giftMessage'].join('_');

  $('#checkout-form .gift-message').val(giftMessage);
  $('#checkout-form .gift-message').attr('name', giftMessageName);
  $('.c-block-cartmessage .input-textarea').val(giftMessage);
  $('.c-block-cartmessage .input-textarea').on('keyup', function () {
    giftMessage = $(this).val().trim();

    if (giftMessage === '' || util.validateMessage(giftMessage)) {
      $('#checkout-form .gift-message').val(giftMessage);
      $('.gift-message-textarea .form-caption').removeClass('error-message');
      $('.gift-message-textarea .form-caption').empty();
      $('#checkout-form button').prop('disabled', false);
      $('.third-party-container').css('opacity', 1);
      $('.third-party-container').css('pointer-events', 'all');
      sessionStorage.setItem('giftMessage', giftMessage);
    } else {
      $('.gift-message-textarea .form-caption').addClass('error-message');
      $('.gift-message-textarea .form-caption').text('Invalid message');
      $('#checkout-form button').prop('disabled', true);
      $('.third-party-container').css('opacity', 0.5);
      $('.third-party-container').css('pointer-events', 'none');
    }
  });
}

function couponCodeEvent() {
  $('.cpb-cart-side_code input').on('keydown', function (e) {
    if (e.which === 13) {
      e.preventDefault();

      $('#add-coupon').click();
    }
  });
}

function updateCart() {
  $('.item-quantity select').change(function () {
    $('#cart-items-form').submit();
  });
}

function cartCount() {
  if ($('.cart-empty').length) {
    sessionStorage.removeItem('isGift');
    sessionStorage.removeItem('giftMessage');
  }
}

function initProductServiceEvents(data) {
  $('#productservicemodal .product-service-step1 .cpb-naire-color_list a').off('click').on('click', function (e) {
    e.preventDefault();
    updateContent($(this), $(this).attr('href'), data);
    return false;
  });

  $('#add-to-cart-in-modal').on('click', data, editEdgingItem);
}

function updateContent($element, url, data) {
  var $productServiceModal = $element.parents('.product-service-step1');
  if ($productServiceModal.length === 0) {
    return;
  }
  var edgingtext = $('[name=dwfrm_productengraving_edgingtext]').val();
  var edgingFont = $('input[name=naire-font]:checked').val();
  ajax.load({
    url: url,
    data: {
      Quantity: '1',
      isProductServiceModal: true,
      isCart: true
    },
    target: '.product-service',
    context: {
      edgingFont: edgingFont
    },
    callback: function callback() {
      $('#productservicemodal #naire-data').val(edgingtext);
      var edgingFont = this.context.edgingFont;
      // 選択状態にするラジオボタン要素を取得
      var checkedEdgingElement = $('input[name=naire-font]').toArray().filter(function (element) {
        return $(element).val() === edgingFont;
      });
      if (checkedEdgingElement.length === 0) {
        // 取得できなかった場合、一番最初の要素を選択状態する
        $('input[name=naire-font]').eq(0).prop('checked', true);
      } else {
        $(checkedEdgingElement).prop('checked', true);
      }
      $('#productservicemodal .js-naire-preview').empty().text(edgingtext);
      initProductServiceEvents(data);
    }
  });
}

function editEdgingItem(e) {
  e.preventDefault();

  var productId = $(this).data('product');
  var engravingText = $('#naire-data').val();
  var engravingFont = $('input[name=naire-font]:checked').data('id');
  if (productId === '') {
    return;
  }
  if (engravingText === '') {
    engravingText = $('#naire-data').attr('placeholder');
  }

  $.ajax({
    type: 'post',
    url: Urls.addToCartInModal,
    data: {
      productId: productId,
      engravingText: engravingText,
      uuid: e.data.uuid,
      engravingFont: engravingFont
    }
  }).done(function (response) {
    if (response.success) {
      window.location.href = Urls.cartShow;
    } else {
      if (response.showGeneralError) {
        return window.location.href = Urls.generalError;
      }
      var $errorPlacement = $('#add-to-cart-in-modal').closest('.cpb-modalR_bottom').find('.c-text-error');
      $errorPlacement.find('li').remove();
      $errorPlacement.append($('<li></li>').text(response.error));
      $errorPlacement.removeClass('mfp-hide');
    }
  });
}

exports.init = function () {
  login.init();
  initializeEvents();
  recommendations();
  isGift();
  giftMessage();
  updateCart();
  couponCodeEvent();
  cartCount();
  giftShipping.init();
  giftCert.init();

  if (SitePreferences.STORE_PICKUP) {
    cartStoreInventory.init();
  }

  account.initCartLogin();
};

},{"../ajax":1,"../bonus-products-view":4,"../design":11,"../giftcert-modal":15,"../modal":24,"../quickview":66,"../samples":69,"../storeinventory/cart":72,"../util":77,"./account":29,"./checkout/login":38,"./checkout/shipping":40,"./product/addToCart":44,"./product/image":47,"./product/recommendations":51,"./product/variant":54}],31:[function(require,module,exports){
'use strict';

var formPrepare = require('./checkout/formPrepare'),
    validator = require('../validator');

/**
 * @private
 * @function
 * @description Validates if check order form is filled out before enabling button
 */
function initializeEvents() {
  validator.initForm('form[id$="ordertrack"]');
}

exports.init = function () {
  initializeEvents();
};

},{"../validator":78,"./checkout/formPrepare":36}],32:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
  var $form = $('.address');
  // select address from list
  $('select[name$="_addressList"]', $form).on('change', function () {
    var selected = $(this).children(':selected').first();
    var selectedAddress = $(selected).data('address');
    if (!selectedAddress) {
      return;
    }
    util.fillAddressFields(selectedAddress, $form);
    shipping.updateShippingMethodList();
    // re-validate the form
    $form.validate().form();
  });
};

},{"../../util":77,"./shipping":40}],33:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    modal = require('../../modal').global,
    cardValidation = require('./card-validation'),
    validator = require('../../validator'),
    design = require('../../design');

var $cache;

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
  var $paymentMethods = $('.payment-method');
  $paymentMethods.removeClass('payment-method-expanded');

  var dataMethod = paymentMethodID;
  if (paymentMethodID == 'SA_SILENTPOST') {
    dataMethod = 'CREDIT_CARD';
  }

  var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + dataMethod + '"]');
  if ($selectedPaymentMethod.length === 0) {
    $selectedPaymentMethod = $('[data-method="Custom"]');
  }

  if (paymentMethodID == 'CREDIT_CARD' || paymentMethodID == 'SA_SILENTPOST') {
    $('.spsavecard').show();
  } else if ((paymentMethodID == 'SA_REDIRECT' || paymentMethodID == 'SA_IFRAME') && SitePreferences.TOKENIZATION_ENABLED) {
    $('.spsavecard').show();
  } else {
    $('.spsavecard').hide();
  }

  $selectedPaymentMethod.addClass('payment-method-expanded');

  // ensure checkbox of payment method is checked
  /* $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');*/
}

function creditCardTypeDetector(options) {
  // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
  // Visa
  var visa_regex = new RegExp('^4[0-9]{0,15}$'),

  // MasterCard
  mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

  // American Express
  amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

  // Diners 300-305,3095,36,38-39
  diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),

  // UnionPay
  unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

  $('.cc-number input').focusout(function (e) {
    var cur_val = $(this).val();

    //Commenting this out since the event is handled on focusout
    // if ( cur_val.length == 16 ) {
    //     e.preventDefault();
    //     return;
    // }

    var $ccNumberContain = $(this).parents('.cc-number');

    // get rid of spaces and dashes before using the regular expression
    cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

    var $creditCard = $('[data-method="CREDIT_CARD"]');

    // checks per each, as their could be multiple hits
    if (cur_val.match(visa_regex)) {
      $ccNumberContain.addClass('is_visa');
      $creditCard.find('input[name$="_type"]').val('Visa').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="visa" src="' + Urls.staticPath + 'images/common/icn_visa.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_visa');
    }

    if (cur_val.match(mastercard_regex)) {
      $ccNumberContain.addClass('is_mastercard');
      $creditCard.find('input[name$="_type"]').val('MasterCard').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="mastercard" src="' + Urls.staticPath + 'images/common/icn_mastercard.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_mastercard');
    }

    if (cur_val.match(amex_regex)) {
      $ccNumberContain.addClass('is_amex');
      $creditCard.find('input[name$="_type"]').val('Amex').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="amex" src="' + Urls.staticPath + 'images/common/icn_amex.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_amex');
    }

    if (cur_val.match(diners_regex)) {
      $ccNumberContain.addClass('is_diners');
      $creditCard.find('input[name$="_type"]').val('Diners').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="diners" src="' + Urls.staticPath + 'images/common/icn_diners.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_diners');
    }

    if (cur_val.match(unionpay_regex)) {
      $ccNumberContain.addClass('is_unionpay');
      $creditCard.find('input[name$="_type"]').val('Union').trigger('change');
      clearCardIcon($creditCard);
      $creditCard.find('input[name*="_number"]').parent().append('<img class="unionpay" src="' + Urls.staticPath + 'images/common/icn_unionpay.gif" alt="">');
    } else {
      $ccNumberContain.removeClass('is_unionpay');
    }

    // if nothing is a hit we add a class to fade them all out
    if (!cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) && !cur_val.match(amex_regex) && !cur_val.match(diners_regex) && !cur_val.match(unionpay_regex)) {
      $ccNumberContain.addClass('is_nothing');
      clearCardIcon($creditCard);
    } else {
      $ccNumberContain.removeClass('is_nothing');
    }
  });
}

/**
 * Clear card icon
 * @returns
 */
function clearCardIcon($creditCard) {
  $creditCard.find('input[name*="_number"]').parent().find('.mastercard').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.visa').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.diners').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.amex').remove();
  $creditCard.find('input[name*="_number"]').parent().find('.unionpay').remove();
}

function checkGiftCert() {
  var $balance = $('.c-block-giftcardbalance-block-send .balance');
  var $error = $('div#gift-card-balance-form .balance-error');
  var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
  var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

  $error.html('');
  $balance.html('');
  if ($giftCode.val().length === 0) {
    $error.html(Resources.GIFT_CARD_CODE_INVALID);
  } else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
    $error.html(Resources.GIFT_CARD_PIN_INVALID);
  } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
    $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
  }
  if ($error.html() !== '') {
    $error.addClass('c-text-error');
    return;
  }

  giftcard.checkBalance($giftCode.val(), $giftPin.val(), function (data) {
    if (data && data.error) {
      $error.addClass('c-text-error');
      return $error.html(data.error);
    }

    if (!data || !data.giftCertificate) {
      $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
      $error.addClass('c-text-error');
      return;
    }

    if (!data || !data.giftCertificate) {
      $balance.html(Resources.GIFT_CERT_INVALID).removeClass('success').addClass('is-error');
      return;
    }

    $balance.html('<div><dt>' + Resources.GIFT_CERT_CURRENT_BALANCE + '</dt><dd>' + data.giftCertificate.balance + '</dd></div>');
    $balance.addClass('c-list-total c-list-total--border c-list-total--large');

    $('button#check-giftcert-modal').closest('.c-row').addClass('mfp-hide');
    $('button#add-giftcert-modal').closest('.c-row').removeClass('mfp-hide');
    $('button#new-giftcert-modal').removeClass('mfp-hide');
  });
}

function applyGiftCert() {
  var $error = $('div#gift-card-balance-form .balance-error');
  var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
  var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

  $error.html('');
  if ($giftCode.val().length === 0) {
    $error.html(Resources.GIFT_CARD_CODE_INVALID);
    return;
  }
  /*else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
        return;
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
        return;
    }*/

  var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
    giftCertCode: $giftCode.val(),
    giftCertPIN: $giftPin.val(),
    format: 'ajax'
  });
  $.getJSON(url, function (data) {
    var fail = false;
    var msg = '';
    if (!data) {
      msg = Resources.BAD_RESPONSE;
      fail = true;
    } else if (!data.success) {
      msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
      fail = true;
    }
    if (fail) {
      $error.html(msg);
      return;
    } else {
      window.location.assign(Urls.billing);
    }
  });
}

function initCache() {
  $cache = {};

  $cache.checkoutForm = $('.checkout-billing');
  $cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}

function initCreditCardForm() {
  $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  $cache.checkoutForm.find('input[name*="_number"]').val('');

  var $ccContainer = $cache.checkoutForm.find('.payment-method').filter(function () {
    return $(this).data('method') == 'CREDIT_CARD';
  });

  $ccContainer.find('input[name*="_number"]').on('change', function (e) {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  });
  $ccContainer.find('input[name$="_owner"]').on('change', function (e) {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
  });

  $ccContainer.find('select[name*="expiration"]').on('change', function (e) {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

    var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
    var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
    if (cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST') {
      $cache.checkoutForm.find('input[name*="_number"]').val('');
    }
  });
}

function initCreditCardEvents() {
  $(document).on('click', '#panel-newcard-label', function (evt) {
    var $form = $('#CreditCardForm');
    $('#CreditCardForm input[type="text"] , #CreditCardForm select').each(function () {
      $(this).val('');
    });
    $('#gmoPaymentCardList option[value="AddNewCard"]').prop('selected', true);
    $('#gmoPaymentCardList').change();
    $('.credit-card-save').css('display', 'flex');
    $('#panel-newcard').find('select,input').not('.payinfo').prop('disabled', false);

    var validator = $form.data('validator');
    if (validator) {
      validator.resetForm();
    }
    $form.find('.is-error').removeClass('is-error');
  });

  //select credit card tile
  $(document).on('click', '.creditcard-tile', function (evt) {
    var $this = $(this);

    if ($this.is('.selected, .default')) {
      return false;
    }

    $('.credit-card-save').css('display', 'flex');

    /* $('input[name="creditcard"]').each(function () {
             $(this).prop('checked', false);
            
         });*/

    //$this.addClass('selected');
    var selectedSeq = $this.find('input[name="CardSeq"]').val();
    $('#gmoPaymentCardList option[value="' + selectedSeq + '"]').prop('selected', true);
    $('#gmoPaymentCardList').change();
    $('#gmoPaymentCardList').siblings('input[name$="currentCardNo"]').val(selectedSeq);
  });

  $(document).on('change', '#gmoPaymentCardList', function (evt) {
    var selectedValue = $('#gmoPaymentCardList option:selected').val();
    if (selectedValue) {
      $('#applyBtn').prop('disabled', false);
    } else {
      $('#applyBtn').prop('disabled', true);
    }
  });

  //check validate card in dialog to submit form
  $(document).on('click', '#CreditCardForm .addCardSubmit', function (evt) {
    var $form = $(this).closest('form');
    if (!$form.data('custom-validator')(evt)) {
      evt.preventDefault();
      evt.stopPropagation();
      return false;
    }
    $(this).parent().find('button[id="applyBtn"]').click();
  });
  $(document).on('click', '.js-modal-r_overlay,.js-modal-r_close', function (evt) {
    $('#gmoPaymentCardList option[value="' + $('#gmoPaymentCardList').siblings('input[name$="currentCardNo"]').val() + '"]').prop('selected', true);
    $('#gmoPaymentCardList').change();
  });
}

function setSelectedCardID(uuid) {
  $cache.selectedCardIdInput.val(uuid);
}

function enableCountryField(status) {
  var countryField = $('input[id$="billing_billingAddress_addressFields_country"]');
  if (status) {
    countryField.removeAttr('disabled');
  } else {
    countryField.prop('disabled', true);
  }
}

function addCVNEvent() {
  $('input[name$="creditCard_cvn"]').on('keydown', function (e) {
    if (e.key.toString().match(/[\d]/) || $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
      // do nothing
    } else {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  });
}

function initGiftCardBalance() {
  var $checkoutForm = $('.checkout-billing');
  var $addGiftCert = $('#add-giftcert');
  var $giftCertCode = $('input[name$="_giftCertCode"]');
  var $giftCertPin = $('input[name$="_giftCertPIN"]');
  var $addCoupon = $('#add-coupon');
  var $couponCode = $('input[name$="_couponCode"]');

  // Check Balance button is clicked in Check Balance Modal
  $(document).off('click', 'button#check-giftcert-modal');
  $(document).on('click', 'button#check-giftcert-modal', function (e) {
    e.preventDefault();
    checkGiftCert();
  });

  // Check Another Card button is clicked in Check Balance Modal
  $(document).off('click', 'button#new-giftcert-modal');
  $(document).on('click', 'button#new-giftcert-modal', function (e) {
    var $balance = $('div#gift-card-balance-form .balance');
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

    $balance.html('');
    $error.html('');
    $giftCode.val(null).removeAttr('disabled');
    $giftPin.val(null).removeAttr('disabled');

    $('button#add-giftcert-modal').closest('.c-row').addClass('mfp-hide');
    $('button#new-giftcert-modal').addClass('mfp-hide');
    $('button#check-giftcert-modal').closest('.c-row').removeClass('mfp-hide');
  });

  // Apply button is clicked in Check Balance Modal
  $(document).off('click', 'button#add-giftcert-modal');
  $(document).on('click', 'button#add-giftcert-modal', function (e) {
    e.preventDefault();
    applyGiftCert();
  });

  $addGiftCert.off();
  $addGiftCert.on('click', function (e) {
    e.preventDefault();
    var code = $giftCertCode.val();
    var pin = $giftCertPin.val();
    //var $error = $checkoutForm.find('.giftcert-error');
    var $error = $checkoutForm.find('.apply-error');

    // clear all errors
    $(this).closest('form').find('span.error').remove();

    $error.html('');
    if (code.length === 0) {
      $error.html(Resources.GIFT_CARD_CODE_INVALID);
      return;
    } else if (code.length !== 0 && pin.length === 0) {
      $error.html(Resources.GIFT_CARD_PIN_INVALID);
      return;
    } else if (code.length === 0 && pin.length === 0) {
      $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
      return;
    }

    var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
      giftCertCode: code,
      giftCertPIN: pin,
      format: 'ajax'
    });
    $.getJSON(url, function (data) {
      var fail = false;
      var msg = '';
      if (!data) {
        msg = Resources.BAD_RESPONSE;
        fail = true;
      } else if (!data.success) {
        msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
        fail = true;
      }
      if (fail) {
        $error.html(msg);
        return;
      } else {
        window.location.assign(Urls.billing);
      }
    });
  });

  $giftCertCode.off();
  $giftCertCode.on('keydown', function (e) {
    if (e.which === 13) {
      e.preventDefault();
      $addGiftCert.click();
    }
  });
}

function initMaskCardNoBeforeNoCardSubmission() {
  $(document).off('submit.billing.mask').on('submit.billing.mask', '.cpb-cart-main form[id$="_billing"]', function () {
    var method = $('input[name$="selectedPaymentMethodID"]:checked').val();
    if (method === 'CREDIT_CARD') {
      return;
    }
    $('[name$="billing_paymentMethods_creditCard_type"]').val('');
    $('[name$="billing_paymentMethods_creditCard_number"]').val('');
    $('[name$="billing_paymentMethods_creditCard_month"]').val('');
    $('[name$="billing_paymentMethods_creditCard_year"]').val('');
    $('[name$="billing_paymentMethods_creditCard_expiration_month"]').val('');
    $('[name$="billing_paymentMethods_creditCard_expiration_year"]').val('');
    $('[name$="billing_paymentMethods_creditCard_cvn"]').val('');
  });
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
  cardValidation.init();
  initCache();
  initCreditCardForm();
  initCreditCardEvents();
  initGiftCardBalance();
  initMaskCardNoBeforeNoCardSubmission();

  var $selectPaymentMethod = $('.payment-method-options');
  var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();

  validator.initForm('form[id$="billing"]');

  function toggleBillingAddressFields(visible) {
    if (visible == true) {
      $('.country-dependent').each(function () {
        $(this).show();
      });
    } else {
      $('.country-dependent').each(function () {
        $(this).hide();
      });
    }

    if (window.User.isCustomerAuthenticated == false) {
      $('.checkout-billing').find('.set-default-cb').hide();
    }
  }

  $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country', function () {
    var selectContry = $(this).val();
    if (selectContry == '') {
      toggleBillingAddressFields();
    } else if (selectContry == 'us') {
      toggleBillingAddressFields(true);
      $('.us-fields').show();
      $('.us-fields input').each(function () {
        $(this).addClass('required');
      });

      $('.cn-fields').hide();
      $('.cn-fields input').each(function () {
        $(this).removeClass('required');
      });
    } else {
      toggleBillingAddressFields(true);
      $('.cn-fields').show().css({ display: 'flex' });
      $('.cn-fields input').each(function () {
        $(this).addClass('required');
      });

      $('.us-fields').hide();
      $('.us-fields input').each(function () {
        $(this).removeClass('required');
      });
    }
  });

  $('.billing-address-section :input').on('change', function (e) {
    if (e.target.id == 'dwfrm_billing_billingAddress_useAsBillingAddress') {
      return false;
    }

    $('#dwfrm_billing_billingAddress_useAsBillingAddress').prop('checked', false);
  });

  if ($('input#same-as-shipping').is(':checked')) {
    $('.saved-addresses.select-billing-address').addClass('mfp-hide');
    $('.saved-addresses.default-billing-address').removeClass('mfp-hide');
  }

  $('input#same-as-shipping').on('change', function () {
    var sameascheckbox = $(this);

    if (sameascheckbox.is(':checked')) {
      $('.saved-addresses.select-billing-address').addClass('mfp-hide');
      $('.saved-addresses.default-billing-address').removeClass('mfp-hide');

      $('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
      $('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
      $('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
      $('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2') != 'null' ? $('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2') : '');
      $('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
      $('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
      $('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').val());
      $('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').parent().find('.c-select-current').attr('data-state'));
      $('#dwfrm_billing_billingAddress_addressFields_phone').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));

      $('.flag-show-hide').fadeIn();
      toggleBillingAddressFields(true);

      // for logged-in users with address, reselect default shipping address
      // if customer chooses to use the shipping address as their billing address
      var selectedShipping = $('div.address-tile.address-default');
      if (selectedShipping) {
        selectedShipping.removeClass('is-current');
        selectedShipping.removeClass('default');
        selectedShipping.click();
      }
    } else {
      $('.saved-addresses.default-billing-address').addClass('mfp-hide');
      $('.saved-addresses.select-billing-address').removeClass('mfp-hide');

      $('#dwfrm_billing_billingAddress_addressFields_address1').val('');
      $('#dwfrm_billing_billingAddress_addressFields_address2').val('');
      $('#dwfrm_billing_billingAddress_addressFields_city').val('');
      $('#dwfrm_billing_billingAddress_addressFields_postal').val('');
      $('#dwfrm_billing_billingAddress_addressFields_phone').val('');
      $('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
      $('#dwfrm_billing_billingAddress_addressFields_province').val('');
      $('#dwfrm_billing_billingAddress_addressFields_states_state').val('');
      $('#dwfrm_billing_billingAddress_addressFields_states_state').parent().find('.c-select-current').attr('data-v', '').html($('#dwfrm_billing_billingAddress_addressFields_states_state').prev().find('li:first .c-select-list-item-text').html());
      $('#dwfrm_billing_billingAddress_addressFields_states_state').prev().find('a.is-selected').removeClass('is-selected');
      $('#dwfrm_billing_billingAddress_addressFields_country').parent().find('.c-select-current').attr('data-v', '').html($('#dwfrm_billing_billingAddress_addressFields_country').prev().find('li:first .c-select-list-item-text').html());
      $('#dwfrm_billing_billingAddress_addressFields_country').prev().find('a.is-selected').removeClass('is-selected');
      $('.flag-show-hide').fadeOut();
      $('.us-fields').show();
      $('.cn-fields').hide();

      $('#dwfrm_billing_billingAddress_addressFields_country').val('sg');

      toggleBillingAddressFields();
    }
  });

  // default payment method to 'CREDIT_CARD'
  updatePaymentMethod(selectedPaymentMethod ? selectedPaymentMethod : 'CREDIT_CARD');
  $selectPaymentMethod.on('click', 'input[type="radio"]', function () {
    updatePaymentMethod($(this).val());
  });

  $('.gift-card-form-toggle').on('click', function (e) {
    e.preventDefault();

    var $giftCardForm = $('.gift-card-form');
    var $giftCardCheckLink = $('.check-gift-card');

    $giftCardForm.slideDown().removeClass('rolledup');
    $giftCardCheckLink.removeClass('mfp-hide');
    $(this).addClass('mfp-hide');
    initGiftCardBalance();
  });

  var $inithtml = $('#giftcardbalancemodal').html();

  $('.check-gift-card').on('click', function (e) {
    $('#giftcardbalancemodal').html($inithtml);
    $.magnificPopup.open({
      items: {
        src: '#giftcardbalancemodal', // can be a HTML string, jQuery object, or CSS selector
        type: 'inline'
      }
    });
    $('.gift-card-balance-modal input[name$="_giftCertCode"], .gift-card-balance-modal input[name$="_giftCertPIN"]').on('blur', function (e) {
      var $this = $(this);
      $this.siblings('ul.c-text-error').remove();
      $this.removeClass('is-error');
      $this.prev().removeClass('is-error');
      $('.gift-card-balance-modal button#check-giftcert-modal').prop('disabled', false);
      $('.gift-card-balance-modal .balance-error').html('');
      $('.gift-card-balance-modal .balance-error').removeClass('c-text-error');
      $('.c-block-giftcardbalance-block-send .balance').html('');
      $('.c-block-giftcardbalance-block-send .balance').removeClass('c-list-total c-list-total--border c-list-total--large');
      $('button#check-giftcert-modal').closest('.c-row').removeClass('mfp-hide');
      $('button#add-giftcert-modal').closest('.c-row').addClass('mfp-hide');

      if ($this.val() && !$this.val().trim().match(/^[a-z0-9]+$/i)) {
        $('<ul class="c-text-error c-text-error--simple"><li>' + $this.attr('data-required-text') + '</li></ul>').insertAfter($this);
        $this.addClass('is-error');
        $this.prev().addClass('is-error');
      }

      if ($('.gift-card-balance-modal span.error').length > 0) {
        //    			$('.gift-card-balance-modal button#check-giftcert-modal').prop('disabled',true);
      }
    });
  });

  creditCardTypeDetector();

  $(document).on('click', '.credit-card-create', function (evt) {
    modal.events.onOpen(function () {
      creditCardTypeDetector();
      validator.initForm('form[id$="CreditCardForm"]');
    });
    modal.restoreDefaultClass();
    modal.addCustomClass('medium add-credit-card');
    modal.renderByUrl(Urls.checkoutAddCreditCard);
    modal.setCallback(cardValidation.init);
  });

  $(document).on('submit', '#CreditCardForm', function (evt) {
    evt.preventDefault();

    var $form = $(this);

    $.ajax({
      url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
      data: $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
      type: 'POST'
    }).done(function (data) {
      if (data.length) {
        modal.setContent(data);
        validator.initForm('form[id$="CreditCardForm"]');
        return;
      }

      if (!location.assign(Urls.billing)) {
        window.location.href = Urls.billing;
      }
    });
  });

  $(document).on('click', '.credit-card-edit', function (evt) {
    var element = document.getElementById(evt.currentTarget.id);
    var creditcardPositin = element.dataset.creditcardPosition;
    var url = Urls.checkoutEditCreditCard + creditcardPositin;

    modal.restoreDefaultClass();
    modal.events.onOpen(function () {
      $('.cc-number input').prop('disabled', true);
      validator.initForm('form[id$="CreditCardForm"]');
    });
    modal.addCustomClass('small edit-credit-card');
    modal.renderByUrl(url);
  });

  //select credit card tile
  $(document).on('click', '.creditcard-tile', function (evt) {
    var $this = $(this);
    var $thisInner = $this.children('.creditcard-tile-inner');

    if ($thisInner.find('#dwfrm_billing_paymentMethods_creditCard_cvn').length > 0) {
      return;
    }

    var ccEdit = $this.find('.credit-card-edit');
    var fauxCVNInput = '<div class="cvn-input"></div>';
    var CVNInput = '<input class="input-text " type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn" value="" maxlength="4" aria-invalid="false">';

    if (evt.target == ccEdit[0]) {
      return;
    }

    if ($(this).is('.is-current, .default')) {
      return false;
    } else {
      $('.creditcard-tile-inner').each(function () {
        $(this).removeClass('is-current');
        $(this).removeClass('default');
        $(this).find('.saved-cvn').addClass('disabled');
        $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
      });

      $thisInner.addClass('is-current');
      $this.find('.cvn-input').removeClass('disabled');
      $this.find('.saved-cvn .cvn-input').replaceWith(CVNInput);
      $this.find('.saved-cvn input').focus();

      var element = document.getElementById(evt.currentTarget.getElementsByClassName('creditcard-tile-inner')[0].id);

      var creditcardPosition = element.dataset.creditcardPosition;

      var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
        position: creditcardPosition
      });
      $.ajax({
        url: url,
        type: 'GET',
        success: function success(result) {}
      });

      setSelectedCardID($this.data('uuid'));
      addCVNEvent();
    }
  });

  //delete card payment
  $('.remove-cardpayment').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $paymentItemData = $(this).closest('.item-action_link');
    $.ajax({
      type: 'POST',
      url: $(this).attr('href'),
      data: {
        CardId: $paymentItemData.find('input[name="Card_id"]').val(),
        CardSeq: $paymentItemData.find('input[name="CardSeq"]').val(),
        CardNumber: $paymentItemData.find('input[name="CardNumber"]').val(),
        csrf_token: $paymentItemData.find('#csrf-token-modal').val()
      }
    }).done(function (response) {
      if (!response.success && response.error === 'CSRF Token Mismatch') {
        window.location.href = Urls.csrffailed;
        return;
      }
      if (response.success) {
        location.reload();
        return;
      }
      window.location.href = Urls.generalError;
    });
  });

  $(document).on('click', '.button-billing-continue', function (e) {
    var $form = $('form[id$="_billing"]');
    var isFormValid = $form.data('custom-validator')(e);
    if (!isFormValid && !$('.payment_creditcard').hasClass('is-active')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }

    if ($('.payment_creditcard').hasClass('is-active')) {
      if (!isFormValid || $('[name$="billing_paymentMethods_creditCard_type"]').val() == '' || $('select[name$=_creditCard_expiration_year]').val() == '' || $('select[name$=_creditCard_expiration_month]').val() == '') {
        cardValidation.validateCardType($('[name$="billing_paymentMethods_creditCard_type"]'));
        cardValidation.validateCardExpiryDropdown($('button#dwfrm_billing_save'), true, event);
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }
    $('html').addClass('cpb-is-loading');
    $('button#dwfrm_billing_save').trigger('click');
  });

  $(document).on('click', '.address-create', function (evt) {
    evt.preventDefault();

    ajax.load({
      url: Urls.checkoutAddBillingAddress,
      callback: function callback(data) {
        $('#editaddressmodal').html(data);
        $.magnificPopup.open({
          items: {
            src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
        validator.initForm('form[id="EditAddressForm"]');
        design.toggleSelectInit();
      }
    });
  });

  $(document).on('click', '.address-edit', function (evt) {
    evt.preventDefault();
    var element = document.getElementById(evt.currentTarget.id);
    var addressID = element.dataset.addressId;
    var addressCode = element.dataset.addressCode;
    var url = Urls.checkoutEditBillingAddress + addressID;

    var $this = $(this);
    var addressID = $this.data('addressId');

    ajax.load({
      url: url,
      callback: function callback(data) {
        $('#editaddressmodal').html(data);
        $.magnificPopup.open({
          items: {
            src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });

        validator.initForm('form[id="EditAddressForm"]');
        design.toggleSelectInit();
      }
    });
  });

  $(document).on('click', '.address-list .address-tile', function (evt) {
    if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
      return false;
    } else {
      $('.address-list .address-tile').each(function () {
        $(this).removeClass('is-current');
        $(this).removeClass('default');
      });

      $(this).addClass('is-current');

      var element = document.getElementById(evt.currentTarget.id);
      var addressID = element.dataset.addressId;

      var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
        addressID: addressID
        //format: 'ajax'
      });
      $.ajax({
        url: url,
        type: 'GET',
        success: function success(result) {
          //alert(result);
        }
      });
    }
  });

  $('.order-summary-footer form').submit(function () {
    $('#summary-place-order').prop('disabled', true).addClass('loading');
    return true;
  });

  // if same as shipping is checked, re-select default address
  // or if nothing is selected, re-select default address
  if ($('input#same-as-shipping').length > 0 && $('input#same-as-shipping').is(':checked') || $('ul.address-list div.address-tile.is-current').length <= 0) {
    $(document).find('ul.address-list div.address-tile').each(function (ind, evt) {
      if ($(this).hasClass('default') || $(this).hasClass('is-current') || $(this).hasClass('address-default')) {
        $(this).removeClass('is-current');
        $(this).removeClass('default');

        $(this).click();
      }
    });
  } else if ($('input#same-as-shipping').length == 0 && $('ul.address-list div.address-tile.is-current').length > 0) {
    // if no physical product to ship, re-select tile to properly assign billing address
    var reSelectTile = $('ul.address-list div.address-tile.is-current');
    reSelectTile.removeClass('is-current');
    reSelectTile.removeClass('default');
    reSelectTile.click();
  }

  // trigger click event for selected by default cc (to manually trigger cc code)
  var selectedCC = $('div.payment-method div.creditcard-tile.selected');
  if (selectedCC) {
    selectedCC.removeClass('selected').click();
  }

  // maximize order checkout summary dropdown
  util.maximizeCheckoutSummary();

  // trigger only for non-registered users
  if (window.User.isCustomerAuthenticated == false) {
    $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on('change', function () {
      $('select[name$="_creditCard_expiration_month"]').trigger('change');
      $('select[name$="_creditCard_expiration_month"]').trigger('change');
    });
  }

  $('.credit-card-create').magnificPopup({
    type: 'ajax',
    ajax: {
      settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
      // For example:
      // settings: {cache:false, async:false}

      cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
      tError: Resources.ADDNEWCARD_OPEN_ERROR //  Error message, can contain %curr% and %total% tags if gallery is enabled
    },
    callbacks: {
      parseAjax: function parseAjax(mfpResponse) {
        // mfpResponse.data is a "data" object from ajax "success" callback
        // for simple HTML file, it will be just String

        // mfpResponse.data must be a String or a DOM (jQuery) element
        mfpResponse.data = $(mfpResponse.data).find('.c-block-modal01-gather').first();
      },
      ajaxContentAdded: function ajaxContentAdded() {
        $('#newcardmodal').remove();
        $('#dwfrm_billing').next().append('<div id="newcardmodal" class="c-block-modal01 mfp-hide"></div>');
        $('#newcardmodal').html(this.content[0].outerHTML);
        $.magnificPopup.open({
          items: {
            src: '#newcardmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });

        design.toggleSelectInit(true);
        creditCardTypeDetector();
        cardValidation.init();
        validator.initForm('form[id$="CreditCardForm"]');
      }
    }
  });

  // select default credit card  after loading all javascript
  $(function () {
    if ($('#paymentmethods_defaultCardPositionNum').length > 0) {
      var $defaultCardPosition = $('#paymentmethods_defaultCardPositionNum');
      var defaultCardPositionNum = Number($defaultCardPosition.val());
      var gmoSelectedCard = Number($defaultCardPosition.data('gmo-selected-card'));
      var selectCreditId = '#card_' + gmoSelectedCard;
      if ($(selectCreditId).length === 0) {
        selectCreditId = '#card_' + defaultCardPositionNum;
      }
      $(selectCreditId).click();
      $(selectCreditId).closest('.creditcard-tile').click();
    }
  });

  $(document).on('click', '.creditcard-tile-inner creditcarditem + label.label', function (ev) {
    ev.stopPropagation();
  });
};

},{"../../ajax":1,"../../design":11,"../../giftcard":14,"../../modal":24,"../../util":77,"../../validator":78,"./card-validation":34,"./formPrepare":36}],34:[function(require,module,exports){
'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var errors = {};
var inputCVN = 'input[name$=_creditCard_cvn]';
var inputMonth = 'select[name$=_creditCard_expiration_month]';
var inputYear = 'select[name$=_creditCard_expiration_year]';
var inputType = 'select[name$=_creditCard_creditCard_type]';

var luhnCheck = function (arr) {
  return function (ccNum) {
    var len = ccNum.length;
    var bit = 1;
    var sum = 0;
    var val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

var cvvCheck = function cvvCheck(cvv) {
  return (/^[0-9]{3,4}$/.test(cvv)
  );
};

var initCardExpiry = function initCardExpiry() {
  var ccSave = $('#CreditCardForm #applyBtn');
  ccSave.on('click', function (e) {
    validateCardExpiry(this, true);
  });

  $('.card-expiry .c-select-current').on('change blur', function () {
    validateCardExpiry(this);
  });

  $('form[id$=_billing] button[name$=_billing_save]').on('click touchstart', function (event) {
    if ($('.payment_creditcard').hasClass('is-active')) {
      validateCardExpiryDropdown($(this), true, event);
      validateCardType($(this), true, event);
    }
  });

  $('form[id$=_billing] select[name$=_creditCard_expiration_month], form[id$=_billing] select[name$=_creditCard_expiration_year]').on('change', function () {
    validateCardExpiryDropdown($(this));
  });

  $('form[id$=_billing] select[name$=_creditCard_type]').on('change', function () {
    validateCardType($(this));
  });
};

var validateCardExpiry = function validateCardExpiry(el, checkEmpty) {
  console.log('validateCardExpiry');
  // need to declare specifically in order not to confuse with other forms with similar inputs
  var $this = $(el);
  var $month = $this.closest('form').find('.card-expiry.month .c-select-current');
  var $year = $this.closest('form').find('.card-expiry.year .c-select-current');
  var $submit = $this.closest('form').find('button[type="submit"]');
  var hasError = false;

  var now = new Date();
  var nowMonth = now.getMonth() + 1;
  var nowYear = now.getFullYear();

  $month.siblings('span.error').remove();
  $year.siblings('span.error').remove(); //-- Ade CG-4
  $month.removeClass('error');
  $year.removeClass('error');
  $submit.prop('disabled', false);

  // validate only on form submit
  /*if(checkEmpty && (!$month.val() || !$year.val())){
  $('<span class="error">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
  hasError = true;*/
  if (checkEmpty) {
    if (!$month.val()) {
      $('<span class="error" id="errormonth">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
      hasError = true;
    }
    if (!$year.val()) {
      $('<span class="error" id="erroryear">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($year);
      hasError = true;
    }
    // validate only if month and year has value, otherwise, ignore
  } else if ($month.val() && $year.val()) {
    if ($year.val() < nowYear) {
      $('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($year);
      hasError = true;
    } else if ($month.val() < nowMonth && $year.val() == nowYear) {
      $('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($month);
      hasError = true;
    }
  }

  // highlight inputs if expiry has error
  if (hasError) {
    $month.addClass('error');
    $year.addClass('error');
  }

  // disable button if there are errors -- // change by ticket shi-5388
  if ($this.closest('form').find('span.error').length > 0) {
    $submit.prop('disabled', true);
  }
};

function validateCardType($el, checkEmpty, e) {
  var $type = $el.closest('form').find('select[name$=_creditCard_type]');

  if ($type.length) {
    var $typeWrapper = $type.parent();
    var typeValue = $type.val() ? $type.val() != 'null' ? $type.val() : 0 : 0;

    if (checkEmpty) {
      if (!typeValue) {
        if ($type.attr('name').match('.*_creditCard_type')) {
          removeErrorType('select[name$=_creditCard_type]');
          showErrorType($type, Resources.INVALID_CREDITCARD_TYPE);
        } else {
          addError($type, Resources.INVALID_CREDITCARD_TYPE);
        }
      }
    } else {
      if (!typeValue) {
        if ($el.attr('name').match('.*_creditCard_type$')) {
          if ($el.closest($('form.checkout-billing')).length) {
            removeErrorType('select[name$=_creditCard_type]');
            showErrorType($type, Resources.INVALID_CREDITCARD_TYPE);
          } else {
            removeError($typeWrapper);
            if (!typeValue) {
              addError($typeWrapper, Resources.INVALID_CREDITCARD_TYPE);
            }
          }
        }
      } else if (typeValue) {
        removeErrorType('select[name$=_creditCard_type]');
      }
    }
  }
}

function validateCardExpiryDropdown($el, checkEmpty, e) {
  var $month = $el.closest('form').find('select[name$=_creditCard_expiration_month]');
  var $year = $el.closest('form').find('select[name$=_creditCard_expiration_year]');

  var monthValue = $month.val() ? $month.val() != 'null' ? $month.val() : 0 : 0;
  var yearValue = $year.val() ? $year.val() != 'null' ? $year.val() : 0 : 0;

  var now = new Date();
  var nowMonth = now.getMonth() + 1;
  var nowYear = now.getFullYear();

  var isAnyEmpty = !monthValue || !yearValue;
  var isInvalidExpiry = yearValue < nowYear || yearValue <= nowYear && monthValue < nowMonth;

  // 保存ボタンを押した場合は、未入力チェックと期限チェックを実施
  // 期限を変更した場合は、未入力でない場合のみ期限チェックを実施（未入力の場合はバリデーションなし）
  if (checkEmpty && (isAnyEmpty || isInvalidExpiry) || !checkEmpty && !isAnyEmpty && isInvalidExpiry) {
    var errorMessage = !isAnyEmpty && isInvalidExpiry ? Resources.INVALID_CARDEXPIRY_EXPIRED : Resources.INVALID_CARDEXPIRY;
    pushError(inputMonth, errorMessage);
    pushError(inputYear);
    showError($month);
    return;
  }
  removeErrorInObj(inputMonth);
  removeErrorInObj(inputYear);
  $month.parents('.cmd-form_box.cmd-box_container').next('.cmd-form_err._simple').remove();
}

function addError($el, message) {
  $el.find('.c-input-label').addClass('is-error');
  $el.find('.c-select').addClass('is-error');
  if (!$el.find('ul.c-text-error').length) {
    $('<ul class="c-text-error c-text-error--simple"><li class="is-error">' + message + '</li></ul>').insertAfter($el.find('.c-input-label'));
  }
}

function removeError($el) {
  $el.find('ul.c-text-error').remove();
  $el.find('.c-input-label').removeClass('is-error');
  $el.find('.c-select').removeClass('is-error');
}

function removeErrorInObj(key) {
  delete errors[key];
  var $el = $(key).closest('.cmd-form_box');
  if ($el.hasClass('is-error')) {
    $el.removeClass('is-error');
  }
}

function removeErrorType(key) {
  $(key).parent().parent().closest('.cmd-box_container').next('.cmd-form_err._simple').remove();
  var $el = $('select[name$=_creditCard_type]').closest('.cmd-form_box');

  if ($el.hasClass('is-error')) {
    $el.removeClass('is-error');
  }
}

function pushError(key, val) {
  errors[key] = val;
}

function showErrorType($el, message) {
  var $elCmd = $('select[name$=_creditCard_type]').closest('.cmd-form_box');
  if (!$elCmd.hasClass('is-error')) {
    $elCmd.addClass('is-error');
  }
  $('<p class="cmd-form_err _simple">' + message + '</p>').insertAfter($el.closest('.cmd-box_container'));
}

function showError($el) {
  $el.parent().parent().parent().closest('.cmd-form_box').next('.cmd-form_err._simple').remove();
  if (Object.keys(errors).length > 0) {
    var errStr = '';
    for (var i in errors) {
      errStr += errors[i] ? errors[i] + '<br>' : '';
      // add class error
      var $elCmd = $(i).closest('.cmd-form_box');
      if (!$elCmd.hasClass('is-error')) {
        $elCmd.addClass('is-error');
      }
    }
    $('<p class="cmd-form_err _simple">' + errStr + '</p>').insertAfter($el.closest('.cmd-box_container'));
  }
}

exports.init = function () {
  initCardExpiry();
};
exports.validateCardType = validateCardType;
exports.validateCardExpiryDropdown = validateCardExpiryDropdown;

},{}],35:[function(require,module,exports){
'use strict';

var customValidator = {
  RegistrationForm: function RegistrationForm($form) {
    var isBirthdayValid = birthdayCheck($form);
    var isStateValid = validateState($form);
    return isBirthdayValid && isStateValid;
  },
  EditAddressForm: function EditAddressForm($form) {
    return validateState($form);
  },
  PasswordResetForm: function PasswordResetForm($form) {
    return birthdayCheck($form);
  },
  ContactUsForm: function ContactUsForm($form) {
    return validateContactUs($form);
  },
  WithdrawForm: function WithdrawForm($form) {
    return validateWithdrawReason($form);
  },
  CreditCardForm: function CreditCardForm($form) {
    var isExpiry = validateCardExpiry($form, true);
    var isCardType = validateCardType($form);
    return isExpiry && isCardType;
  },
  dwfrm_billing: function dwfrm_billing($form) {
    if ($form.find('input[name$="_selectedPaymentMethodID"]:checked').val() === 'GMO_CVSSTORE') {
      return Boolean($('#gmo-cvs-code-selection').val());
    }
    if ($form.find('input[name$="_selectedPaymentMethodID"]:checked').val() === 'CREDIT_CARD') {
      var validateExpiryResult = validateExpiry($form);
      if (!validateExpiryResult.month || !validateExpiryResult.isValid) {
        addErrorFields($form, $form.find('[name$="_expiration_month"]'));
      } else if (!validateExpiryResult.year) {
        addErrorFields($form, $form.find('[name$="_expiration_year"]'));
      }
      return validateExpiryResult.isValid;
    }
    return true;
  }
};

var initiator = {
  RegistrationForm: function RegistrationForm($form) {
    $form.find('[name$="_birthyear"], [name$="_birthmonth"], [name$="_dob"]').on('change', function () {
      var $birthday = $form.find('[name$="_birthday"]');
      if ($birthday.hasClass('is-error')) {
        birthdayCheck($form);
      }
    });
    $form.find('[name$="_state"]').on('change', function () {
      validateState($form);
    });
    $form.find('[name$="_addtodirectmaillist"]').on('change', function () {
      $form.find('[name$="_addtodirectmaillist"]').valid();
    });
  },
  EditAddressForm: function EditAddressForm($form) {
    $form.find('[name$="_state"]').on('change', function () {
      validateState($form);
    });
  },
  PasswordResetForm: function PasswordResetForm($form) {
    $form.find('[name$="_birthyear"], [name$="_birthmonth"], [name$="_dob"]').on('change', function () {
      var $birthday = $form.find('[name$="_birthday"]');
      if ($birthday.hasClass('is-error')) {
        birthdayCheck($form);
      }
    });
  },
  ContactUsForm: function ContactUsForm($form) {
    $form.find('[name$="_myquestion"]').on('change', function () {
      validateContactUs($form);
    });
  },
  WithdrawForm: function WithdrawForm($form) {
    $form.find('.c-c-input-checklist label input').on('change', function () {
      validateWithdrawReason($form);
    });
  },
  CreditCardForm: function CreditCardForm($form) {
    $form.find('[name$="_expiration_month"], [name$="_expiration_year"]').on('change', function () {
      validateCardExpiry($form, false);
    });
    $form.find('[name$="_newcreditcard_type"]').on('change', function () {
      validateCardType($form);
    });
  },
  'add-use-point': function addUsePoint($form) {
    function forceNaturalNumber(el) {
      var $el = $(el);
      var value = $el.val() || '';
      $el.val(value.replace(/[^0-9]/g, ''));
    }
    $form.find('input.point_value').on('blur', function (ev) {
      forceNaturalNumber(ev.target);
    });
  }
};

function init($form) {
  var id = $form.attr('id');
  if (initiator[id]) {
    initiator[id]($form);
  }

  var validator = customValidator[id] || function () {
    return true;
  };
  $form.data('custom-validator', function (e) {
    $form.data('error-fields', {});

    var conditions = [$form.valid(), validator($form, e), $form.data('validator').numberOfInvalids() === 0, $form.data('submitting') !== true];

    var isValid = conditions.reduce(function (valid, current) {
      return valid && current;
    }, true);
    if (!isValid) {
      scrollToFirstError($form);
    }
    return isValid;
  });
}

function addErrorFields($form, $field, prev) {
  if (!$form.data('error-fields')) {
    $form.data('error-fields', {});
  }
  $form.data('error-fields')[$field.attr('name')] = prev ? $field.prev()[0] : $field[0];
}

function scrollToFirstError($form) {
  if ($form.closest('.mfp-wrap').length > 0) {
    $form.closest('.mfp-wrap').animate({ scrollTop: 0 }, 200);
    return;
  }
  if ($form.find('.cpb-modalR_inner.cpb-modal_scroll.js-modal_scroll').length > 0) {
    $form.find('.cpb-modalR_inner.cpb-modal_scroll.js-modal_scroll').animate({ scrollTop: 0 }, 200);
    return;
  }
  var normalErrorFields = $form.data('validator').errorList.map(function (error) {
    return error.element;
  });
  var customErrorFields = Object.keys($form.data('error-fields')).map(function (key) {
    return $form.data('error-fields')[key];
  });
  var errorFields = normalErrorFields.concat(customErrorFields);
  var top = Math.min.apply(null, errorFields.map(function (e) {
    return $(e).offset().top;
  }));
  $('html, body').animate({ scrollTop: top - 100 }, 200);
}
function validateExpiry($form) {
  var $month = $form.find('[name$="_expiration_month"]');
  var $year = $form.find('[name$="_expiration_year"]');
  var month = Number($month.val());
  var year = Number($year.val());
  var now = new Date();
  var yearNow = now.getFullYear();
  var monthNow = now.getMonth() + 1;

  return {
    month: month,
    year: year,
    isValid: month && year && (year > yearNow || year == yearNow && month >= monthNow)
  };
}
function birthdayCheck($form) {
  var $birthyear = $form.find('[name$="_birthyear"]');
  var $birthmonth = $form.find('[name$="_birthmonth"]');
  var $dob = $form.find('[name$="_dob"]');
  var $birthday = $form.find('[name$="_birthday"]');
  var fields = [$birthyear, $birthmonth, $dob];
  var $containerUl = $birthyear.closest('ul');

  var onError = function onError(message) {
    $birthday.addClass('is-error');
    $containerUl.prev().addClass('is-error');
    $containerUl.find('.birthday-error').remove();
    $containerUl.append($('<li class="c-col c-col_sm_08 birthday-error"></li>').append($('<p style="margin-top: 5px;" class="c-input-label is-error"></p>').text(message)));
  };

  var allValueExist = fields.reduce(function (valid, $field) {
    if (!Number($field.val())) {
      $field.prev().addClass('is-error');
      addErrorFields($form, $field, true);
      return false;
    }
    $field.prev().removeClass('is-error');
    return valid;
  }, true);
  if (!allValueExist) {
    onError(Resources.VALIDATE_REQUIRED);
    return false;
  }

  var year = Number($birthyear.val());
  var month = Number($birthmonth.val());
  var date = Number($dob.val());

  if (!validateDate(year, month, date)) {
    fields.forEach(function ($field) {
      $field.prev().addClass('is-error');
      addErrorFields($form, $field, true);
    });
    onError(Resources.INVALID_BIRTHDAY);
    return false;
  }

  $birthday.removeClass('is-error');
  $birthday.val(zeroPadding(month, 2) + '/' + zeroPadding(date, 2) + '/' + year.toString());
  $containerUl.prev().removeClass('is-error');
  fields.forEach(function ($field) {
    $field.prev().removeClass('is-error');
  });
  $containerUl.find('.birthday-error').remove();
  return true;
}

function validateDate(year, month, date) {
  var isLeapYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  if (month === 2 && date > (isLeapYear ? 29 : 28)) {
    return false;
  }
  if (date > ([4, 6, 9, 11].indexOf(month) === -1 ? 31 : 30)) {
    return false;
  }
  var now = new Date();
  var yearNow = now.getFullYear();
  var monthNow = now.getMonth() + 1;
  var dateNow = now.getDate();

  if (year < yearNow) {
    return true;
  }
  if (year > yearNow) {
    return false;
  }
  if (month < monthNow) {
    return true;
  }
  if (month > monthNow) {
    return false;
  }
  return date <= dateNow;
}

function validateState($form) {
  var $state = $('[name$="_state"]');
  var $stateShippingPage = $('[name="dwfrm_singleshipping_shippingAddress_addressFields_states_state"]');
  var errorMessage;
  if (!$state.val()) {
    if ($state.closest('#editaddressmodal').length > 0 || $stateShippingPage.length > 0) {
      errorMessage = Resources.VALIDATE_REQUIRED;
    } else if (!$.validator.methods.addressForDM()) {
      errorMessage = Resources.VALIDATE_ADDRESS_FOR_DM;
    } else if (!$.validator.methods.primaryAddress()) {
      errorMessage = Resources.VALIDATE_ADDRESS;
    }
  }
  if (errorMessage && $stateShippingPage.length === 0) {
    addErrorFields($form, $state, true);
    $state.prev('.c-select').addClass('is-error');
    if ($state.parent().find('p.is-error').length === 0) {
      $state.parent().append('<p class="c-input-label is-error" style="margin-top:5px;">' + errorMessage + '</p>');
    }
    return false;
  }

  if (errorMessage && $stateShippingPage.length > 0) {
    addErrorFields($form, $stateShippingPage, true);
    var errorId = $stateShippingPage.attr('name') + '-error';
    $stateShippingPage.parent().parent().find('#' + errorId).remove();
    $stateShippingPage.parent().after('<p id="' + errorId + '" class="jquery-validation is-error c-text-error c-text-error--simple">' + errorMessage + '</p>');
  } else {
    $stateShippingPage.parent().next().remove();
  }

  $state.prev('.c-select').removeClass('is-error');
  $state.parent().find('.c-input-label.is-error').remove();
  return true;
}

/**
 * Validate for contacus form
 * @returns
 */
function validateContactUs($form) {
  var $myquestion = $form.find('[name$=_myquestion]');
  var $myquestionField = $myquestion.parent().parent();
  if ($myquestion.val() === '') {
    $myquestion.prev().prev().addClass('is-error');
    $myquestion.prev().addClass('is-error');
    if ($myquestionField.find('li.c-col_sm_08>p.is-error').length === 0) {
      $('<li class="c-col c-col_sm_08"></li>').append($('<p class="c-input-label is-error"></p>').text(Resources.VALIDATE_REQUIRED)).insertAfter($myquestion.parent());
    }
    addErrorFields($form, $myquestion, true);
    return false;
  }
  $myquestion.prev().prev().removeClass('is-error');
  $myquestion.prev().removeClass('is-error');
  $myquestionField.find('li.c-col_sm_08>p.is-error').parent().remove();
  return true;
}

function validateWithdrawReason($form) {
  var isChecked = $form.find('.c-c-input-checklist label input').toArray().some(function (e) {
    return $(e).prop('checked');
  });
  var $ul = $form.find('ul.c-c-input-checklist.c-block_01');
  if (!isChecked) {
    $ul.addClass('is-error');
    if ($ul.parent().find('.is-error.c-input-label').length === 0) {
      $('<p class="c-input-label is-error"></p>').text(Resources.VALIDATE_REASONS).insertBefore($ul);
    }
    addErrorFields($form, $ul.prev().prev());
    return false;
  }
  $ul.removeClass('is-error');
  $ul.parent().find('.is-error.c-input-label').remove();
  return true;
}

/**
 * Validate for add new credit card form
 * @returns
 */
function validateCardExpiry($form, clickSave) {
  var $month = $form.find('[name$="_expiration_month"]');
  var $year = $form.find('[name$="_expiration_year"]');
  var fields = [$month, $year];
  var $containerUl = $month.closest('ul');

  var month = Number($month.val());
  var year = Number($year.val());
  var now = new Date();
  var yearNow = now.getFullYear();
  var monthNow = now.getMonth() + 1;

  var isAnyEmpty = 0 === month || 0 === year;
  var isInvalidExpiry = year < yearNow || year <= yearNow && month < monthNow;

  // 保存ボタンを押した場合は、未入力チェックと期限チェックを実施
  // 期限を変更した場合は、未入力でない場合のみ期限チェックを実施（未入力の場合はバリデーションなし）
  if (clickSave && (isAnyEmpty || isInvalidExpiry) || !clickSave && !isAnyEmpty && isInvalidExpiry) {
    var errorMessage = !isAnyEmpty && isInvalidExpiry ? Resources.INVALID_CARDEXPIRY_EXPIRED : Resources.INVALID_CARDEXPIRY;
    fields.forEach(function ($field) {
      $month.parent().prev().addClass('is-error');
      $year.parent().prev().addClass('is-error');
      $month.parent().prev().parent().parent().parent().parent().find('#card-expiry-error').remove();
      $month.parent().prev().parent().parent().parent().after($('<p class="jquery-validation is-error c-text-error c-text-error--simple" id="card-expiry-error"></p>').text(errorMessage));
      $field.prev().addClass('is-error');
      addErrorFields($form, $field, true);
      $containerUl.prev().addClass('is-error');
      $containerUl.find('.card-expiry-error').remove();

      //distinguish the validate text of between validate style  account-payment page and checkout-payment page
      if ($form.hasClass('credit-card-account')) {
        $containerUl.append($('<li class="c-col c-col_08 card-expiry-error"></li>').append($('<p class="c-input-label is-error"></p>').text(errorMessage)));
      } else {
        $containerUl.append($('<li class="c-col c-col_sm_08 card-expiry-error"></li>').append($('<p class="is-error c-text-error c-text-error--simple"></p>').text(errorMessage)));
      }
    });
    return false;
  }

  $month.parent().prev().removeClass('is-error');
  $year.parent().prev().removeClass('is-error');
  $month.parent().prev().parent().parent().parent().parent().find('#card-expiry-error').remove();
  $containerUl.prev().removeClass('is-error');
  fields.forEach(function ($field) {
    $field.prev().removeClass('is-error');
  });
  $containerUl.find('.card-expiry-error').remove();
  return true;
}

/**
 * Validate for add new credit card form
 * @returns
 */
function validateCardType($form) {
  var $cardType = $('[name$="_newcreditcard_type"]');
  var type = $cardType.val();
  var $containerUl = $cardType.closest('ul');

  if (!type) {
    $cardType.prev().addClass('is-error');
    addErrorFields($form, $cardType, true);
    $cardType.prevAll().addClass('is-error');
    $containerUl.find('.card-type-error').remove();

    //distinguish the validate text of between validate style  account-payment page and checkout-payment page
    if ($cardType.closest('li').length == 0) {
      $cardType.closest('.cmd-form_box').after($('<p class="jquery-validation is-error c-text-error c-text-error--simple card-type-error"></p>').text(Resources.VALIDATE_REQUIRED));
    } else if ($form.hasClass('credit-card-account')) {
      $cardType.closest('li').after($('<li class="c-col c-col_08 card-type-error"></li>').append($('<p class="c-input-label is-error"></p>').text(Resources.VALIDATE_REQUIRED)));
    } else {
      $cardType.closest('li').after($('<li class="c-col c-col_sm_08 card-type-error"></li>').append($('<p class="jquery-validation is-error c-text-error c-text-error--simple"></p>').text(Resources.VALIDATE_REQUIRED)));
    }
    return false;
  }

  $cardType.prevAll().removeClass('is-error');
  if ($containerUl.length > 0) {
    $containerUl.find('.card-type-error').remove();
  } else {
    $cardType.closest('.cmd-form_box').siblings('.card-type-error').remove();
  }
  return true;
}

/**
 * IEでは「Array.fill」が使えないため代替処理
 * 処理詳細は「MDN」参照
 *
 * @param {Array} value
 * @returns {Array}
 * @see {@link https://developer.mozilla.org/ja/docs/Web/JavaScript/Reference/Global_Objects/Array/fill#Polyfill Polyfill}
 */
function arrayFill(value) {
  // Steps 1-2.
  if (this == null) {
    throw new TypeError('this is null or not defined');
  }

  var O = Object(this);

  // Steps 3-5.
  var len = O.length >>> 0;

  // Steps 6-7.
  var start = arguments[1];
  var relativeStart = start >> 0;

  // Step 8.
  var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

  // Steps 9-10.
  var end = arguments[2];
  var relativeEnd = end === undefined ? len : end >> 0;

  // Step 11.
  var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

  // Step 12.
  while (k < final) {
    O[k] = value;
    k++;
  }

  // Step 13.
  return O;
}

function zeroPadding(number, digits) {
  if (Array.prototype.fill) {
    return (Array(digits).fill('0').join('') + number.toString()).slice(-digits);
  }

  return (arrayFill.bind(Array(digits))('0').join('') + number.toString()).slice(-digits);
}

module.exports = {
  init: init,
  validateDate: validateDate,
  zeroPadding: zeroPadding
};

},{}],36:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = require('lodash');
var customForm = require('./custom-form');

var hasEmptyRequired = function hasEmptyRequired() {
  // filter out only the visible fields
  var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
    return $(this).val();
  });
  return _(requiredValues).contains('');
};

var validateForm = function validateForm() {
  var _self = this;
  // only validate form when all required fields are filled to avoid
  // throwing errors on empty form
  if (!this.validator) {
    return;
  }

  // wait for the form to show before validating.. this applies to modals
  this.timer = setInterval(function () {
    if (_self.$form.is(':visible')) {
      if (_self.$form.find('span.error:visible, .error-form:visible').length == 0) {
        //!_self.hasEmptyRequired() &&
        _self.$continue.removeAttr('disabled');
      } else {
        _self.$continue.prop('disabled', true);
      }
      clearInterval(_self.timer);
    }
  }, 100);
};

var validateEl = function validateEl(e) {
  if ($(e.target).val() === '') {
    this.$continue.prop('disabled', true);
  } else {
    // enable continue button on last required field that is valid
    // only validate single field
    if (!this.hasEmptyRequired()) {
      this.$continue.removeAttr('disabled');
    } else {
      this.$continue.prop('disabled', true);
    }
  }
};

var checkValue = function checkValue(repopulateRequiredFields, e) {
  var $el = $(e.target);
  var attr = $el.attr('clear-on-error');

  // check for new required fields (e.g. changing US -> CH in address)
  if (repopulateRequiredFields) {
    this.$requiredInputs = this.$form.find('input.required');
  }

  // remove any error message residue from previous validation
  $el.siblings('span.is-error').remove();

  if (this.validator.element($el) && this.$form.find('span.is-error:visible').length == 0) {
    this.$continue.prop('disabled', false);
  } else {
    //        this.$continue.prop('disabled', true);

    // clear the value if input has error
    if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && attr !== false) $el.val('');
  }
};

var submitForm = function submitForm(e) {
  this.$form.find('input').blur();
  this.$form.find('select').blur();

  if (!this.$form.data('custom-validator')(e)) {
    //      this.$continue.prop('disabled', true);
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // adding this to prevent multiple submission of forms
  if (this.$form.attr('multiple-submission') === 'false') {
    this.$form.data('submitting', true);
  }
};

var init = function init(opts, settings) {
  if (!opts.formSelector || !opts.continueSelector) {
    throw new Error('Missing form and continue action selectors.');
  }
  this.$form = $(opts.formSelector);
  this.$continue = $(opts.continueSelector);
  this.validator = settings ? this.$form.validate(settings) : this.$form.validate();
  this.$form.data('validator', this.validator);
  customForm.init(this.$form);
  this.$allInputs = $('input, textarea', this.$form);
  this.$allSelect = $('select', this.$form);
  this.$requiredInputs = this.$form.find('input.required');
  //    this.validateForm();

  // start listening
  //    this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
  //this.$allInputs.on('keyup', $.proxy(this.checkValue, this, false));
  this.$allSelect.on('blur', $.proxy(this.checkValue, this, true));
  this.$continue.on('click', $.proxy(this.submitForm, this));
  // [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
  if (this.$continue.attr('mousesubmit') === 'true') {
    this.$continue.on('mousedown', $.proxy(function (e) {
      this.$continue.click();
    }, this));
  }
};

var formPrepare = function formPrepare() {
  return {
    $form: null,
    $continue: null,
    $allInputs: null,
    $allSelect: null,
    $requiredInputs: null,
    validator: null,
    init: init,
    timer: null,
    hasEmptyRequired: hasEmptyRequired,
    checkValue: checkValue,
    validateForm: validateForm,
    submitForm: submitForm,
    validateEl: validateEl
  };
};

module.exports = formPrepare;

},{"./custom-form":35,"lodash":111}],37:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping'),
    cart = require('../cart');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
  address.init();
  cart.init();
  if ($('.checkout-shipping').length > 0) {
    shipping.init();
  } else if ($('.checkout-multi-shipping').length > 0) {
    multiship.init();
  } else {
    billing.init();
  }

  //if on the order review page and there are products that are not available diable the submit order button
  if ($('.order-summary-footer').length > 0) {
    if ($('.notavailable').length > 0) {
      $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
    }
  }

  $('.cpb-cart-checkout_fixed.js-place-order').off('click.trigger.placeorder').on('click.trigger.placeorder', 'button', function () {
    $('#summary-place-order').trigger('click');
  });
  $(document).off('click.rakuten.placeorder', '.summary-place-order-rakuten').on('click.rakuten.placeorder', '.summary-place-order-rakuten', function () {
    $('#summary-place-order').trigger('click');
  });
  $('#summary-place-order').off('click.placeorder.loading').on('click.placeorder.loading', function () {
    $('html').addClass('cpb-is-loading');
  });
};

},{"../cart":30,"./address":32,"./billing":33,"./multiship":39,"./shipping":40}],38:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Enable/disable button depending if input has value
 */

exports.init = function () {
  var $emailInput = $('.checkoutlogin input[type="email"]');
  var $emailButton = $('.checkoutlogin button');
  $emailInput.on('keyup', function (e) {
    if ($emailInput.val().length) {
      $emailButton.prop('disabled', false);
    } else {
      //    	    	$emailButton.prop('disabled', true);
    }
  });
};

},{}],39:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
  $.each($('.item-list'), function () {
    var $this = $(this);
    var $giftMessage = $this.find('.gift-message-text');

    //handle initial load
    $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

    //set event listeners
    $this.on('change', function () {
      $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
    });
  });
}

/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
  var $addressForm = $('form[name$="multishipping_editAddress"]'),
      $addressDropdown = $addressForm.find('select[name$=_addressList]'),
      $addressList = $addressForm.find('.address-list'),
      add = true,
      originalUUID,
      resetOptionValue = false,
      selectedAddressUUID = $(target).parent().siblings('.select-address').val();

  $addressDropdown.on('change', function (e) {
    e.preventDefault();

    var selectedAddress = $addressList.find('select').val();
    if (selectedAddress !== 'newAddress') {
      selectedAddress = $.grep($addressList.data('addresses'), function (add) {
        return add.UUID === selectedAddress;
      })[0];
      add = false;
      resetOptionValue = false;
      // proceed to fill the form with the selected address
      util.fillAddressFields(selectedAddress, $addressForm);
    } else if (selectedAddress === 'newAddress') {
      add = true;
      resetOptionValue = true;
      $addressForm.find('.input-text, .input-select').val('');
    } else {
      //reset the form if the value of the option is not a UUID
      $addressForm.find('.input-text, .input-select').val('');
    }
  });

  $addressForm.on('click', '.cancel', function (e) {
    e.preventDefault();
    dialog.close();
  });

  $addressForm.on('submit', function (e) {
    e.preventDefault();
    if (!$addressForm.valid()) {
      return false;
    }

    $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
      if (!response.success) {
        $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
        return;
      }
      $('#multiaddresserror').toggleClass('hidden', response.success);

      var address = response.address,
          $shippingAddress = $(target).closest('.shippingaddress'),
          $select = $shippingAddress.find('.select-address'),
          $selected = $select.find('option:selected'),
          newOption = '<option value="' + address.UUID + '">' + (address.ID ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' + address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode + '</option>';
      dialog.close();

      if (address.UUID !== originalUUID) {
        resetOptionValue = true;
      }

      if (add) {
        $('.shippingaddress select').removeClass('no-option').append(newOption);
        $('.no-address').hide();
      } else {
        $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
      }
      // if there's no previously selected option, select it
      if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
        $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
      }
    });
  });

  //preserve the uuid of the option for the hop up form
  if (selectedAddressUUID) {
    //update the form with selected address
    $addressList.find('option').each(function () {
      //check the values of the options
      if ($(this).attr('value') === selectedAddressUUID) {
        $(this).prop('selected', 'selected');
        $addressDropdown.trigger('change');
      }
    });
    originalUUID = selectedAddressUUID;
  }

  validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
  initMultiGiftMessageBox();
  if ($('.cart-row .shippingaddress .select-address').length > 0) {
    validator.initForm('form[id$="multishipping_addressSelection"]');
  }
  $('.edit-address').on('click', 'span', function (e) {
    dialog.open({
      url: this.attributes.href.value,
      options: {
        open: function open() {
          address.init();
          addEditAddress(e.target);
        }
      }
    });
  });
};

},{"../../dialog":12,"../../util":77,"../../validator":78,"./address":32,"./formPrepare":36}],40:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ajax = require('../../ajax'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    validator = require('../../validator'),
    modal = require('../../modal').global,
    design = require('../../design'),
    page = require('../../page'),
    addressVerificationSvc = require('../../qas');

var $cache, shippingMethods;

/**
 * Filter the delivery timespan based on the selected date and nearly date.
 * */
function filterDeliveryTimespan() {
  var selectedDate = $('.deliveryDate').val();
  var csrf_token = $('#checkout-shipping-deliverydate-csrf').val();
  var $form = $('#dwfrm_singleshipping_shippingAddress');
  var $shippingAddressSelection = $form.find('[name$="shipping"]:checked');
  var zipCode = $shippingAddressSelection.length > 0 ? $shippingAddressSelection.attr('data-postal-code') : $form.find('[name$="_postal"]').val();

  if ($('.deliveryTime').length <= 0) {
    return;
  }

  var url = Urls.filterDeliveryTimespan;
  var params = {
    selectedDate: selectedDate,
    zipCode: zipCode,
    format: 'ajax',
    csrf_token: csrf_token
  };

  $.ajax({
    dataType: 'json',
    url: url,
    type: 'POST',
    data: params,
    loading: true
  }).done(function (data) {
    if (data && data.csrfToken) {
      $('#checkout-shipping-deliverydate-csrf').val(data.csrfToken);
    }
    if (!data || !data.success) {
      forceUnspecified($form.find('.deliveryDate'));
      forceUnspecified($form.find('.deliveryTime'));
      return;
    }

    var selectbox = $('.deliveryTime');
    var currentlySelectedTime = $(selectbox).val();
    $(selectbox).empty();
    var deliveryTimeList = data.data;
    var isSelectedTimeValid = deliveryTimeList.some(function (item) {
      return item.value === currentlySelectedTime;
    });
    var selectedTime = isSelectedTimeValid ? currentlySelectedTime : '00'; // 00: Not Specified
    for (var i = 0; i < deliveryTimeList.length; i++) {
      var selectedText = deliveryTimeList[i].value === selectedTime ? 'selected="selected"' : '';
      $(selectbox).append($('<option ' + selectedText + '></option>').attr('value', deliveryTimeList[i].value).text(deliveryTimeList[i].name));
    }

    if (data.isUnavailableTimespan) {
      $('.error-timespan').show();
      $('.error-timespan').text(Resources.UNAVAILABLE_TIMESPAN);
    } else {
      $('.error-timespan').hide();
      $('.error-timespan').text('');
    }
  });
}

function updateDeliveryDateTime() {
  var url = Urls.updateDeliveryDateTimeSelection;
  var $form = $('#dwfrm_singleshipping_shippingAddress');
  var $shippingAddressSelection = $form.find('[name$="shipping"]:checked');
  var zipCode = $shippingAddressSelection.length > 0 ? $shippingAddressSelection.attr('data-postal-code') : $form.find('[name$="_postal"]').val();
  var params = {
    selectedDate: $('.deliveryDate').val(),
    selectedTimespan: $('.deliveryTime').val(),
    csrf_token: $('#checkout-shipping-deliverydate-csrf').val(),
    zipCode: zipCode
  };
  $.ajax({
    dataType: 'json',
    url: url,
    type: 'POST',
    data: params,
    loading: true
  }).done(function (data) {
    if (data && data.csrfToken) {
      $('#checkout-shipping-deliverydate-csrf').val(data.csrfToken);
    }
    if (!data.success && data.invalidDate) {
      updateDeliveryDateForm(zipCode);
      return;
    }
    if (!data.success) {
      forceUnspecified($form.find('.deliveryTime'));
      forceUnspecified($form.find('.deliveryDate'));
      return;
    }
    // do nothing if succeeded
  });
}

function forceUnspecified($selectBox) {
  $selectBox.find('option:not(:first-of-type)').remove();
}

function initCache() {
  var $formEle = $('form[id$="_shippingAddress"]');
  $cache = {
    addrForm: {
      address1: $formEle.find('input[name$="_address1"]'),
      address2: $formEle.find('input[name$="_address2"]'),
      countryCode: $formEle.find('input[id$="_country"]'),
      stateCode: $formEle.find('input[id$="_state"]'),
      postalCode: $formEle.find('input[name$="_postal"]'),
      city: $formEle.find('input[name$="_city"]')
    }
  };
}

function updateDeliveryDateForm(zip7) {
  var params = {
    zip7: zip7,
    addunregistered: true
  };
  var $shippingErrorPlacement = $('#shipping-page-error');
  var $deliveryDatetime = $('#delivery-datetime');
  $.ajax({
    url: util.ajaxUrl(util.appendParamsToUrl(Urls.getdelivery, params)),
    type: 'get',
    loading: true
  }).done(function (data) {
    $shippingErrorPlacement.addClass('mfp-hide');
    $shippingErrorPlacement.text('');
    $deliveryDatetime.addClass('mfp-hide');
    $deliveryDatetime.text('');
    if (typeof data === 'string' && data !== '') {
      $deliveryDatetime.html(data);
      $deliveryDatetime.removeClass('mfp-hide');
    } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !data.success) {
      $shippingErrorPlacement.text(data.errorMsg);
      $shippingErrorPlacement.removeClass('mfp-hide');
    } else {
      console.log('Something went wrong!');
    }
  });
}

function initEvents() {
  $('#dwfrm_singleshipping_shippingAddress_addressFields_postal').change(function () {
    if ($(this).closest('.cmd-box_container').find('.customer-registered').length > 0) {
      var zipCode = $(this).val();

      var regexp = new RegExp(/^[0-9]{7}$/);
      var valid = regexp.test(zipCode);
      if (valid) {
        $.ajax({
          url: Urls.getdelivery + '?zip7=' + zipCode,
          type: 'get'
        }).done(function (data) {
          if (data.length) {
            $('#delivrery-datatime').html(data);
            return;
          } else {
            console.log('delivery is empty');
          }
        });
      } else {
        console.log('invalid zipcode ');
      }
    }
  });

  $(document)
  // create address link
  .on('click', '.address-create', function (evt) {
    evt.preventDefault();
    var $createShippingAddBtn = $(this);
    var dataSend = {
      format: 'ajax',
      showtype: 'rightmodal'
    };
    ajax.load({
      url: Urls.checkoutAddAddress,
      data: dataSend,
      callback: function callback(data) {
        $('.js-modal-r_content[data-modal-type="address"] .cpb-modalR_contents').html(data);
        // show modal
        cpbUi.util.rightModalOpen.call($createShippingAddBtn, undefined, function (target) {
          validator.initForm('form[id="EditAddressForm"]');
          cpbUi.niceScroll.ready();
          initAddressEvent();
        });
      }
    });
  })

  // edit address link
  .on('click', '.address-edit', function (evt) {
    evt.preventDefault();
    var $editShippingAddressBtn = $(this);
    var addressID = $editShippingAddressBtn.data('address-id');
    var dataSend = {
      format: 'ajax',
      showtype: 'rightmodal'
    };

    var addressObject = '';
    if ($editShippingAddressBtn.data('address') == 'wplus') {
      addressObject = $editShippingAddressBtn.data('address-object');
    }

    var $target = $('.js-modal-r_content[data-modal-type="address"] .cpb-modalR_contents');
    $target.html('');
    ajax.load({
      url: Urls.checkoutEditShippingAddress + addressID + '&wplus=' + addressObject,
      data: dataSend,
      callback: function callback(data) {
        $target.html(data);
        if (addressID === 0) {
          var $addressName = $('#EditAddressForm input[name$="_addressFields_addressname"]');
          $addressName.prop('disabled', true);
          $addressName.prev().find('.required').hide();
        }
        // show modal
        cpbUi.util.rightModalOpen.call($editShippingAddressBtn, undefined, function (target) {
          validator.initForm('form[id="EditAddressForm"]');
          cpbUi.niceScroll.ready();
          initAddressEvent();
        });
      }
    });
  })
  // delete address link
  .on('click', '.address-delete', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var params = {
      wplus: $(this).attr('wplus'),
      format: 'ajax',
      csrf_token: this.dataset.csrfvalue
    };
    var url = util.appendParamsToUrl(href, params);
    var data = util.getQueryStringParams(util.getQueryString(url));

    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json'
    }).done(function (data) {
      page.refresh();
    });
  })

  // filter Delivery Timespan
  .off('change.filterDeliveryDate', '.deliveryDate').on('change.filterDeliveryDate', '.deliveryDate', function (e) {
    filterDeliveryTimespan();
  }).off('change.updateDeliveryDateTime', '.deliveryTime').on('change.updateDeliveryDateTime', '.deliveryTime', updateDeliveryDateTime)

  // set default address
  .on('click', '.address-make-default', function (e) {
    e.preventDefault();
    var params = {
      wplus: $(this).attr('wplus'),
      format: 'ajax',
      csrf_token: this.dataset.csrfvalue,
      shipping: 'true'
    };
    var href = $(this).attr('href');
    href = util.appendParamsToUrl(href, params);
    var data = util.getQueryStringParams(util.getQueryString(href));

    $.ajax({
      type: 'POST',
      url: href,
      data: data,
      dataType: 'json'
    }).done(function (data) {
      page.refresh();
    }).fail(function (jqXHR, textStatus, errorThrown) {
      console.log('error');
      console.log(jqXHR);
      console.log(textStatus);
      console.log(errorThrown);
    });
  })

  // select address shipping
  .off('click', '.shipping-radio').on('click', '.shipping-radio', function () {
    var zip = $(this).data('postal-code');
    var addressId = $(this).data('address-id');
    var currentAddressId = $('input[name$="_shippingAddress_addressFields_addressid"]').val();
    var $form = $(this).closest('form.checkout-shipping');
    var $csrf = $form.find('#checkout-shipping-csrf');
    if (addressId == currentAddressId) {
      return;
    }
    $('input[name$="_shippingAddress_addressFields_addressid"]').val(addressId);

    var $shippingErrorPlacement = $('#shipping-page-error');
    var $deliveryDatetime = $('#delivery-datetime');
    var url = Urls.updateAddressSelection;
    url = util.appendParamToURL(url, 'no', addressId);
    url = util.appendParamToURL(url, $csrf.attr('name'), $csrf.val());

    $.ajax({
      url: util.ajaxUrl(url),
      type: 'get',
      loading: true
    }).done(function (data) {
      $shippingErrorPlacement.addClass('mfp-hide');
      $shippingErrorPlacement.text('');
      $deliveryDatetime.addClass('mfp-hide');
      $deliveryDatetime.text('');
      if (typeof data === 'string' && data !== '') {
        $deliveryDatetime.html(data);
        $deliveryDatetime.removeClass('mfp-hide');
      } else if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && !data.success) {
        if (data.invalidRequest) {
          window.location.href = Urls.generalError;
          return;
        }
        $shippingErrorPlacement.text(data.errorMsg);
        $shippingErrorPlacement.removeClass('mfp-hide');
      } else {
        console.log('Something went wrong!');
      }
    });
  }).off('focusout.deliveryDate', '#dwfrm_singleshipping_shippingAddress').on('focusout.deliveryDate', '#dwfrm_singleshipping_shippingAddress', function (ev) {
    if (!/_(postal|state|city|address1)$/.test($(ev.target).attr('name'))) {
      return;
    }
    var $form = $('#dwfrm_singleshipping_shippingAddress');
    var isAddressFullFilled = ['_postal', '_state', '_city', '_address1'].every(function (name) {
      return $form.find('[name$="' + name + '"]').val();
    });
    if (!isAddressFullFilled) {
      var $deliveryDatetime = $('#delivery-datetime');
      $deliveryDatetime.addClass('mfp-hide');
      return;
    }
    updateDeliveryDateForm($form.find('[name$="_postal"]').val());
  });

  // authenticated user address change
  $('.address-list').on('change', '.address-tile input[name="shipping"]', function () {
    var $addressTile = $(this).closest('.address-tile');
    var addressID = $addressTile.data('addressId');

    // update address; on success update shipping method list
    $.get(Urls.updateAddressDetails, { addressID: addressID }, function (response) {
      updateShippingMethodList();
    });

    //checkSelectedAddress();
  });

  // guest user address change
  var timer = null;
  $('form[id$="_shippingAddress"]').on('change', 'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], input[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]', function () {
    if (!validateAddrForm()) {
      return;
    }

    if (timer) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(function () {
      $.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function (result) {
        updateShippingMethodList();
      });
    }, 200);
  });

  $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
  $('input[name$="_cart_isGift"]').on('click', giftMessageBox);

  $('.cpb-cart-gift_chk input[name$="_cart_isGift"]').on('change', applyGiftFlag);
  $('#checkout-form button[name$="_cart_checkoutCart"]').on('click', applyGiftFlag);

  $('.cpb-cart-checkout_fixed .cpb-cart_submit button').off('click.checkout_fixed').on('click.checkout_fixed', function (e) {
    e.preventDefault();
    $('button.cpb-cart-side_submit').trigger('click');
  });
}

/**
 * @function
 * @description Apply isGift flag to checkout form.
 */
function applyGiftFlag() {
  $('#checkout-form input[name$="_cart_isGift"]').val($('.cpb-cart-gift_chk input[name$="_cart_isGift"]').is(':checked'));
}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
  // show gift message box, if shipment is gift
  $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
  $('.c-block-cartmessage').toggleClass('mfp-hide', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
  var $summary = $('#secondary.summary');
  var couponError;

  if ($('.cart-coupon-code .error').length) {
    couponError = $('.cart-coupon-code .error').clone();
  }

  // indicate progress
  progress.show($summary);

  // load the updated summary area
  $summary.load(Urls.summaryRefreshURL, function () {
    // hide edit shipping method link
    $summary.fadeIn('fast');

    // checkout checkout minicart on right side event handling
    addSummaryScrollbar();

    $summary.find('.checkout-mini-cart .minishipment .header a').hide();
    $summary.find('.order-totals-table .order-shipping .label a').hide();
    $('.cart-coupon-code').append(couponError);
    util.maximizeCheckoutSummary();

    $('.checkout-mini-cart .accordion').foundation();
  });
}

function getAddressFromTile() {
  var $selectedAddress = $('.address-tile.is-current address');

  return {
    address1: $selectedAddress.data('address-one'),
    address2: $selectedAddress.data('address-two') || '',
    countryCode: $selectedAddress.data('country-code'),
    stateCode: $selectedAddress.data('state-code'),
    postalCode: $selectedAddress.data('postal-code'),
    city: $selectedAddress.data('city')
  };
}

/**
 * Init submit button on address add/edit modal, on change content in form
 * @returns
 */
function initAddressEvent() {
  $('#EditAddressForm button[name$="_address_create"]').on('click', function (e) {
    e.preventDefault();

    $(this).closest('[data-modal-type="address"]').find('.js-modal_scroll').removeClass('scroll-initialized');

    cpbUi.niceScroll.ready();
  });

  //link submit
  $('#EditAddressForm .shipping-address-submit-link').on('click', function (evt) {
    evt.preventDefault();
    $(this).parent().find('button.shipping-address-submit-button').click();
  });

  $('#EditAddressForm button.shipping-address-submit-button').on('click', function (e) {
    var _util$appendParamsToU;

    e.preventDefault();
    var $form = $('#EditAddressForm');
    if (!$form.data('custom-validator')(e)) {
      e.stopPropagation();
      return;
    }
    var dataToPost = $form.serialize();
    var url = util.appendParamsToUrl($(this).data('url'), (_util$appendParamsToU = {}, _defineProperty(_util$appendParamsToU, $(this).data('csrfname'), $(this).data('csrfvalue')), _defineProperty(_util$appendParamsToU, 'from', 'shipping'), _util$appendParamsToU));
    $.ajax({
      method: 'POST',
      url: url,
      data: dataToPost
    }).done(function (response) {
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.validationError) {
        var errorObj = response.errors.reduce(function (result, error) {
          result[error.name] = error.message;
          return result;
        }, {});
        $form.data('validator').showErrors(errorObj);
        $form.data('submitting', false);
        return;
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        var errorText = response.errors.join('\n');
        var $errorPlacement = $('#EditAddressForm').find('.cmd-form_container>.cmd-form_err');
        $errorPlacement.empty().html(errorText);
        $errorPlacement.removeClass('mfp-hide');
      } else {
        page.refresh();
      }
    });
  });
}

function getAddressFromForm() {
  return {
    address1: $cache.addrForm.address1.val(),
    address2: $cache.addrForm.address2.val(),
    countryCode: $cache.addrForm.countryCode.val(),
    stateCode: $cache.addrForm.stateCode.val(),
    postalCode: $cache.addrForm.postalCode.val(),
    city: $cache.addrForm.city.val()
  };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
  var params = User.isCustomerAuthenticated ? getAddressFromTile() : getAddressFromForm();
  return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
  // nothing entered
  if (!shippingMethodID) {
    return;
  }
  // attempt to set shipping method
  var url = getShippingMethodURL(Urls.selectShippingMethodsList, {
    shippingMethodID: shippingMethodID
  });
  ajax.getJson({
    url: url,
    callback: function callback(data) {
      updateSummary();
      if (!data || !data.shippingMethodID) {
        window.alert("Couldn't select shipping method.");
        return false;
      }
      // display promotion in UI and update the summary section,
      // if some promotions were applied
      $('.shippingpromotions').empty();

      // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
      //     var len = data.shippingPriceAdjustments.length;
      //     for (var i=0; i < len; i++) {
      //         var spa = data.shippingPriceAdjustments[i];
      //     }
      // }
    }
  });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
  var $shippingMethodList = $('#shipping-method-list');
  if (!$shippingMethodList || $shippingMethodList.length === 0) {
    return;
  }
  var url = getShippingMethodURL(Urls.shippingMethodsJSON);
  ajax.getJson({
    url: url,
    callback: function callback(data) {
      if (!data) {
        window.alert("Couldn't get list of applicable shipping methods.");
        return false;
      }

      // shipping methods remain unchanged; update summary as selected method may/may not change
      if (shippingMethods && shippingMethods.toString() === data.toString()) {
        updateSummary();
        return true;
      }

      // We need to update the UI.  The list has changed.
      // Cache the array of returned shipping methods.
      shippingMethods = data;
      // indicate progress
      progress.show($shippingMethodList);

      // load the shipping method form
      var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
      $shippingMethodList.load(smlUrl, function () {
        $shippingMethodList.fadeIn('fast');
        // rebind the radio buttons onclick function to a handler.
        $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
          selectShippingMethod($(this).val());
        });

        // update the summary
        updateSummary();
        progress.hide();
        tooltip.init();
        //if nothing is selected in the shipping methods select the first one
        if ($shippingMethodList.find('.input-radio:checked').length === 0) {
          $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
        }
      });
    }
  });
}

/**
 * Check there is an address selected, if not, disable the continue button
 * */
function checkSelectedAddress() {
  var $form = $('form[id$="_shippingAddress"]');
  var $submit = $form.find('button[type="submit"]');
  var $footerSubmit = $('.cpb-cart-checkout_fixed .cpb-cart_submit button');

  // enable the submit button if there are no shipping card
  // if there are, user must have at least 1 selected shipping card for the button to be enabled
  if ($form.find('.address-tile').length == 0 || $form.find('.address-tile input[name="shipping"]:checked').length) {
    $submit.prop('disabled', false);
    $footerSubmit.prop('disabled', false);
  } else {
    $submit.prop('disabled', true);
    $footerSubmit.prop('disabled', true);
  }
}

function validateAddrForm() {
  var addr = getAddressFromForm();
  return addr.address1 && addr.city && addr.postalCode && addr.stateCode && addr.countryCode;
}

function initCouponCodeField() {
  $('.cpb-cart-side_code input').on('keyup', function (e) {
    var couponCode = $('.cpb-cart-side_code input').val();
    if (couponCode == '') {
      $('#add-coupon').prop('disabled', true);
    } else {
      $('#add-coupon').prop('disabled', false);
    }

    if (e.which === 13) {
      e.preventDefault();
      $('#add-coupon').click();
    }
  });
}

exports.init = function () {
  initCache();
  initEvents();
  addressVerificationSvc.init();

  if (window.User.isCustomerAuthenticated == false) {
    $('.checkout-shipping').find('.set-default-cb').hide();
  }

  validator.initForm('form[name$="shippingAddress_save"]');

  giftMessageBox();
  updateShippingMethodList();
  initCouponCodeField();

  $(document).find('ul.address-list div.address-tile').each(function () {
    if ($(this).hasClass('default') || $(this).hasClass('is-current') || $(this).hasClass('address-default')) {
      $(this).removeClass('is-current');
      $(this).removeClass('default');

      $(this).click();
    }
  });

  //checkSelectedAddress();
};
exports.initCouponCodeField = initCouponCodeField;
exports.updateShippingMethodList = updateShippingMethodList;

},{"../../ajax":1,"../../design":11,"../../modal":24,"../../page":28,"../../progress":64,"../../qas":65,"../../tooltip":76,"../../util":77,"../../validator":78}],41:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
  $('#compare-table').on('click', '.remove-link', function (e) {
    e.preventDefault();
    ajax.getJson({
      url: this.href,
      callback: function callback() {
        page.refresh();
      }
    });
  }).on('click', '.open-quick-view', function (e) {
    e.preventDefault();
    var url = $(this).closest('.product').find('.thumb-link').attr('href');
    quickview.show({
      url: url,
      source: 'quickview'
    });
  });

  $('#compare-category-list').on('change', function () {
    $(this).closest('form').submit();
  });
}

exports.init = function () {
  productTile.init();
  initializeEvents();
  addProductToCart();
};

},{"../ajax":1,"../page":28,"../product-tile":63,"../quickview":66,"./product/addToCart":44}],42:[function(require,module,exports){
'use strict';

var util = require('../util'),
    addToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    skin_trouble_check = require('./product/skin_trouble_check');

function initializeEvents() {
  $(document)
  // mobile navigation
  .on('change', '.promotion-nav-select select', function (e) {
    var newUrl = $(this).find('option:selected').val();

    if (newUrl) {
      window.location.href = newUrl;
    }
  });

  // concierge form events
  var conciergeForm = $('form[id$="_beautyconsultant"]');
  if (conciergeForm.length > 0) {
    // secure concierge access
    /*if (location && location.protocol === 'http:') {
            window.location.href = Urls.secureConciergeForm;
        }*/

    var successShown = false;
    conciergeForm.on('click', 'button#sendBtn', function (e) {
      e.preventDefault();

      $.ajax({
        url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
        data: conciergeForm.serialize(),
        method: 'POST'
      }).done(function (response) {
        var conciergeModal = $('#concierge-modal');
        if (response && response.success && conciergeModal.length > 0) {
          // show success modal
          successShown = true;
          var popup = new Foundation.Reveal(conciergeModal);
          //Window height minus 80px, which sets the modal to fit inside the device's screen
          var windowHeight = window.innerHeight - 130;

          popup.$element.children('.modal-body').css('max-height', windowHeight);
          popup.open();

          // trigger ga
          window.history.pushState('', '', Urls.conciergeForm);
          $(document).trigger('askanexpert');
        }
      });
    });

    $(document).on('click', '.reveal-overlay', function () {
      // trigger redirect when concierge overlay is closed
      if (successShown && $(this).css('display') == 'none') {
        successShown = false;
        window.location.href = Urls.secureConciergeForm;
      }
    });
  }

  var $productServiceModal = $('#psm-in-asset');
  if ($productServiceModal.length > 0) {
    $('.open_engrave_asset').on('click', function (e) {
      e.preventDefault();

      $('#naire-data').val('');
      $('.cpb-naire_preview_txt.js-naire-preview').text(Resources.ENGRAVING_DEFAULT_DISP);
      simpleUpdateContent($(this).data('url'));

      setTimeout(function () {
        cpbUi.util.rightModalOpen.call($('.open_engrave_asset'), undefined, function () {
          cpbUi.niceScroll.ready();
        });
      }, 300);
    });
  }
}

function initActions() {
  $('#psm-in-asset .product-service-step1 .cpb-naire-color_list a').off('click.naire_color').on('click.naire_color', function (e) {
    e.preventDefault();
    var data = {
      Quantity: '1',
      isProductServiceModal: true
    };
    simpleUpdateContent($(this).attr('href'), data);
    return false;
  });
}

function simpleUpdateContent(url, data) {
  var edgingtext = $('[name$=_edgingtext]').val();
  ajax.load({
    url: util.ajaxUrl(url),
    data: data,
    target: '.product-service',
    callback: function callback() {
      initActions();
      addToCart();
      if (edgingtext) {
        $('.product-service #naire-data').val(edgingtext);
        $('.product-service .js-naire-preview').empty().text(edgingtext);
      }
    }
  });
}

module.exports.init = function () {
  initializeEvents();
};

},{"../ajax":1,"../util":77,"./product/addToCart":44,"./product/skin_trouble_check":52}],43:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {
  if ($('.pt_order-confirmation').length) {
    recommendations();
  } else {
    return;
  }
};

},{"./product/recommendations":51}],44:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    page = require('../../page'),
    util = require('../../util'),
    Promise = require('promise'),
    _ = require('lodash'),
    design = require('../../design'),
    skin_trouble_check = require('./skin_trouble_check');
var quickview = require('../../quickview');

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function setAddToCartError(msg) {
  var $errEle = $('.cmd-form_err');
  $errEle.html(msg);
  $errEle.show();
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function addItemToCart(form) {
  var $form = $(form);
  return $.ajax({
    type: 'POST',
    url: util.ajaxUrl(Urls.addProduct),
    data: $form.serialize(),
    loading: true
  }).then(function (response) {
    // handle error in the response
    if (response.error) {
      setAddToCartError(response.error);
      return { success: false, result: response };
    }
    return { success: true, result: response };
  });
};

/**
 * set addToCartType
 */
var setAddToCartType = function setAddToCartType(type, pid) {
  $.ajax({
    type: 'POST',
    url: util.appendParamsToUrl(util.ajaxUrl(Urls.addToCartType), {
      type: type,
      pid: pid
    })
  });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function addToCart(e, $this) {
  e.preventDefault();
  var $form = $this ? $this.closest('form') : $(this).closest('form');
  $form.find('input[name="Quantity"]').val($form.find('.c-quantitySelection .c-select-current').text() || 1);
  var pid = $form.find('input[name="pid"]').val();
  var isQuickView = $(this).parents('#cpb-modal-quickview').length > 0 || $form.hasClass('quickview-form');
  var addToCartType = isQuickView ? 'Quick Shop' : 'Product page';
  return $.when(addItemToCart($form)).then(function (response) {
    var href = $form.find('.quickview-source-url').attr('href');
    // クイックビュー用一時確保formを削除する。
    $('.quickview-form').remove();

    if (!response.success) {
      var error = {
        isQuickView: isQuickView,
        pid: pid,
        href: href,
        message: response.result.error
      };
      var deferred = $.Deferred();
      deferred.reject(error);
      return deferred.promise();
    }

    var $uuid = $form.find('input[name="uuid"]');
    // ここで格納された関数は肌トラブルチェックの最後に実行される
    var callBackFunc = function () {
      if ($uuid.length > 0 && $uuid.val().length > 0) {
        return page.refresh;
      } else {
        // do not close quickview if adding individual item that is part of product set
        // @TODO should notify the user some other way that the add action has completed successfully
        $(document).trigger('gtadd-to-cart');
        return function () {
          minicart.show(response.result);
        };
      }
    }();
    setAddToCartType(addToCartType, pid);
    return callBackFunc;
  }.bind(this)).then(function (value) {
    // dummy success handler
    return value;
  }, function (error) {
    if ((typeof error === 'undefined' ? 'undefined' : _typeof(error)) !== 'object' || !error.isQuickView) {
      return $.Deferred().reject(error).promise();
    }
    quickview.openQuickView(error.href).then(function () {
      if (error.message) {
        var $bottom = $('#cpb-modal-quickview form .cpb-modalR_bottom');
        $bottom.find('.quickview-error-message').remove();
        $bottom.prepend($('<ul class="c-text-error quickview-error-message"><li>' + error.message + '</li></ul>'));
      }
    });
  });
};
exports.addToCart = addToCart;

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function addAllTo(e) {
  e.preventDefault();

  var pidData = formatPidDataFromEles($('.cpb-products-variety_area').find('.cpb-products-variety_box'));
  return minicart.addAllProducts(pidData, e.data.to, e.currentTarget);
};

/**
 * @description Handler to handle the add an item to cart event on PDP footer
 */
var addToCartOnFooter = function addToCartOnFooter(e) {
  e.preventDefault();
  var $form = $('.pdpForm');
  if (!$form.length || $(this).find('button').prop('disabled')) {
    return;
  }

  var quantity = 1;

  $form.find('input[name="Quantity"]').val(quantity);
  var pid = $form.find('input[name="pid"]').val();

  return $.when(addItemToCart($form)).then(function (response) {
    if (!response.success) {
      return $.Deferred().reject().promise();
    }

    var $uuid = $form.find('input[name="uuid"]');

    // ここで格納された関数は肌トラブルチェックの最後に実行される
    var callBackFunc = function () {
      if ($uuid.length > 0 && $uuid.val().length > 0) {
        return page.refresh;
      } else {
        // do not close quickview if adding individual item that is part of product set
        // @TODO should notify the user some other way that the add action has completed successfully
        $(document).trigger('gtadd-to-cart');
        return function () {
          minicart.show(response.result);
        };
      }
    }();

    setAddToCartType('Product page', pid);
    return callBackFunc;
  }.bind(this));
};

// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
  return $selector.toArray().map(function (ele) {
    var $ele = $(ele),
        pid = $ele.find('input[name="setpd"]').val(),
        qty = $ele.find('input[name="Quantity"]').length ? $ele.find('input[name="Quantity"]').val() : 1;

    return pid + ':' + qty;
  }).join(',');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
  $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
  $('#add-all-to-cart').off('click').on('click', { to: 'Cart' }, skinCheckAddAllTo);
  $('.cpb-products-cart_fixed').off('click.fotter').on('click.fotter', '.cpb-products-cart_submit button', skinCheckAddToCartOnFooter);
  $('.open_engrave.c-btn.c-btn-secondary').off('click').on('click', skincheckEngrave);
  $('#cpb-products_submit .add-to-cart').on('click', skinCheck);
  $('#add-to-cart-in-modal').on('click', addToCartFromServiceModal);
  $('.js-naire-setting-button').on('click', function (e) {
    e.preventDefault();
    $('#naire-data').siblings('p.is-error').remove();
    if ($('#naire-data').val() == '') {
      $('#naire-data').after($('<p class="c-input-label is-error"></p>').append(Resources.ENGRAVING_DATA_EMPTY));
    } else {
      $('.js-naire-setting').click();
    }
  });
};

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '#samples-add-to-cart', addSamplesToCart);
$(document).on('click', '.cpb-cart-sample_list .cpb-cart-sample_item .cpb-cart-sample_chk label', sampleTileSelect);
$(document).on('change', '.reveal.sample-selection .close-button', function (e) {
  scrollToTop(e);
});
$('form.multi-select-form').on('submit', function (e) {
  e.preventDefault();

  var pidData = formatPidDataFromEles($(this).find('button.multiselect[value="selected"]'));
  minicart.addAllProducts(pidData, 'Cart');
});

function sampleTileSelect(e) {
  e.preventDefault();

  var $this = $(this).closest('.cpb-cart-sample_item');
  var $tile = $this.find('[name="sampleselect"]');
  $tile.prop('checked', !$tile.prop('checked'));
  var $multiSelectForm = $this.parents('form');
  var $thresholdInput = $multiSelectForm.find('input#pids');

  var selectedCount = $multiSelectForm.find($('input[name="sampleselect"]:checked')).length;
  var limitCount = $thresholdInput.data('limit');

  if (!$('#sampleserror').hasClass('invisible')) {
    $('#sampleserror').addClass('invisible');
    $('#sampleserror').text(null);
  }

  // do checking to compare if limit is met
  if (selectedCount > limitCount) {
    // toggle val/text
    $tile.prop('checked', false);
    $('#sampleserror').removeClass('invisible');
    $('#sampleserror').text($('input#pids').data('error'));

    // refresh niceScroll
    var $niceScrollPlace = $(this).closest('[data-modal-type="sample"]').find('.js-modal_scroll');
    $niceScrollPlace.removeClass('scroll-initialized');
    cpbUi.niceScroll.ready();
    $niceScrollPlace.getNiceScroll(0).doScrollTop(0);
  }

  var selectedProductList = [];

  // fetch all items that are selected
  $multiSelectForm.find('[name="sampleselect"]:checked').each(function (index, item) {
    selectedProductList.push($(item).val());
  });

  // store all selected products to hidden input
  $thresholdInput.val(selectedProductList);

  // update selected counter
  var selectedCount = parseInt(selectedProductList.length);
  var selectedLimit = parseInt($thresholdInput.data('count'));
  $('span#sample-count').html(selectedCount <= selectedLimit ? selectedCount : selectedLimit);

  // enable "Add to Bag" button
  var cartButton = $thresholdInput.data('button');
  $('#' + cartButton).removeAttr('disabled');
  $('button#' + cartButton).removeClass('is-outofstock');
}

function addSamplesToCart(e) {
  e.preventDefault();

  var url = util.toAbsoluteUrl($(this).data('action'));
  var data = {};
  data['pid'] = $(this).parents('form').find('input#pids').val();
  data[$(this).parents('form').find('input#csrf')[0].name] = $(this).parents('form').find('input#csrf').val();

  $.ajax({
    url: util.appendParamToURL(url, 'format', 'ajax'),
    data: data,
    method: 'POST'
  }).done(function (response) {
    if ($(location).attr('pathname').match('.*Cart-Show$|.*Cart-SubmitForm$') || pageContext.type === 'Cart') {
      window.location.assign(Urls.cartShow);
    } else {
      minicart.show(response);
      design.dropdownToggleInit();
    }
  });

  // close sample modal
  cpbUi.util.rightModalClose.call($('.js-modal-r_content[data-modal-type="sample"] .js-modal-r_close'), undefined, function (target) {});
}

function skinCheck(e) {
  var isQuickView = $(this).parents('#cpb-modal-quickview').length > 0;
  if (isQuickView) {
    // モーダルを閉じるときの時間差でsubmitが走ってしまうのでイベントを止める
    e.preventDefault();
    // クイックビュー内にフォームがあるため、一時的に外部に確保しておく。（addToCart関数内で削除する）
    $(this).closest('form').clone().addClass('quickview-form').addClass('mfp-hide').appendTo('body');
    // クイックビューを閉じてから、肌トラブルチェックを実行する
    cpbUi.util.rightModalClose.call($('#cpb-modal-quickview .js-quickview_close'), 'quickview', function () {
      $('#cpb-modal-quickview').find('.js-modal_scroll').getNiceScroll().remove();
      $('#cpb-modal-quickview').remove();
      cpbUi.isQuickView = false;
      skin_trouble_check.skinTroubleExecute(e, $('.quickview-form #cpb-products_submit .add-to-cart'), addToCart);
    });
  } else {
    skin_trouble_check.skinTroubleExecute(e, $(this), addToCart);
  }
}

// skin check before displaying  engraving service
function skincheckEngrave(e) {
  $('#naire-data').val('');
  $('.cpb-naire_preview_txt.js-naire-preview').text(Resources.ENGRAVING_DEFAULT_DISP);
  setTimeout(function () {
    cpbUi.util.rightModalOpen.call($('.open_engrave'), undefined, function (target) {
      cpbUi.niceScroll.ready();
    });
  }, 300);
}

function skinCheckAddAllTo(e) {
  var setNotEmpty = $(this).closest('form.pdpForm').find('input[name="Quantity"]').toArray().some(function (quantity) {
    return $(quantity).val() > 0;
  });

  if (!setNotEmpty) {
    // セット小商品の個数がすべて0の場合はエラーを表示して処理を止める
    var errorBeforeElem = $('form.pdpForm').find('button#add-all-to-cart').parent();
    errorBeforeElem.siblings('.cmd-form_err').remove();
    errorBeforeElem.after($('<div class="cmd-form_err _simple"></div>').text(Resources.SET_NOT_ADD_PRODUCT));
    return false;
  }

  skin_trouble_check.skinTroubleExecute(e, $(this), addAllTo);
}

function skinCheckAddToCartOnFooter(e) {
  skin_trouble_check.skinTroubleExecute(e, $(this), addToCartOnFooter);
}

/**
 * 刻印サービスのモーダル内にあるショッピングバッグに入れるボタン用関数(LP、PDP)
 *
 * @param {*} e イベント
 */
function addToCartFromServiceModal(e) {
  // カート追加用関数
  var addToCart = function () {
    e.preventDefault();
    var productId = $(this).attr('data-product');
    var engravingText = $('#naire-data').val();
    var engravingFont = $('input[name=naire-font]:checked').data('id');
    if (productId === '') {
      return;
    }

    if (engravingText === '') {
      engravingText = $('#naire-data').attr('placeholder');
    }

    return $.ajax({
      method: 'post',
      url: Urls.addToCartInModal,
      data: {
        productId: productId,
        engravingText: engravingText,
        engravingFont: engravingFont
      },
      loading: true
    }).then(function (response) {
      if (response.success) {
        window.location.href = Urls.cartShow;
      } else {
        if (response.showGeneralError) {
          return window.location.href = Urls.generalError;
        }
        var errorAreaArray = [];
        errorAreaArray.push($('#add-to-cart-in-modal').closest('.cpb-modalR_bottom').find('.c-text-error'));
        errorAreaArray.push(function () {
          var ele = $('.cpb-modalR_bottom').toArray().filter(function (ele) {
            return $(ele).find('button').data('target') === 'naire-setting';
          })[0];
          return $(ele).find('.c-text-error');
        }());
        errorAreaArray.forEach(function (ele) {
          $(ele).find('li').remove();
          $(ele).append($('<li></li>').text(response.error));
          $(ele).removeClass('mfp-hide');
        });

        $('#productservicemodal').find('.cpb-naire-variation').before(response.error);

        // 刻印サービス用モーダルは閉じているので再度開く
        var targetElement = function () {
          var element = $('.open_engrave');
          if (element.length > 0) {
            return element;
          }
          return $('.open_engrave_asset');
        }();
        return $.Deferred().reject(function () {
          cpbUi.util.rightModalOpen.call(targetElement, undefined, function (target) {
            cpbUi.niceScroll.ready();
          });
        }).promise();
      }
    });
  }.bind(this);

  // 刻印サービス用モーダルを閉じてから肌トラブルチェックを行う
  cpbUi.util.rightModalClose.call($('.product-service .js-modal-r_close'), undefined, skin_trouble_check.skinTroubleExecute(e, $(this), addToCart));
}

},{"../../design":11,"../../dialog":12,"../../minicart":23,"../../page":28,"../../quickview":66,"../../util":77,"./skin_trouble_check":52,"lodash":111,"promise":121}],45:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

var updateContainer = function updateContainer(data) {
  var $availabilityMsg = $('.pdp-main .cpb-products-stock');
  var message; // this should be lexically scoped, when `let` is supported (ES6)
  if (!data) {
    $availabilityMsg.html('<div class="item-txt">' + Resources.ITEM_STATUS_NOTAVAILABLE + '</div>');
    return;
  }
  $availabilityMsg.empty();
  // Look through levels ... if msg is not empty, then create span el
  if (data.levels.IN_STOCK > 0) {
    if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
      // Just in stock
      message = Resources.IN_STOCK;
    } else {
      // In stock with conditions ...
      message = Resources.IN_STOCK + '<br>' + data.inStockMsg;
    }
    $availabilityMsg.append('<div class="item-txt">' + message);
  }
  if (data.levels.PREORDER > 0) {
    if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
      message = Resources.PREORDER;
    } else {
      message = Resources.PREORDER + '<br>' + data.preOrderMsg;
    }
    $availabilityMsg.append('<div class="item-txt">' + message);
  }
  if (data.levels.BACKORDER > 0) {
    if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
      message = Resources.BACKORDER;
    } else {
      message = Resources.BACKORDER + '<br>' + data.backOrderMsg;
    }
    $availabilityMsg.append('<div class="item-txt">' + message);
  }
  if (data.inStockDate !== '') {
    $availabilityMsg.append(String.format(Resources.IN_STOCK_DATE, data.inStockDate));
  }
  if (data.levels.NOT_AVAILABLE > 0) {
    if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
      message = Resources.NOT_AVAILABLE;
    } else {
      message = Resources.NOT_AVAILABLE + '<br>' + Resources.REMAIN_NOT_AVAILABLE;
    }
    $availabilityMsg.append('<div class="item-txt">' + message);
  }

  $availabilityMsg.append('</div>');
};

var getAvailability = function getAvailability() {
  ajax.getJson({
    url: util.appendParamsToUrl(Urls.getAvailability, {
      pid: $('#pid').val(),
      Quantity: $(this).val()
    }),
    callback: updateContainer
  });
};

module.exports = function () {
  $('#pdpMain').on('change', '.pdpForm input[name="Quantity"]', getAvailability);
};

},{"../../ajax":1,"../../util":77}],46:[function(require,module,exports){
'use strict';

function initializeEvents() {
  $('.video-carousel').slick({
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 480,
      settings: 'unslick'
    }]
  });
}

module.exports = {
  init: function init() {
    initializeEvents();
  }
};

},{}],47:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog');
var modal = require('../../modal').global;
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');

function getProductImageURL(viewType) {
  var pid = $("span[itemprop='productID']").data('pid');
  return util.appendParamsToUrl(Urls.getProductImages, {
    pid: pid,
    sz: viewType
  });
}

function lazyLoadThumbnails() {
  var viewType = util.isMobile() ? 'large' : 'icon';
  var thumbnailProductImageURL = getProductImageURL(viewType);

  $.get(thumbnailProductImageURL).done(function (res) {
    $('#thumbnails').html(res);

    var thumbnailImageCount = $('#thumbnails li').length;
    if (thumbnailImageCount == 0) {
      return false;
    } else if (thumbnailImageCount > 1 && window.innerWidth > 767) {
      initThumbnailCarousel();
    } else if (thumbnailImageCount > 1 && window.innerWidth < 768) {
      initMainImageCarousel();
    }
  });
}

function initThumbnailCarousel() {
  $('#thumbnails ul').slick({
    dots: false,
    infinite: true,
    arrows: true,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true
  });
}

function initMainImageCarousel() {
  $('#thumbnails ul').slick({
    dots: true,
    vertical: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 1,
    focusOnSelect: true
  });
}

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts) {
  $('#pdpMain .primary-image').attr({
    src: atts.url,
    alt: atts.alt,
    title: atts.title
  });
  updatePinButton(atts.url);
  updateFacebookButton(atts.url);
  if (!dialog.isActive() && !util.isMobile()) {
    $('#pdpMain .main-image').find('img').attr('src', atts.hires);
  }
}

function updatePinButton(imageUrl) {
  var pinButton = document.querySelector('.share-icon[data-share=pinterest]');

  if (!pinButton) {
    return;
  }
  var newUrl = imageUrl;
  if (!imageUrl) {
    newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
  }
  var href = url.parse(pinButton.href);
  var query = qs.parse(href.query);
  query.media = url.resolve(window.location.href, newUrl);
  query.url = window.location.href;
  var newHref = url.format(_.extend({}, href, {
    query: query, // query is only used if search is absent
    search: qs.stringify(query)
  }));
  pinButton.href = newHref;
}

function updateFacebookButton(imageUrl) {
  var facebookButton = document.querySelector('.share-icon[data-share=facebook]');

  if (!facebookButton) {
    return;
  }
  var newUrl = imageUrl;
  if (!imageUrl) {
    newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
  }
  var href = url.parse(facebookButton.href);
  var query = qs.parse(href.query);
  query.picture = url.resolve(window.location.href, newUrl);
  query.u = window.location.href;
  var newHref = url.format(_.extend({}, href, {
    query: query, // query is only used if search is absent
    search: qs.stringify(query)
  }));
  facebookButton.href = newHref;
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
  if (dialog.isActive() || util.isMobile()) {
    $('#pdpMain .main-image').removeAttr('href');
  }
  updatePinButton();
  updateFacebookButton();
  lazyLoadThumbnails();

  // bind zoom event handler
  $(document).on('click', '.image-zoom', function (evt) {
    evt.preventDefault();
    var viewType = 'zoom';
    // var thumbnailProductImageURL = getSingleProductImageURL(viewType);
    // modal.renderByUrl(thumbnailProductImageURL);

    var zoomImageUrl = null;
    if ($('.productthumbnail').length > 1) {
      zoomImageUrl = $('.productthumbnail.slick-current').data('zoomimg');
    } else {
      // for only one thumbnail, select that one image
      zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
    }

    modal.renderContent('<img src="' + zoomImageUrl + '">');

    modal.addCustomClass('productImageZoom');
  });

  // handle product thumbnail click event
  $('#thumbnails').on('click', '.productthumbnail', function () {
    var $that = $(this);
    if (!$that.hasClass('selected')) {
      $(document).trigger('clickproductthumbnail');
    }

    $('#thumbnails').find('.productthumbnail.selected').removeClass('selected');
    $that.addClass('selected');
    setMainImage($that.data('lgimg'));
  });
};

module.exports.setMainImage = setMainImage;
module.exports.lazyLoadThumbnails = lazyLoadThumbnails;

},{"../../dialog":12,"../../modal":24,"../../util":77,"lodash":111,"qs":130,"url":147}],48:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dialog = require('../../dialog'),
    modal = require('../../modal').global,
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    image = require('./image'),

//productNav = require('./productNav'),
howToSection = require('./howToSection'),
    productSet = require('./productSet'),
    productKit = require('./productKit'),
    recommendations = require('./recommendations'),
    socialShareIcons = require('./socialShareIcons'),
    variant = require('./variant'),
    design = require('../../design'),
    ajax = require('../../ajax');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */

function initializeDom() {
  //productNav();
  recommendations();
  var ua = navigator.userAgent;
  if ((ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0) {
    // Processing for smartphones
  } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Macintosh') > -1 && 'ontouchend' in document) {
    // Processing for tablets
  } else {
    // Processing for PC
    $('.hadapasha_link_sp').css('display', 'none');
  }
}

var addToWishlist = function addToWishlist(e) {
  if (!window.User.isCustomerAuthenticated) {
    return;
  }

  e.preventDefault();
  var $target = $(this).parent();
  var url = util.appendParamsToUrl($(this).attr('href'), {
    format: 'ajax'
  });
  var data = {};
  data[this.dataset.csrfname] = this.dataset.csrfvalue;

  $.ajax({
    type: 'POST',
    url: url,
    data: data
  }).done(function (response) {
    if (typeof response === 'string' && response !== '') {
      $target.empty().html(response);
      product.initializeEvents();
    } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
      window.alert(response.error);
    }
  });
};

var removeFromWishlist = function removeFromWishlist(e) {
  e.preventDefault();

  var $target = $(this).parent();
  var url = util.appendParamsToUrl($(this).attr('href'), {
    format: 'ajax'
  });
  var data = {};
  data[this.dataset.csrfname] = this.dataset.csrfvalue;

  $.ajax({
    type: 'POST',
    url: url,
    data: data
  }).done(function (response) {
    if (typeof response === 'string' && response !== '') {
      $target.empty().html(response);
      product.initializeEvents();
    } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
      window.alert(response.error);
    }
  }).fail(function (xhr, textStatus) {
    if (textStatus === 'parsererror') {
      window.alert(Resources.BAD_RESPONSE);
    } else {
      window.alert(Resources.SERVER_CONNECTION_ERROR);
    }
  });
};

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
  var $pdpMain = $('#pdpMain');

  addToCart();
  availability();
  variant();
  image();
  howToSection.init();
  //productSet();
  productKit();
  socialShareIcons();
  //    design.pdpInit();
  if (SitePreferences.STORE_PICKUP) {
    productStoreInventory.init();
  }

  // Add to Wishlist and Add to Gift Registry links behaviors
  $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
    var data = util.getQueryStringParams($('.pdpForm').serialize());
    if (data.cartAction) {
      delete data.cartAction;
    }
    var url = util.appendParamsToUrl(this.href, data);
    this.setAttribute('href', url);
  });

  // product options
  $pdpMain.on('change', '.product-options select', function () {
    var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
    var selectedItem = $(this).children().filter(':selected').first();
    salesPrice.text(selectedItem.data('combined'));
  });

  // prevent default behavior of thumbnail link and add this Button
  $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
    e.preventDefault();
  });

  $('.full-ingredients').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $fullIngredientList = $('.c-block-ingredientslist');
    var contentUrl = $this.attr('href');

    if ($fullIngredientList.length) {
      $this.toggleClass('show-list');
    } else {
      $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(function (content) {
        $('<div class="full-ingredients-list"><a class="close"><i class="icon-close"></i></a>' + content + '</div>').insertAfter($this);
      });
      $this.toggleClass('show-list');
    }
  });

  $pdpMain.on('click', '.close', function (e) {
    e.preventDefault();
    $('.full-ingredients.show-list').removeClass('show-list');
  });

  $('.cpb-products-details #save-for-later').on('click', addToWishlist);

  $('.cpb-products-details .remove-from-wishlist').on('click', removeFromWishlist);

  if ($('.item-link_box').length > 0) {
    var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
    var pids = $productForms.map(function (formEle) {
      return $(formEle).data('pid');
    }).join(',');

    $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
      pid: pids
    }), function (data) {
      if (data === 'false') {
        $('.product-form-actions .product-set-wishlist').removeClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
      } else {
        $('.product-form-actions .product-set-wishlist').addClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
      }
    });

    $('.product-set-wishlist').on('click', function (e) {
      if (!window.User.isCustomerAuthenticated) {
        return;
      }

      e.preventDefault();

      var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
      var pids = $productForms.map(function (formEle) {
        return $(formEle).data('pid');
      }).join(',');

      $.post(util.appendParamsToUrl($(this).attr('href'), {
        pid: pids,
        format: 'ajax'
      }), function (data) {
        if (data === 'false') {
          $('.product-form-actions .product-set-wishlist').removeClass('invisible');
          $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
        } else {
          $('.product-form-actions .product-set-wishlist').addClass('invisible');
          $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
        }
      });
    });

    $('.remove-product-set-from-wishlist').on('click', function (e) {
      e.preventDefault();

      var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
      var pids = $productForms.map(function (formEle) {
        return $(formEle).data('pid');
      }).join(',');

      $.post(util.appendParamsToUrl(Urls.wishlistRemoveAll, {
        pid: pids,
        format: 'ajax'
      }), function (data) {
        if (data === 'false') {
          $('.product-form-actions .product-set-wishlist').removeClass('invisible');
          $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
        } else {
          $('.product-form-actions .product-set-wishlist').addClass('invisible');
          $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
        }
      });
    });
  }

  $('.ico-favorite.unlogin').on('click', function (e) {
    e.preventDefault();
    var original = $(this).data('original');
    var pids = '';
    if ($('.cpb-products-variety_area').length > 0) {
      var _$productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
      pids = _$productForms.map(function (formEle) {
        return $(formEle).data('pid');
      }).join(',');
    } else {
      pids = $('#pid').val();
    }

    var originalUrl = original + pids;

    window.location = Urls.showLogin + '?original=' + originalUrl;
  });

  $('.size-chart-link a').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href')
    });
  });

  $('.accordion-toggle').on('click', function (e) {
    e.preventDefault();
    var $toggleFor = $(this).attr('href');
    var $toggleHeight = $('.accordion-toggle').outerHeight();
    var $stickyHeader = $('.sticky-header').outerHeight();

    var totalOffset = $toggleHeight + $stickyHeader;

    if ($(this).hasClass('is-open')) {
      $(this).removeClass('is-open');
      $($toggleFor).removeClass('is-open').slideUp();
      return false;
    } else {
      var accordionToggle = $('.accordion-toggle.is-open');
      var accordionContent = $('.pdp-content-section.is-open');

      // $(document).find(accordionToggle).removeClass('is-open');
      // $(document).find(accordionContent).removeClass('is-open').slideUp(100);

      $(this).toggleClass('is-open');
      $($toggleFor).toggleClass('is-open').slideDown(function () {
        $('html, body').animate({
          scrollTop: $(this).offset().top - totalOffset
        }, 400);
      });
    }

    if ($(this).attr('id') == 'rec-toggle') {
      $('.carousel-recommendations.slick-slider').slick('refresh');
    }
  });

  $('.js-modal-r_open[data-modal-target="product-service-modal"]').on('click', function () {
    if ($('#productservicemodal').length === 0) {
      return;
    }
    var $errorPlacement = $('#productservicemodal').find('.cpb-modalR_bottom>.c-text-error');
    $errorPlacement.addClass('mfp-hide');
    $errorPlacement.text('');
  });
}

var product = {
  initializeEvents: initializeEvents,
  init: function init() {
    initializeDom();
    initializeEvents();
  }
};

module.exports = product;

},{"../../ajax":1,"../../design":11,"../../dialog":12,"../../modal":24,"../../storeinventory/product":74,"../../util":77,"./addToCart":44,"./availability":45,"./howToSection":46,"./image":47,"./productKit":49,"./productSet":50,"./recommendations":51,"./socialShareIcons":53,"./variant":54}],49:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    variant = require('./variant'),
    util = require('../../util'),
    skin_trouble_check = require('./skin_trouble_check');

function productKitInit() {
  // 新テンプレートの場合、新テンプレート用初期化処理を実行
  if ($('#kit-step-main-content').length > 0) {
    return productKitStepInit();
  }
  var $kitMainContent = $('#kit-main-content');
  var $kitBottomContent = $('#kit-bottom-content');
  var $kitModal = $('#kitproductmodal');
  var kitProductId = $kitMainContent.find('input[name="data-kit-product-id"]').val();
  var isOutOfStockIems = $kitMainContent.find('input[name="is-out-of-stock-kit-istems"]').length == 0 ? false : $kitMainContent.find('input[name="is-out-of-stock-kit-istems"]').val();
  // click on swatch for product set
  $kitMainContent.on('click', '.kit-select-variation', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var productId = $(this).attr('data-product');
    var setId = $(this).attr('set-id');
    var setNum = $(this).attr('set-number');
    var productNum = $(this).attr('product-number');
    var params = {
      productId: productId,
      kitProductId: kitProductId,
      setId: setId,
      productSetNumber: setNum,
      productNumber: productNum,
      isOutOfStockIems: isOutOfStockIems
    };

    ajax.load({
      url: util.appendParamsToUrl(href, params),
      target: $('.product-kit'),
      callback: function callback() {
        $('#kit-main-content').find('input[name="kit-open-select-modal"]').click();
        variant();
      }
    });
  });

  $kitModal.on('click', '.cpb-modalR_bottom .cmd-button_box button', function (e) {
    e.preventDefault();
    var productId = $(this).attr('data-product');
    var setId = $(this).attr('set-id');
    var variationImageUrl = $(this).attr('variation-image-url');
    var setNum = $(this).attr('set-number');
    var productNum = $(this).attr('product-number');
    var _target1 = '.kit-product-set-' + setNum;
    var _target2 = '.c-kit-confirm-' + setNum;
    if (productId === '') {
      return;
    }

    var params = {
      productId: productId,
      kitProductId: kitProductId,
      setId: setId,
      productSetNumber: setNum,
      productNumber: productNum,
      variationImageUrl: variationImageUrl,
      unselectFlag: 'false'
    };
    ajax.load({
      url: Urls.selectProduct,
      data: params,
      target: $(_target1),
      callback: function callback() {
        $kitModal.find('.js-modal-r_close').click();
        $('.cpb-products_reccomend_slider').not('.slick-initialized').slick({
          dots: true,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          responsive: [{
            breakpoint: 993,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
        updateConfirmKitButton($kitMainContent, kitProductId, isOutOfStockIems);
      }
    });

    ajax.load({
      url: Urls.confirmKitProduct,
      data: params,
      target: $(_target2)
    });
  });

  $kitMainContent.on('click', '.kit-select-product-no-variation', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var productId = $(this).attr('data-product');
    var setId = $(this).attr('set-id');
    var setNum = $(this).attr('set-number');
    var productNum = $(this).attr('product-number');
    var _target1 = '.kit-product-set-' + setNum;
    var _target2 = '.c-kit-confirm-' + setNum;
    var params = {
      productId: productId,
      kitProductId: kitProductId,
      setId: setId,
      productSetNumber: setNum,
      productNumber: productNum,
      variationImageUrl: '',
      unselectFlag: 'false'
    };

    ajax.load({
      url: util.appendParamsToUrl(href, params),
      target: $(_target1),
      callback: function callback() {
        $('.cpb-products_reccomend_slider').not('.slick-initialized').slick({
          dots: true,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          responsive: [{
            breakpoint: 993,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
        updateConfirmKitButton($kitMainContent, kitProductId, isOutOfStockIems);
      }
    });

    ajax.load({
      url: Urls.confirmKitProduct,
      data: params,
      target: $(_target2)
    });
  });

  $kitMainContent.on('click', '.kit-select-product-selected', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var productId = $(this).attr('data-product');
    var setId = $(this).attr('set-id');
    var setNum = $(this).attr('set-number');
    var productNum = $(this).attr('product-number');
    var _target1 = '.kit-product-set-' + setNum;
    var _target2 = '.c-kit-confirm-' + setNum;
    var params = {
      productId: productId,
      kitProductId: kitProductId,
      setId: setId,
      productSetNumber: setNum,
      productNumber: productNum,
      variationImageUrl: '',
      unselectFlag: 'true'
    };

    ajax.load({
      url: util.appendParamsToUrl(href, params),
      target: $(_target1),
      callback: function callback() {
        $('.cpb-products_reccomend_slider').not('.slick-initialized').slick({
          dots: true,
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          responsive: [{
            breakpoint: 993,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }]
        });
        updateConfirmKitButton($kitMainContent, kitProductId, isOutOfStockIems);
      }
    });

    ajax.load({
      url: Urls.confirmKitProduct,
      data: params,
      target: $(_target2)
    });
  });

  $kitBottomContent.on('click', '.kit-confirm-products-button', skinCheckKit);

  function skinCheckKit(e) {
    skin_trouble_check.skinTroubleExecute(e, $(this), addToCartKit);
  }

  function addToCartKit(e, $this) {
    e.preventDefault();
    var selected_items = [];
    var length = $kitMainContent.find('.c-kit-product-reccomend').length;
    var mandatory_length = $kitMainContent.find('.c-kit-other_element').length;
    var mandatoryFlag = $kitMainContent.find('input[name="mandatory-flag"]').val();
    var gift_length = $kitMainContent.find('.c-kit-gift_element').length;
    var pset, pid, master_id, set_id;
    var kitProductId = $('#kit-main-content').find('input[name="data-kit-product-id"]').val();
    var checkedit = $('input[name=edit-cart-product]').val();
    if (checkedit == 'cart_edit_kit') {
      checkedit = true;
      var $productDetailForm = $('#add-to-cart').closest('form');
      $productDetailForm.append('<input type="hidden" name="cartAction" value="editkit">');
    } else {
      checkedit = false;
    }

    return $.ajax({
      url: Urls.checkExistAnyProduct,
      data: {
        pid: kitProductId,
        checkEdit: checkedit
      },
      loading: true
    }).then(function (response) {
      if (!response.error) {
        for (var i = 0; i < length; i++) {
          pset = '#c-kit-recomend_select' + i.toFixed();
          pid = $(pset).find('a').attr('pid');
          master_id = $(pset).find('a').attr('master-id');
          set_id = $(pset).find('a').attr('set-id');
          selected_items.push(set_id + ';' + master_id + ';' + pid);
        }
        for (var j = 0; j < mandatory_length; j++) {
          pset = '#c-kit-other-element' + j.toFixed();
          pid = $(pset).find('a').attr('pid');
          master_id = $(pset).find('a').attr('master-id');
          set_id = $(pset).find('a').attr('set-id');
          selected_items.push(set_id + ';' + master_id + ';' + pid);
        }
        for (var k = 0; k < gift_length; k++) {
          pset = '#c-kit-gift_element' + k.toFixed();
          pid = $(pset).find('a').attr('pid');
          master_id = $(pset).find('a').attr('master-id');
          set_id = 'bonus';
          selected_items.push(set_id + ';' + master_id + ';' + pid);
        }
        $('#items_selected').val(selected_items.join());

        var $form = $('#items_selected').closest('form');
        return $.ajax({
          type: 'POST',
          url: util.ajaxUrl(Urls.addProduct),
          data: $form.serialize(),
          loading: true
        }).then(function () {
          return function () {
            window.location.href = Urls.cartShow;
          };
        });
      } else {
        $('#kit-main-content').find('.cmd-form_err._simple').remove();
        $('#kit-main-content').find('div').first().before($("<div class='cmd-form_err _simple' style='text-align: center'></div>").text(response.errorMsg));
        ajax.load({
          url: Urls.confirmKitButton,
          data: {
            allSelectedFlag: false,
            mandatoryFlag: mandatoryFlag,
            kitProductId: kitProductId,
            isOutOfStockIems: isOutOfStockIems
          },
          target: $('.c-kit-confirmproducts-button-form')
        });
        return $.Deferred().reject().promise();
      }
    });
  }
}

function updateConfirmKitButton(kitMainContent, kitProductId, isOutOfStockIems) {
  var allSelectedFlag = function () {
    if (0 < kitMainContent.find('.no-product-selected').length) {
      return false;
    } else {
      return true;
    }
  }();
  var mandatoryFlag = kitMainContent.find('input[name="mandatory-flag"]').length == 0 ? true : kitMainContent.find('input[name="mandatory-flag"]').val();
  var data = {
    allSelectedFlag: allSelectedFlag,
    mandatoryFlag: mandatoryFlag,
    kitProductId: kitProductId,
    isOutOfStockIems: isOutOfStockIems
  };
  // ショッピングバックの編集から遷移した時のみ設定する
  if ($('.kit_product_cart_edit_kit').length > 0) data['source'] = $('.kit_product_cart_edit_kit').val();

  ajax.load({
    url: Urls.confirmKitButton,
    data: data,
    target: $('.c-kit-confirmproducts-button-form')
  });
}

/**
 * キット新テンプレート用初期化処理
 * 既存テンプレートとHTML構造が大分違うため処理完全に切り分ける
 * 新テンプレート内で使う関数は全てこの関数内で定義
 *
 * ※「_assets/js/cpb.trialset.js」でデザイン側の処理をしている
 */
function productKitStepInit() {
  var URI = require('urijs');

  var dataCategoryFirstId = '0';
  // 一部デザイン側の処理を変更するため使用
  var isEdit = false;

  /**
   * 選択内容の確認画面に表示される画像を更新する関数
   *
   * @param {object} target - 処理対象の「this」
   * @param {string} path -画像path
   */
  function updateConfirmImg(target, path) {
    var index = $(target).closest('.tks-category_box').closest('.slick-slide').data('slick-index');
    var imgList = $('.tks-confirm-img_list li');
    var imgElement = imgList.toArray().filter(function (element) {
      return $(element).data('img-index') == index;
    });

    // 「path」が空の場合、style「display:none」を付与する関数
    var updateStyle = function updateStyle(element) {
      if (path) {
        $(element).prop('style').display = '';
      } else {
        $(element).prop('style').display = 'none';
      }
    };

    // 選択したエリアの画像がすでにある場合上書き、無い場合HTMLを追加
    if (imgElement.length > 0) {
      $(imgElement).find('img').prop('src', path);
      updateStyle(imgElement);
    } else {
      var appendImgElement = $('<img>');
      var appendListElement = $('<li>');
      appendImgElement.prop('src', path);
      appendImgElement.prop('alt', '');
      appendListElement.attr('data-img-index', index);
      appendListElement.append($('<span>').append(appendImgElement));
      $('.tks-confirm-img_list').append(appendListElement);
      updateStyle(appendListElement);
    }
  }

  /**
   * 選択内容の確認画面の各項目を更新する関数
   *
   * @param {object} info - 更新する情報を格納している連想配列
   * {
   *   productSetId: productSetId,
   *   itemName: itemName,
   *   itemDispPrice: itemDispPrice,
   *   calcPrice: calcPrice,
   *   itemProductId: itemProductId,
   *   itemProductMasterId: itemProductMasterId
   *   chipUrl: chipUrl,
   *   chipText: chipText
   * }
   */
  function updateConfirmProductInfo(info) {
    // 選択内容の確認画面を取得
    var confirmItemArea = $('.tks-confirm_item');
    var updateTargetDdElement = confirmItemArea.find('dd').toArray().filter(function (element) {
      return $(element).data('product-set-id') === info.productSetId;
    });

    $(updateTargetDdElement).find('.item-name').text(info.itemName || '');

    $(updateTargetDdElement).find('.item-price').text(info.itemDispPrice || '');

    $(updateTargetDdElement).find('.calc-price').val(info.calcPrice || 0);

    $(updateTargetDdElement).find('.product-id').val(info.itemProductId || '');

    $(updateTargetDdElement).find('.product-master-id').val(info.itemProductMasterId || '');

    // バリエーション商品の場合、表示用エリアを追加、変更等を考慮し最初に削除
    $(updateTargetDdElement).find('.item-colors').remove();
    if (info.chipUrl && info.chipText) {
      var pColors = $('<p>');
      var spanChip = $('<span>');
      var spanTxt = $('<span>');
      var img = $('<img>');
      pColors.addClass('item-colors');
      spanChip.addClass('chip');
      spanTxt.addClass('txt');
      spanTxt.text(info.chipText);
      img.prop('src', info.chipUrl);
      img.prop('alt', '');
      spanChip.append(img);
      pColors.append(spanChip);
      pColors.append(spanTxt);
      $(updateTargetDdElement).find('.item-name').after(pColors);
    }

    // 合計金額を再計算
    var totalPrice = confirmItemArea.find('dd .calc-price').toArray().reduce(function (price, currentValue) {
      return price + Number($(currentValue).val());
    }, 0);
    confirmItemArea.find('.tks-confirm_total').text(Number(totalPrice).toLocaleString() + Resources.YEN_TAX);
  }

  /**
   * 「選択内容をご確認」から変更をクリックして商品を選択した際の処理
   */
  function moveConfirmByEdit(e) {
    cpbUi.trialKitSet.moveConfirm();
    isEdit = false;
    e.stopPropagation();
  }

  /**
   * 「選択する」ボタンクリック時の処理
   *  選択内容確認画面を更新する
   */
  function productSelect(e) {
    e.preventDefault();
    // 選択内容の確認画面の表示更新に使う値を取得
    var productSetId = $(this).closest('.tks-category_box').data('product-set-id');

    var prorductInfoElement = $(this).closest('.cmd-button_container');

    /* 画像の追加処理 */
    var imgPath = function () {
      var confirmImg = $(prorductInfoElement).find('.item-confirm-image').val();
      if (confirmImg) {
        return confirmImg;
      }
      return $(this).closest('.slick-slide').find('span.thumb img').prop('src');
    }.call(this);
    updateConfirmImg(this, imgPath);

    var itemName = $(prorductInfoElement).find('.item-name').val();
    var itemDispPrice = $(prorductInfoElement).find('.item-disp-price').val();
    var calcPrice = $(prorductInfoElement).find('.item-calc-price').val();
    var itemProductId = $(prorductInfoElement).find('.item-product-id').val();
    var chipUrl = $(prorductInfoElement).find('.item-chip-url').val();
    var chipText = $(prorductInfoElement).find('.item-chip-text').val();
    var itemProductMasterId = $(prorductInfoElement).find('.item-product-master-id').val();

    // 更新
    updateConfirmProductInfo({
      productSetId: productSetId,
      itemName: itemName,
      itemDispPrice: itemDispPrice,
      calcPrice: calcPrice,
      itemProductId: itemProductId,
      itemProductMasterId: itemProductMasterId,
      chipUrl: chipUrl,
      chipText: chipText
    });

    $('.tks-confirm_wrap .tks-confirm_item_list .tks-confirm_item_txt .sold-out').remove();
    // ショッピングバッグに入れるボタンを活性
    $('.tks-confirm_item .cmd-button_container button').prop('disabled', false);
    $('.tks-confirm_item .tks-error p').html('');

    // 確認内容画面から遷移した時はデザイン側のイベントを止めて確認内容画面へ遷移
    if (isEdit) moveConfirmByEdit(e);
  }

  /**
   * 「選択しない」ボタンクリック時の処理
   *  選択内容確認画面を更新する
   */
  function notProductSelect(e) {
    e.preventDefault();
    // 画像表示の更新
    updateConfirmImg(this, '');
    // 選択内容の確認画面更新
    var productSetId = $(this).closest('.tks-category_box').data('product-set-id');
    updateConfirmProductInfo({
      productSetId: productSetId,
      itemName: '',
      itemDispPrice: '',
      calcPrice: 0,
      itemProductId: '',
      itemProductMasterId: '',
      chipUrl: '',
      chipText: ''
    });

    $('.tks-confirm_wrap .tks-confirm_item_list .tks-confirm_item_txt .sold-out').remove();
    // ショッピングバッグに入れるボタンを活性
    $('.tks-confirm_item .cmd-button_container button').prop('disabled', false);
    $('.tks-confirm_item .tks-error p').html('');

    // 確認内容画面から遷移した時はデザイン側のイベントを止めて確認内容画面へ遷移
    if (isEdit) moveConfirmByEdit(e);
  }

  /**
   * 「色を選択する」ボタンクリック時の処理
   */
  function openModal(e) {
    e.preventDefault();
    var href = $(this).attr('href');
    var paramInfo = $(this).closest('.cmd-button_container').find('.param-info');
    var productId = paramInfo.attr('product-id');
    var kitId = paramInfo.attr('kit-id');
    var setId = paramInfo.attr('set-id');
    var productNum = paramInfo.attr('product-number');
    var setNum = paramInfo.attr('set-number');
    var params = {
      productId: productId,
      kitProductId: kitId,
      setId: setId,
      productSetNumber: setNum,
      productNumber: productNum
    };

    ajax.load({
      url: util.appendParamsToUrl(href, params),
      target: $('.product-kit'),
      callback: function callback() {
        $('#kit-step-main-content').find('input[name="kit-open-select-modal"]').click();
        variant();
      }
    });
  }

  /**
   * バリエーション商品を選択した時の処理
   */
  function selectVariation(e) {
    e.preventDefault();

    var modalInfo = $(this).closest('.cpb-modalR_scroll_cover').find('.cmd-form_container .cpb-naire-variation li.is-current a');

    // 画面を更新するための値を取得
    var productId = modalInfo.data('product');
    var colorChipUrl = modalInfo.find('img').prop('src');
    var dispValue = $(this).closest('.cpb-modalR_scroll_cover').find('.cmd-form_container .cpb-naire-data_box .item-color').text().trim();
    var prorductImgUrl = $(this).closest('.cpb-modalR_scroll_cover').find('.cmd-form_container .cpb-naire-photo img').prop('src');

    // 更新対象の商品エリアを取得
    var updateProductArea = function () {
      var productNumber = modalInfo.attr('product-number');
      var setNumber = modalInfo.attr('set-number');
      return $('.tks-item_box').toArray().filter(function (element) {
        var paramInfo = $(element).find('.param-info');
        if (paramInfo.length <= 0) return;
        return paramInfo.attr('set-number') == setNumber && paramInfo.attr('product-number') == productNumber;
      })[0];
    }();

    // 値を更新
    $(updateProductArea).find('.param-info').attr('product-id', productId);

    $(updateProductArea).find('._TRP a .item-colors img').prop('src', colorChipUrl);

    $(updateProductArea).find('._TRP a .item-colors span.txt').text(dispValue);

    $(updateProductArea).find('.item-product-id').val(productId);

    $(updateProductArea).find('.thumb img').prop('src', prorductImgUrl);

    $(updateProductArea).find('.item-chip-url').val(colorChipUrl);

    $(updateProductArea).find('.item-chip-text').val(dispValue);

    // ボタンの表示を切り替える
    $(updateProductArea).find('.cmd-button_box').toArray().forEach(function (element, index) {
      if (index == 0) {
        $(element).css('display', 'none');
        return;
      }
      $(element).css('display', 'flex');
    });
    $(updateProductArea).find('.in-stock').css('display', '');
    $(updateProductArea).find('.sold-out').css('display', 'none');

    $('.product-kit .js-modal-r_close').click();
  }

  function addKitStepCart(e) {
    // カート追加処理
    var addToCartKit = function addToCartKit(e, $this) {
      e.preventDefault();
      var kitProductId = $('#kit-step-main-content').find('#pid').val();

      var checkedit = function () {
        var inputElement = $('input[name=edit-cart-product]').val();
        if (inputElement == 'cart_edit_kit') {
          var productDetailForm = $('#add-to-cart').closest('form');
          productDetailForm.append('<input type="hidden" name="cartAction" value="editkit">');
          return true;
        } else {
          return false;
        }
      }();

      var selectProductInfo = $('.tks-confirm_item dd').toArray().reduce(function (map, currentValue) {
        var productId = $(currentValue).find('.product-id').val();
        // 選択しないの場合「productId」が取得できないためreturn
        if (!productId) return map;
        var productSetId = $(currentValue).data('productSetId');
        var productMasterId = $(currentValue).find('.product-master-id').val();
        map.productId.push(productId);
        map.productSetId.push(productSetId);
        map.productMasterId.push(productMasterId);
        return map;
      }, {
        productId: [],
        productSetId: [],
        productMasterId: []
      });

      return $.ajax({
        url: Urls.checkExistAnyProduct,
        data: {
          pid: kitProductId,
          checkEdit: checkedit,
          selectProductInfo: {
            productId: selectProductInfo.productId.join(','),
            productSetId: selectProductInfo.productSetId.join(','),
            productMasterId: selectProductInfo.productMasterId.join(',')
          }
        },
        loading: true
      }).then(function (response) {
        if (!response.error) {
          var selectedItems = $('.tks-confirm_item dd').toArray().reduce(function (array, currentValue) {
            var setId = $(currentValue).data('product-set-id');
            var masterId = $(currentValue).find('.product-master-id').val();
            var productId = $(currentValue).find('.product-id').val();
            // 選択しないの場合「productId」が取得できないためreturn
            if (!productId) return array;
            array.push(setId + ';' + masterId + ';' + productId);
            return array;
          }, []);
          $('#items_selected').val(selectedItems.join());

          var $form = $('#items_selected').closest('form');
          return $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.addProduct),
            data: $form.serialize(),
            loading: true
          }).then(function () {
            return function () {
              window.location.href = Urls.cartShow;
            };
          });
        } else {
          if (!response.updateDispProductList) {
            var url = new URI(location.href);
            url.addQuery('reload', true);
            return location.replace(url.toString());
          }
          var productIdList = response.updateDispProductList.map(function (obj) {
            return obj.productId;
          });
          // 品切れを表示
          $('.tks-confirm_item dd').toArray().forEach(function (element) {
            if (productIdList.indexOf($(element).find('input.product-id').val()) >= 0) {
              // 品切れの表示がすでにある場合削除
              $(element).find('.sold-out').remove();
              var pElement = '<p class="colRED sold-out">　' + Resources.PRODUCT_OUT_OF_STOCK + '</p>';
              if ($(element).find('.item-colors').length > 0) {
                $(element).find('.item-colors').after(pElement);
              } else {
                $(element).find('.item-name').after(pElement);
              }
            }
          });
          // 選択するボタンを品切れに切り替える
          $('.item-product-id').toArray().forEach(function (element) {
            if (productIdList.indexOf($(element).val()) >= 0) {
              $(element).siblings('p').find('button.in-stock').prop('style').display = 'none';
              $(element).siblings('p').find('button.sold-out').prop('style').display = '';
            } else {
              var inStockBottun = $(element).siblings('p').find('button.in-stock');
              var soldOutButton = $(element).siblings('p').find('button.sold-out');
              if (inStockBottun.length > 0 && soldOutButton.length > 0) {
                $(inStockBottun).prop('style').display = '';
                $(soldOutButton).prop('style').display = 'none';
              }
            }
          });
          // ショッピングバッグに入れるボタンを非活性
          $('.tks-confirm_item .cmd-button_container button').prop('disabled', true);
          $('.tks-confirm_item .tks-error p').html(response.errorMsg);
          return $.Deferred().reject().promise();
        }
      });
    };

    if ($('input[name=edit-cart-product]').val() == 'cart_edit_kit') {
      return $.when(addToCartKit(e, $(this))).then(function (arg) {
        if (typeof arg === 'function') {
          arg();
        }
      });
    }
    skin_trouble_check.skinTroubleExecute(e, $(this), addToCartKit);
  }

  /**
   * イベント追加
   */
  // 「選択する」ボタン
  $('#kit-step-main-content').off('click.selectProduct', '.slick-slide .tks-item_box .cmd-button_container button').on('click.selectProduct', '.slick-slide .tks-item_box .cmd-button_container button', productSelect);

  // 「色を選択する」ボタン
  $('#kit-step-main-content').off('click.openModal', '.slick-slide .tks-item_box .cmd-button_container a.button').on('click.openModal', '.slick-slide .tks-item_box .cmd-button_container a.button', openModal);

  // 「このカラーを選択する」ボタン
  $('.product-kit').off('click.selectVariation', '.cpb-modalR_scroll_cover .cmd-button_box button').on('click.selectVariation', '.cpb-modalR_scroll_cover .cmd-button_box button', selectVariation);
  // 「選択しない」ボタン
  $('#kit-step-main-content').off('click.notSelectProduct', '.tks-category_box .cmd-button_box .not-select-button').on('click.notSelectProduct', '.tks-category_box .cmd-button_box .not-select-button', notProductSelect);

  // 「ショッピングバッグに入れる」ボタン
  $('#kit-step-main-content').off('click.addKitStepCart', '.tks-confirm_item .cmd-button_container button').on('click.addKitStepCart', '.tks-confirm_item .cmd-button_container button', addKitStepCart);

  $('.js-tks-edit').on('click', function (e) {
    isEdit = true;
  });

  /**
   * 画面初期表示時に実行する関数
   * 内部でajax処理を行うため必ず返却値はPromiseにすること
   */
  function dispInit() {
    if ($('[name=edit-cart-product]').length === 0) {
      // 初回表示時は最初のカテゴリを表示状態にする
      return $.Deferred().resolve(function () {
        cpbUi.trialKitSet.moveSelect(dataCategoryFirstId);
      }).promise();
    }

    // カート編集から遷移した場合は、カートから商品情報を取得し画面を更新
    return $.ajax({
      url: Urls.getProductInfoUseKitStep,
      type: 'get',
      loading: true
    }).then(function (resp) {
      var click = function click(inputElement) {
        $(inputElement).siblings().find('button.in-stock').click();
      };

      resp.forEach(function (object) {
        if (!object.masterId) {
          // バリエーション商品以外の場合、選択するボタンをクリック
          var _inputElement = function () {
            return $('input.item-product-id').toArray().filter(function (element) {
              return $(element).val() === object.productId;
            })[0];
          }();
          click(_inputElement);
          return;
        }
        // バリエーション商品の場合、各カテゴリに表示されている情報を取得
        var inputElement = function () {
          var element = $('input.item-product-master-id').toArray().filter(function (item) {
            return $(item).val() === object.masterId;
          });
          if (element.length > 0) {
            // 足りない情報を設定
            $(element[0]).siblings('input.item-chip-text').val(object.chipText);
            $(element[0]).siblings('input.item-chip-url').val(object.chipUrl);
            $(element[0]).siblings('input.item-confirm-image').val(object.confirmImageUrl);
            $(element[0]).closest('.tks-item_box').find('.cmd-visual_card .thumb img').prop('src', object.productImage);
            return element[0];
          }
          // バリエーション商品でもバリエーション子商品がキットに含まれるパターン
          return $('input.item-product-id').toArray().filter(function (item) {
            return $(item).val() === object.productId;
          })[0];
        }();
        click(inputElement);
      });

      // 確認内容画面へ遷移
      return $.Deferred().resolve(function () {
        cpbUi.trialKitSet.moveConfirm();
      }).promise();
    });
  }

  $.when(dispInit()).then(function (resp) {
    if (typeof resp === 'function') {
      resp();
    }
    var url = new URI(location.href);
    // リロードの際は画面をスクロール
    if (url.hasQuery('reload')) {
      var position = $('#kit-step-main-content').offset().top;
      $('html, body').animate({ scrollTop: position }, 550, 'swing');
    }
  });
}

module.exports = function () {
  productKitInit();
};

},{"../../ajax":1,"../../tooltip":76,"../../util":77,"./skin_trouble_check":52,"./variant":54,"urijs":145}],50:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
  var $addToCart = $('#add-to-cart'),
      $addAllToCart = $('#add-all-to-cart'),
      $productSetList = $('#product-set-list');

  var updateAddToCartButtons = function updateAddToCartButtons() {
    if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
      $addAllToCart.attr('disabled', 'disabled');
      // product set does not have an add-to-cart button, but product bundle does
      $addToCart.attr('disabled', 'disabled');
    } else {
      $addAllToCart.removeAttr('disabled');
      $addToCart.removeAttr('disabled');
    }
  };

  if ($productSetList.length > 0) {
    updateAddToCartButtons();
  }
  // click on swatch for product set
  $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
    e.preventDefault();
    var url = Urls.getSetItem + this.search;
    var $container = $(this).closest('.product-set-item');
    var qty = $container.find('form input[name="Quantity"]').first().val();

    ajax.load({
      url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
      target: $container,
      callback: function callback() {
        updateAddToCartButtons();
        tooltip.init();
      }
    });
  });

  $productSetList.on('change', '.product-set-item .variation-select', function (e) {
    e.preventDefault();

    var $selectedVariantOption = $(this).find('option:selected');
    if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
      return;
    }

    var url = Urls.getSetItem + '?' + util.getQueryString($selectedVariantOption.val());
    var $container = $(this).closest('.product-set-item');
    var qty = $container.find('select[name="Quantity"] option:selected').val();

    ajax.load({
      url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
      target: $container,
      callback: function callback() {
        updateAddToCartButtons();
        tooltip.init();
      }
    });
  });
  if (screen.width > 640) {
    $(window).load(function () {
      $('#pdpMain').find('#BVRRSummaryContainer .bv-rating-stars-container').off().on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.tabs-title:nth-child(1)').removeClass('is-active');
        $('.tabs-title:nth-child(2)').addClass('is-active');
        $('#questions').removeClass('is-active');
        $('#reviews').addClass('is-active').stop(true, true);
        $('html, body').stop(true, true).animate({
          scrollTop: $('#bazaarvoice-tabs').offset().top - 150
        }, 1000);
      });
    });
  }
};

$(document).on('click', '.bv-popup-in .bv-read-review', function () {
  $('.tabs-title:nth-child(1)').removeClass('is-active');
  $('.tabs-title:nth-child(2)').addClass('is-active');
  $('#questions').removeClass('is-active');
  $('#reviews').addClass('is-active');
  e.preventDefault();
  e.stopPropagation();
  $('html, body').stop(true, true).animate({
    scrollTop: $('#bazaarvoice-tabs').offset().top - 150
  }, 1000);
});

},{"../../ajax":1,"../../tooltip":76,"../../util":77}],51:[function(require,module,exports){
'use strict';

/**
 * @description Creates product recommendation carousel using Slick carousel
 **/

module.exports = function () {
  var $carousel = $('.carousel-recommendations').not('.slick-initialized');
  if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
    return;
  }
  $carousel.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    slide: 'li',
    dots: true,
    responsive: [{
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    }, {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    }]
  });
};

},{}],52:[function(require,module,exports){
'use strict';

var util = require('../../util');

var cpbUi = window.cpbUi || {};
var SkinCheck = window.SkinCheck || false;

(function (window, $, cpbUi, browserWindow, Urls, SkinCheck, util) {
  if (!SkinCheck) {
    return;
  }

  var isTroubleCheckFinished;
  var isTotalCounselingFinished;
  var isTroubleCheckType;

  function skinTroubleExecute(buttonEvent, buttonElement, buttonCallback) {
    // 購入前チェック完了フラグ取得処理記述箇所
    isTroubleCheckFinished = buttonElement.data('skincheck') === false ? 'OK' : SkinCheck.isTroubleCheckFinished;

    // 購入前チェック完了タイプ
    isTroubleCheckType = SkinCheck.isTroubleCheckType;

    // カウンセリング完了フラグ取得処理記述箇所
    isTotalCounselingFinished = buttonElement.data('skincheck') === false ? true : SkinCheck.isTotalCounselingFinished;

    skinTroubleCheckModalViewModel.$children[0].buttonEvent = buttonEvent;
    skinTroubleCheckModalViewModel.$children[0].buttonElement = buttonElement;
    skinTroubleCheckModalViewModel.$children[0].buttonCallback = buttonCallback;

    if (isTroubleCheckFinished == 'OK') {
      // トラブルチェック完了時処理
      if (!isTotalCounselingFinished) {
        // カウンセリング未完了時処理
        switch (isTroubleCheckType) {
          default:
            skinTroubleCheckModalViewModel.$children[0].page = 6;
            break;
          case 'b':
            skinTroubleCheckModalViewModel.$children[0].q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL2;
            skinTroubleCheckModalViewModel.$children[0].page = 4;
            break;
          case 'c':
            skinTroubleCheckModalViewModel.$children[0].q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL3;
            skinTroubleCheckModalViewModel.$children[0].page = 4;
            break;
          case 'd':
            skinTroubleCheckModalViewModel.$children[0].q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL4;
            skinTroubleCheckModalViewModel.$children[0].page = 4;
            break;
          case 'e':
            skinTroubleCheckModalViewModel.$children[0].q3Text = null;
            skinTroubleCheckModalViewModel.$children[0].page = 4;
            break;
        }
        buttonEvent.preventDefault();
        cpbUi.util.centerModalOpen.call(this, 'skin_trouble_check_modal', function (target) {});
      } else {
        // カウンセリング完了時処理
        $.when(_addToCart(buttonEvent, buttonElement, buttonCallback)).then(function (arg) {
          if (typeof arg === 'function') {
            arg();
          }
        });
      }
    } else if (isTroubleCheckFinished == 'NG') {
      // トラブルチェック結果NG時処理
      skinTroubleCheckModalViewModel.$children[0].page = 3;
      buttonEvent.preventDefault();
      cpbUi.util.centerModalOpen.call(this, 'skin_trouble_check_modal', function (target) {});
    } else {
      // トラブルチェック未完了時処理
      skinTroubleCheckModalViewModel.$children[0].page = 1;
      buttonEvent.preventDefault();
      cpbUi.util.centerModalOpen.call(this, 'skin_trouble_check_modal', function (target) {});
    }
    return false;
  }
  exports.skinTroubleExecute = skinTroubleExecute;

  function _addToCart(e, element, callback) {
    return $.when(callback(e, element));
  }

  Vue.component('skin-trouble-check-modal', {
    template: '<div class="cpb-modalC_container js-modal-c_content js-skin_trouble_check_modal_content" data-modal-type="skin_trouble_check_modal">\
      <div class="cpb-modalC_wrap">\
        <div class="cpb-modalC_inner cpb-modalC_inner--trouble">\
          <div class="cpb-modal_scroll js-modal_scroll">\
            <button class="cpb-modalC_close js-modal-c_close" @click="onCloseModal"><span class="invisible">CLOSE</span></button>\
\
            <!--質問1-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 1">\
                <div class="cmd-title-section _h2 modal-trouble-title">\
                  <h2 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_TITLE + '</h2>\
                </div>\
                <div class="modal-trouble-lead">\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_SUBTITLE + '\
                </div>\
                <div class="modal-trouble-content">\
                  <div class="cmd-title-section _h3">\
                    <h3 class="title">' + Resources.SKIN_CHECK_QUESTION1 + '</h3>\
                  </div>\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_QUESTION1 + '\
                  <div class="modal-trouble-content_form">\
                    <div class="modal-trouble-content_element">\
                      <label><input type="radio" name="a1" value="yes" v-model="answer.q1" @click="onClickQ1RadioButton($event.target.value)"><span>' + Resources.SKIN_CHECK_YES + '</span></label>\
                    </div>\
                    <div class="modal-trouble-content_element">\
                      <label><input type="radio" name="a1" value="no" v-model="answer.q1" @click="onClickQ1RadioButton($event.target.value)"><span>' + Resources.SKIN_CHECK_NO + '</span></label>\
                    </div>\
                  </div>\
                </div>\
                <transition name="fade">\
                  <div class="modal-trouble-content" v-if="answer.q1 === \'yes\'">\
                    <div class="cmd-title-section _h3">\
                      <h3 class="title">' + Resources.SKIN_CHECK_QUESTION1_1 + '</h3>\
                    </div>\
                    ' + SkinCheck.Asset.SKIN_CHECK_ASSET_QUESTION1_1 + '\
                    <div class="modal-trouble-content_form">\
                      <div class="modal-trouble-content_element">\
                        <label><input type="radio" name="a1-1" value="yes" v-model="answer.q1_1"><span>' + Resources.SKIN_CHECK_YES + '</span></label>\
                      </div>\
                      <div class="modal-trouble-content_element">\
                        <label><input type="radio" name="a1-1" value="no" v-model="answer.q1_1"><span>' + Resources.SKIN_CHECK_NO + '</span></label>\
                      </div>\
                    </div>\
                  </div>\
                </transition>\
                <div class="modal-trouble-content_button">\
                  <p class="cmd-button_box _sizeM _WHT"><button class="button js-modal-c_close" @click="onCloseModal"><span class="txt">' + Resources.SKIN_CHECK_CLOSE + '</span></button></p>\
                  <p class="cmd-button_box _sizeM"><button class="button" @click="onClickPage1NextButton" v-bind:disabled="!isPage1Completed"><span class="txt">' + Resources.SKIN_CHECK_NEXT + '</span></button></p>\
                </div>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
            <!--質問2-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 2">\
                <div class="cmd-title-section _h2 modal-trouble-title">\
                  <h2 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_TITLE + '</h2>\
                </div>\
                <div class="modal-trouble-content">\
                  <div class="cmd-title-section _h3">\
                    <h3 class="title">' + Resources.SKIN_CHECK_QUESTION2 + '</h3>\
                  </div>\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_QUESTION2 + '\
                  <div class="modal-trouble-content_form">\
                    <div class="modal-trouble-content_element">\
                      <label><input type="radio" name="a2" value="yes" v-model="answer.q2"><span>' + Resources.SKIN_CHECK_YES + '</span></label>\
                    </div>\
                    <div class="modal-trouble-content_element">\
                      <label><input type="radio" name="a2" value="no" v-model="answer.q2"><span>' + Resources.SKIN_CHECK_NO + '</span></label>\
                    </div>\
                  </div>\
                </div>\
                <div class="modal-trouble-content_button">\
                  <p class="cmd-button_box _sizeM _WHT"><button class="button js-modal-c_close" @click="onCloseModal"><span class="txt">' + Resources.SKIN_CHECK_CLOSE + '</span></button></p>\
                  <p class="cmd-button_box _sizeM"><button class="button" @click="onClickPage2NextButton" v-bind:disabled="!isPage2Completed"><span class="txt">' + Resources.SKIN_CHECK_NEXT + '</span></button></p>\
                </div>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
            <!--購入不可-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 3">\
                <div class="cmd-title-section _h2 modal-trouble-title">\
                  <h2 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_TITLE + '</h2>\
                </div>\
                <div class="cmd-title-section _h3 modal-trouble-title-s">\
                  <h3 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_SUBTITLE1 + '</h3>\
                </div>\
                <div class="modal-trouble-caption">\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL1 + '\
                  <div class="modal-trouble-content_button">\
                    <p class="cmd-button_box _sizeM _WHT"><button class="button" @click="onClickPage3AgainButton"><span class="txt">' + Resources.SKIN_CHECK_SKINCHECKAGAIN + '</span></button></p>\
                  </div>\
                </div>\
                <p class="cmd-button_box _sizeM modal-trouble-close"><button class="button js-modal-c_close" @click="onCloseModal"><span class="txt">' + Resources.SKIN_CHECK_CLOSE + '</span></button></p>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
            <!--質問3-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 4">\
                <div class="cmd-title-section _h2 modal-trouble-title">\
                  <h2 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_TITLE + '</h2>\
                </div>\
                <template v-if="q3Text">\
                  <div class="modal-trouble-caption_head">\
                    <h3 class="title">' + SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_SUBTITLE2 + '</h3>\
                  </div>\
                  <div class="modal-trouble-caption">\
                    <div class="modal-trouble-caption_text" v-html="q3Text"></div>\
                  </div>\
                </template>\
                <div class="modal-trouble-content">\
                  <div class="cmd-title-section _h3">\
                    <h3 class="title">' + Resources.SKIN_CHECK_QUESTION3 + '</h3>\
                  </div>\
                  <p>' + SkinCheck.Asset.SKIN_CHECK_ASSET_QUESTION3 + '</p>\
                  <div class="modal-trouble-content_form">\
                    <div class="modal-trouble-content_element modal-trouble-content_element--block">\
                      <label><input type="radio" name="a3" value="yes" v-model="answer.q3"><span>' + Resources.SKIN_CHECK_TC_YES + '</span></label>\
                    </div>\
                    <div class="modal-trouble-content_element modal-trouble-content_element--block">\
                      <label><input type="radio" name="a3" value="no" v-model="answer.q3"><span>' + Resources.SKIN_CHECK_TC_NO + '</span></label>\
                    </div>\
                  </div>\
                </div>\
                <div class="modal-trouble-content_button">\
                  <p class="cmd-button_box _sizeM _WHT"><button class="button js-modal-c_close" @click="onCloseModal"><span class="txt">' + Resources.SKIN_CHECK_CLOSE + '</span></button></p>\
                  <p class="cmd-button_box _sizeM"><button class="button" @click="onClickPage4NextButton" v-bind:disabled="!isPage4Completed"><span class="txt">' + Resources.SKIN_CHECK_NEXT + '</span></button></p>\
                </div>\
                <div class="modal-trouble-app">\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_TOTAL_COUNSELING_APP + '\
                </div>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
            <!--終了-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 5">\
                <div class="cmd-title-section _h3 modal-trouble-title-s modal-trouble-title-s--margin">\
                  <h3 class="title tcenter">' + SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL_FINISH + '</h3>\
                </div>\
                <p class="cmd-button_box _sizeM modal-trouble-close"><button class="button js-modal-c_close" @click="onClickPage5CloseButton"><span class="txt">' + Resources.SKIN_CHECK_CLOSE + '</span></button></p>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
            <!--購入前診断完了済-->\
            <transition name="fade">\
              <div class="cpb-modalC_contents" v-if="page === 6">\
                <div class="cmd-title-section _h2 modal-trouble-title">\
                  <h2 class="title"></h2>\
                </div>\
                <div class="modal-trouble-content">\
                  <div class="cmd-title-section _h3">\
                    <h3 class="title"></h3>\
                  </div>\
                  <p class="trouble_completed">' + SkinCheck.Asset.SKIN_CHECK_ASSET_QUESTION3 + '</p>\
                  <div class="modal-trouble-content_form">\
                    <div class="modal-trouble-content_element modal-trouble-content_element--block">\
                      <label><input type="radio" name="a4" value="yes" v-model="answer.q3"><span>' + Resources.SKIN_CHECK_TC_YES + '</span></label>\
                    </div>\
                    <div class="modal-trouble-content_element modal-trouble-content_element--block">\
                      <label><input type="radio" name="a4" value="no" v-model="answer.q3"><span>' + Resources.SKIN_CHECK_TC_NO + '<br><small>' + Resources.SKIN_CHECK_TC_NO_CONTINUE + '</small></span></label>\
                    </div>\
                  </div>\
                </div>\
                <div class="modal-trouble-content_button-close">\
                  <p class="cmd-button_box _sizeM"><button class="button" @click="onClickPage6NextButton" v-bind:disabled="!isPage4Completed"><span class="txt">' + Resources.SKIN_CHECK_NEXT + '</span></button></p>\
                </div>\
                <div class="modal-trouble-app">\
                  ' + SkinCheck.Asset.SKIN_CHECK_ASSET_TOTAL_COUNSELING_APP + '\
                </div>\
              </div><!-- / cpb-modalC_contents -->\
            </transition>\
\
          </div><!-- / cpb-modalC_scroll-->\
        </div><!-- / cpb-modalC_inner-->\
      </div><!-- / cpb-modalC_wrap -->\
      <div class="cpb-modal_overlay js-modal-c_overlay" @click="onCloseModal"></div>\
    </div><!-- / cpb-modalC_container -->',
    data: function data() {
      return {
        isTroubleCheckFinished: isTroubleCheckFinished,
        page: 1,
        answer: {
          q1: null,
          q1_1: null,
          q2: null,
          q3: null
        },
        q3Text: null
      };
    },
    created: function created() {
      if (isTroubleCheckFinished == 'OK') {
        this.page = 6;
      } else if (isTroubleCheckFinished == 'NG') {
        this.page = 3;
      } else {
        this.page = 1;
      }
    },
    computed: {
      isPage1Completed: function isPage1Completed() {
        return this.answer.q1 === 'no' || this.answer.q1 === 'yes' && this.answer.q1_1;
      },
      isPage2Completed: function isPage2Completed() {
        return !!this.answer.q2;
      },
      isPage4Completed: function isPage4Completed() {
        return !!this.answer.q3;
      }
    },
    methods: {
      onClickQ1RadioButton: function onClickQ1RadioButton(v) {
        this.answer.q1 = v;
        this.$nextTick(function () {
          cpbUi.niceScroll.resize(skinTroubleCheckModalViewModel.$children[0].$el);
        });
      },
      onCloseModal: function onCloseModal() {
        setTimeout(this.resetAnswers, 300);
      },
      resetAnswers: function resetAnswers() {
        this.answer = {
          q1: null,
          q1_1: null,
          q2: null,
          q3: null
        };
      },
      onClickPage1NextButton: function onClickPage1NextButton() {
        this.page = 2;
      },
      onClickPage2NextButton: function onClickPage2NextButton() {
        isTroubleCheckFinished = 'OK';
        SkinCheck.isTroubleCheckFinished = isTroubleCheckFinished;
        isTroubleCheckType = this.checkResult();
        SkinCheck.isTroubleCheckType = isTroubleCheckType;
        switch (isTroubleCheckType) {
          case 'a':
            isTroubleCheckFinished = 'NG';
            SkinCheck.isTroubleCheckFinished = isTroubleCheckFinished;
          default:
            this.page = 3;
            break;
          case 'b':
            this.q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL2;
            this.page = 4;
            break;
          case 'c':
            this.q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL3;
            this.page = 4;
            break;
          case 'd':
            this.q3Text = SkinCheck.Asset.SKIN_CHECK_ASSET_RESULT_DETAIL4;
            this.page = 4;
            break;
          case 'e':
            this.q3Text = null;
            this.page = 4;
            break;
        }
        $.ajax({
          url: util.ajaxUrl(util.appendParamsToUrl(Urls.setSkinCheckSession, {
            value: isTroubleCheckFinished,
            type: isTroubleCheckType
          }))
        });
        this.saveTroubleCheckFlg();
      },
      checkResult: function checkResult() {
        if (this.answer.q1 === 'yes') {
          if (this.answer.q1_1 === 'yes') {
            if (this.answer.q2 === 'yes') {
              // q1:yes q1_1:yes q2:yes
              return 'b';
            } else {
              // q1:yes q1_1:yes q2:no
              return 'c';
            }
          } else {
            if (this.answer.q2 === 'yes') {
              // q1:yes q1_1:no q2:yes
              return 'a';
            } else {
              // q1:yes q1_1:no q2:no
              return 'a';
            }
          }
        } else {
          if (this.answer.q2 === 'yes') {
            // q1:no q2:yes
            return 'd';
          } else {
            // q1:no q2:no
            return 'e';
          }
        }
      },
      saveTroubleCheckFlg: function saveTroubleCheckFlg() {
        // モーダル開閉時のフラグ切り替え処理
      },
      onClickPage3AgainButton: function onClickPage3AgainButton() {
        this.clearTroubleCheckFlg();
        this.resetAnswers();
        this.page = 1;
      },
      clearTroubleCheckFlg: function clearTroubleCheckFlg() {
        // モーダル開閉時のフラグ切り替え処理
        isTroubleCheckFinished = null;
        SkinCheck.isTroubleCheckFinished = null;
        $.ajax({
          url: Urls.clearSkinCheckSession
        });
      },
      onClickPage4NextButton: function onClickPage4NextButton(e) {
        if (this.answer.q3 === 'yes') {
          $.ajax({
            url: util.ajaxUrl(util.appendParamsToUrl(Urls.setSkinCheckSession, {
              value: 'OK',
              type: ''
            }))
          });
          e.preventDefault();
          var closeModal = function (arg) {
            // 肌トラのモーダルを閉じた後に実行する関数を格納
            var modalCallBackFunc = function () {
              if (typeof arg === 'function') {
                return arg;
              }
              return function () {};
            }.bind(this)();
            setTimeout(function () {
              cpbUi.util.centerModalClose.call(e.target, 'skin_trouble_check_modal', modalCallBackFunc, 10);
            });
            this.onCloseModal();
          }.bind(this);
          $.when(this.addToCart()).then(function (_) {
            return this.redirectToTotalCounsellingPage();
          }.bind(this)).fail(closeModal);
        } else {
          $.ajax({
            url: util.ajaxUrl(util.appendParamsToUrl(Urls.setSkinCheckSession, {
              value: 'OK',
              type: ''
            }))
          });
          // 終了画面を開く
          this.page = 5;
        }
      },
      onClickPage5CloseButton: function onClickPage5CloseButton(e) {
        var closeModal = function (arg) {
          // 肌トラのモーダルを閉じた後に実行する関数を格納
          var modalCallBackFunc = function () {
            if (typeof arg === 'function') {
              return arg;
            }
            return function () {};
          }.bind(this)();
          setTimeout(function () {
            cpbUi.util.centerModalClose.call(e.target, 'skin_trouble_check_modal', modalCallBackFunc, 10);
          });
          this.onCloseModal();
        }.bind(this);
        $.when(this.addToCart()).then(closeModal).fail(closeModal);
      },
      onClickPage6NextButton: function onClickPage6NextButton(e) {
        e.preventDefault();
        var closeModal = function (arg) {
          // 肌トラのモーダルを閉じた後に実行する関数を格納
          var modalCallBackFunc = function () {
            if (typeof arg === 'function') {
              return arg;
            }
            return function () {};
          }.bind(this)();
          setTimeout(function () {
            cpbUi.util.centerModalClose.call(e.target, 'skin_trouble_check_modal', modalCallBackFunc, 10);
          });
          this.onCloseModal();
        }.bind(this);
        $.when(this.addToCart()).then(function (arg) {
          if (this.answer.q3 === 'yes') {
            return this.redirectToTotalCounsellingPage();
          }
          // カート追加時に画面遷移する物はモーダルを閉じなくても良いが
          // ajaxで処理をしている場合、ミニカートを表示する必要があるためモーダルを必ず閉じる
          closeModal(arg);
        }.bind(this)).fail(closeModal);
      },
      openTotalCounsellingTab: function openTotalCounsellingTab() {
        // カウンセリングを新規タブで開く処理を記述
        browserWindow.open(Urls.totalCounselingInput + ($('main#contents').data('pid') ? '?callerpid=' + $('main#contents').data('pid') : '?callerlocation=' + browserWindow.location.href), '_blank');
      },
      redirectToTotalCounsellingPage: function redirectToTotalCounsellingPage() {
        // redirect to the consultation process
        $(document).ajaxComplete(function () {
          browserWindow.window.location.href = Urls.totalCounselingInput + ($('main#contents').data('pid') ? '?callerpid=' + $('main#contents').data('pid') : '?callerlocation=' + browserWindow.location.href);
        });
      },
      addToCart: function addToCart() {
        // カートに追加する処理を記述
        return $.when(_addToCart(this.buttonEvent, this.buttonElement, this.buttonCallback));
      }
    }
  });

  var skinTroubleCheckModalViewModel = new Vue({
    el: '#skin-trouble-check-modal'
  });
})(undefined, jQuery, cpbUi, window, Urls, SkinCheck, util);

},{"../../util":77}],53:[function(require,module,exports){
'use strict';

module.exports = function socialShareIcons() {
  $('.social-share-trigger').on('click', function () {
    $(this).parent().toggleClass('animate');

    if (!Foundation.MediaQuery.atLeast('medium')) {
      $('#wrapper').toggleClass('overlay');
    }
  });

  $('.social-modal-close').on('click', function () {
    $(this).parent().removeClass('animate');
    $('#wrapper').removeClass('overlay');
  });
};

},{}],54:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ajax = require('../../ajax'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util'),
    design = require('../../design'),
    addToCart = require('./addToCart');

function colorSelectInit() {
  var index = 0;
  /**
   * NORMAL PRODUCT
   */

  $('.cpb-products_details_area .cpb-products-color_list a').off('click').on('click', function (e) {
    e.preventDefault();

    // 追従フッダー用
    var suppressScrollOnce = function suppressScrollOnce(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      window.removeEventListener('scroll', suppressScrollOnce, true);
      return;
    };
    window.addEventListener('scroll', suppressScrollOnce, true);

    $('.cpb-products-cart_fixed .cpb-products-color_list li').removeClass('selected');
    $('.cpb-products-cart_fixed .cpb-products-color_list .c-list-color-panel').removeClass('is-current');
    var index = $('.cpb-products_details_area .cpb-products-color_list a').index(this);
    $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
      var $btn = $(this).find('li').eq(index);
      $btn.addClass('selected');
      $btn.find('.c-list-color-panel').addClass('is-current');
    });

    var href = $(this).attr('href');
    updateContent($(this), href, '.js-product-top-content');
    updateProductSummaryArea($(this).data('params'), $('.js-product-top-content+.cpb-products-summary_area'));
    return;
  });

  $('.cpb-products_details_area .c-tileradio-list li.c-tileradio-list-item').off('click').on('click', function (e) {
    e.preventDefault();
    var href = $(this).data('href');
    updateContent($(this), href, '.js-product-top-content');
    updateProductSummaryArea($(this).data('params'), $('.js-product-top-content+.cpb-products-summary_area'));
  });

  $('.cmd-select select.js-select-change_tab').off('change.ingredientContent').on('change.ingredientContent', function (e) {
    e.preventDefault();
    updateProductSummaryArea($(this).children('option:selected').data('params'), $('#ingredient-tab-content'), true);
  });

  $('.cmd-select select.js-select-change-variation').off('change.pdpVariation').on('change.pdpVariation', function (e) {
    e.preventDefault();
    var href = $(this).val();
    updateContent($(this), href, '.js-product-top-content');
    updateProductSummaryArea($(this).children('option:selected').data('params'), $('.js-product-top-content+.cpb-products-summary_area'));
  });

  $('.cpb-modal_quickview-inner .cpb-products-color_list a').off('click').on('click', function (e) {
    e.preventDefault();

    $('.cpb-products-cart_fixed .cpb-products-color_list li').removeClass('selected');
    $('.cpb-products-cart_fixed .cpb-products-color_list .c-list-color-panel').removeClass('is-current');
    var index = $('.cpb-modal_quickview-inner .cpb-products-color_list a').index(this);
    $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
      var $btn = $(this).find('li').eq(index);
      $btn.addClass('selected');
      $btn.find('.c-list-color-panel').addClass('is-current');
    });

    var href = $(this).attr('href');
    updateQuickviewContent($(this), href);
    return;
  });

  $('.cpb-modal_quickview-inner .c-tileradio-list .cmd-chk_parts').off('click').on('click', function (e) {
    var href = $(this).closest('li').attr('data-href');
    updateQuickviewContent($(this), href);
    return;
  });

  $('.cpb-products-cart_fixed .cpb-products-color_list a').off('click').on('click', function (e) {
    e.preventDefault();

    $(this).closest('.cpb-products-color_list').find('li').removeClass('selected');
    $(this).closest('.cpb-products-color_list').find('.c-list-color-panel').removeClass('is-current');
    var index = $('.cpb-products-cart_fixed .cpb-products-color_list a').index(this);
    $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
      var $btn = $(this).find('li').eq(index);
      $btn.addClass('selected');
      $btn.find('.c-list-color-panel').addClass('is-current');
    });

    if ($('.cpb-products_details_area').length > 0) {
      $('.cpb-products_details_area .cpb-products-color_list a').eq(index).trigger('click');
    }
    if ($('.cpb-modal_quickview-inner').length > 0) {
      $('.cpb-modal_quickview-inner .cpb-products-color_list a').eq(index).trigger('click');
    }
  });

  $('#productservicemodal .product-service-step1 .cpb-naire-color_list a').off('click').on('click', function (e) {
    e.preventDefault();
    var index = $(this).closest('.cpb-naire-color_list').find('a').index(this);
    var href = $(this).attr('href');
    updateContent($(this), href);
    return false;
  });

  $('.cpb-products_details_area .cpb-products-size_list li').off('click').on('click', function (e) {
    e.preventDefault();

    var href = $(this).data('href');
    updateContent($(this), href, '.js-product-top-content');
    updateProductSummaryArea($(this).data('params'), $('.js-product-top-content+.cpb-products-summary_area'));
    return;
  });

  // Change color / Bottom bar - color swatch
  $('.c-block-shoppingDock .c-list-color a').off('click').on('click', function (e) {
    e.preventDefault();
    var index = $(this).closest('.c-list-color').find('a').index(this);
    $($('#shopingmodalAnker.c-block-shopingmodal .c-list-color a')[index]).trigger('colorSelect');
  });

  /**
   * PRODUCT SET
   */
  $('#product-set.c-block-shopingmodal .c-list-color a').off('colorSelect').on('colorSelect', function (e) {
    e.preventDefault();
    var index = $(this).closest('.c-list-color').find('a').index(this);

    var href = $(this).attr('href');

    updateSetContent($(this), href);

    return false;
  });

  //PC時 クリック処理
  $('#product-set.c-block-shopingmodal .c-list-color a').off('click').on('click', function (e) {
    e.preventDefault();
    if (window.innerWidth > 992) {
      var index = $(this).closest('.c-list-color').find('a').index(this);
      $(this).trigger('colorSelect');
      return;
    }

    var href = $(this).attr('href');

    updateSetContent($(this), href);
  });

  //セレクトボックス内選択時
  $('#product-set .c-block-shopingmodal-side-colorSelect .c-select-list-item a').off('click').on('click', function () {
    var index = $(this).closest('.c-select-list').find('a').index(this);
    $(this).closest('.c-block-shopingmodal-set-item').find('.c-list-color a').eq(index).trigger('colorSelect');
  });

  $('#product-set .c-block-shopingmodal-side-size li.c-tileradio-list-item').off('click').on('click', function (e) {
    e.preventDefault();

    var href = $(this).data('href');

    updateSetContent($(this), href);
  });

  $('.cpb-products-variety_box .cpb-products-color_list a').off('click').on('click', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    updateSetContent($(this), href);
    return;
  });

  $('.cpb-products-variety_box li.c-tileradio-list-item').off('click').on('click', function (e) {
    e.preventDefault();
    var href = $(this).data('href');
    updateSetContent($(this), href);
  });

  /**
   * PRODUCT KIT
   */
  $('#kitproductmodal .cpb-naire-variation .cpb-naire-color_list a').off('click.kit_product_modal').on('click.kit_product_modal', function (e) {
    e.preventDefault();
    var href = $(this).attr('href');
    updateKitModalContent($(this), href);
    return false;
  });

  var url = location.href;
  if (url.indexOf('?') != -1) {
    var params = url.split('?');
    var paramms = params[1].split('&');
    var paramArray = [];
    var neet = void 0;
    for (var i = 0; i < paramms.length; i++) {
      neet = paramms[i].split('=');
      paramArray.push(neet[0]);
      paramArray[neet[0]] = neet[1];
    }
    index = paramArray['color'];
    $('#shopingmodalAnker.c-block-shopingmodal .c-list-color a').eq(index).trigger('colorSelect');
  }
}

function updateContent($ele, href, target) {
  var $pdpForm = $('.pdpForm');
  var isPopup = $ele.parents('.pt_product-details').length == 0;
  var isColorSelect = $ele.parents('.c-block-shopingmodal-side-color').length == 1;
  var isProductServiceModal = $ele.parents('.product-service-step1').length == 1;
  var _target = '.c-block-shopingmodal';
  var edgingtext = '';
  var edgingFont = '';
  if (target != null) {
    _target = target;
  }
  if (isProductServiceModal == true) {
    isPopup = false;
    _target = '.product-service';
    edgingtext = $('[name=dwfrm_productengraving_edgingtext]').val();
    edgingFont = $('input[name=naire-font]:checked').data('id');
  }
  var qty = $pdpForm.find('.c-quantitySelection-num .c-select-list a.is-selected .c-select-list-item-text').first().data('num');

  var params = {
    Quantity: isNaN(qty) ? '1' : qty,
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
    isProductServiceModal: isProductServiceModal
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    target: $(_target),
    callback: function callback() {
      updateVariationContent($ele, false);
      changeBottomButton();

      if (typeof VIRTUAL_MAKE !== 'undefined') {
        VIRTUAL_MAKE.MODULE.setVM();
      }

      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }

      //$(document).trigger("gtvariationchange");
      cpbUi.pdp.ready();
      addToCart();
      colorSelectInit();
      design.selectQuantityInit();
      design.toggleSelectInit(true);
      design.modalInit();
      //design.pdpInit();
      if (isColorSelect) {
        $('.c-block-shoppingDock').show();
      }

      // update zenSeibunHyjny on tab content
      $('#ingredient-tab-content').html($('#zenSeibunHyjny').val());
      $('.cmd-select select > option').each(function () {
        if (this.value === href) {
          this.setAttribute('selected', 'selected');
        } else {
          this.removeAttribute('selected');
        }
      });
      if (isPopup) {
        $.magnificPopup.open({
          items: {
            src: '#shopingmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });
      }

      if ('' !== edgingtext) {
        $('#productservicemodal #naire-data').val(edgingtext);
        $('#productservicemodal .js-naire-preview').empty().text(edgingtext);
      }
      if ('' !== edgingFont) {
        // 選択状態にするラジオボタン要素を取得
        var checkedEdgingElement = $('input[name=naire-font]').toArray().filter(function (element) {
          return $(element).data('id') === edgingFont;
        });
        if (checkedEdgingElement.length === 0) {
          // 取得できなかった場合、一番最初の要素を選択状態する
          $('input[name=naire-font]').eq(0).prop('checked', true);
        } else {
          $(checkedEdgingElement).prop('checked', true);
        }
      }
      // reload wishlist button event
      reloadWishlistButtonEvent();
      changeBottomButton();

      var ua = navigator.userAgent;
      if ((ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0) {
        // Processing for smartphones
      } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Macintosh') > -1 && 'ontouchend' in document) {
        // Processing for tablets
      } else {
        // Processing for PC
        $('.hadapasha_link_sp').css('display', 'none');
      }
    }
  });
}

/**
 * Update product summary area (information right below cpb-products_details_area)
 *
 * @param {Object} params: This variant params
 * @returns {HTML}
 */
function updateProductSummaryArea(params, $target) {
  var isPartialUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ($target === undefined || $target.length === 0) {
    return;
  }

  var targetBeforeUpdate = isPartialUpdate ? '' : $target.find('.js-tab-acc_list a.js-tab-acc_btn.is-active').data('tab-target');
  var url = params ? Urls.productSummaryArea + '?' + params : Urls.productSummaryArea;

  $.ajax({
    dataType: 'html',
    url: util.appendParamToURL(url, 'format', 'ajax'),
    xhrFields: {
      withCredentials: true
    }
  }).done(function (response) {
    colorSelectInit();
    if (isPartialUpdate) {
      var updateInformation = $(response).find($target.selector).text();
      $target.empty().text(updateInformation);
      return;
    }
    $target.empty().html(response);
    $target.find('.js-tab-acc_list a[data-tab-target="' + targetBeforeUpdate + '"]').click();
  });
}

function updateSetContent($ele, href) {
  var $productSetItemCtnr = $ele.closest('.cpb-products-variety_box');
  var qty = $productSetItemCtnr.find('input[name="Quantity"]').val();

  ajax.load({
    url: util.appendParamsToUrl(href, {
      Quantity: isNaN(qty) ? '1' : qty,
      format: 'ajax',
      setproduct: true
    }),
    target: $productSetItemCtnr,
    callback: function callback() {
      updateVariationContent($ele, true);

      if (typeof VIRTUAL_MAKE !== 'undefined') {
        VIRTUAL_MAKE.MODULE.setVM();
      }

      addToCart();
      colorSelectInit(true);

      // Update wishlist button
      updateWishlistButton();
      updateAmountPricePS($productSetItemCtnr, href);
      updateAddToCartButton();
    }
  });
}

/**
 * Update amount price for product set
 * @param $ele
 * @returns
 */
function updateAmountPricePS($ele, href) {
  var totalPrice = $('.cpb-products-variety_area .cpb-products-variety_box').toArray().reduce(function (totalPrice, currentValue) {
    var count = Number($(currentValue).find('.cpb-products-conut .js-num-drop_input').val()) || 0;
    var price = Number($(currentValue).find('.item-price .num').data().value) || 0;
    return totalPrice + count * price;
  }, 0);

  var $target = $ele.parent().siblings('.cpb-products-conut').find('.item-price');
  ajax.load({
    url: util.appendParamsToUrl(href, {
      format: 'ajax',
      pricingps: true
    }),
    target: $target,
    data: {
      standardPricePS: totalPrice,
      salesPricePS: totalPrice
    },
    callback: function callback() {}
  });
}

function updateKitModalContent($ele, href) {
  var productId = $ele.attr('data-product');
  var kitProductId = $ele.attr('data-kit-product');
  var setId = $ele.attr('set-id');

  var params = {
    isKitModal: true,
    productId: productId,
    kitProductId: kitProductId,
    setId: setId,
    productSetNumber: $ele.attr('set-number'),
    productNumber: $ele.attr('product-number')
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    target: $('.product-kit'),
    callback: function callback() {
      colorSelectInit();
    }
  });
}

/**
 * Update selected color
 * @param $ele
 * @param isSet
 * @returns
 */
function updateVariationContent($ele, isSet) {
  // update product bottom fixed position
  if ($('.cpb-products-cart_fixed .cpb-products-data_box').length > 0) {
    if ($('.cpb-products-cart_fixed .cpb-products-data_box').find('.item-color').length > 0) {
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-color').remove();
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-state').remove();
    }

    if ($('.cpb-products_details_area .c-tileradio-list li.c-tileradio-list-item input').length == 0) {
      $('.cpb-products-cart_fixed .cpb-products-data_box').prepend(colorSelectedTag($ele));
    }

    // update price bottom fixed position
    if ($('.cpb-products-cart_fixed .cpb-products-data_box').find('.item-price').html() != '') {
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-price').html('');
    }

    $('.cpb-products-cart_fixed .cpb-products-data_box .item-price').html($('#cpb-products_price').html().replace('class="num"', ''));
  }
}

function colorSelectedTag($ele) {
  var description = $ele.find('span').first().data('description');
  return '<p class="item-color">' + description + '</p>';
}

function updateQuickviewContent($ele, href) {
  var $pdpForm = $('.pdpForm');

  var params = {
    Quantity: '1',
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val(),
    isQuickviewModal: true
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    callback: function callback(data) {
      var $pdpHtml = $(data);
      var $modal = $('#cpb-modal-quickview');
      updateVariationContent($ele, false);

      $modal.find('.cpb-modalR_bottom .quantity_box').html($pdpHtml.find('#cpb-products_price').prop('outerHTML'));
      $modal.find('.cpb-modalR_bottom .cmd-button_container').html($pdpHtml.find('#cpb-products_submit').prop('outerHTML'));
      $modal.find('.cpb-modal_quickview-inner').html($pdpHtml.find('.cpb-products-details'));

      changeBottomButton();

      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }

      // re-init pdp events
      cpbUi.pdp.ready();

      addToCart();
      colorSelectInit();

      // reload wishlist button event
      reloadWishlistButtonEvent();
      changeBottomButton();
      if (/Product-Variation/.test(href)) {
        $('.quickview-source-url').attr('href', href.replace('Product-Variation', 'Product-Show'));
        $('.quickview-error-message').remove();
      }
    }
  });
}

/**
 * Reload wishlist button event
 * @returns
 */
function reloadWishlistButtonEvent() {
  $('.cpb-products-details #save-for-later').on('click', function (e) {
    if (!window.User.isCustomerAuthenticated) {
      return;
    }

    e.preventDefault();
    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    });
  });

  $('.cpb-products-details .remove-from-wishlist').on('click', function (e) {
    e.preventDefault();

    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    }).fail(function (xhr, textStatus) {
      if (textStatus === 'parsererror') {
        window.alert(Resources.BAD_RESPONSE);
      } else {
        window.alert(Resources.SERVER_CONNECTION_ERROR);
      }
    });
  });
}

/**
 * Update wishlist button
 * @returns
 */
function updateWishlistButton() {
  if ($('.item-link_box').length > 0) {
    var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
    var pids = $productForms.map(function (formEle) {
      return $(formEle).data('pid');
    }).join(',');

    $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
      pid: pids
    }), function (data) {
      if (data === 'false') {
        $('.product-form-actions .product-set-wishlist').removeClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
      } else {
        $('.product-form-actions .product-set-wishlist').addClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
      }
    });
  }
}

/**
 * 商品セット内のバリエーションを変えた際に「ショッピングバックに入れる」の表示を更新
 */
function updateAddToCartButton() {
  var elementList = $('.cpb-products-variety_area .cpb-products-variety_box').toArray();
  // 一つでも在庫切れ、オフライン、店舗限定の商品が有った場合、true
  var checkProduct = function checkProduct() {
    return elementList.some(function (element) {
      return 'none' === $(element).find('.cmd-num_set').css('display');
    });
  };
  // すべての商品の購入個数が「0」の場合、true
  var checkNum = function checkNum() {
    return elementList.every(function (element) {
      return 0 < $(element).find('.cpb-products-conut .js-num-drop_input').length && 0 === Number($(element).find('.cpb-products-conut .js-num-drop_input').val());
    });
  };
  if (checkProduct() || checkNum()) {
    $('#add-all-to-cart').prop('disabled', 'disabled');
  } else {
    $('#add-all-to-cart').prop('disabled', '');
  }
}

/**
 * Update product bottom fixed position cart button when select variation
 * @returns
 */
function changeBottomButton() {
  var $dockButton = $('.cpb-products-cart_fixed .cpb-products-cart_submit button');
  var $cartButton = $('#add-to-cart');
  var isDisabledAddCart = $('#is_disabled_add_cart').length === 0 ? false : true;
  if (!isDisabledAddCart && ($cartButton.length === 0 || $('.cpb-products-cart_fixed').length === 0)) {
    return;
  }
  if (isDisabledAddCart) {
    // ショッピングバックに入れるボタンを削除
    $dockButton.remove();
    // 追従フッダーにクラスを付与する
    if ($('.cpb-products-cart_fixed').length !== 0) {
      $('.cpb-products-cart_fixed')[0].classList.add('sp_disabled_footer');
    }
    return;
  } else {
    // ショッピングバックに入れるボタンが無い場合、作成
    if ($dockButton.length === 0) {
      var element = document.createElement('button');
      element.classList.add('button');
      element.type = 'submit';
      $('.cpb-products-cart_fixed .cpb-products-cart_submit').append(element);
      $dockButton = $(element);
    }
    // 追従フッダーのクラスを削除する
    if ($('.cpb-products-cart_fixed').length !== 0) {
      $('.cpb-products-cart_fixed')[0].classList.remove('sp_disabled_footer');
    }
  }

  var buttonText = $cartButton.text();
  $dockButton.text(buttonText);
  if ($cartButton.prop('disabled') == true) {
    $dockButton.attr('disabled', 'disabled');
  } else {
    $dockButton.removeAttr('disabled');
  }
}

module.exports = function () {
  var isSet = $('.cpb-products-variety_area').length > 0;
  // color select event
  if ($('.cpb-products-details .cpb-products-color_list a span.is-current').length > 0) {
    var $ele = $('.cpb-products-details .cpb-products-color_list a span.is-current').closest('a');
    updateVariationContent($ele, isSet);
  } else if ($('.cpb-products_details_area .c-tileradio-list li.c-tileradio-list-item input:checked').length > 0) {
    var _$ele = $('.cpb-products_details_area .c-tileradio-list li.c-tileradio-list-item input:checked').closest('li');
    updateVariationContent(_$ele, isSet);
  }
  changeBottomButton();
  colorSelectInit();
};

},{"../../ajax":1,"../../design":11,"../../progress":64,"../../storeinventory/product":74,"../../util":77,"./addToCart":44}],55:[function(require,module,exports){
'use strict';

var util = require('../util');

var $cache;

function initializeCache() {
  $cache = {};
  $cache['errorMsg'] = $('#promotion-landing-container .landing-error');
}

function initializeEvents() {
  $(document).on('submit', '#PromoLandingForm', function (e) {
    var httpParams = util.getQueryStringParams(util.getQueryString(window.location.href));
    $('<input type="hidden" name="promoid" value="' + httpParams['promoid'] + '" />').appendTo(e.target);
  }).on('focus', '#PromoLandingForm input', function () {
    $cache.errorMsg.hide();
  });
}

module.exports.init = function () {
  initializeCache();
  initializeEvents();

  if (window.location.href.indexOf('error') > -1) {
    $cache.errorMsg.show();
  }
  if (window.couponCode) {
    $('#promo-code').text(window.couponCode);
  }
};

},{"../util":77}],56:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
  // load address details
  var url = Urls.giftRegAdd + addressID;
  ajax.getJson({
    url: url,
    callback: function callback(data) {
      if (!data || !data.address) {
        window.alert(Resources.REG_ADDR_ERROR);
        return false;
      }
      // fill the form
      $form.find('[name$="_addressid"]').val(data.address.ID);
      $form.find('[name$="_firstname"]').val(data.address.firstName);
      $form.find('[name$="_lastname"]').val(data.address.lastName);
      $form.find('[name$="_address1"]').val(data.address.address1);
      $form.find('[name$="_address2"]').val(data.address.address2);
      $form.find('[name$="_city"]').val(data.address.city);
      $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
      $form.find('[name$="_postal"]').val(data.address.postalCode);
      $form.find('[name$="_state"]').val(data.address.stateCode);
      $form.find('[name$="_phone"]').val(data.address.phone);
      // $form.parent('form').validate().form();
    }
  });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
  var $eventAddressForm = $('form[name$="_giftregistry"]'),
      $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
      $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

  $('.usepreevent').on('click', function () {
    // filter out storefront toolkit
    $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
      var fieldName = $(this).attr('name'),
          $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
      $afterField.val($(this).val()).trigger('change');
    });
  });
  $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
    var addressID = $(this).val();
    if (addressID.length === 0) {
      return;
    }
    populateForm(addressID, $beforeAddress);
  }).on('change', 'select[name$="_addressAfterList"]', function () {
    var addressID = $(this).val();
    if (addressID.length === 0) {
      return;
    }
    populateForm(addressID, $afterAddress);
  });

  $('.item-list').on('click', '.item-edit-details a', function (e) {
    e.preventDefault();
    var productListID = $('input[name=productListID]').val();
    quickview.show({
      url: e.target.href,
      source: 'giftregistry',
      productlistid: productListID
    });
  });
}

exports.init = function () {
  initializeEvents();
  addProductToCart();
  login.init();
  util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":1,"../login":22,"../quickview":66,"../util":77,"./product/addToCart":44}],57:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    video = require('../video'),
    util = require('../util'),
    design = require('../design');

function copyBottomResultHitsToTop() {
  $('#results-hits-top').html($('#results-hits-bottom .results-hits').html());
}

function viewAllClick(ev) {
  return viewMoreClick(ev, $('.order-view-all'));
}

function viewMoreClick(ev, $target) {
  // getting the hidden div, which is the placeholder for the next page
  var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
  // get url hidden in DOM
  if (loadingPlaceHolder.length === 0) {
    return;
  }
  var gridUrl = loadingPlaceHolder.attr('data-grid-url');
  if ($target && $target.attr('data-grid-count')) {
    var splitted = gridUrl.split('?');
    var base = splitted[0];
    var params = splitted[1].split('&').map(function (str) {
      var pair = str.split('=');
      if (pair[0] === 'sz') {
        pair[1] = $target.attr('data-grid-count');
      }
      return pair.join('=');
    }).join('&');
    if (params) {
      gridUrl = base + '?' + params;
    }
  }
  if (loadingPlaceHolder.length === 1) {
    // switch state to 'loading'
    // - switches state, so the above selector is only matching once
    // - shows loading indicator
    loadingPlaceHolder.attr('data-loading-state', 'loading');
    loadingPlaceHolder.addClass('infinite-scroll-loading');

    // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
    var fillEndlessScrollChunk = function fillEndlessScrollChunk(html) {
      loadingPlaceHolder.removeClass('infinite-scroll-loading');
      loadingPlaceHolder.attr('data-loading-state', 'loaded');
      $('.js-page-list').append(html);

      var currentNum = $('.number-item-of-page').last().text().trim();
      $('.c-list-pagination .js-list-num-current').html(currentNum);

      var winT = $(window).scrollTop();
      matchHeightProducts();
      $(window).scrollTop(winT);

      // rebind the View More event
      $('#view-more').off();
      $('#view-more').on('click', viewMoreClick);
      $('.order-view-all').off('click').on('click', viewAllClick);
      // hide view-more button and view-all button when items in OrderHistory all loaded
      if ($('.ajaxAllOrderHistory').length === 1 || $('.ajax-all').length > 0) {
        $('#view-more').parents('li').remove();
        $('#view-all').parents('li').remove();
      }
    };

    // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
    // it was removed to temporarily address RAP-2649
    $.ajax({ type: 'GET', dataType: 'html', url: gridUrl }).done(function (response) {
      // put response into cache
      try {
        sessionStorage['scroll-cache_' + gridUrl] = response;
      } catch (e) {}
      // nothing to catch in case of out of memory of session storage
      // it will fall back to load via ajax

      // update UI
      $('.results-hits').remove();
      fillEndlessScrollChunk(response);
      copyBottomResultHitsToTop();
      productTile.init();
      $(document).trigger('plpviewmore');
    }).then(function () {
      updateHistoryURL($('.c-block-listItem-wrap > .c-block-listItem-history').length);
    });
  }
}

function updateHistoryURL(sz) {
  if (!sz) {
    return;
  }
  window.history.replaceState(null, document.title, window.location.href.split('?')[0] + '?sz=' + sz.toFixed(0));
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, tabType) {
  if (!url || url === window.location.href) {
    return;
  }
  progress.show($('.js-page-list'));
  if (typeof tabType === 'undefined' || tabType === null) {
    tabType = 'undefined';
  }

  $.ajax({
    type: 'GET',
    dataType: 'html',
    url: util.appendParamToURL(url, 'format', 'ajax')
  }).done(function (data, textStatus, jqXHR) {
    var dataRes = $($.parseHTML(data));
    if (dataRes.find('main').length > 0) {
      $('main').html(dataRes.find('main')[0].innerHTML);
    } else {
      $('main').html(data);
    }

    compareWidget.init();
    productTile.init();
    design.searchInit();
    design.plpInit();
    design.selectQuantityInit();
    design.productSearchInit();
    if (tabType === 'sort') {
      $('.c-block-products-search-tabs .c-block-products-search-tabs--sort .tab').trigger('click');
    }
    if (tabType === 'filter') {
      $('.c-block-products-search-tabs .c-block-products-search-tabs--filter .tab').trigger('click');
    }
    design.toggleSelectInit(true);
    matchHeightProducts();
    progress.hide();
    history.pushState(undefined, '', url);
  });
}

function excludeCompoundAttributeRefinements(refineUrl) {
  var newUrl = refineUrl;

  var params = util.getQueryStringParams(refineUrl);
  Object.keys(params).forEach(function (paramName) {
    if (paramName.indexOf('prefv') === -1) {
      return;
    }

    var splitParam = params[paramName].split('|');
    newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
  });

  return newUrl;
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
  var $main = $('main');
  // compare checked
  $main.on('click', 'input[type="checkbox"].compare-check', function () {
    var cb = $(this);
    var tile = cb.closest('.product-tile');

    var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
    var itemImg = tile.find('.product-image a img').first();
    func({
      itemid: tile.data('itemid'),
      uuid: tile[0].id,
      img: itemImg,
      cb: cb
    });
  });

  // handle events for updating grid
  $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
    // don't intercept for category and folder refinements, as well as unselectable
    if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
      return;
    }
    e.preventDefault();
    updateProductListing(this.href);
  });

  // handle sorting change
  $main.on('click', '.c-block-products-search-panel--sort .c-select-list-item', function (e) {
    e.preventDefault();
    updateProductListing($(this).find('a').attr('data'), 'sort');
  }).on('change', '.items-per-page select', function () {
    var refineUrl = $(this).find('option:selected').val();
    if (refineUrl === 'INFINITE_SCROLL') {
      $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
    } else {
      $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
      updateProductListing(refineUrl);
    }
  });

  //handle refinement change
  $main.on('click', '.c-block-products-search-panel--filter .c-select-list-item', function (e) {
    e.preventDefault();

    if ($(this).hasClass('is-skip')) {
      return;
    }

    var refineUrl = $(this).data('url');
    if (refineUrl.indexOf('prefv') > -1) {
      refineUrl = excludeCompoundAttributeRefinements(refineUrl);
    }

    updateProductListing(refineUrl, 'filter');
  }).on('change', '.items-per-page select', function () {
    var refineUrl = $(this).find('option:selected').val();
    $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
    updateProductListing(refineUrl);
  });

  $('.category-tab-links select').off('change').on('change', function (e) {
    var $selected = $(this).find(':selected');
    var link = $selected.attr('href');

    if (link) {
      window.location.href = link;
    }
  });
}

function matchHeightProducts() {
  if ($('.c-product-cards-step-header').length) {
    $('.c-product-cards-list .c-product-cards-step-header').matchHeight();
  }
  $('.c-product-cards-list .c-product-cards-list-item').matchHeight();
}

exports.init = function () {
  video.init(function () {
    initializeEvents();
  });

  compareWidget.init();
  //$("#view-more").on("click", viewMoreClick);

  $(document).on('click', '#view-more', viewMoreClick);
  $(document).on('click', '.order-view-all', viewAllClick);
  //$('#filter1-submit').click(function() {
  //	$('#filter1').val('0');
  //});
  productTile.init();
  //initializeEvents();
  design.toggleSelectInit(true);

  // content navigation title link
  $('.nav.content-navigation .accordion-title span').on('click', function () {
    window.location = $(this).data('url');
  });

  // content navigation dropdown redirect
  $('.nav.content-navigation select').on('change', function () {
    window.location = $(this).val();
  });

  var $accordionToggle = $('.refinements .accordion-arrow');

  $accordionToggle.on('click', function (evt) {
    console.log($(this));
    evt.preventDefault();

    $(this).next($('#category-level-2')).slideToggle();

    $(this).parent($('li')).toggleClass('expanded');
  });
};
exports.viewMore = function () {
  $(document).on('click', '#view-more', viewMoreClick);
  $(document).on('click', '.order-view-all', viewAllClick);
};

},{"../compare-widget":5,"../design":11,"../product-tile":63,"../progress":64,"../util":77,"../video":79}],58:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    login = require('../login'),
    util = require('../util'),
    account = require('./account'),
    minicart = require('../minicart'),
    design = require('../design'),
    skin_trouble_check = require('./product/skin_trouble_check');

function addItemToBag(e, $this) {
  e.preventDefault();
  if (!$this) {
    var $this = $(this);
  }
  var displayPopup = false;

  if (window.innerWidth <= 768) {
    displayPopup = true;
  }

  var $form = $this.closest('form');
  var $errorLocation = $form.find('ul.c-text-error>li');

  return $.ajax({
    type: 'POST',
    url: util.ajaxUrl(Urls.wishlistAddToCart),
    data: $form.serialize() + '&displayPopup=' + displayPopup,
    loading: true
  }).then(function (response) {
    if (response.error) {
      $errorLocation.html(response.error);
      $errorLocation.parent().removeClass('mfp-hide');
      return $.Deferred().reject().promise();
    }
    $errorLocation.parent().addClass('mfp-hide');
    $errorLocation.html(null);
    return function () {
      minicart.show(response);
      design.dropdownToggleInit();
    };
  });
}

function initAddToCart() {
  $(document).off('click', 'button[name="waitlist_addtocart"]').on('click', 'button[name="waitlist_addtocart"]', skinCheck);
}

function skinCheck(e) {
  skin_trouble_check.skinTroubleExecute(e, $(this), addItemToBag);
}

exports.init = function () {
  // addProductToCart();
  initAddToCart();
  design.selectQuantityInit();
  //login.init();
  account.initMobileMenu();
};

},{"../design":11,"../login":22,"../minicart":23,"../util":77,"./account":29,"./product/addToCart":44,"./product/skin_trouble_check":52}],59:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {
  recommendations();
  $('#homepage-hero').slick({
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 480,
      settings: {
        arrows: false
      }
    }]
  });
  $('.sub-feature-article').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [{
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    }]
  });
};

},{"./product/recommendations":51}],60:[function(require,module,exports){
'use strict';

var dialog = require('../dialog');

exports.init = function () {
  $('.store-details-link').on('click', function (e) {
    e.preventDefault();
    dialog.open({
      url: $(e.target).attr('href')
    });
  });
};

},{"../dialog":12}],61:[function(require,module,exports){
'use strict';

function initTutorialCarousel() {
  $('.related-carousel-wrapper .tutorial-wrapper').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    }, {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        dots: true
      }
    }]
  });

  if ($('#thumbnails li').length == 0) {
    return false;
  } else if ($('#thumbnails li').length > 1 && window.innerWidth > 767) {
    tutorialThumbnailCarousel();
  } else if ($('#thumbnails li').length > 1 && window.innerWidth < 768) {
    tutorialMainImageCarousel();
  }
  tutorialImages();
}

function tutorialThumbnailCarousel() {
  $('#thumbnails ul').slick({
    dots: false,
    infinite: true,
    arrows: true,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1
  });
}

function tutorialMainImageCarousel() {
  $('#thumbnails').find('.productthumbnail.selected').removeClass('selected');
  $('#thumbnails ul').slick({
    dots: true,
    vertical: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    slidesToShow: 1
  });
}

// tutorial image carousel
function tutorialImages() {
  $('#thumbnails').on('click', '.productthumbnail', function () {
    var $that = $(this);

    $('#thumbnails').find('.productthumbnail.selected').removeClass('selected');
    $that.addClass('selected');
    setTutorialMainImage($that.find('img').attr('src'));
  });
}

function setTutorialMainImage(src) {
  $('#tutorial-image-template .primary-image').attr('src', src);
}

exports.init = function () {
  initTutorialCarousel();
};

},{}],62:[function(require,module,exports){
'use strict';

var page = require('../page'),
    login = require('../login'),
    util = require('../util'),
    account = require('./account'),
    minicart = require('../minicart'),
    design = require('../design'),
    skin_trouble_check = require('./product/skin_trouble_check');

function addAllItemToBag(e, $this) {
  e.preventDefault();
  if (!$this) {
    var $this = $(this);
  }

  //Clear list of product added to cart
  $('.add-all-form .cart-added-list').data('plist', '');
  $('#minicart-notification .notify').text('');
  var deferredList = $(document).find('.c-pcOnly-tb>button[name$="_addToCart"]').map(function (index) {
    return addItemToBag(e, $(this), {
      isAddAllToBagClicked: true,
      count: index + 1
    }); //since we want to know if the click is from add all to bag or not.
  });

  // 「...rest」には「addItemToBag」の返却値が格納される
  return $.when.apply($this, deferredList).then(function () {
    for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }

    var isAllFailed = rest.some(function (result) {
      return !result.success;
    });
    if (isAllFailed) {
      return $.Deferred().reject().promise();
    }
    // 一つでもカートに追加出来た商品があった場合、ミニカートを表示
    // 最後に返却された結果のコールバック関数を使用
    var sortResult = rest.sort(function (a, b) {
      if (a.execTime < b.execTime) {
        return -1;
      }
      if (a.execTime > b.execTime) {
        return 1;
      }
      return 0;
    });
    return sortResult.reduce(function (func, currentValue) {
      if (currentValue.success) {
        return currentValue.callBackFunc;
      }
      return func;
    });
  });
}

/**
 * お気に入り内にある「ショッピングバッグに入れる」「すべての商品をショッピングバッグに入れる」クリック時に実行される関数
 * 肌トラブルチェックの仕様上、返却値は以下になる
 * ・ショッピングバッグに入れる：肌トラブルチェック後に実行するコールバック関数
 * ・すべての商品をショッピングバッグに入れる：エラーがあるか無いか判定するためのオブジェクト
 *
 * @param {*} e
 * @param {*} $this
 * @param {*} wishListData
 */
function addItemToBag(e, $this, wishListData) {
  e.preventDefault();
  if (!$this) {
    var $this = $(this);
  }

  var displayPopup = false;
  var wishListItemLen = $('.c-list-products-full-item').length;
  var displayProdSpecificMsg = wishListItemLen === 1 ? true : false;
  if (typeof wishListData == 'undefined') {
    var wishListData = {};
    wishListData.isAddAllToBagClicked = false;
    wishListData.count = 1;
    displayProdSpecificMsg = true;
  }

  if (window.innerWidth <= 768) {
    displayPopup = true;
  }
  if (wishListData.isAddAllToBagClicked === false) {
    $('#minicart-notification .notify').text('');
    displayPopup = true;
  } else {
    if (wishListItemLen === wishListData.count) {
      displayPopup = true;
    }
  }

  var $form = $this.closest('form');
  var extraParams = '&displayPopup=' + displayPopup + '&displayProdSpecificMsg=' + displayProdSpecificMsg + '&isAddAllToBagClicked=' + wishListData.isAddAllToBagClicked;
  var $errorLocation = $form.find('ul.c-text-error>li');
  var $cartAddedList = $('.add-all-form .cart-added-list');

  return $.ajax({
    type: 'POST',
    url: util.ajaxUrl(Urls.wishlistAddToCart),
    data: $form.serialize() + extraParams,
    loading: true
  }).then(function (response) {
    if (response.error) {
      $errorLocation.text(response.error);
      $errorLocation.parent().removeClass('mfp-hide');
      if (wishListData.isAddAllToBagClicked) {
        // 「すべての商品をショッピングバッグに入れる」で使用するため判定用の連想配列を返却
        // 最後に実行した結果を画面に出力するため実行終了時間も設定
        return { success: false, execTime: new Date().getTime() };
      }
      return $.Deferred().reject().promise();
    }
    $errorLocation.parent().addClass('mfp-hide');
    $errorLocation.text('');

    if (wishListData.isAddAllToBagClicked == true && window.innerWidth <= 768) {
      //Create a list of product added to cart successful
      if ($cartAddedList.data('plist') !== '') {
        $cartAddedList.data('plist', $cartAddedList.data('plist') + ', ' + $form.find('input[name=pname]').val());
      } else {
        $cartAddedList.data('plist', $form.find('input[name=pname]').val());
      }

      //Copy list of product added to cart successful to display
      $('#minicart-notification .notify').text($cartAddedList.data('plist'));
    } else if (wishListData.isAddAllToBagClicked == false && window.innerWidth <= 768) {
      $('#minicart-notification .notify').text($form.find('input[name=pname]').val());
    }

    var callBackFunc = function callBackFunc() {
      minicart.show(response);
      design.dropdownToggleInit();
    };
    // 「すべての商品をショッピングバッグに入れる」で使用するため判定用の連想配列を返却
    // 最後に実行した結果を画面に出力するため実行終了時間も設定
    if (wishListData.isAddAllToBagClicked) {
      return {
        success: true,
        callBackFunc: callBackFunc,
        execTime: new Date().getTime()
      };
    }
    // 肌トラブルチェック後に実行するコールバック関数
    return callBackFunc;
  });
}

function initAddToCart() {
  $(document).off('click', 'button.add-all-to-cart').on('click', 'button.add-all-to-cart', skinCheckOnAll);
  $(document).off('click', 'button[name$="_addToCart"]').on('click', 'button[name$="_addToCart"]', skinCheck);
}

function skinCheckOnAll(e) {
  skin_trouble_check.skinTroubleExecute(e, $(this), addAllItemToBag);
}

function skinCheck(e) {
  skin_trouble_check.skinTroubleExecute(e, $(this), addItemToBag);
}

exports.init = function () {
  initAddToCart();

  $('#editAddress').on('change', function () {
    page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
  });

  //add js logic to remove the , from the qty feild to pass regex expression on client side
  $('.option-quantity-desired input').on('focusout', function () {
    $(this).val($(this).val().replace(',', ''));
  });

  login.init();
  account.initMobileMenu();
};

},{"../design":11,"../login":22,"../minicart":23,"../page":28,"../util":77,"./account":29,"./product/skin_trouble_check":52}],63:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    images = require('./pages/product/image'),
    quickview = require('./quickview'),
    addToCart = require('./pages/product/addToCart'),
    variant = require('./pages/product/variant'),
    design = require('./design');

function initQuickViewButtons() {
  if (!quickViewEnabled) {
    return;
  }

  $('.c-product-cards-quickshop-toggle').magnificPopup({
    type: 'ajax',
    ajax: {
      settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
      // For example:
      // settings: {cache:false, async:false}

      cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
      tError: Resources.QUICKVIEW_ERROR //  Error message, can contain %curr% and %total% tags if gallery is enabled
    },
    callbacks: {
      parseAjax: function parseAjax(mfpResponse) {
        // mfpResponse.data is a "data" object from ajax "success" callback
        // for simple HTML file, it will be just String

        // mfpResponse.data must be a String or a DOM (jQuery) element
        mfpResponse.data = $(mfpResponse.data).find('.c-block-shopingmodal').first();
      },
      ajaxContentAdded: function ajaxContentAdded() {
        $('#shopingmodal').html(this.content[0].outerHTML);
        $.magnificPopup.open({
          items: {
            src: '#shopingmodal', // can be a HTML string, jQuery object, or CSS selector
            type: 'inline'
          }
        });

        images();
        addToCart();
        variant();
        renderThumbnails();
        quickview.initWishlistButton();

        $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function () {
          window.location.href = url + '#reviews'; // redirect when rating star is clicked
        });

        $(document).on('click', '.bv-popup-in .bv-read-review', function () {
          window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
        });

        design.toggleSelectInit(true);
        design.modalInit();
        design.pdpInit();
        design.selectQuantityInit();
      }
    }
  });
}

function gridViewToggle() {
  $('.toggle-grid').on('click', function () {
    $('.search-result-content').toggleClass('wide-tiles');
    $(this).toggleClass('wide');
  });
}

function renderThumbnails() {
  if ($('#thumbnails').length > 0) {
    $('#thumbnails').empty(); // clear the list
    images(); // populate the thumbnails
  }
}

function initCarouselSwatches() {
  $('.swatch-list').not('.slick-slider').slick({
    dots: false,
    focusOnSelect: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 3,
    speed: 300
  });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
  initQuickViewButtons();
  initColorChange();
  gridViewToggle();
  $('.swatch-list').on('mouseleave', function () {
    // Restore current thumb image
    var $tile = $(this).closest('.product-tile'),
        $thumb = $tile.find('.product-image .thumb-link img').eq(0),
        data = $thumb.data('current');

    if (!data) {
      return;
    }

    $thumb.attr({
      src: data.src,
      alt: data.alt,
      title: data.title
    });
  });
  $('.swatch-list .swatch').on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('selected')) {
      return;
    }

    var $tile = $(this).closest('.product-tile');
    $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
    $(this).addClass('selected');
    $tile.find('.thumb-link').attr('href', $(this).attr('href'));
    $tile.find('name-link').attr('href', $(this).attr('href'));

    var data = $(this).children('img').filter(':first').data('thumb');
    var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
    var currentAttrs = {
      src: data.src,
      alt: data.alt,
      title: data.title
    };
    $thumb.attr(currentAttrs);
    $thumb.data('current', currentAttrs);
  }).on('mouseenter', function () {
    // get current thumb details
    var $tile = $(this).closest('.product-tile'),
        $thumb = $tile.find('.product-image .thumb-link img').eq(0),
        data = $(this).children('img').filter(':first').data('thumb'),
        current = $thumb.data('current');

    if (!data) {
      return;
    }

    // If this is the first time, then record the current img
    if (!current) {
      $thumb.data('current', {
        src: $thumb[0].src,
        alt: $thumb[0].alt,
        title: $thumb[0].title
      });
    }

    // Set the tile image to the values provided on the swatch data attributes
    $thumb.attr({
      src: data.src,
      alt: data.alt,
      title: data.title
    });
  });
}

function initColorChange() {
  $('div.c-product-cards .c-list-color li > a').on('click mousehover', function () {
    $(this).closest('.c-product-cards').find('.c-product-cards-photo-img').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val());
    $(this).closest('.c-product-cards').find('.c-product-cards-text > a').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val());
    $(this).closest('.c-product-cards').find('.c-product-cards-quickshop-toggle').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val() + '&source=quickview');
  });
}

exports.init = function () {
  var $tiles = $('.c-product-cards-list .c-product-cards-list-item');
  if ($tiles.length === 0) {
    return;
  }

  initCarouselSwatches();
  initializeEvents();
};

exports.initCarouselSwatches = initCarouselSwatches;
exports.initQuickViewButtons = initQuickViewButtons;
exports.initColorChange = initColorChange;

},{"./design":11,"./pages/product/addToCart":44,"./pages/product/image":47,"./pages/product/variant":54,"./quickview":66,"imagesloaded":110}],64:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function show(container) {
  var target = !container || $(container).length === 0 ? $('body') : $(container);
  $loader = $loader || $('.loader');

  if ($loader.length === 0) {
    $loader = $('<div/>').addClass('loader').append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
  }
  return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function hide() {
  if ($loader) {
    $loader.hide();
  }
};

exports.show = show;
exports.hide = hide;

},{}],65:[function(require,module,exports){
'use strict';

var util = require('./util');
var page = require('./page');
var modal = require('./modal');
var cache = {};

function initCache() {
  if ($('#EditAddressForm').length > 0) {
    cache['$formId'] = '#EditAddressForm';
    cache['$form'] = $('#EditAddressForm');
    cache['$source'] = 'dwfrm_shippingaddress';
    cache['$save'] = $('#EditAddressForm').find('.apply-button').attr('name');
  } else if ($('#dwfrm_singleshipping_shippingAddress').length > 0) {
    cache['$formId'] = '#dwfrm_singleshipping_shippingAddress';
    cache['$form'] = $('#dwfrm_singleshipping_shippingAddress');
    cache['$source'] = 'dwfrm_singleshipping_shippingAddress_addressFields';
    cache['$save'] = 'dwfrm_singleshipping_shippingAddress_save';
  }

  cache['$modal'] = modal.create('#qas-modal', '#qas-modal .modal-body', {
    closeOnClick: false,
    closeOnEsc: false
  });
}

function initEvents() {
  if (cache.$form && cache.$form.length > 0) {
    cache.$form.off('click').on('click', ' button[name="' + cache.$save + '"]', validate);
  }
}

function submitForm() {
  cache.$form.append('<input type="hidden" name="' + cache.$save + '"/>');
  cache.$form.submit();
}

function updateAddressForm(addr) {
  cache.$form.find('input[name$="_address1"]').val(addr.add1);
  cache.$form.find('input[name$="_address2"]').val(addr.add2);
  cache.$form.find('select[id$="_state"]').val(addr.state ? addr.state.toUpperCase() : '');
  cache.$form.find('input[name$="_city"]').val(addr.city);
  cache.$form.find('input[name$="_postal"]').val(addr.zip);
}

function updateAddress(data) {
  $.ajax({
    type: 'POST',
    url: Urls.qasUpdateAddress,
    data: data,
    dataType: 'html'
  }).done(function (response, textStatus, request) {
    var response = JSON.parse(response);
    if (response.action === 'reValidate') {
      cache.$modal.close();
      validate('reValidate');
    } else {
      if (response.action !== 'useOrig') {
        updateAddressForm(response.address);
      }

      submitForm();
    }
  });
}

function validate(action) {
  if ($('#dwfrm_singleshipping_shippingAddress').length > 0 && !$('#EditAddressForm').is(':visible')) {
    //Ade -- if (cache.$formId === '#EditAddressForm' &&
    cache['$formId'] = '#dwfrm_singleshipping_shippingAddress';
    cache['$form'] = $('#dwfrm_singleshipping_shippingAddress');
    cache['$source'] = 'dwfrm_singleshipping_shippingAddress_addressFields';
    cache['$save'] = 'dwfrm_singleshipping_shippingAddress_save';
  }

  if (!cache.$form.validate().form()) {
    return;
  }

  var data = cache.$form.serialize() + '&source=' + cache.$source;
  if (typeof action === 'string') {
    data = data + '&dwfrm_addForm_action=' + action;
  }

  $.ajax({
    type: 'POST',
    url: Urls.qasVerifyAddress,
    data: data,
    dataType: 'html'
  }).done(function (content, textStatus, request) {
    if (/json/.test(request.getResponseHeader('Content-Type'))) {
      var response = JSON.parse(content);
      if (response.action === 'addrVerified') {
        updateAddressForm(response.address);
        submitForm();
      } else if (response.action === 'verified') {
        submitForm();
      }
    } else {
      cache.$modal.renderContent(content);

      $('.addForm').on('click', 'button', function () {
        var form = $(this).parents('form');
        form.append('<input type="hidden" name="' + $(this).attr('name') + '"/>');

        updateAddress(form.serialize());
        cache.$modal.close();

        return false;
      });
    }
  });

  return false;
}

var qas = {
  init: function init() {
    if (SitePreferences.IS_QAS_ENABLED) {
      initCache();
      initEvents();
    }
  }
};

module.exports = qas;

},{"./modal":24,"./page":28,"./util":77}],66:[function(require,module,exports){
'use strict';

module.exports = {};
var product = require('./pages/product');

/**
 * QuickView
 */
cpbUi.directQuickView = function (href, callback) {
  var modalHtml = '<div id="cpb-modal-quickview" class="cpb-modalR_container js-quickview_content" data-modal-type="quickview">\
        <div class="cpb-modalR_wrap">\
            <div class="cpb-modalR_contents cpb-cart_style">\
                <form action="#">\
                    <div class="cpb-modalR_scroll_cover">\
                        <div class="cpb-modalR_inner cpb-modal_scroll js-modal_scroll">\
                            <div class="cpb-modal_quickview">\
                                <button class="cpb-modalR_close js-quickview_close"><span class="invisible">CLOSE</span></button>\
                                <!-- pdp -->\
                                <div class="cpb-modal_quickview-inner"></div>\
                                <!-- /pdp -->\
                            </div><!-- / cpb-modal_quickview -->\
                        </div><!-- / cpb-modalR_inner -->\
                        <div class="cpb-modalR_bottom">\
                            <!-- price -->\
                            <div class="quantity_box"></div>\
                            <!-- /price -->\
                            <!-- button -->\
                            <div class="cmd-button_container"></div>\
                            <!-- /button -->\
                        </div><!-- / cpb-modalR_bottom -->\
                    </div><!-- / cpb-modalR_scroll_cover -->\
                </form>\
            </div><!-- / cpb-modalR_contents" -->\
        </div><!-- / cpb-modalR_wrap -->\
        <div class="cpb-modal_overlay js-quickview_overlay"></div>\
    </div><!-- / cpb-modalR_container -->';

  $.ajax({
    type: 'GET',
    url: href,
    dataType: 'html'
  }).done(function (data, textStatus, jqXHR) {
    var $pdpHtml = $(data);
    var $modal = $(modalHtml);

    $modal.find('.cpb-modalR_bottom .quantity_box').append($pdpHtml.find('#cpb-products_price').prop('outerHTML'));
    $modal.find('.cpb-modalR_bottom .cmd-button_container').append($pdpHtml.find('#cpb-products_submit').prop('outerHTML'));
    $modal.find('.cpb-modal_quickview-inner').append($pdpHtml.find('.cpb-products_details_area .cpb-products-details'));
    var isSynactifProduct = $modal.find('.cpb-products-details').attr('data-issynactifproduct');
    if (isSynactifProduct === 'true') {
      $modal.addClass('quickView-synactif');
    }
    $('body').append($modal);

    if (typeof callback === 'function') callback();
  }).fail(function (jqXHR, textStatus, errorThrown) {});
};

function openQuickView(href) {
  var deferred = $.Deferred();
  cpbUi.isQuickView = true;
  cpbUi.directQuickView(href, function () {
    cpbUi.pdp.ready();

    cpbUi.util.rightModalOpen.call(this, 'quickview', function () {
      // init product's events
      product.initializeEvents();

      cpbUi.niceScroll.ready();
      cpbUi.sliderControl.resize();
      var $form = $('#cpb-modal-quickview form');
      $form.find('.quickview-source-url').remove();
      $form.append($('<a class="quickview-source-url mfp-hide" href=' + href + '></a>'));
      deferred.resolve();
    });
  });
  return deferred.promise();
}

module.exports.init = function () {
  $(document).on('click', '.js-quickview-btn', function (e) {
    e.preventDefault();
    if (!cpbUi.isQuickView) {
      var href = $(this).attr('href');
      openQuickView(href);
    }
  });
  $(document).on('click', '.js-quickview_close', function (e) {
    e.preventDefault();
    cpbUi.util.rightModalClose.call(this, 'quickview', function () {
      $('#cpb-modal-quickview').find('.js-modal_scroll').getNiceScroll().remove();
      $('#cpb-modal-quickview').remove();
      cpbUi.isQuickView = false;
    });
  });
  $(document).on('click', '.js-quickview_overlay', function (e) {
    e.preventDefault();
    cpbUi.util.rightModalClose.call(this, 'quickview', function () {
      $('#cpb-modal-quickview').find('.js-modal_scroll').getNiceScroll().remove();
      $('#cpb-modal-quickview').remove();
      cpbUi.isQuickView = false;
    });
  });
};

module.exports.openQuickView = openQuickView;

},{"./pages/product":48}],67:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */

function hashFn(str) {
  var hash = 5381,
      i = str.length;

  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }
  /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */
  return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
  return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
  init: function init() {
    $('.product-review').each(function (index, review) {
      var pid = $(review).data('pid');
      if (!pid) {
        return;
      }
      // rating range from 2 - 5
      var rating = getRating(pid);
      var baseRating = Math.floor(rating);
      var starsCount = 0;
      for (var i = 0; i < baseRating; i++) {
        $('.rating', review).append('<i class="fa fa-star"></i>');
        starsCount++;
      }
      // give half star for anything in between
      if (rating > baseRating) {
        $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
        starsCount++;
      }
      if (starsCount < 5) {
        for (var j = 0; j < 5 - starsCount; j++) {
          $('.rating', review).append('<i class="fa fa-star-o"></i>');
        }
      }
    });
  }
};

},{}],68:[function(require,module,exports){
'use strict';

// recaptcha
$(function () {
  $('[name*="_login_username_"]').on('blur', function () {
    validateForm();
  });
  $('[name*="_login_password_"]').on('blur', function () {
    validateForm();
  });

  $('button[name$="_login"], button[name$="_loginexternal"]').prop('disabled', true);

  window.validateForm = validateForm;

  // if recaptcha is off, do nothing.
  if ($('#captcha').length === 0) {
    return;
  }
  window.recaptchaCallback = recaptchaCallback;
  window.recaptchaExpiredCallback = recaptchaExpiredCallback;
});
/**
 * Callback of recaptcha
 * @returns
 */
function recaptchaCallback() {
  $('button.c-btn--login_disabled, button[name$="_login"], button[name$="_loginexternal"]').prop('disabled', false).removeClass('c-btn--login_disabled');
  $('#dummy-error-span-for-recaptcha').css({ visibility: 'hidden' });
}
/**
 * Expired callback of recaptcha
 * @returns
 */
function recaptchaExpiredCallback() {
  $('button.c-btn--login_disabled, button[name$="_login"], button[name$="_loginexternal"]').prop('disabled', true).addClass('c-btn--login_disabled');
  $('#dummy-error-span-for-recaptcha').css({ visibility: 'visible' });
}
/**
 * Validate and reset submit button
 * @returns
 */
function validateForm() {
  var recaptchaIsEnabled = $('#captcha').length > 0;
  var recaptchaRegistration = recaptchaIsEnabled ? $('#hiddenRecaptcha_registration').val() == 'false' : false;

  if ($('[id*="_login_password_"][id$="-error"]').text() != '' || $('[name*="_login_password_"]').val() == '' || $('[id*="_login_username_"][id$="-error"]').text() != '' || $('[name*="_login_username_"]').val() == '' || recaptchaRegistration) {
    // バリデーションチェックNG
    $('form[id$="_login"]').find('input[type="submit"], button[type="submit"]').closest('form').data('submitting', true);

    // reCAPTCHAオフの場合は、バリデーションNG時にログインボタンを非活性にする
    if (!recaptchaIsEnabled) {
      recaptchaExpiredCallback();
    }
  } else {
    // バリデーションチェックOK
    $('form[id$="_login"]').find('input[type="submit"], button[type="submit"]').closest('form').data('submitting', false);

    // reCAPTCHAオフの場合は、バリデーションOK時にログインボタンを活性化する
    if (!recaptchaIsEnabled) {
      recaptchaCallback();
    }
  }
}

},{}],69:[function(require,module,exports){
'use strict';

var util = require('./util'),
    modal = require('./modal').global,
    ajax = require('./ajax'),
    sampleCookieName = 'sample.selection.shown';

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookie = function createSelectionShownCookie() {
  util.setCookie(sampleCookieName, '1');
};

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelection = function canShowSelection() {
  return !SitePreferences.SAMPLES_ENABLED ? false : true;
};

/**
 * Render Samples
 * @return {boolean}
 */
var showSelection = function showSelection() {
  // set selection cookie
  //createSelectionShownCookie();

  // render content to modal by url

  modal.addCustomClass('sample-selection');
  modal.renderByUrl(Urls.showSampleSelection);

  // close quickview
  if ($('.mfp-ready').length > 0) {
    $.magnificPopup.close();
  }

  $.magnificPopup.open({
    items: {
      src: '#sampleselectionmodal',
      type: 'inline',
      removalDelay: 500
    }
  });
};

var showSelectionInCart = function showSelectionInCart() {
  $.get(util.appendParamsToUrl(Urls.showSampleSelectionInCart, {
    format: 'ajax',
    isOnlyShowcontent: true
  })).done(function (data) {
    $('.js-modal-r_content[data-modal-type="sample"] .cpb-modalR_contents').html(data);
    cpbUi.util.rightModalOpen.call($('#item-sample .cpb-cart_add_btn a.button[data-modal-target="sample"]'), undefined, function (target) {
      cpbUi.niceScroll.ready();
    });
  });
};

exports.createSelectionShownCookie = createSelectionShownCookie;
exports.canShowSelection = canShowSelection;
exports.showSelection = showSelection;
exports.showSelectionInCart = showSelectionInCart;

},{"./ajax":1,"./modal":24,"./util":77}],70:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */

function initializeEvents() {
  $('#q').focus(function () {
    var input = $(this);
    if (input.val() === input.attr('placeholder')) {
      input.val('');
    }
  }).blur(function () {
    var input = $(this);
    if (input.val() === '' || input.val() === input.attr('placeholder')) {
      input.val(input.attr('placeholder'));
    }
  }).blur();
}

exports.init = initializeEvents;

},{}],71:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */

exports.init = function () {
  $('.slick').slick();
};

},{}],72:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
  setSelectedStore: function setSelectedStore(storeId) {
    var $selectedStore = $('.store-tile.' + storeId),
        $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
        storeAddress = $selectedStore.find('.store-address').html(),
        storeStatus = $selectedStore.find('.store-status').data('status'),
        storeStatusText = $selectedStore.find('.store-status').text();
    this.selectedStore = storeId;

    $lineItem.find('.instore-delivery .selected-store-address').data('storeId', storeId).attr('data-store-id', storeId).html(storeAddress);
    $lineItem.find('.instore-delivery .selected-store-availability').data('status', storeStatus).attr('data-status', storeStatus).text(storeStatusText);
    $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
  },
  cartSelectStore: function cartSelectStore(selectedStore) {
    var self = this;
    inventory.getStoresInventory(this.uuid).then(function (stores) {
      inventory.selectStoreDialog({
        stores: stores,
        selectedStoreId: selectedStore,
        selectedStoreText: Resources.SELECTED_STORE,
        continueCallback: function continueCallback() {},
        selectStoreCallback: self.setSelectedStore.bind(self)
      });
    }).done();
  },
  setDeliveryOption: function setDeliveryOption(value, storeId) {
    // set loading state
    $('.item-delivery-options').addClass('loading').children().hide();

    var data = {
      plid: this.uuid,
      storepickup: value === 'store' ? true : false
    };
    if (value === 'store') {
      data.storepickup = true;
      data.storeid = storeId;
    } else {
      data.storepickup = false;
    }
    $.ajax({
      url: Urls.setStorePickup,
      data: data,
      success: function success() {
        // remove loading state
        $('.item-delivery-options').removeClass('loading').children().show();
      }
    });
  },
  init: function init() {
    var self = this;
    $('.item-delivery-options .set-preferred-store').on('click', function (e) {
      e.preventDefault();
      self.uuid = $(this).data('uuid');
      var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
      if (!User.zip) {
        inventory.zipPrompt(function () {
          self.cartSelectStore(selectedStore);
        });
      } else {
        self.cartSelectStore(selectedStore);
      }
    });
    $('.item-delivery-options .delivery-option').on('click', function () {
      // reset the uuid
      var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
      self.uuid = $(this).closest('.cart-row').data('uuid');
      self.setDeliveryOption($(this).val(), selectedStore);
    });
  }
};

module.exports = cartInventory;

},{"./":73}],73:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function storeTemplate(store, selectedStoreId, selectedStoreText) {
  return ['<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">', '    <p class="store-address">', '        ' + store.address1 + '<br/>', '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode, '    </p>', '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>', '    <button class="select-store-button" data-store-id="' + store.storeId + '"' + (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>', '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE), '    </button>', '</li>'].join(newLine);
};

var storeListTemplate = function storeListTemplate(stores, selectedStoreId, selectedStoreText) {
  if (stores && stores.length) {
    return ['<div class="store-list-container">', '<ul class="store-list">', _.map(stores, function (store) {
      return storeTemplate(store, selectedStoreId, selectedStoreText);
    }).join(newLine), '</ul>', '</div>', '<div class="store-list-pagination">', '</div>'].join(newLine);
  } else {
    return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
  }
};

var zipPromptTemplate = function zipPromptTemplate() {
  return ['<div id="preferred-store-panel">', '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>', '</div>'].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function validateZipCode(zipCode) {
  var regexes = {
    canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
    usa: /^\d{5}(-\d{4})?$/
  },
      valid = false;
  if (!zipCode) {
    return;
  }
  _.each(regexes, function (re) {
    var regexp = new RegExp(re);
    valid = regexp.test(zipCode);
  });
  return valid;
};

var storeinventory = {
  zipPrompt: function zipPrompt(callback) {
    var self = this;
    dialog.open({
      html: zipPromptTemplate(),
      options: {
        title: Resources.STORE_NEAR_YOU,
        width: 500,
        buttons: [{
          text: Resources.SEARCH,
          click: function click() {
            var zipCode = $('#user-zip').val();
            if (validateZipCode(zipCode)) {
              self.setUserZip(zipCode);
              if (callback) {
                callback(zipCode);
              }
            }
          }
        }],
        open: function open() {
          $('#user-zip').on('keypress', function (e) {
            if (e.which === 13) {
              // trigger the search button
              $('.ui-dialog-buttonset .ui-button').trigger('click');
            }
          });
        }
      }
    });
  },
  getStoresInventory: function getStoresInventory(pid) {
    return TPromise.resolve($.ajax({
      url: util.appendParamsToUrl(Urls.storesInventory, {
        pid: pid,
        zipCode: User.zip
      }),
      dataType: 'json'
    }));
  },
  /**
   * @description open the dialog to select store
   * @param {Array} options.stores
   * @param {String} options.selectedStoreId
   * @param {String} options.selectedStoreText
   * @param {Function} options.continueCallback
   * @param {Function} options.selectStoreCallback
   **/
  selectStoreDialog: function selectStoreDialog(options) {
    var self = this,
        stores = options.stores,
        selectedStoreId = options.selectedStoreId,
        selectedStoreText = options.selectedStoreText,
        storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
    dialog.open({
      html: storeList,
      options: {
        title: Resources.SELECT_STORE + ' - ' + User.zip,
        buttons: [{
          text: Resources.CHANGE_LOCATION,
          click: function () {
            self.setUserZip(null);
            // trigger the event to start the process all over again
            $('.set-preferred-store').trigger('click');
          }.bind(this)
        }, {
          text: Resources.CONTINUE,
          click: function click() {
            if (options.continueCallback) {
              options.continueCallback(stores);
            }
            dialog.close();
          }
        }],
        open: function open() {
          $('.select-store-button').on('click', function (e) {
            e.preventDefault();
            var storeId = $(this).data('storeId');
            // if the store is already selected, don't select again
            if (storeId === selectedStoreId) {
              return;
            }
            $('.store-list .store-tile.selected').removeClass('selected').find('.select-store-button').text(Resources.SELECT_STORE);
            $(this).text(selectedStoreText).closest('.store-tile').addClass('selected');
            if (options.selectStoreCallback) {
              options.selectStoreCallback(storeId);
            }
          });
        }
      }
    });
  },
  setUserZip: function setUserZip(zip) {
    User.zip = zip;
    $.ajax({
      type: 'POST',
      url: Urls.setZipCode,
      data: {
        zipCode: zip
      }
    });
  },
  shippingLoad: function shippingLoad() {
    var $checkoutForm = $('.address');
    $checkoutForm.off('click');
    $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
      $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
    });
  }
};

module.exports = storeinventory;

},{"../dialog":12,"../util":77,"lodash":111,"promise":121}],74:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./'),
    util = require('../util');

var newLine = '\n';
var pdpStoreTemplate = function pdpStoreTemplate(store) {
  return ['<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">', '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode + ' ' + store.postalCode + '</div>', '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>', '</li>'].join(newLine);
};
var pdpStoresListingTemplate = function pdpStoresListingTemplate(stores) {
  if (stores && stores.length) {
    return ['<div class="store-list-pdp-container">', stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : '', '    <ul class="store-list-pdp">', _.map(stores, pdpStoreTemplate).join(newLine), '    </ul>', '</div>'].join(newLine);
  }
};

var storesListing = function storesListing(stores) {
  // list all stores on PDP page
  if ($('.store-list-pdp-container').length) {
    $('.store-list-pdp-container').remove();
  }
  $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
  setPreferredStore: function setPreferredStore(storeId) {
    User.storeId = storeId;
    $.ajax({
      url: Urls.setPreferredStore,
      type: 'POST',
      data: { storeId: storeId }
    });
  },
  productSelectStore: function productSelectStore() {
    var self = this;
    inventory.getStoresInventory(this.pid).then(function (stores) {
      inventory.selectStoreDialog({
        stores: stores,
        selectedStoreId: User.storeId,
        selectedStoreText: Resources.PREFERRED_STORE,
        continueCallback: storesListing,
        selectStoreCallback: self.setPreferredStore
      });
    }).done();
  },
  init: function init() {
    var $availabilityContainer = $('.availability-results'),
        self = this;
    this.pid = $('input[name="pid"]').val();

    $('#product-content .set-preferred-store').on('click', function (e) {
      e.preventDefault();
      if (!User.zip) {
        inventory.zipPrompt(function () {
          self.productSelectStore();
        });
      } else {
        self.productSelectStore();
      }
    });

    if ($availabilityContainer.length) {
      if (User.storeId) {
        inventory.getStoresInventory(this.pid).then(storesListing);
      }

      // See more or less stores in the listing
      $availabilityContainer.on('click', '.stores-toggle', function (e) {
        e.preventDefault();
        $('.store-list-pdp .store-list-item').toggleClass('visible');
        if ($(this).hasClass('collapsed')) {
          $(this).text(Resources.SEE_LESS);
        } else {
          $(this).text(Resources.SEE_MORE);
        }
        $(this).toggleClass('collapsed');
      });
    }

    if ($('.js-select-change_tab option').length == 0) {
      $('.cmd-select._auto').hide();
    }
  }
};

module.exports = productInventory;

$('#product-image-carousel').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  }]
});

$('#product-video-carousel').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  }]
});

},{"../util":77,"./":73,"lodash":111}],75:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
  // Use an external service to check the TLS of the browser
  // NOTE: this implementation uses https://www.howsmyssl.com
  //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
  var url = 'https://www.howsmyssl.com/a/check';
  var cookieName = 'dw_TLSWarning';
  var cookieValue = getCookie(cookieName);

  // Test to see if this browser has already been flagged by looking at its cookies
  if (!cookieValue) {
    getTLS(url, function (message) {
      if (message.length > 0) {
        showWarning(message[0]);

        // the browser is bad - set the cookie to true (for 15 minutes)
        util.setCookie(cookieName, 'true', 15);
      } else {
        // else the browser is good, set the cookie to false (for 30 days) so we don't check again
        util.setCookie(cookieName, 'false', 60 * 24 * 30);
      }
    });
  } else if (cookieValue === 'true') {
    // if we already know that this is an invalid browser, show the warning
    showWarning(Resources.TLS_WARNING);
  }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
  var message = [];

  // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
  var userAgent = navigator.userAgent;

  /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
  var badBrowsers = ['MSIE 6.0', 'MSIE 7.0', 'MSIE 8.0', 'MSIE 9.0', 'MSIE 10.0', 'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3', 'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
  function checkTLSLevel(data) {
    // If we can determine the TLS level, check to see if it's less than 1.2
    if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
      message.push(Resources.TLS_WARNING);
      callback(message);

      //If you want to track statistics on bad TLS hits, include this call
      $.ajax({ url: Urls.TLSBadTLS });
    }
  }

  function reportBadBrowser() {
    // If the TLS level cannot be determined just report that this browser is suspect
    message.push(Resources.TLS_WARNING);
    callback(message);

    //If you want to track statistics on deprecated browsers, include this call
    $.ajax({ url: Urls.TLSBadBrowser });
  }

  for (var i = 0; i < badBrowsers.length; i++) {
    if (userAgent.match(badBrowsers[i])) {
      // It's a suspect browser, let's see what it's TLS level is
      $.ajax({
        url: url
      }).done(checkTLSLevel).fail(reportBadBrowser);
      break;
    }
  }

  /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
  callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
  $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var tokens = cookies[i].split('=');
    var cookieKey = tokens[0].trim();
    if (cookieKey === key) {
      return tokens[1];
    }
  }
  return '';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{"./util":77}],76:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */

exports.init = function () {
  $(document).tooltip({
    items: '.tooltip',
    track: true,
    content: function content() {
      return $(this).find('.tooltip-content').html();
    }
  });

  $('.share-link').on('click', function (e) {
    e.preventDefault();
    var target = $(this).data('target');
    if (!target) {
      return;
    }
    $(target).toggleClass('active');
  });
};

},{}],77:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = require('lodash');
var validator = require('./validator');
var util = {
  filterArr: function filterArr(arr) {
    var finishedArr = new Array();

    arr.forEach(function (o) {
      if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object') {
        var finishedObj = new Object();

        Object.keys(o).forEach(function (k) {
          if (!o[k]) {
            return;
          }
          finishedObj[k] = o[k];
        });

        if (Object.keys(finishedObj).length > 0) {
          finishedArr.push(finishedObj);
        }
      } else if (!!o) {
        finishedArr.push(o);
      }
    });

    return finishedArr;
  },

  filterObj: function filterObj(o) {
    var finishedObj = {};

    Object.keys(o).forEach(function (k) {
      if (!o[k]) {
        return;
      } else if (o[k] instanceof Array) {
        finishedObj[k] = this.filterArr(o[k]);
      } else {
        finishedObj[k] = o[k];
      }
    }, this);

    return finishedObj;
  },

  /**
   * @function
   * @description appends the parameter with the given name and value to the given url and returns the changed url
   * @param {String} url the url to which the parameter will be added
   * @param {String} name the name of the parameter
   * @param {String} value the value of the parameter
   */
  appendParamToURL: function appendParamToURL(url, name, value) {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
      return url;
    }
    var separator = url.indexOf('?') !== -1 ? '&' : '?';

    return url + separator + name + '=' + encodeURIComponent(value);
  },

  /**
   * @function
   * @description remove the parameter and its value from the given url and returns the changed url
   * @param {String} url the url from which the parameter will be removed
   * @param {String} name the name of parameter that will be removed from url
   */
  removeParamFromURL: function removeParamFromURL(url, name) {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
      return url;
    }
    var hash;
    var params;
    var domain = url.split('?')[0];
    var paramUrl = url.split('?')[1];
    var newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
      hash = paramUrl.split('#')[1] || '';
      paramUrl = paramUrl.split('#')[0];
    }
    params = paramUrl.split('&');
    for (var i = 0; i < params.length; i++) {
      // put back param to newParams array if it is not the one to be removed
      if (params[i].split('=')[0] !== name) {
        newParams.push(params[i]);
      }
    }
    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
  },

  /**
   * @function
   * @description appends the parameters to the given url and returns the changed url
   * @param {String} url the url to which the parameters will be added
   * @param {Object} params
   */
  appendParamsToUrl: function appendParamsToUrl(url, params) {
    var _url = url;
    _.each(params, function (value, name) {
      _url = this.appendParamToURL(_url, name, value);
    }.bind(this));

    return _url;
  },
  /**
   * @function
   * @description extract the query string from URL
   * @param {String} url the url to extra query string from
   **/
  getQueryString: function getQueryString(url) {
    var qs;
    if (!_.isString(url)) {
      return;
    }
    var a = document.createElement('a');
    a.href = url;
    if (a.search) {
      qs = a.search.substr(1); // remove the leading ?
    }
    return qs;
  },

  updateQueryStringParam: function updateQueryStringParam(url, paramName, newVal) {
    var _url = url;

    if (_url.indexOf(paramName) === -1) {
      return _url;
    }

    var newParamObj = new Object();
    newParamObj[paramName] = newVal;

    _url = this.removeParamFromURL(_url, paramName);
    _url = this.appendParamsToUrl(_url, newParamObj);

    return _url;
  },

  getHashParam: function getHashParam(paramName) {
    var output = '';

    var hashParams = window.location.hash.replace('#', '').split('&');
    for (var i = 0; i < hashParams.length; i++) {
      if (hashParams[i].indexOf(paramName) > -1) {
        output = hashParams[i].split('=')[1];
      }
    }

    return output;
  },

  /**
   * @function
   * @description
   * @param {String}
   * @param {String}
   */
  elementInViewport: function elementInViewport(el, offsetToTop) {
    var top = el.offsetTop,
        left = el.offsetLeft,
        width = el.offsetWidth,
        height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    if (typeof offsetToTop !== 'undefined') {
      top -= offsetToTop;
    }

    if (window.pageXOffset !== null) {
      return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
    }

    if (document.compatMode === 'CSS1Compat') {
      return top < window.document.documentElement.scrollTop + window.document.documentElement.clientHeight && left < window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth && top + height > window.document.documentElement.scrollTop && left + width > window.document.documentElement.scrollLeft;
    }
  },

  /**
   * @function
   * @description Appends the parameter 'format=ajax' to a given path
   * @param {String} path the relative path
   */
  ajaxUrl: function ajaxUrl(path) {
    return this.appendParamToURL(path, 'format', 'ajax');
  },

  /**
   * @function
   * @description
   * @param {String} url
   */
  toAbsoluteUrl: function toAbsoluteUrl(url) {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
      url = '/' + url;
    }
    return url;
  },
  /**
   * @function
   * @description Loads css dynamically from given urls
   * @param {Array} urls Array of urls from which css will be dynamically loaded.
   */
  loadDynamicCss: function loadDynamicCss(urls) {
    var i,
        len = urls.length;
    for (i = 0; i < len; i++) {
      this.loadedCssFiles.push(this.loadCssFile(urls[i]));
    }
  },

  /**
   * @function
   * @description Loads css file dynamically from given url
   * @param {String} url The url from which css file will be dynamically loaded.
   */
  loadCssFile: function loadCssFile(url) {
    return $('<link/>').appendTo($('head')).attr({
      type: 'text/css',
      rel: 'stylesheet'
    }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
  },
  // array to keep track of the dynamically loaded CSS files
  loadedCssFiles: [],

  /**
   * @function
   * @description Removes all css files which were dynamically loaded
   */
  clearDynamicCss: function clearDynamicCss() {
    var i = this.loadedCssFiles.length;
    while (0 > i--) {
      $(this.loadedCssFiles[i]).remove();
    }
    this.loadedCssFiles = [];
  },

  /**
   * @function
   * @description Extracts all parameters from a given query string into an object
   * @param {String} qs The query string from which the parameters will be extracted
   */
  getQueryStringParams: function getQueryStringParams(qs) {
    if (!qs || qs.length === 0) {
      return {};
    }
    var params = {},
        unescapedQS = decodeURIComponent(qs);
    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
      params[$1] = $3;
    });
    return params;
  },

  fillAddressFields: function fillAddressFields(address, $form) {
    for (var field in address) {
      if (field === 'ID' || field === 'UUID' || field === 'key') {
        continue;
      }
      // if the key in address object ends with 'Code', remove that suffix
      // keys that ends with 'Code' are postalCode, stateCode and countryCode
      $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
      // update the state fields
      if (field === 'countryCode') {
        $form.find('[name$="country"]').trigger('change');
        // retrigger state selection after country has changed
        // this results in duplication of the state code, but is a necessary evil
        // for now because sometimes countryCode comes after stateCode
        $form.find('[name$="state"]').val(address.stateCode);
      }
    }
  },
  /**
   * @function
   * @description Updates the number of the remaining character
   * based on the character limit in a text area
   */
  limitCharacters: function limitCharacters() {
    $('form').find('textarea[data-character-limit]').each(function () {
      var characterLimit = $(this).data('character-limit');
      var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG, '<span class="countnow">0</span>', '<span class="countlimit">' + characterLimit + '</span>');

      //if window size is small then char-count should be after
      var containerPlacement = $(this).prev('p.c-textarea-count');
      var containerInsert = $('<p class="c-textarea-count"/>').insertBefore($(this));

      if ($(window).width() < 640) {
        containerPlacement = $(this).next('p.c-textarea-count');
        containerInsert = $('<p class="c-textarea-count"/>').insertAfter($(this));
      }

      var charCountContainer = containerPlacement;
      if (charCountContainer.length === 0) {
        charCountContainer = containerInsert;
      }
      charCountContainer.html(charCountHtml);
      // trigger the keydown event so that any existing character data is calculated
      $(this).change();
    });

    $('form').find('textarea[maxlength]').each(function () {
      if ($(this).data('character-limit') !== undefined || $(this).parent().find('.c-textarea-count').length) {
        return;
      }
      var characterLimit = $(this).attr('maxlength');
      var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG_BOT, '<span class="countlimit">' + characterLimit + '</span>');

      var containerPlacement = $(this).next('p.c-textarea-count');
      var containerInsert = $('<p class="c-textarea-count js-countDown is-bottom"/>').insertAfter($(this));
      var charCountContainer = containerPlacement;
      if (charCountContainer.length === 0) {
        charCountContainer = containerInsert;
      }
      charCountContainer.html(charCountHtml);
      // trigger the keydown event so that any existing character data is calculated
      $(this).change();
    });
  },
  /**
   * @function
   * @description Binds the onclick-event to a delete button on a given container,
   * which opens a confirmation box with a given message
   * @param {String} container The name of element to which the function will be bind
   * @param {String} message The message the will be shown upon a click
   */
  setDeleteConfirmation: function setDeleteConfirmation(container, message) {
    $(container).on('click', '.delete', function () {
      return window.confirm(message);
    });
  },
  /**
   * @function
   * @description Scrolls a browser window to a given x point
   * @param {String} The x coordinate
   */
  scrollBrowser: function scrollBrowser(xLocation) {
    $('html, body').animate({ scrollTop: xLocation }, 500);
  },

  isMobile: function isMobile() {
    var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
    var idx = 0;
    var isMobile = false;
    var userAgent = navigator.userAgent.toLowerCase();

    while (mobileAgentHash[idx] && !isMobile) {
      isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
      idx++;
    }
    return isMobile;
  },

  /**
   * @function getCookieSelector
   * @description Returns the cookie value
   **/
  getCookieSelector: function getCookieSelector(cookieName) {
    var regularExpression = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
    var regExp = new RegExp(regularExpression, '');

    return document.cookie.replace(regExp, '$1');
  },

  /**
   * @function setCookie
   *
   * @param {string} key - The cookie name
   * @param {string} value - The cookie value
   * @param {integer} minutes - The number of minutes to expire the cookie
   **/
  setCookie: function setCookie(key, value, minutes) {
    var duration = '';

    if (minutes) {
      var date = new Date();

      date.setTime(date.getTime() + minutes * 60 * 1000);

      duration = ' expires=' + date.toGMTString() + ';';
    }

    document.cookie = key + '=' + value + ';' + duration + ' path=/';
  },

  /**
   * @function validateEmail
   *
   * @description Returns boolean
   * @param {string} emailAddress - The email address
   **/
  validateEmail: function validateEmail(emailAddress) {
    var emailRegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$');

    return emailRegExp.test(emailAddress);
  },

  /**
   * @function validateMessage
   *
   * @description Returns boolean
   * @param {string} message - The message
   **/
  validateMessage: function validateMessage(message) {
    var country = 'other';

    if (window.User.locale) {
      switch (window.User.locale) {
        case 'default':
        case 'en_SG':
        case 'en_ID':
        case 'en_MY':
          break;
        case 'en':
          country = 'int';
          break;
        default:
          country = window.User.locale.slice(-2).toLowerCase();
          break;
      }
    }
    var messageRegExp = validator.regex.message[country];

    return messageRegExp.test(message);
  },

  /**
   * @function maximizeCheckoutSummary
   *
   * @description Maximizes/Expands the Order Checkout Summary
   **/
  maximizeCheckoutSummary: function maximizeCheckoutSummary() {
    if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
      $('.accordion-navigation').addClass('is-active');
      $('.accordion-title').attr('aria-expanded', true);
      $('.accordion-title').attr('aria-selected', true);
      $('#panel11a').css('display', 'block');
    }
  }
};

module.exports = util;

},{"./validator":78,"lodash":111}],78:[function(require,module,exports){
'use strict';

var formPrepare = require('./pages/checkout/formPrepare');

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
  phone: {
    ca: /^\d{10}$/,
    hk: /^\d{8}$/,
    id: /^\d{10,11}$/,
    int: /^\d{1,30}$/,
    jp: /^\d{10,11}$/,
    kr: /^\d{10,11}$/,
    my: /^\d{10,11}$/,
    ru: /^\d{10}$/,
    sg: /^\d{8}$/,
    th: /^\d{9,10}$/,
    tw: /^\d{10}$/,
    vn: /^\d{10,11}$/,
    us: naPhone,
    fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
    it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
    cn: /.*/,
    gb: /^((\(?0\d{4}\)?\s?\d{3}\s?\d{3})|(\(?0\d{3}\)?\s?\d{3}\s?\d{4})|(\(?0\d{2}\)?\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/,
    other: /^\(?([0-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
  },
  postal: {
    ca: /^([0-9]){6}$/,
    id: /^([0-9]){5}$/,
    jp: /^([0-9]){7}$/,
    kr: /^([0-9]){6}$/,
    my: /^([0-9]){5}$/,
    ru: /^([0-9]){6}$/,
    sg: /^([0-9]){6}$/,
    th: /^([0-9]){5}$/,
    tw: /^([0-9]){5}$/,
    vn: /^([0-9]){6}$/,
    us: /^\d{5}(-\d{4})?$/,
    fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
    it: /^([0-9]){5}$/,
    cn: /^([0-9]){6}$/,
    gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
    other: /^\d{5}(-\d{4})?$/
  },
  name: {
    ca: /^[a-zA-ZÀ-ÿ ]+$/,
    hk: /^[豈-舘㐀-䶵一-鿏 ]+$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 ]+$/,
    int: /.+/,
    jp: /^[一-龥ぁ-ゔァ-ヴー々〆〤]+$/,
    ru: /^[Ѐ-ӷ ]+$/,
    th: /^[ก-๛ ]+$/,
    tw: /^[豈-舘㐀-䶵一-鿏 ]+$/,
    vn: /^[ A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]+$/,
    other: /^[a-zA-Z\s.-]*$/
  },
  simpletext: {
    ca: /^[a-zA-ZÀ-ÿ 0-9-.,']+$/,
    hk: /^[豈-舘㐀-䶵一-鿏 0-9-.,']+$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 0-9-.,']+$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤　０-９－0-9-。、’]+$/,
    ru: /^[Ѐ-ӷ 0-9-.,']+$/,
    th: /^[ก-๛ 0-9-.,']+$/,
    tw: /^[豈-舘㐀-䶵一-鿏 0-9-.,']+$/,
    vn: /^[ ',-9A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]+$/,
    other: /^[0-9a-zA-Z .,'-]*$/
  },
  addr2regex: {
    ca: /^[a-zA-ZÀ-ÿａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    hk: /^[豈-舘㐀-䶵一-鿏a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    kr: /^[a-zA-Zᄀ-ᇿㄱ-ㆎ가-힣a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-。、’＃]*$/,
    ru: /^[Ѐ-ӷa-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    th: /^[ก-๛a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    tw: /^[豈-舘㐀-䶵一-鿏a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    vn: /^[ #',-9A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9\u3000\uFF0D\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]*$/,
    other: /^[0-9a-zA-Z .,'#]*$/
  },
  message: {
    ca: /^[a-zA-ZÀ-ÿ 0-9-.,'!?;:()"\n]*$/,
    hk: /^[豈-舘㐀-䶵一-鿏 0-9-.,'!?;:()"\n]*$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 0-9-.,'!?;:()"\n]*$/,
    int: /^[\s\S]*$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤　０-９－0-9-。、’！？；：（）”\n]*$/,
    ru: /^[Ѐ-ӷ 0-9-.,'!?;:()"\n]*$/,
    th: /^[ก-๛ 0-9-.,'!?;:()"\n]*$/,
    tw: /^[豈-舘㐀-䶵一-鿏 0-9-.,'!?;:()"\n]*$/,
    vn: /^[\n -"'-\),-\.0-;\?A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xDD\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\xFD\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]*$/,
    other: /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/
  },
  notCC: /^(?!(([0-9 -]){13,19}))([a-zA-Z0-9 .-]*)$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,12}$/,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i,
  hasPOBox: /[p]+(ost)*\.*\s*[o|0]+(ffice)*\.*\s*b[o|0]x/gi,
  ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
  cvn: /^\d{3,4}$/,
  cvn_amex: /^\d{4}$/,
  cvn_visa: /^\d{3}$/,
  cvn_master: /^\d{3}$/,
  cvn_diners: /^\d{3}$/,
  cvn_union: /^\d{3}$/,
  alphanumeric: /^[a-z0-9]*$/i
};
var nameKana = /^[ァ-ヶー]+$/;
// global form validator settings
var settings = {
  errorClass: 'jquery-validation is-error',
  errorElement: 'p',
  onkeyup: false,
  onfocusout: function onfocusout(element) {
    if (!this.checkable(element) || element.className.indexOf('required') > -1) {
      this.element(element);
    }

    // remove label error class
    if (!$(element).hasClass('is-error')) {
      // remove error message when no error
      if ($(element).parent().find('.c-text-error').length > 0) {
        $(element).parent().find('.c-text-error').remove();
      }
      if ($(element).parent().find('p[id="' + $(element).attr('id') + '-error"]').length > 0) {
        $(element).parent().find('p[id="' + $(element).attr('id') + '-error"]').remove();
      }
      if ($(element).parent('.c-input-group').length == 1) {
        $(element).parent().parent().children('.c-text-error').remove();
        $(element).parent().parent().children('.c-input-label').first().removeClass('is-error');
      }
      if ($(element).hasClass('pcemail') || $(element).hasClass('spemail')) {
        $(element).parent().find('.c-input-label').first().removeClass('is-error');
      } else if ($(element).prev().hasClass('c-input-label')) {
        $(element).prev().removeClass('is-error');
        if ($(element).parent().next().children().hasClass('jquery-validation is-error') && $(element).closest('.credit-card-account').length > 0) {
          // remove message validate on register payment account
          $(element).parent().next().remove();
        }
      } else if ($(element).parent().prev().hasClass('c-input-label') && $(element).closest('.credit-card-account').length > 0) {
        // remove tag content message validate on register payment account
        $(element).parent().prev().removeClass('is-error');
        if ($(element).closest('.c-col.c-col_08').next().children().hasClass('jquery-validation is-error')) {
          $(element).closest('.c-col.c-col_08').next().remove();
        }
      } else if ($(element).hasClass('c-input-box')) {
        if ($(element).closest('.shipping-address-checkout').length == 1) {
          //remove class is-error for shipping address of checkout page
          $(element).closest('.cmd-form_box').find('p.cmd-form_ttl').removeClass('is-error');
        } else {
          $(element).parent().parent().prev().removeClass('is-error');
        }
      } else if ($(element).parents('.cmd-form_box').length === 1) {
        if ($(element).parents('.cmd-form_input').length === 1) {
          $(element).parent().prev().removeClass('is-error');
        } else if ($(element).closest('.shipping-address-checkout').length == 1) {
          // remove class is error for label select box state on shipping address page
          $(element).closest('.cmd-form_box').find('p.cmd-form_ttl').removeClass('is-error');
        } else {
          $(element).prev().removeClass('is-error');
        }
      } else {
        $(element).parent().parent().prev().removeClass('is-error');
      }
    } else {
      // add label error class
      if ($(element).hasClass('pcemail') || $(element).hasClass('spemail')) {
        $(element).parent().find('.c-input-label').first().addClass('is-error');
      } else if ($(element).prev().hasClass('c-input-label')) {
        $(element).prev().addClass('is-error');
      } else if ($(element).hasClass('c-input-box') && $(element).closest('.shipping-address-checkout').length == 1) {
        // add label error class for shipping address on checkout shipping page
        $(element).closest('.cmd-form_box').find('p.cmd-form_ttl').addClass('is-error');
      } else if ($(element).hasClass('c-input-box')) {
        $(element).parent().parent().prev().addClass('is-error');
      } else if ($(element).parents('.cmd-form_box').length === 1) {
        if ($(element).parents('.cmd-form_input').length === 1) {
          $(element).parent().prev().addClass('is-error');
        } else {
          $(element).prev().addClass('is-error');
        }
      } else {
        $(element).parent().parent().prev().addClass('is-error');
      }
    }
  },
  errorPlacement: function errorPlacement(error, element) {
    // insert error message
    if ($(element).prop('type') === 'checkbox') {
      error.insertAfter($(element).parent());
    } else if ($(element).parent('.c-input-group').length == 1) {
      if ($(element).parent().parent().find('.c-text-error').length == 0) {
        error.insertAfter($(element).parent());
      } else {
        $(element).parent().parent().find('.c-text-error').remove();
        error.insertAfter($(element).parent());
      }
    } else if (element.parents('.cmd-form_box').length === 1) {
      error.insertAfter(element.parent());
    } else if (element.closest('.credit-card-account').length > 0) {
      if (element.closest('.c-input-group--card').length > 0) {
        error.insertAfter($(element).parent().parent()).wrap('<li class="c-col c-col_08" />');
      } else {
        error.insertAfter($(element).parent()).wrap('<li class="c-col c-col_08" />');
      }
    } else {
      if ($(element).parent().find('.c-text-error').length == 0) {
        if ($(element).parents('form.news-letter-form .ge-footer-connectWithUs-check').length) {
          error.insertAfter($(element).next());
        } else {
          if (element.prev('p.c-input-label').length === 0) {
            element.parent().parent().prev().addClass('is-error');
          } else if (element.attr('name').indexOf('passwordconfirm') > -1) {
            element.prev().addClass('is-error');
          }
          error.insertAfter($(element));
        }
      } else {
        $(element).parent().find('.c-text-error').remove();
        error.insertAfter($(element));
      }
    }
    // add class error for ul tag
    if ($(element).closest($('form.news-letter-form')).length == 1) {
      error.addClass('c-text-error');
    } else if ($(element).attr('id') == 'dwfrm_profile_tempcustomer_email' || $(element).attr('id') == 'dwfrm_profile_tempcustomer_emailconfirm' || $(element).attr('id') == 'dwfrm_contactus_comment' || $(element).attr('id') == 'dwfrm_requestpassword_email' || $(element).attr('id') == 'dwfrm_requestpassword_postal' || $(element).closest('#RegistrationForm').length > 0 || $(element).closest('#ChangeUsername').length > 0 || $(element).closest('#ChangePasswordForm').length > 0 || $(element).closest('.credit-card-account').length > 0 || $(element).closest('#OmotionAuthForm').length > 0) {
      error.addClass('c-input-label');
    } else {
      error.addClass('c-text-error c-text-error--simple');
    }
    // add class error for label
    if (element.closest('.credit-card-account').length > 0) {
      // add label error class for register payment on account - payment page
      error.parent().prev().children('p.c-input-label').addClass('is-error');
    } else if (element.closest('.shipping-address-checkout').length == 1) {
      // add label error class for shipping address on check out shipping page
      $(element).closest('.cmd-form_box').find('p.cmd-form_ttl').addClass('is-error');
    } else {
      error.parent().find('.c-input-label').first().addClass('is-error');
    }
    // clear error message when has `no-display-error` attribute in the field
    if (error.parent().find('input[no-display-error]').length > 0) {
      error.remove();
    }
  },
  ignore: ':hidden, .ignore'
};

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = function (arr) {
  return function (ccNum) {
    // luhn check only in production.
    if (Constants.INSTANCE_TYPE != Constants.INSTANCE_TYPE_PRODUCTION) {
      return true;
    }
    var len = ccNum.length;
    var bit = 1;
    var sum = 0;
    var val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

/**
 * @function
 * @description Determine the current country
 * @param {String} el The input field
 * @param {Object} regex The type of regex
 */
function findSelectedCountry(el, regex) {
  var selectedCountry = 'other';
  var country = 'sg';

  if (window.User.locale) {
    switch (window.User.locale) {
      case 'default':
        break;
      case 'en':
        country = 'int';
        break;
      default:
        country = window.User.locale.slice(-2).toLowerCase();
        break;
    }
  }

  if (regex[country]) {
    selectedCountry = country;
  }
  return selectedCountry;
}

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function validateOwner(value) {
  var isValid = regex.notCC.test($.trim(value));
  return isValid;
};

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod('alphanumeric', function (value) {
  var isValid = regex.alphanumeric.test($.trim(value));
  return isValid;
}, simpleTextMessage);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
  var isOptional = this.optional(el);
  var isValid = !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
  return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
  if ($.trim(value).length === 0) {
    return true;
  }
  return !isNaN(value) && Number(value) >= 0;
}, ''); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod('number', function (value) {
  // number == Credit card number
  var isValid = luhnCheck($.trim(value));
  return isValid;
}, Resources.VALIDATE_CREDIT_NUMBER);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod('cvn', function (value, el) {
  // Visa
  var visa_regex = new RegExp('^4[0-9]{0,15}$'),

  // MasterCard
  mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),

  // American Express
  amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),

  // Diners 300-305,3095,36,38-39
  diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),

  // UnionPay
  unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

  var isValid = false;
  var $form = $(el).closest('form');
  var cur_val = $form.find('input[name$="_number"]').val();

  // get rid of spaces and dashes before using the regular expression
  cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

  if (cur_val.match(visa_regex)) {
    isValid = regex.cvn_visa.test($.trim(value));
  } else if (cur_val.match(mastercard_regex)) {
    isValid = regex.cvn_master.test($.trim(value));
  } else if (cur_val.match(amex_regex)) {
    isValid = regex.cvn_amex.test($.trim(value));
  } else if (cur_val.match(diners_regex)) {
    isValid = regex.cvn_diners.test($.trim(value));
  } else if (cur_val.match(unionpay_regex)) {
    isValid = regex.cvn_union.test($.trim(value));
  } else {
    isValid = regex.cvn.test($.trim(value));
  }

  return isValid;
}, Resources.VALIDATE_CVN);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod('ordernumber', function (value) {
  var isValid = regex.ordernumber.test($.trim(value));
  return isValid;
}, Resources.INVALID_ORDER_NUMBER);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod('equal-to', function (value, el) {
  var equalTo = $(el).attr('equal-to');
  var $equalToEl = $(el).closest('form').find(equalTo);

  return value === $equalToEl.val();
}, function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_EQUALTO;
});

$.validator.addMethod('regexp', function (value, el) {
  var pattern = $(el).attr('pattern');
  if (!pattern || !$(el).val()) {
    return true;
  }
  var re = new RegExp(pattern);
  return re.test($.trim(value));
}, function (value, el) {
  return $(el).attr('data-parse-error-text') || Resources.VALIDATE_REGEXP;
});

// Validators for multi-field relations.

var addressFormNames = ['state', 'city', 'address1', 'address2', 'address3'];
var primaryAddressFormNames = ['state', 'city', 'address1'];

function validateAddress(value) {
  var primaryAddresses = primaryAddressFormNames.map(function (name) {
    return $('[name$="_' + name + '"]');
  });

  var allAddresses = addressFormNames.map(function (name) {
    return $('[name$="_' + name + '"]');
  }).filter(function ($item) {
    return $item.length > 0;
  });

  if (allAddresses.some(function ($item) {
    return $item.val();
  })) {
    return value && value.length > 0 || primaryAddresses.every(function ($item) {
      return $item.val();
    });
  }

  return true;
}

function validateAddressForDM(value) {
  var addToDMListElement = $('[name$="_addtodirectmaillist"]');
  if (addToDMListElement.data('home-address-fullfilled') !== undefined) {
    return addToDMListElement.data('home-address-fullfilled') || !addToDMListElement.prop('checked');
  }
  var primaryAddresses = primaryAddressFormNames.map(function (name) {
    return $('[name$="_' + name + '"]');
  });
  if (addToDMListElement.length > 0 && addToDMListElement.prop('checked')) {
    return value && value.length > 0 || primaryAddresses.every(function ($item) {
      return $item.val();
    });
  }
  return true;
}

function validateConfirm(value, el, param) {
  var $form = $(el).closest('form');
  var actualValueSelector = param.dynamic ? 'input[name*="_' + param.actual + '_"]' : 'input[name$="_' + param.actual + '"]';
  var actualValue = $form.find(actualValueSelector).val();
  return actualValue === value;
}

function requireOther(value, el, param) {
  var $form = $(el).closest('form');
  var $target = param.target ? $form.find('[name$="_' + param.target + '"]') : $(el);
  if (param.source) {
    var valueExists = param.source.some(function (src) {
      var $source = $form.find('[name$="_' + src.name + '"]');
      return src.value && src.value === $source.val() || $source.prop('checked');
    });
    return !valueExists || $target.val();
  }
  if (param.value && param.value === $(el).val() || $(el).prop('checked')) {
    return $target.val();
  }
  return true;
}

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod('create-password', function (value) {
  //Not same as local part of email address
  if ($(this.currentForm).find('input[name$="_email"]').length > 0) {
    if ($('input[name$="_email"]').val().split('@')[0].indexOf(value) > -1) {
      return false;
    }
  }
  return true;
}, Resources.VALIDATE_PASSWORD);

$.validator.addMethod('addressForDM', validateAddressForDM, Resources.VALIDATE_ADDRESS_FOR_DM);
$.validator.addMethod('primaryAddress', validateAddress, Resources.VALIDATE_ADDRESS);
$.validator.addMethod('confirmValue', validateConfirm, Resources.VALIDATE_EQUALTO);
$.validator.addMethod('requireOther', requireOther, function (value, el) {
  var message = $(el).attr('data-require-other-text');
  return message || Resources.VALIDATE_REQUIRE_OTHER;
});

$.validator.addClassRules('addtodirectmaillist', { addressForDM: true });
$.validator.addClassRules('state', {
  addressForDM: true,
  primaryAddress: true
});
$.validator.addClassRules('city', { addressForDM: true, primaryAddress: true });
$.validator.addClassRules('address1', {
  addressForDM: true,
  primaryAddress: true
});
$.validator.addClassRules('emailconfirm', {
  confirmValue: { actual: 'email' }
});
$.validator.addClassRules('pcemailconfirm', {
  confirmValue: { actual: 'pcemail' }
});
$.validator.addClassRules('spemailconfirm', {
  confirmValue: { actual: 'spemail' }
});
$.validator.addClassRules('passwordconfirm', {
  confirmValue: { actual: 'password', dynamic: true }
});
$.validator.addClassRules('newpasswordconfirm', {
  confirmValue: { actual: 'newpassword', dynamic: true }
});
$.validator.addClassRules('spemail', {
  requireOther: {
    source: [{ name: 'mobilemailmagazine' }, { name: 'useemail', value: '2' }]
  }
});
$.validator.addClassRules('mobilemailmagazine', {
  requireOther: { target: 'spemail' }
});
$.validator.addClassRules('useemail', {
  requireOther: { target: 'spemail', value: '2' }
});

var requiredMessage = function requiredMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var simpleTextMessage = function simpleTextMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var passwordMessage = function passwordMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_PASSWORD;
};

$.extend($.validator.messages, {
  required: Resources.VALIDATE_REQUIRED,
  remote: Resources.VALIDATE_REMOTE,
  email: Resources.VALIDATE_EMAIL,
  address1: Resources.ADDRESS_PO_BOX_ERROR,
  password: passwordMessage,
  url: Resources.VALIDATE_URL,
  date: Resources.VALIDATE_DATE,
  dateISO: Resources.VALIDATE_DATEISO,
  number: Resources.VALIDATE_CREDIT_NUMBER,
  digits: Resources.VALIDATE_DIGITS,
  creditcard: Resources.VALIDATE_CREDITCARD,
  equalTo: Resources.VALIDATE_EQUALTO,
  maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
  minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
  rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
  range: $.validator.format(Resources.VALIDATE_RANGE),
  max: $.validator.format(Resources.VALIDATE_MAX),
  min: $.validator.format(Resources.VALIDATE_MIN),
  postal: Resources.INVALID_ZIP,
  message: Resources.INVALID_MESSAGE,
  fullname: simpleTextMessage,
  simpletext: simpleTextMessage,
  alphanumeric: simpleTextMessage
});
// Updated code to populate green tick check if the password meets the requirements.
var validator = {
  regex: regex,
  settings: settings,
  init: function init() {
    var _self = this;
    $('form:not(.suppress)').each(function () {
      _self.initForm(this);
    });
  },
  initForm: function initForm(f) {
    var _self = this;
    var $form = $(f);
    var $submitForm = $form.find('button[type="submit"], input[type="submit"]').not('.ignore');
    var fp = formPrepare();
    fp.init({
      formSelector: $form,
      continueSelector: $submitForm
    }, _self.settings);
  }
};

module.exports = validator;

},{"./pages/checkout/formPrepare":36}],79:[function(require,module,exports){
'use strict';

var modal = require('./modal').global;

module.exports = {
  init: function init(cb) {
    if (typeof window.YT !== 'undefined') {
      if (cb !== undefined) {
        return cb();
      } else {
        return;
      }
    }

    window.onYouTubeIframeAPIReady = cb;

    // load youtube iframe api
    var tag = document.createElement('script');

    tag.async = true;
    tag.src = 'https://www.youtube.com/iframe_api';

    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  },

  playInline: function playInline($ele, videoId) {
    var eleId = $ele.attr('id');
    if (!eleId || !videoId) {
      return;
    }

    new YT.Player(eleId, {
      videoId: videoId,
      width: $ele.width(),
      height: $ele.height(),
      playerVars: { rel: 0 },
      events: {
        onReady: function onReady(evt) {
          var player = evt.target;
          player.playVideo();
        }
      }
    });
  },

  playInModal: function playInModal(videoId) {
    if (!videoId) {
      return;
    }

    modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

    new YT.Player('video-player', {
      videoId: videoId,
      events: {
        onReady: function onReady(evt) {
          var player = evt.target;
          modal.events.onOpen(function () {
            var modalBodyWidth = $('.modal-body').width();
            //$("#video-player").width(modalBodyWidth);
            player.playVideo();
          });
          modal.events.onClose(function () {
            player.destroy();
          });
          modal.open();
        }
      }
    });
  }
};

},{"./modal":24}],80:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":81}],81:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],82:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);

},{"./functionApply":83,"./functionCall":84,"./reflectApply":86,"function-bind":100}],83:[function(require,module,exports){
'use strict';

/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;

},{}],84:[function(require,module,exports){
'use strict';

/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;

},{}],85:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var $TypeError = require('es-errors/type');

var $call = require('./functionCall');
var $actualApply = require('./actualApply');

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};

},{"./actualApply":82,"./functionCall":84,"es-errors/type":95,"function-bind":100}],86:[function(require,module,exports){
'use strict';

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

},{}],87:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBindBasic = require('call-bind-apply-helpers');

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};

},{"call-bind-apply-helpers":85,"get-intrinsic":101}],88:[function(require,module,exports){
'use strict';

var callBind = require('call-bind-apply-helpers');
var gOPD = require('gopd');

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;

},{"call-bind-apply-helpers":85,"gopd":106}],89:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;

},{}],90:[function(require,module,exports){
'use strict';

/** @type {import('./eval')} */
module.exports = EvalError;

},{}],91:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Error;

},{}],92:[function(require,module,exports){
'use strict';

/** @type {import('./range')} */
module.exports = RangeError;

},{}],93:[function(require,module,exports){
'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;

},{}],94:[function(require,module,exports){
'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;

},{}],95:[function(require,module,exports){
'use strict';

/** @type {import('./type')} */
module.exports = TypeError;

},{}],96:[function(require,module,exports){
'use strict';

/** @type {import('./uri')} */
module.exports = URIError;

},{}],97:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
module.exports = Object;

},{}],98:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],99:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],100:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":99}],101:[function(require,module,exports){
'use strict';

var undefined;

var $Object = require('es-object-atoms');

var $Error = require('es-errors');
var $EvalError = require('es-errors/eval');
var $RangeError = require('es-errors/range');
var $ReferenceError = require('es-errors/ref');
var $SyntaxError = require('es-errors/syntax');
var $TypeError = require('es-errors/type');
var $URIError = require('es-errors/uri');

var abs = require('math-intrinsics/abs');
var floor = require('math-intrinsics/floor');
var max = require('math-intrinsics/max');
var min = require('math-intrinsics/min');
var pow = require('math-intrinsics/pow');
var round = require('math-intrinsics/round');
var sign = require('math-intrinsics/sign');

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = require('gopd');
var $defineProperty = require('es-define-property');

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = require('get-proto');
var $ObjectGPO = require('get-proto/Object.getPrototypeOf');
var $ReflectGPO = require('get-proto/Reflect.getPrototypeOf');

var $apply = require('call-bind-apply-helpers/functionApply');
var $call = require('call-bind-apply-helpers/functionCall');

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('hasown');
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"call-bind-apply-helpers/functionApply":83,"call-bind-apply-helpers/functionCall":84,"es-define-property":89,"es-errors":91,"es-errors/eval":90,"es-errors/range":92,"es-errors/ref":93,"es-errors/syntax":94,"es-errors/type":95,"es-errors/uri":96,"es-object-atoms":97,"function-bind":100,"get-proto":104,"get-proto/Object.getPrototypeOf":102,"get-proto/Reflect.getPrototypeOf":103,"gopd":106,"has-symbols":107,"hasown":109,"math-intrinsics/abs":112,"math-intrinsics/floor":113,"math-intrinsics/max":115,"math-intrinsics/min":116,"math-intrinsics/pow":117,"math-intrinsics/round":118,"math-intrinsics/sign":119}],102:[function(require,module,exports){
'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;

},{"es-object-atoms":97}],103:[function(require,module,exports){
'use strict';

/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;

},{}],104:[function(require,module,exports){
'use strict';

var reflectGetProto = require('./Reflect.getPrototypeOf');
var originalGetProto = require('./Object.getPrototypeOf');

var getDunderProto = require('dunder-proto/get');

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;

},{"./Object.getPrototypeOf":102,"./Reflect.getPrototypeOf":103,"dunder-proto/get":88}],105:[function(require,module,exports){
'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;

},{}],106:[function(require,module,exports){
'use strict';

/** @type {import('.')} */
var $gOPD = require('./gOPD');

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;

},{"./gOPD":105}],107:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":108}],108:[function(require,module,exports){
'use strict';

/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],109:[function(require,module,exports){
'use strict';

var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = require('function-bind');

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);

},{"function-bind":100}],110:[function(require,module,exports){
/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  var queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = extend( {}, this.options );
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});

},{"ev-emitter":98}],111:[function(require,module,exports){
(function (global){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.18.1';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`',
      INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution:
      // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      while (++index < length) {
        var key = toKey(path[index]);

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        baseAssignValue(result, pair[0], pair[1]);
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      arrayEach(importsKeys, function(key) {
        if (reForbiddenIdentifierChars.test(key)) {
          throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
        }
      });

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],112:[function(require,module,exports){
'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;

},{}],113:[function(require,module,exports){
'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;

},{}],114:[function(require,module,exports){
'use strict';

/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],115:[function(require,module,exports){
'use strict';

/** @type {import('./max')} */
module.exports = Math.max;

},{}],116:[function(require,module,exports){
'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

},{}],117:[function(require,module,exports){
'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;

},{}],118:[function(require,module,exports){
'use strict';

/** @type {import('./round')} */
module.exports = Math.round;

},{}],119:[function(require,module,exports){
'use strict';

var $isNaN = require('./isNaN');

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};

},{"./isNaN":114}],120:[function(require,module,exports){
(function (global){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./util.inspect":138}],121:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":126}],122:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._x = 0;
  this._y = 0;
  this._z = null;
  this._A = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._B = null;
Promise._C = null;
Promise._D = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._y === 3) {
    self = self._z;
  }
  if (Promise._B) {
    Promise._B(self);
  }
  if (self._y === 0) {
    if (self._x === 0) {
      self._x = 1;
      self._A = deferred;
      return;
    }
    if (self._x === 1) {
      self._x = 2;
      self._A = [self._A, deferred];
      return;
    }
    self._A.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._y === 1) {
        resolve(deferred.promise, self._z);
      } else {
        reject(deferred.promise, self._z);
      }
      return;
    }
    var ret = tryCallOne(cb, self._z);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._y = 3;
      self._z = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._y = 1;
  self._z = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._y = 2;
  self._z = newValue;
  if (Promise._C) {
    Promise._C(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._x === 1) {
    handle(self, self._A);
    self._A = null;
  }
  if (self._x === 2) {
    for (var i = 0; i < self._A.length; i++) {
      handle(self, self._A[i]);
    }
    self._A = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":81}],123:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":122}],124:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._D);
  p._y = 1;
  p._z = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

var iterableToArray = function (iterable) {
  if (typeof Array.from === 'function') {
    // ES2015+, iterables exist
    iterableToArray = Array.from;
    return Array.from(iterable);
  }

  // ES5, only arrays and array-likes exist
  iterableToArray = function (x) { return Array.prototype.slice.call(x); };
  return Array.prototype.slice.call(iterable);
}

Promise.all = function (arr) {
  var args = iterableToArray(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._y === 3) {
            val = val._z;
          }
          if (val._y === 1) return res(i, val._z);
          if (val._y === 2) reject(val._z);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

function onSettledFulfill(value) {
  return { status: 'fulfilled', value: value };
}
function onSettledReject(reason) {
  return { status: 'rejected', reason: reason };
}
function mapAllSettled(item) {
  if(item && (typeof item === 'object' || typeof item === 'function')){
    if(item instanceof Promise && item.then === Promise.prototype.then){
      return item.then(onSettledFulfill, onSettledReject);
    }
    var then = item.then;
    if (typeof then === 'function') {
      return new Promise(then.bind(item)).then(onSettledFulfill, onSettledReject)
    }
  }

  return onSettledFulfill(item);
}
Promise.allSettled = function (iterable) {
  return Promise.all(iterableToArray(iterable).map(mapAllSettled));
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    iterableToArray(values).forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

function getAggregateError(errors){
  if(typeof AggregateError === 'function'){
    return new AggregateError(errors,'All promises were rejected');
  }

  var error = new Error('All promises were rejected');

  error.name = 'AggregateError';
  error.errors = errors;

  return error;
}

Promise.any = function promiseAny(values) {
  return new Promise(function(resolve, reject) {
    var promises = iterableToArray(values);
    var hasResolved = false;
    var rejectionReasons = [];

    function resolveOnce(value) {
      if (!hasResolved) {
        hasResolved = true;
        resolve(value);
      }
    }

    function rejectionCheck(reason) {
      rejectionReasons.push(reason);

      if (rejectionReasons.length === promises.length) {
        reject(getAggregateError(rejectionReasons));
      }
    }

    if(promises.length === 0){
      reject(getAggregateError(rejectionReasons));
    } else {
      promises.forEach(function(value){
        Promise.resolve(value).then(resolveOnce, rejectionCheck);
      });
    }
  });
};

},{"./core.js":122}],125:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.finally = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":122}],126:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":122,"./done.js":123,"./es6-extensions.js":124,"./finally.js":125,"./node-extensions.js":127,"./synchronous.js":128}],127:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":122,"asap":80}],128:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._y === 3) {
      return this._z.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._z;
  };

  Promise.prototype.getReason = function () {
    if (this._y === 3) {
      return this._z.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._z;
  };

  Promise.prototype.getState = function () {
    if (this._y === 3) {
      return this._z.getState();
    }
    if (this._y === -1 || this._y === -2) {
      return 0;
    }

    return this._y;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":122}],129:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};

},{}],130:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":129,"./parse":131,"./stringify":132}],131:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = parent;
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = segment[1];
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};

},{"./utils":133}],132:[function(require,module,exports){
'use strict';

var getSideChannel = require('side-channel');
var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":129,"./utils":133,"side-channel":137}],133:[function(require,module,exports){
'use strict';

var formats = require('./formats');
var getSideChannel = require('side-channel');

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};

},{"./formats":129,"side-channel":137}],134:[function(require,module,exports){
'use strict';

var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};

},{"es-errors/type":95,"object-inspect":120}],135:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');

var $TypeError = require('es-errors/type');
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};

},{"call-bound":87,"es-errors/type":95,"get-intrinsic":101,"object-inspect":120}],136:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bound');
var inspect = require('object-inspect');
var getSideChannelMap = require('side-channel-map');

var $TypeError = require('es-errors/type');
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;

},{"call-bound":87,"es-errors/type":95,"get-intrinsic":101,"object-inspect":120,"side-channel-map":135}],137:[function(require,module,exports){
'use strict';

var $TypeError = require('es-errors/type');
var inspect = require('object-inspect');
var getSideChannelList = require('side-channel-list');
var getSideChannelMap = require('side-channel-map');
var getSideChannelWeakMap = require('side-channel-weakmap');

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};

},{"es-errors/type":95,"object-inspect":120,"side-channel-list":134,"side-channel-map":135,"side-channel-weakmap":136}],138:[function(require,module,exports){

},{}],139:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],140:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],141:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],142:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":140,"./encode":141}],143:[function(require,module,exports){
/*!
 * URI.js - Mutating URLs
 * IPv6 Support
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(factory);
  } else {
    // Browser globals (root is window)
    root.IPv6 = factory(root);
  }
}(this, function (root) {
  'use strict';

  /*
  var _in = "fe80:0000:0000:0000:0204:61ff:fe9d:f156";
  var _out = IPv6.best(_in);
  var _expected = "fe80::204:61ff:fe9d:f156";

  console.log(_in, _out, _expected, _out === _expected);
  */

  // save current IPv6 variable, if any
  var _IPv6 = root && root.IPv6;

  function bestPresentation(address) {
    // based on:
    // Javascript to test an IPv6 address for proper format, and to
    // present the "best text representation" according to IETF Draft RFC at
    // http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04
    // 8 Feb 2010 Rich Brown, Dartware, LLC
    // Please feel free to use this code as long as you provide a link to
    // http://www.intermapper.com
    // http://intermapper.com/support/tools/IPV6-Validator.aspx
    // http://download.dartware.com/thirdparty/ipv6validator.js

    var _address = address.toLowerCase();
    var segments = _address.split(':');
    var length = segments.length;
    var total = 8;

    // trim colons (:: or ::a:b:c… or …a:b:c::)
    if (segments[0] === '' && segments[1] === '' && segments[2] === '') {
      // must have been ::
      // remove first two items
      segments.shift();
      segments.shift();
    } else if (segments[0] === '' && segments[1] === '') {
      // must have been ::xxxx
      // remove the first item
      segments.shift();
    } else if (segments[length - 1] === '' && segments[length - 2] === '') {
      // must have been xxxx::
      segments.pop();
    }

    length = segments.length;

    // adjust total segments for IPv4 trailer
    if (segments[length - 1].indexOf('.') !== -1) {
      // found a "." which means IPv4
      total = 7;
    }

    // fill empty segments them with "0000"
    var pos;
    for (pos = 0; pos < length; pos++) {
      if (segments[pos] === '') {
        break;
      }
    }

    if (pos < total) {
      segments.splice(pos, 1, '0000');
      while (segments.length < total) {
        segments.splice(pos, 0, '0000');
      }
    }

    // strip leading zeros
    var _segments;
    for (var i = 0; i < total; i++) {
      _segments = segments[i].split('');
      for (var j = 0; j < 3 ; j++) {
        if (_segments[0] === '0' && _segments.length > 1) {
          _segments.splice(0,1);
        } else {
          break;
        }
      }

      segments[i] = _segments.join('');
    }

    // find longest sequence of zeroes and coalesce them into one segment
    var best = -1;
    var _best = 0;
    var _current = 0;
    var current = -1;
    var inzeroes = false;
    // i; already declared

    for (i = 0; i < total; i++) {
      if (inzeroes) {
        if (segments[i] === '0') {
          _current += 1;
        } else {
          inzeroes = false;
          if (_current > _best) {
            best = current;
            _best = _current;
          }
        }
      } else {
        if (segments[i] === '0') {
          inzeroes = true;
          current = i;
          _current = 1;
        }
      }
    }

    if (_current > _best) {
      best = current;
      _best = _current;
    }

    if (_best > 1) {
      segments.splice(best, _best, '');
    }

    length = segments.length;

    // assemble remaining segments
    var result = '';
    if (segments[0] === '')  {
      result = ':';
    }

    for (i = 0; i < length; i++) {
      result += segments[i];
      if (i === length - 1) {
        break;
      }

      result += ':';
    }

    if (segments[length - 1] === '') {
      result += ':';
    }

    return result;
  }

  function noConflict() {
    /*jshint validthis: true */
    if (root.IPv6 === this) {
      root.IPv6 = _IPv6;
    }

    return this;
  }

  return {
    best: bestPresentation,
    noConflict: noConflict
  };
}));

},{}],144:[function(require,module,exports){
/*!
 * URI.js - Mutating URLs
 * Second Level Domain (SLD) Support
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */

(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(factory);
  } else {
    // Browser globals (root is window)
    root.SecondLevelDomains = factory(root);
  }
}(this, function (root) {
  'use strict';

  // save current SecondLevelDomains variable, if any
  var _SecondLevelDomains = root && root.SecondLevelDomains;

  var SLD = {
    // list of known Second Level Domains
    // converted list of SLDs from https://github.com/gavingmiller/second-level-domains
    // ----
    // publicsuffix.org is more current and actually used by a couple of browsers internally.
    // downside is it also contains domains like "dyndns.org" - which is fine for the security
    // issues browser have to deal with (SOP for cookies, etc) - but is way overboard for URI.js
    // ----
    list: {
      'ac':' com gov mil net org ',
      'ae':' ac co gov mil name net org pro sch ',
      'af':' com edu gov net org ',
      'al':' com edu gov mil net org ',
      'ao':' co ed gv it og pb ',
      'ar':' com edu gob gov int mil net org tur ',
      'at':' ac co gv or ',
      'au':' asn com csiro edu gov id net org ',
      'ba':' co com edu gov mil net org rs unbi unmo unsa untz unze ',
      'bb':' biz co com edu gov info net org store tv ',
      'bh':' biz cc com edu gov info net org ',
      'bn':' com edu gov net org ',
      'bo':' com edu gob gov int mil net org tv ',
      'br':' adm adv agr am arq art ato b bio blog bmd cim cng cnt com coop ecn edu eng esp etc eti far flog fm fnd fot fst g12 ggf gov imb ind inf jor jus lel mat med mil mus net nom not ntr odo org ppg pro psc psi qsl rec slg srv tmp trd tur tv vet vlog wiki zlg ',
      'bs':' com edu gov net org ',
      'bz':' du et om ov rg ',
      'ca':' ab bc mb nb nf nl ns nt nu on pe qc sk yk ',
      'ck':' biz co edu gen gov info net org ',
      'cn':' ac ah bj com cq edu fj gd gov gs gx gz ha hb he hi hl hn jl js jx ln mil net nm nx org qh sc sd sh sn sx tj tw xj xz yn zj ',
      'co':' com edu gov mil net nom org ',
      'cr':' ac c co ed fi go or sa ',
      'cy':' ac biz com ekloges gov ltd name net org parliament press pro tm ',
      'do':' art com edu gob gov mil net org sld web ',
      'dz':' art asso com edu gov net org pol ',
      'ec':' com edu fin gov info med mil net org pro ',
      'eg':' com edu eun gov mil name net org sci ',
      'er':' com edu gov ind mil net org rochest w ',
      'es':' com edu gob nom org ',
      'et':' biz com edu gov info name net org ',
      'fj':' ac biz com info mil name net org pro ',
      'fk':' ac co gov net nom org ',
      'fr':' asso com f gouv nom prd presse tm ',
      'gg':' co net org ',
      'gh':' com edu gov mil org ',
      'gn':' ac com gov net org ',
      'gr':' com edu gov mil net org ',
      'gt':' com edu gob ind mil net org ',
      'gu':' com edu gov net org ',
      'hk':' com edu gov idv net org ',
      'hu':' 2000 agrar bolt casino city co erotica erotika film forum games hotel info ingatlan jogasz konyvelo lakas media news org priv reklam sex shop sport suli szex tm tozsde utazas video ',
      'id':' ac co go mil net or sch web ',
      'il':' ac co gov idf k12 muni net org ',
      'in':' ac co edu ernet firm gen gov i ind mil net nic org res ',
      'iq':' com edu gov i mil net org ',
      'ir':' ac co dnssec gov i id net org sch ',
      'it':' edu gov ',
      'je':' co net org ',
      'jo':' com edu gov mil name net org sch ',
      'jp':' ac ad co ed go gr lg ne or ',
      'ke':' ac co go info me mobi ne or sc ',
      'kh':' com edu gov mil net org per ',
      'ki':' biz com de edu gov info mob net org tel ',
      'km':' asso com coop edu gouv k medecin mil nom notaires pharmaciens presse tm veterinaire ',
      'kn':' edu gov net org ',
      'kr':' ac busan chungbuk chungnam co daegu daejeon es gangwon go gwangju gyeongbuk gyeonggi gyeongnam hs incheon jeju jeonbuk jeonnam k kg mil ms ne or pe re sc seoul ulsan ',
      'kw':' com edu gov net org ',
      'ky':' com edu gov net org ',
      'kz':' com edu gov mil net org ',
      'lb':' com edu gov net org ',
      'lk':' assn com edu gov grp hotel int ltd net ngo org sch soc web ',
      'lr':' com edu gov net org ',
      'lv':' asn com conf edu gov id mil net org ',
      'ly':' com edu gov id med net org plc sch ',
      'ma':' ac co gov m net org press ',
      'mc':' asso tm ',
      'me':' ac co edu gov its net org priv ',
      'mg':' com edu gov mil nom org prd tm ',
      'mk':' com edu gov inf name net org pro ',
      'ml':' com edu gov net org presse ',
      'mn':' edu gov org ',
      'mo':' com edu gov net org ',
      'mt':' com edu gov net org ',
      'mv':' aero biz com coop edu gov info int mil museum name net org pro ',
      'mw':' ac co com coop edu gov int museum net org ',
      'mx':' com edu gob net org ',
      'my':' com edu gov mil name net org sch ',
      'nf':' arts com firm info net other per rec store web ',
      'ng':' biz com edu gov mil mobi name net org sch ',
      'ni':' ac co com edu gob mil net nom org ',
      'np':' com edu gov mil net org ',
      'nr':' biz com edu gov info net org ',
      'om':' ac biz co com edu gov med mil museum net org pro sch ',
      'pe':' com edu gob mil net nom org sld ',
      'ph':' com edu gov i mil net ngo org ',
      'pk':' biz com edu fam gob gok gon gop gos gov net org web ',
      'pl':' art bialystok biz com edu gda gdansk gorzow gov info katowice krakow lodz lublin mil net ngo olsztyn org poznan pwr radom slupsk szczecin torun warszawa waw wroc wroclaw zgora ',
      'pr':' ac biz com edu est gov info isla name net org pro prof ',
      'ps':' com edu gov net org plo sec ',
      'pw':' belau co ed go ne or ',
      'ro':' arts com firm info nom nt org rec store tm www ',
      'rs':' ac co edu gov in org ',
      'sb':' com edu gov net org ',
      'sc':' com edu gov net org ',
      'sh':' co com edu gov net nom org ',
      'sl':' com edu gov net org ',
      'st':' co com consulado edu embaixada gov mil net org principe saotome store ',
      'sv':' com edu gob org red ',
      'sz':' ac co org ',
      'tr':' av bbs bel biz com dr edu gen gov info k12 name net org pol tel tsk tv web ',
      'tt':' aero biz cat co com coop edu gov info int jobs mil mobi museum name net org pro tel travel ',
      'tw':' club com ebiz edu game gov idv mil net org ',
      'mu':' ac co com gov net or org ',
      'mz':' ac co edu gov org ',
      'na':' co com ',
      'nz':' ac co cri geek gen govt health iwi maori mil net org parliament school ',
      'pa':' abo ac com edu gob ing med net nom org sld ',
      'pt':' com edu gov int net nome org publ ',
      'py':' com edu gov mil net org ',
      'qa':' com edu gov mil net org ',
      're':' asso com nom ',
      'ru':' ac adygeya altai amur arkhangelsk astrakhan bashkiria belgorod bir bryansk buryatia cbg chel chelyabinsk chita chukotka chuvashia com dagestan e-burg edu gov grozny int irkutsk ivanovo izhevsk jar joshkar-ola kalmykia kaluga kamchatka karelia kazan kchr kemerovo khabarovsk khakassia khv kirov koenig komi kostroma kranoyarsk kuban kurgan kursk lipetsk magadan mari mari-el marine mil mordovia mosreg msk murmansk nalchik net nnov nov novosibirsk nsk omsk orenburg org oryol penza perm pp pskov ptz rnd ryazan sakhalin samara saratov simbirsk smolensk spb stavropol stv surgut tambov tatarstan tom tomsk tsaritsyn tsk tula tuva tver tyumen udm udmurtia ulan-ude vladikavkaz vladimir vladivostok volgograd vologda voronezh vrn vyatka yakutia yamal yekaterinburg yuzhno-sakhalinsk ',
      'rw':' ac co com edu gouv gov int mil net ',
      'sa':' com edu gov med net org pub sch ',
      'sd':' com edu gov info med net org tv ',
      'se':' a ac b bd c d e f g h i k l m n o org p parti pp press r s t tm u w x y z ',
      'sg':' com edu gov idn net org per ',
      'sn':' art com edu gouv org perso univ ',
      'sy':' com edu gov mil net news org ',
      'th':' ac co go in mi net or ',
      'tj':' ac biz co com edu go gov info int mil name net nic org test web ',
      'tn':' agrinet com defense edunet ens fin gov ind info intl mincom nat net org perso rnrt rns rnu tourism ',
      'tz':' ac co go ne or ',
      'ua':' biz cherkassy chernigov chernovtsy ck cn co com crimea cv dn dnepropetrovsk donetsk dp edu gov if in ivano-frankivsk kh kharkov kherson khmelnitskiy kiev kirovograd km kr ks kv lg lugansk lutsk lviv me mk net nikolaev od odessa org pl poltava pp rovno rv sebastopol sumy te ternopil uzhgorod vinnica vn zaporizhzhe zhitomir zp zt ',
      'ug':' ac co go ne or org sc ',
      'uk':' ac bl british-library co cym gov govt icnet jet lea ltd me mil mod national-library-scotland nel net nhs nic nls org orgn parliament plc police sch scot soc ',
      'us':' dni fed isa kids nsn ',
      'uy':' com edu gub mil net org ',
      've':' co com edu gob info mil net org web ',
      'vi':' co com k12 net org ',
      'vn':' ac biz com edu gov health info int name net org pro ',
      'ye':' co com gov ltd me net org plc ',
      'yu':' ac co edu gov org ',
      'za':' ac agric alt bourse city co cybernet db edu gov grondar iaccess imt inca landesign law mil net ngo nis nom olivetti org pix school tm web ',
      'zm':' ac co com edu gov net org sch ',
      // https://en.wikipedia.org/wiki/CentralNic#Second-level_domains
      'com': 'ar br cn de eu gb gr hu jpn kr no qc ru sa se uk us uy za ',
      'net': 'gb jp se uk ',
      'org': 'ae',
      'de': 'com '
    },
    // gorhill 2013-10-25: Using indexOf() instead Regexp(). Significant boost
    // in both performance and memory footprint. No initialization required.
    // http://jsperf.com/uri-js-sld-regex-vs-binary-search/4
    // Following methods use lastIndexOf() rather than array.split() in order
    // to avoid any memory allocations.
    has: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') >= 0;
    },
    is: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return false;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset >= 0) {
        return false;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return false;
      }
      return sldList.indexOf(' ' + domain.slice(0, tldOffset) + ' ') >= 0;
    },
    get: function(domain) {
      var tldOffset = domain.lastIndexOf('.');
      if (tldOffset <= 0 || tldOffset >= (domain.length-1)) {
        return null;
      }
      var sldOffset = domain.lastIndexOf('.', tldOffset-1);
      if (sldOffset <= 0 || sldOffset >= (tldOffset-1)) {
        return null;
      }
      var sldList = SLD.list[domain.slice(tldOffset+1)];
      if (!sldList) {
        return null;
      }
      if (sldList.indexOf(' ' + domain.slice(sldOffset+1, tldOffset) + ' ') < 0) {
        return null;
      }
      return domain.slice(sldOffset+1);
    },
    noConflict: function(){
      if (root.SecondLevelDomains === this) {
        root.SecondLevelDomains = _SecondLevelDomains;
      }
      return this;
    }
  };

  return SLD;
}));

},{}],145:[function(require,module,exports){
/*!
 * URI.js - Mutating URLs
 *
 * Version: 1.19.2
 *
 * Author: Rodney Rehm
 * Web: http://medialize.github.io/URI.js/
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 */
(function (root, factory) {
  'use strict';
  // https://github.com/umdjs/umd/blob/master/returnExports.js
  if (typeof module === 'object' && module.exports) {
    // Node
    module.exports = factory(require('./punycode'), require('./IPv6'), require('./SecondLevelDomains'));
  } else if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['./punycode', './IPv6', './SecondLevelDomains'], factory);
  } else {
    // Browser globals (root is window)
    root.URI = factory(root.punycode, root.IPv6, root.SecondLevelDomains, root);
  }
}(this, function (punycode, IPv6, SLD, root) {
  'use strict';
  /*global location, escape, unescape */
  // FIXME: v2.0.0 renamce non-camelCase properties to uppercase
  /*jshint camelcase: false */

  // save current URI variable, if any
  var _URI = root && root.URI;

  function URI(url, base) {
    var _urlSupplied = arguments.length >= 1;
    var _baseSupplied = arguments.length >= 2;

    // Allow instantiation without the 'new' keyword
    if (!(this instanceof URI)) {
      if (_urlSupplied) {
        if (_baseSupplied) {
          return new URI(url, base);
        }

        return new URI(url);
      }

      return new URI();
    }

    if (url === undefined) {
      if (_urlSupplied) {
        throw new TypeError('undefined is not a valid argument for URI');
      }

      if (typeof location !== 'undefined') {
        url = location.href + '';
      } else {
        url = '';
      }
    }

    if (url === null) {
      if (_urlSupplied) {
        throw new TypeError('null is not a valid argument for URI');
      }
    }

    this.href(url);

    // resolve to base according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#constructor
    if (base !== undefined) {
      return this.absoluteTo(base);
    }

    return this;
  }

  function isInteger(value) {
    return /^[0-9]+$/.test(value);
  }

  URI.version = '1.19.2';

  var p = URI.prototype;
  var hasOwn = Object.prototype.hasOwnProperty;

  function escapeRegEx(string) {
    // https://github.com/medialize/URI.js/commit/85ac21783c11f8ccab06106dba9735a31a86924d#commitcomment-821963
    return string.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
  }

  function getType(value) {
    // IE8 doesn't return [Object Undefined] but [Object Object] for undefined value
    if (value === undefined) {
      return 'Undefined';
    }

    return String(Object.prototype.toString.call(value)).slice(8, -1);
  }

  function isArray(obj) {
    return getType(obj) === 'Array';
  }

  function filterArrayValues(data, value) {
    var lookup = {};
    var i, length;

    if (getType(value) === 'RegExp') {
      lookup = null;
    } else if (isArray(value)) {
      for (i = 0, length = value.length; i < length; i++) {
        lookup[value[i]] = true;
      }
    } else {
      lookup[value] = true;
    }

    for (i = 0, length = data.length; i < length; i++) {
      /*jshint laxbreak: true */
      var _match = lookup && lookup[data[i]] !== undefined
        || !lookup && value.test(data[i]);
      /*jshint laxbreak: false */
      if (_match) {
        data.splice(i, 1);
        length--;
        i--;
      }
    }

    return data;
  }

  function arrayContains(list, value) {
    var i, length;

    // value may be string, number, array, regexp
    if (isArray(value)) {
      // Note: this can be optimized to O(n) (instead of current O(m * n))
      for (i = 0, length = value.length; i < length; i++) {
        if (!arrayContains(list, value[i])) {
          return false;
        }
      }

      return true;
    }

    var _type = getType(value);
    for (i = 0, length = list.length; i < length; i++) {
      if (_type === 'RegExp') {
        if (typeof list[i] === 'string' && list[i].match(value)) {
          return true;
        }
      } else if (list[i] === value) {
        return true;
      }
    }

    return false;
  }

  function arraysEqual(one, two) {
    if (!isArray(one) || !isArray(two)) {
      return false;
    }

    // arrays can't be equal if they have different amount of content
    if (one.length !== two.length) {
      return false;
    }

    one.sort();
    two.sort();

    for (var i = 0, l = one.length; i < l; i++) {
      if (one[i] !== two[i]) {
        return false;
      }
    }

    return true;
  }

  function trimSlashes(text) {
    var trim_expression = /^\/+|\/+$/g;
    return text.replace(trim_expression, '');
  }

  URI._parts = function() {
    return {
      protocol: null,
      username: null,
      password: null,
      hostname: null,
      urn: null,
      port: null,
      path: null,
      query: null,
      fragment: null,
      // state
      preventInvalidHostname: URI.preventInvalidHostname,
      duplicateQueryParameters: URI.duplicateQueryParameters,
      escapeQuerySpace: URI.escapeQuerySpace
    };
  };
  // state: throw on invalid hostname
  // see https://github.com/medialize/URI.js/pull/345
  // and https://github.com/medialize/URI.js/issues/354
  URI.preventInvalidHostname = false;
  // state: allow duplicate query parameters (a=1&a=1)
  URI.duplicateQueryParameters = false;
  // state: replaces + with %20 (space in query strings)
  URI.escapeQuerySpace = true;
  // static properties
  URI.protocol_expression = /^[a-z][a-z0-9.+-]*$/i;
  URI.idn_expression = /[^a-z0-9\._-]/i;
  URI.punycode_expression = /(xn--)/i;
  // well, 333.444.555.666 matches, but it sure ain't no IPv4 - do we care?
  URI.ip4_expression = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
  // credits to Rich Brown
  // source: http://forums.intermapper.com/viewtopic.php?p=1096#1096
  // specification: http://www.ietf.org/rfc/rfc4291.txt
  URI.ip6_expression = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
  // expression used is "gruber revised" (@gruber v2) determined to be the
  // best solution in a regex-golf we did a couple of ages ago at
  // * http://mathiasbynens.be/demo/url-regex
  // * http://rodneyrehm.de/t/url-regex.html
  URI.find_uri_expression = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/ig;
  URI.findUri = {
    // valid "scheme://" or "www."
    start: /\b(?:([a-z][a-z0-9.+-]*:\/\/)|www\.)/gi,
    // everything up to the next whitespace
    end: /[\s\r\n]|$/,
    // trim trailing punctuation captured by end RegExp
    trim: /[`!()\[\]{};:'".,<>?«»“”„‘’]+$/,
    // balanced parens inclusion (), [], {}, <>
    parens: /(\([^\)]*\)|\[[^\]]*\]|\{[^}]*\}|<[^>]*>)/g,
  };
  // http://www.iana.org/assignments/uri-schemes.html
  // http://en.wikipedia.org/wiki/List_of_TCP_and_UDP_port_numbers#Well-known_ports
  URI.defaultPorts = {
    http: '80',
    https: '443',
    ftp: '21',
    gopher: '70',
    ws: '80',
    wss: '443'
  };
  // list of protocols which always require a hostname
  URI.hostProtocols = [
    'http',
    'https'
  ];

  // allowed hostname characters according to RFC 3986
  // ALPHA DIGIT "-" "." "_" "~" "!" "$" "&" "'" "(" ")" "*" "+" "," ";" "=" %encoded
  // I've never seen a (non-IDN) hostname other than: ALPHA DIGIT . - _
  URI.invalid_hostname_characters = /[^a-zA-Z0-9\.\-:_]/;
  // map DOM Elements to their URI attribute
  URI.domAttributes = {
    'a': 'href',
    'blockquote': 'cite',
    'link': 'href',
    'base': 'href',
    'script': 'src',
    'form': 'action',
    'img': 'src',
    'area': 'href',
    'iframe': 'src',
    'embed': 'src',
    'source': 'src',
    'track': 'src',
    'input': 'src', // but only if type="image"
    'audio': 'src',
    'video': 'src'
  };
  URI.getDomAttribute = function(node) {
    if (!node || !node.nodeName) {
      return undefined;
    }

    var nodeName = node.nodeName.toLowerCase();
    // <input> should only expose src for type="image"
    if (nodeName === 'input' && node.type !== 'image') {
      return undefined;
    }

    return URI.domAttributes[nodeName];
  };

  function escapeForDumbFirefox36(value) {
    // https://github.com/medialize/URI.js/issues/91
    return escape(value);
  }

  // encoding / decoding according to RFC3986
  function strictEncodeURIComponent(string) {
    // see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/encodeURIComponent
    return encodeURIComponent(string)
      .replace(/[!'()*]/g, escapeForDumbFirefox36)
      .replace(/\*/g, '%2A');
  }
  URI.encode = strictEncodeURIComponent;
  URI.decode = decodeURIComponent;
  URI.iso8859 = function() {
    URI.encode = escape;
    URI.decode = unescape;
  };
  URI.unicode = function() {
    URI.encode = strictEncodeURIComponent;
    URI.decode = decodeURIComponent;
  };
  URI.characters = {
    pathname: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(24|26|2B|2C|3B|3D|3A|40)/ig,
        map: {
          // -._~!'()*
          '%24': '$',
          '%26': '&',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%3A': ':',
          '%40': '@'
        }
      },
      decode: {
        expression: /[\/\?#]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23'
        }
      }
    },
    reserved: {
      encode: {
        // RFC3986 2.1: For consistency, URI producers and normalizers should
        // use uppercase hexadecimal digits for all percent-encodings.
        expression: /%(21|23|24|26|27|28|29|2A|2B|2C|2F|3A|3B|3D|3F|40|5B|5D)/ig,
        map: {
          // gen-delims
          '%3A': ':',
          '%2F': '/',
          '%3F': '?',
          '%23': '#',
          '%5B': '[',
          '%5D': ']',
          '%40': '@',
          // sub-delims
          '%21': '!',
          '%24': '$',
          '%26': '&',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '='
        }
      }
    },
    urnpath: {
      // The characters under `encode` are the characters called out by RFC 2141 as being acceptable
      // for usage in a URN. RFC2141 also calls out "-", ".", and "_" as acceptable characters, but
      // these aren't encoded by encodeURIComponent, so we don't have to call them out here. Also
      // note that the colon character is not featured in the encoding map; this is because URI.js
      // gives the colons in URNs semantic meaning as the delimiters of path segements, and so it
      // should not appear unencoded in a segment itself.
      // See also the note above about RFC3986 and capitalalized hex digits.
      encode: {
        expression: /%(21|24|27|28|29|2A|2B|2C|3B|3D|40)/ig,
        map: {
          '%21': '!',
          '%24': '$',
          '%27': '\'',
          '%28': '(',
          '%29': ')',
          '%2A': '*',
          '%2B': '+',
          '%2C': ',',
          '%3B': ';',
          '%3D': '=',
          '%40': '@'
        }
      },
      // These characters are the characters called out by RFC2141 as "reserved" characters that
      // should never appear in a URN, plus the colon character (see note above).
      decode: {
        expression: /[\/\?#:]/g,
        map: {
          '/': '%2F',
          '?': '%3F',
          '#': '%23',
          ':': '%3A'
        }
      }
    }
  };
  URI.encodeQuery = function(string, escapeQuerySpace) {
    var escaped = URI.encode(string + '');
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    return escapeQuerySpace ? escaped.replace(/%20/g, '+') : escaped;
  };
  URI.decodeQuery = function(string, escapeQuerySpace) {
    string += '';
    if (escapeQuerySpace === undefined) {
      escapeQuerySpace = URI.escapeQuerySpace;
    }

    try {
      return URI.decode(escapeQuerySpace ? string.replace(/\+/g, '%20') : string);
    } catch(e) {
      // we're not going to mess with weird encodings,
      // give up and return the undecoded original string
      // see https://github.com/medialize/URI.js/issues/87
      // see https://github.com/medialize/URI.js/issues/92
      return string;
    }
  };
  // generate encode/decode path functions
  var _parts = {'encode':'encode', 'decode':'decode'};
  var _part;
  var generateAccessor = function(_group, _part) {
    return function(string) {
      try {
        return URI[_part](string + '').replace(URI.characters[_group][_part].expression, function(c) {
          return URI.characters[_group][_part].map[c];
        });
      } catch (e) {
        // we're not going to mess with weird encodings,
        // give up and return the undecoded original string
        // see https://github.com/medialize/URI.js/issues/87
        // see https://github.com/medialize/URI.js/issues/92
        return string;
      }
    };
  };

  for (_part in _parts) {
    URI[_part + 'PathSegment'] = generateAccessor('pathname', _parts[_part]);
    URI[_part + 'UrnPathSegment'] = generateAccessor('urnpath', _parts[_part]);
  }

  var generateSegmentedPathFunction = function(_sep, _codingFuncName, _innerCodingFuncName) {
    return function(string) {
      // Why pass in names of functions, rather than the function objects themselves? The
      // definitions of some functions (but in particular, URI.decode) will occasionally change due
      // to URI.js having ISO8859 and Unicode modes. Passing in the name and getting it will ensure
      // that the functions we use here are "fresh".
      var actualCodingFunc;
      if (!_innerCodingFuncName) {
        actualCodingFunc = URI[_codingFuncName];
      } else {
        actualCodingFunc = function(string) {
          return URI[_codingFuncName](URI[_innerCodingFuncName](string));
        };
      }

      var segments = (string + '').split(_sep);

      for (var i = 0, length = segments.length; i < length; i++) {
        segments[i] = actualCodingFunc(segments[i]);
      }

      return segments.join(_sep);
    };
  };

  // This takes place outside the above loop because we don't want, e.g., encodeUrnPath functions.
  URI.decodePath = generateSegmentedPathFunction('/', 'decodePathSegment');
  URI.decodeUrnPath = generateSegmentedPathFunction(':', 'decodeUrnPathSegment');
  URI.recodePath = generateSegmentedPathFunction('/', 'encodePathSegment', 'decode');
  URI.recodeUrnPath = generateSegmentedPathFunction(':', 'encodeUrnPathSegment', 'decode');

  URI.encodeReserved = generateAccessor('reserved', 'encode');

  URI.parse = function(string, parts) {
    var pos;
    if (!parts) {
      parts = {
        preventInvalidHostname: URI.preventInvalidHostname
      };
    }
    // [protocol"://"[username[":"password]"@"]hostname[":"port]"/"?][path]["?"querystring]["#"fragment]

    // extract fragment
    pos = string.indexOf('#');
    if (pos > -1) {
      // escaping?
      parts.fragment = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract query
    pos = string.indexOf('?');
    if (pos > -1) {
      // escaping?
      parts.query = string.substring(pos + 1) || null;
      string = string.substring(0, pos);
    }

    // extract protocol
    if (string.substring(0, 2) === '//') {
      // relative-scheme
      parts.protocol = null;
      string = string.substring(2);
      // extract "user:pass@host:port"
      string = URI.parseAuthority(string, parts);
    } else {
      pos = string.indexOf(':');
      if (pos > -1) {
        parts.protocol = string.substring(0, pos) || null;
        if (parts.protocol && !parts.protocol.match(URI.protocol_expression)) {
          // : may be within the path
          parts.protocol = undefined;
        } else if (string.substring(pos + 1, pos + 3) === '//') {
          string = string.substring(pos + 3);

          // extract "user:pass@host:port"
          string = URI.parseAuthority(string, parts);
        } else {
          string = string.substring(pos + 1);
          parts.urn = true;
        }
      }
    }

    // what's left must be the path
    parts.path = string;

    // and we're done
    return parts;
  };
  URI.parseHost = function(string, parts) {
    if (!string) {
      string = '';
    }

    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://github.com/joyent/node/blob/386fd24f49b0e9d1a8a076592a404168faeecc34/lib/url.js#L115-L124
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    // https://github.com/medialize/URI.js/pull/233
    string = string.replace(/\\/g, '/');

    // extract host:port
    var pos = string.indexOf('/');
    var bracketPos;
    var t;

    if (pos === -1) {
      pos = string.length;
    }

    if (string.charAt(0) === '[') {
      // IPv6 host - http://tools.ietf.org/html/draft-ietf-6man-text-addr-representation-04#section-6
      // I claim most client software breaks on IPv6 anyways. To simplify things, URI only accepts
      // IPv6+port in the format [2001:db8::1]:80 (for the time being)
      bracketPos = string.indexOf(']');
      parts.hostname = string.substring(1, bracketPos) || null;
      parts.port = string.substring(bracketPos + 2, pos) || null;
      if (parts.port === '/') {
        parts.port = null;
      }
    } else {
      var firstColon = string.indexOf(':');
      var firstSlash = string.indexOf('/');
      var nextColon = string.indexOf(':', firstColon + 1);
      if (nextColon !== -1 && (firstSlash === -1 || nextColon < firstSlash)) {
        // IPv6 host contains multiple colons - but no port
        // this notation is actually not allowed by RFC 3986, but we're a liberal parser
        parts.hostname = string.substring(0, pos) || null;
        parts.port = null;
      } else {
        t = string.substring(0, pos).split(':');
        parts.hostname = t[0] || null;
        parts.port = t[1] || null;
      }
    }

    if (parts.hostname && string.substring(pos).charAt(0) !== '/') {
      pos++;
      string = '/' + string;
    }

    if (parts.preventInvalidHostname) {
      URI.ensureValidHostname(parts.hostname, parts.protocol);
    }

    if (parts.port) {
      URI.ensureValidPort(parts.port);
    }

    return string.substring(pos) || '/';
  };
  URI.parseAuthority = function(string, parts) {
    string = URI.parseUserinfo(string, parts);
    return URI.parseHost(string, parts);
  };
  URI.parseUserinfo = function(string, parts) {
    // extract username:password
    var firstSlash = string.indexOf('/');
    var pos = string.lastIndexOf('@', firstSlash > -1 ? firstSlash : string.length - 1);
    var t;

    // authority@ must come before /path
    if (pos > -1 && (firstSlash === -1 || pos < firstSlash)) {
      t = string.substring(0, pos).split(':');
      parts.username = t[0] ? URI.decode(t[0]) : null;
      t.shift();
      parts.password = t[0] ? URI.decode(t.join(':')) : null;
      string = string.substring(pos + 1);
    } else {
      parts.username = null;
      parts.password = null;
    }

    return string;
  };
  URI.parseQuery = function(string, escapeQuerySpace) {
    if (!string) {
      return {};
    }

    // throw out the funky business - "?"[name"="value"&"]+
    string = string.replace(/&+/g, '&').replace(/^\?*&*|&+$/g, '');

    if (!string) {
      return {};
    }

    var items = {};
    var splits = string.split('&');
    var length = splits.length;
    var v, name, value;

    for (var i = 0; i < length; i++) {
      v = splits[i].split('=');
      name = URI.decodeQuery(v.shift(), escapeQuerySpace);
      // no "=" is null according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#collect-url-parameters
      value = v.length ? URI.decodeQuery(v.join('='), escapeQuerySpace) : null;

      if (hasOwn.call(items, name)) {
        if (typeof items[name] === 'string' || items[name] === null) {
          items[name] = [items[name]];
        }

        items[name].push(value);
      } else {
        items[name] = value;
      }
    }

    return items;
  };

  URI.build = function(parts) {
    var t = '';
    var requireAbsolutePath = false

    if (parts.protocol) {
      t += parts.protocol + ':';
    }

    if (!parts.urn && (t || parts.hostname)) {
      t += '//';
      requireAbsolutePath = true
    }

    t += (URI.buildAuthority(parts) || '');

    if (typeof parts.path === 'string') {
      if (parts.path.charAt(0) !== '/' && requireAbsolutePath) {
        t += '/';
      }

      t += parts.path;
    }

    if (typeof parts.query === 'string' && parts.query) {
      t += '?' + parts.query;
    }

    if (typeof parts.fragment === 'string' && parts.fragment) {
      t += '#' + parts.fragment;
    }
    return t;
  };
  URI.buildHost = function(parts) {
    var t = '';

    if (!parts.hostname) {
      return '';
    } else if (URI.ip6_expression.test(parts.hostname)) {
      t += '[' + parts.hostname + ']';
    } else {
      t += parts.hostname;
    }

    if (parts.port) {
      t += ':' + parts.port;
    }

    return t;
  };
  URI.buildAuthority = function(parts) {
    return URI.buildUserinfo(parts) + URI.buildHost(parts);
  };
  URI.buildUserinfo = function(parts) {
    var t = '';

    if (parts.username) {
      t += URI.encode(parts.username);
    }

    if (parts.password) {
      t += ':' + URI.encode(parts.password);
    }

    if (t) {
      t += '@';
    }

    return t;
  };
  URI.buildQuery = function(data, duplicateQueryParameters, escapeQuerySpace) {
    // according to http://tools.ietf.org/html/rfc3986 or http://labs.apache.org/webarch/uri/rfc/rfc3986.html
    // being »-._~!$&'()*+,;=:@/?« %HEX and alnum are allowed
    // the RFC explicitly states ?/foo being a valid use case, no mention of parameter syntax!
    // URI.js treats the query string as being application/x-www-form-urlencoded
    // see http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type

    var t = '';
    var unique, key, i, length;
    for (key in data) {
      if (hasOwn.call(data, key)) {
        if (isArray(data[key])) {
          unique = {};
          for (i = 0, length = data[key].length; i < length; i++) {
            if (data[key][i] !== undefined && unique[data[key][i] + ''] === undefined) {
              t += '&' + URI.buildQueryParameter(key, data[key][i], escapeQuerySpace);
              if (duplicateQueryParameters !== true) {
                unique[data[key][i] + ''] = true;
              }
            }
          }
        } else if (data[key] !== undefined) {
          t += '&' + URI.buildQueryParameter(key, data[key], escapeQuerySpace);
        }
      }
    }

    return t.substring(1);
  };
  URI.buildQueryParameter = function(name, value, escapeQuerySpace) {
    // http://www.w3.org/TR/REC-html40/interact/forms.html#form-content-type -- application/x-www-form-urlencoded
    // don't append "=" for null values, according to http://dvcs.w3.org/hg/url/raw-file/tip/Overview.html#url-parameter-serialization
    return URI.encodeQuery(name, escapeQuerySpace) + (value !== null ? '=' + URI.encodeQuery(value, escapeQuerySpace) : '');
  };

  URI.addQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.addQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (data[name] === undefined) {
        data[name] = value;
        return;
      } else if (typeof data[name] === 'string') {
        data[name] = [data[name]];
      }

      if (!isArray(value)) {
        value = [value];
      }

      data[name] = (data[name] || []).concat(value);
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }
  };

  URI.setQuery = function(data, name, value) {
    if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          URI.setQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      data[name] = value === undefined ? null : value;
    } else {
      throw new TypeError('URI.setQuery() accepts an object, string as the name parameter');
    }
  };

  URI.removeQuery = function(data, name, value) {
    var i, length, key;

    if (isArray(name)) {
      for (i = 0, length = name.length; i < length; i++) {
        data[name[i]] = undefined;
      }
    } else if (getType(name) === 'RegExp') {
      for (key in data) {
        if (name.test(key)) {
          data[key] = undefined;
        }
      }
    } else if (typeof name === 'object') {
      for (key in name) {
        if (hasOwn.call(name, key)) {
          URI.removeQuery(data, key, name[key]);
        }
      }
    } else if (typeof name === 'string') {
      if (value !== undefined) {
        if (getType(value) === 'RegExp') {
          if (!isArray(data[name]) && value.test(data[name])) {
            data[name] = undefined;
          } else {
            data[name] = filterArrayValues(data[name], value);
          }
        } else if (data[name] === String(value) && (!isArray(value) || value.length === 1)) {
          data[name] = undefined;
        } else if (isArray(data[name])) {
          data[name] = filterArrayValues(data[name], value);
        }
      } else {
        data[name] = undefined;
      }
    } else {
      throw new TypeError('URI.removeQuery() accepts an object, string, RegExp as the first parameter');
    }
  };
  URI.hasQuery = function(data, name, value, withinArray) {
    switch (getType(name)) {
      case 'String':
        // Nothing to do here
        break;

      case 'RegExp':
        for (var key in data) {
          if (hasOwn.call(data, key)) {
            if (name.test(key) && (value === undefined || URI.hasQuery(data, key, value))) {
              return true;
            }
          }
        }

        return false;

      case 'Object':
        for (var _key in name) {
          if (hasOwn.call(name, _key)) {
            if (!URI.hasQuery(data, _key, name[_key])) {
              return false;
            }
          }
        }

        return true;

      default:
        throw new TypeError('URI.hasQuery() accepts a string, regular expression or object as the name parameter');
    }

    switch (getType(value)) {
      case 'Undefined':
        // true if exists (but may be empty)
        return name in data; // data[name] !== undefined;

      case 'Boolean':
        // true if exists and non-empty
        var _booly = Boolean(isArray(data[name]) ? data[name].length : data[name]);
        return value === _booly;

      case 'Function':
        // allow complex comparison
        return !!value(data[name], name, data);

      case 'Array':
        if (!isArray(data[name])) {
          return false;
        }

        var op = withinArray ? arrayContains : arraysEqual;
        return op(data[name], value);

      case 'RegExp':
        if (!isArray(data[name])) {
          return Boolean(data[name] && data[name].match(value));
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      case 'Number':
        value = String(value);
        /* falls through */
      case 'String':
        if (!isArray(data[name])) {
          return data[name] === value;
        }

        if (!withinArray) {
          return false;
        }

        return arrayContains(data[name], value);

      default:
        throw new TypeError('URI.hasQuery() accepts undefined, boolean, string, number, RegExp, Function as the value parameter');
    }
  };


  URI.joinPaths = function() {
    var input = [];
    var segments = [];
    var nonEmptySegments = 0;

    for (var i = 0; i < arguments.length; i++) {
      var url = new URI(arguments[i]);
      input.push(url);
      var _segments = url.segment();
      for (var s = 0; s < _segments.length; s++) {
        if (typeof _segments[s] === 'string') {
          segments.push(_segments[s]);
        }

        if (_segments[s]) {
          nonEmptySegments++;
        }
      }
    }

    if (!segments.length || !nonEmptySegments) {
      return new URI('');
    }

    var uri = new URI('').segment(segments);

    if (input[0].path() === '' || input[0].path().slice(0, 1) === '/') {
      uri.path('/' + uri.path());
    }

    return uri.normalize();
  };

  URI.commonPath = function(one, two) {
    var length = Math.min(one.length, two.length);
    var pos;

    // find first non-matching character
    for (pos = 0; pos < length; pos++) {
      if (one.charAt(pos) !== two.charAt(pos)) {
        pos--;
        break;
      }
    }

    if (pos < 1) {
      return one.charAt(0) === two.charAt(0) && one.charAt(0) === '/' ? '/' : '';
    }

    // revert to last /
    if (one.charAt(pos) !== '/' || two.charAt(pos) !== '/') {
      pos = one.substring(0, pos).lastIndexOf('/');
    }

    return one.substring(0, pos + 1);
  };

  URI.withinString = function(string, callback, options) {
    options || (options = {});
    var _start = options.start || URI.findUri.start;
    var _end = options.end || URI.findUri.end;
    var _trim = options.trim || URI.findUri.trim;
    var _parens = options.parens || URI.findUri.parens;
    var _attributeOpen = /[a-z0-9-]=["']?$/i;

    _start.lastIndex = 0;
    while (true) {
      var match = _start.exec(string);
      if (!match) {
        break;
      }

      var start = match.index;
      if (options.ignoreHtml) {
        // attribut(e=["']?$)
        var attributeOpen = string.slice(Math.max(start - 3, 0), start);
        if (attributeOpen && _attributeOpen.test(attributeOpen)) {
          continue;
        }
      }

      var end = start + string.slice(start).search(_end);
      var slice = string.slice(start, end);
      // make sure we include well balanced parens
      var parensEnd = -1;
      while (true) {
        var parensMatch = _parens.exec(slice);
        if (!parensMatch) {
          break;
        }

        var parensMatchEnd = parensMatch.index + parensMatch[0].length;
        parensEnd = Math.max(parensEnd, parensMatchEnd);
      }

      if (parensEnd > -1) {
        slice = slice.slice(0, parensEnd) + slice.slice(parensEnd).replace(_trim, '');
      } else {
        slice = slice.replace(_trim, '');
      }

      if (slice.length <= match[0].length) {
        // the extract only contains the starting marker of a URI,
        // e.g. "www" or "http://"
        continue;
      }

      if (options.ignore && options.ignore.test(slice)) {
        continue;
      }

      end = start + slice.length;
      var result = callback(slice, start, end, string);
      if (result === undefined) {
        _start.lastIndex = end;
        continue;
      }

      result = String(result);
      string = string.slice(0, start) + result + string.slice(end);
      _start.lastIndex = start + result.length;
    }

    _start.lastIndex = 0;
    return string;
  };

  URI.ensureValidHostname = function(v, protocol) {
    // Theoretically URIs allow percent-encoding in Hostnames (according to RFC 3986)
    // they are not part of DNS and therefore ignored by URI.js

    var hasHostname = !!v; // not null and not an empty string
    var hasProtocol = !!protocol;
    var rejectEmptyHostname = false;

    if (hasProtocol) {
      rejectEmptyHostname = arrayContains(URI.hostProtocols, protocol);
    }

    if (rejectEmptyHostname && !hasHostname) {
      throw new TypeError('Hostname cannot be empty, if protocol is ' + protocol);
    } else if (v && v.match(URI.invalid_hostname_characters)) {
      // test punycode
      if (!punycode) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_] and Punycode.js is not available');
      }
      if (punycode.toASCII(v).match(URI.invalid_hostname_characters)) {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-:_]');
      }
    }
  };

  URI.ensureValidPort = function (v) {
    if (!v) {
      return;
    }

    var port = Number(v);
    if (isInteger(port) && (port > 0) && (port < 65536)) {
      return;
    }

    throw new TypeError('Port "' + v + '" is not a valid port');
  };

  // noConflict
  URI.noConflict = function(removeAll) {
    if (removeAll) {
      var unconflicted = {
        URI: this.noConflict()
      };

      if (root.URITemplate && typeof root.URITemplate.noConflict === 'function') {
        unconflicted.URITemplate = root.URITemplate.noConflict();
      }

      if (root.IPv6 && typeof root.IPv6.noConflict === 'function') {
        unconflicted.IPv6 = root.IPv6.noConflict();
      }

      if (root.SecondLevelDomains && typeof root.SecondLevelDomains.noConflict === 'function') {
        unconflicted.SecondLevelDomains = root.SecondLevelDomains.noConflict();
      }

      return unconflicted;
    } else if (root.URI === this) {
      root.URI = _URI;
    }

    return this;
  };

  p.build = function(deferBuild) {
    if (deferBuild === true) {
      this._deferred_build = true;
    } else if (deferBuild === undefined || this._deferred_build) {
      this._string = URI.build(this._parts);
      this._deferred_build = false;
    }

    return this;
  };

  p.clone = function() {
    return new URI(this);
  };

  p.valueOf = p.toString = function() {
    return this.build(false)._string;
  };


  function generateSimpleAccessor(_part){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        this._parts[_part] = v || null;
        this.build(!build);
        return this;
      }
    };
  }

  function generatePrefixAccessor(_part, _key){
    return function(v, build) {
      if (v === undefined) {
        return this._parts[_part] || '';
      } else {
        if (v !== null) {
          v = v + '';
          if (v.charAt(0) === _key) {
            v = v.substring(1);
          }
        }

        this._parts[_part] = v;
        this.build(!build);
        return this;
      }
    };
  }

  p.protocol = generateSimpleAccessor('protocol');
  p.username = generateSimpleAccessor('username');
  p.password = generateSimpleAccessor('password');
  p.hostname = generateSimpleAccessor('hostname');
  p.port = generateSimpleAccessor('port');
  p.query = generatePrefixAccessor('query', '?');
  p.fragment = generatePrefixAccessor('fragment', '#');

  p.search = function(v, build) {
    var t = this.query(v, build);
    return typeof t === 'string' && t.length ? ('?' + t) : t;
  };
  p.hash = function(v, build) {
    var t = this.fragment(v, build);
    return typeof t === 'string' && t.length ? ('#' + t) : t;
  };

  p.pathname = function(v, build) {
    if (v === undefined || v === true) {
      var res = this._parts.path || (this._parts.hostname ? '/' : '');
      return v ? (this._parts.urn ? URI.decodeUrnPath : URI.decodePath)(res) : res;
    } else {
      if (this._parts.urn) {
        this._parts.path = v ? URI.recodeUrnPath(v) : '';
      } else {
        this._parts.path = v ? URI.recodePath(v) : '/';
      }
      this.build(!build);
      return this;
    }
  };
  p.path = p.pathname;
  p.href = function(href, build) {
    var key;

    if (href === undefined) {
      return this.toString();
    }

    this._string = '';
    this._parts = URI._parts();

    var _URI = href instanceof URI;
    var _object = typeof href === 'object' && (href.hostname || href.path || href.pathname);
    if (href.nodeName) {
      var attribute = URI.getDomAttribute(href);
      href = href[attribute] || '';
      _object = false;
    }

    // window.location is reported to be an object, but it's not the sort
    // of object we're looking for:
    // * location.protocol ends with a colon
    // * location.query != object.search
    // * location.hash != object.fragment
    // simply serializing the unknown object should do the trick
    // (for location, not for everything...)
    if (!_URI && _object && href.pathname !== undefined) {
      href = href.toString();
    }

    if (typeof href === 'string' || href instanceof String) {
      this._parts = URI.parse(String(href), this._parts);
    } else if (_URI || _object) {
      var src = _URI ? href._parts : href;
      for (key in src) {
        if (key === 'query') { continue; }
        if (hasOwn.call(this._parts, key)) {
          this._parts[key] = src[key];
        }
      }
      if (src.query) {
        this.query(src.query, false);
      }
    } else {
      throw new TypeError('invalid input');
    }

    this.build(!build);
    return this;
  };

  // identification accessors
  p.is = function(what) {
    var ip = false;
    var ip4 = false;
    var ip6 = false;
    var name = false;
    var sld = false;
    var idn = false;
    var punycode = false;
    var relative = !this._parts.urn;

    if (this._parts.hostname) {
      relative = false;
      ip4 = URI.ip4_expression.test(this._parts.hostname);
      ip6 = URI.ip6_expression.test(this._parts.hostname);
      ip = ip4 || ip6;
      name = !ip;
      sld = name && SLD && SLD.has(this._parts.hostname);
      idn = name && URI.idn_expression.test(this._parts.hostname);
      punycode = name && URI.punycode_expression.test(this._parts.hostname);
    }

    switch (what.toLowerCase()) {
      case 'relative':
        return relative;

      case 'absolute':
        return !relative;

      // hostname identification
      case 'domain':
      case 'name':
        return name;

      case 'sld':
        return sld;

      case 'ip':
        return ip;

      case 'ip4':
      case 'ipv4':
      case 'inet4':
        return ip4;

      case 'ip6':
      case 'ipv6':
      case 'inet6':
        return ip6;

      case 'idn':
        return idn;

      case 'url':
        return !this._parts.urn;

      case 'urn':
        return !!this._parts.urn;

      case 'punycode':
        return punycode;
    }

    return null;
  };

  // component specific input validation
  var _protocol = p.protocol;
  var _port = p.port;
  var _hostname = p.hostname;

  p.protocol = function(v, build) {
    if (v) {
      // accept trailing ://
      v = v.replace(/:(\/\/)?$/, '');

      if (!v.match(URI.protocol_expression)) {
        throw new TypeError('Protocol "' + v + '" contains characters other than [A-Z0-9.+-] or doesn\'t start with [A-Z]');
      }
    }

    return _protocol.call(this, v, build);
  };
  p.scheme = p.protocol;
  p.port = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      if (v === 0) {
        v = null;
      }

      if (v) {
        v += '';
        if (v.charAt(0) === ':') {
          v = v.substring(1);
        }

        URI.ensureValidPort(v);
      }
    }
    return _port.call(this, v, build);
  };
  p.hostname = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v !== undefined) {
      var x = { preventInvalidHostname: this._parts.preventInvalidHostname };
      var res = URI.parseHost(v, x);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      v = x.hostname;
      if (this._parts.preventInvalidHostname) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }
    }

    return _hostname.call(this, v, build);
  };

  // compound accessors
  p.origin = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var protocol = this.protocol();
      var authority = this.authority();
      if (!authority) {
        return '';
      }

      return (protocol ? protocol + '://' : '') + this.authority();
    } else {
      var origin = URI(v);
      this
        .protocol(origin.protocol())
        .authority(origin.authority())
        .build(!build);
      return this;
    }
  };
  p.host = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildHost(this._parts) : '';
    } else {
      var res = URI.parseHost(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.authority = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      return this._parts.hostname ? URI.buildAuthority(this._parts) : '';
    } else {
      var res = URI.parseAuthority(v, this._parts);
      if (res !== '/') {
        throw new TypeError('Hostname "' + v + '" contains characters other than [A-Z0-9.-]');
      }

      this.build(!build);
      return this;
    }
  };
  p.userinfo = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined) {
      var t = URI.buildUserinfo(this._parts);
      return t ? t.substring(0, t.length -1) : t;
    } else {
      if (v[v.length-1] !== '@') {
        v += '@';
      }

      URI.parseUserinfo(v, this._parts);
      this.build(!build);
      return this;
    }
  };
  p.resource = function(v, build) {
    var parts;

    if (v === undefined) {
      return this.path() + this.search() + this.hash();
    }

    parts = URI.parse(v);
    this._parts.path = parts.path;
    this._parts.query = parts.query;
    this._parts.fragment = parts.fragment;
    this.build(!build);
    return this;
  };

  // fraction accessors
  p.subdomain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    // convenience, return "www" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // grab domain and add another segment
      var end = this._parts.hostname.length - this.domain().length - 1;
      return this._parts.hostname.substring(0, end) || '';
    } else {
      var e = this._parts.hostname.length - this.domain().length;
      var sub = this._parts.hostname.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(sub));

      if (v && v.charAt(v.length - 1) !== '.') {
        v += '.';
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      if (v) {
        URI.ensureValidHostname(v, this._parts.protocol);
      }

      this._parts.hostname = this._parts.hostname.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.domain = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // convenience, return "example.org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      // if hostname consists of 1 or 2 segments, it must be the domain
      var t = this._parts.hostname.match(/\./g);
      if (t && t.length < 2) {
        return this._parts.hostname;
      }

      // grab tld and add another segment
      var end = this._parts.hostname.length - this.tld(build).length - 1;
      end = this._parts.hostname.lastIndexOf('.', end -1) + 1;
      return this._parts.hostname.substring(end) || '';
    } else {
      if (!v) {
        throw new TypeError('cannot set domain empty');
      }

      if (v.indexOf(':') !== -1) {
        throw new TypeError('Domains cannot contain colons');
      }

      URI.ensureValidHostname(v, this._parts.protocol);

      if (!this._parts.hostname || this.is('IP')) {
        this._parts.hostname = v;
      } else {
        var replace = new RegExp(escapeRegEx(this.domain()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.tld = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v === 'boolean') {
      build = v;
      v = undefined;
    }

    // return "org" from "www.example.org"
    if (v === undefined) {
      if (!this._parts.hostname || this.is('IP')) {
        return '';
      }

      var pos = this._parts.hostname.lastIndexOf('.');
      var tld = this._parts.hostname.substring(pos + 1);

      if (build !== true && SLD && SLD.list[tld.toLowerCase()]) {
        return SLD.get(this._parts.hostname) || tld;
      }

      return tld;
    } else {
      var replace;

      if (!v) {
        throw new TypeError('cannot set TLD empty');
      } else if (v.match(/[^a-zA-Z0-9-]/)) {
        if (SLD && SLD.is(v)) {
          replace = new RegExp(escapeRegEx(this.tld()) + '$');
          this._parts.hostname = this._parts.hostname.replace(replace, v);
        } else {
          throw new TypeError('TLD "' + v + '" contains characters other than [A-Z0-9]');
        }
      } else if (!this._parts.hostname || this.is('IP')) {
        throw new ReferenceError('cannot set TLD on non-domain host');
      } else {
        replace = new RegExp(escapeRegEx(this.tld()) + '$');
        this._parts.hostname = this._parts.hostname.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.directory = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path && !this._parts.hostname) {
        return '';
      }

      if (this._parts.path === '/') {
        return '/';
      }

      var end = this._parts.path.length - this.filename().length - 1;
      var res = this._parts.path.substring(0, end) || (this._parts.hostname ? '/' : '');

      return v ? URI.decodePath(res) : res;

    } else {
      var e = this._parts.path.length - this.filename().length;
      var directory = this._parts.path.substring(0, e);
      var replace = new RegExp('^' + escapeRegEx(directory));

      // fully qualifier directories begin with a slash
      if (!this.is('relative')) {
        if (!v) {
          v = '/';
        }

        if (v.charAt(0) !== '/') {
          v = '/' + v;
        }
      }

      // directories always end with a slash
      if (v && v.charAt(v.length - 1) !== '/') {
        v += '/';
      }

      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);
      this.build(!build);
      return this;
    }
  };
  p.filename = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (typeof v !== 'string') {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var pos = this._parts.path.lastIndexOf('/');
      var res = this._parts.path.substring(pos+1);

      return v ? URI.decodePathSegment(res) : res;
    } else {
      var mutatedDirectory = false;

      if (v.charAt(0) === '/') {
        v = v.substring(1);
      }

      if (v.match(/\.?\//)) {
        mutatedDirectory = true;
      }

      var replace = new RegExp(escapeRegEx(this.filename()) + '$');
      v = URI.recodePath(v);
      this._parts.path = this._parts.path.replace(replace, v);

      if (mutatedDirectory) {
        this.normalizePath(build);
      } else {
        this.build(!build);
      }

      return this;
    }
  };
  p.suffix = function(v, build) {
    if (this._parts.urn) {
      return v === undefined ? '' : this;
    }

    if (v === undefined || v === true) {
      if (!this._parts.path || this._parts.path === '/') {
        return '';
      }

      var filename = this.filename();
      var pos = filename.lastIndexOf('.');
      var s, res;

      if (pos === -1) {
        return '';
      }

      // suffix may only contain alnum characters (yup, I made this up.)
      s = filename.substring(pos+1);
      res = (/^[a-z0-9%]+$/i).test(s) ? s : '';
      return v ? URI.decodePathSegment(res) : res;
    } else {
      if (v.charAt(0) === '.') {
        v = v.substring(1);
      }

      var suffix = this.suffix();
      var replace;

      if (!suffix) {
        if (!v) {
          return this;
        }

        this._parts.path += '.' + URI.recodePath(v);
      } else if (!v) {
        replace = new RegExp(escapeRegEx('.' + suffix) + '$');
      } else {
        replace = new RegExp(escapeRegEx(suffix) + '$');
      }

      if (replace) {
        v = URI.recodePath(v);
        this._parts.path = this._parts.path.replace(replace, v);
      }

      this.build(!build);
      return this;
    }
  };
  p.segment = function(segment, v, build) {
    var separator = this._parts.urn ? ':' : '/';
    var path = this.path();
    var absolute = path.substring(0, 1) === '/';
    var segments = path.split(separator);

    if (segment !== undefined && typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (segment !== undefined && typeof segment !== 'number') {
      throw new Error('Bad segment "' + segment + '", must be 0-based integer');
    }

    if (absolute) {
      segments.shift();
    }

    if (segment < 0) {
      // allow negative indexes to address from the end
      segment = Math.max(segments.length + segment, 0);
    }

    if (v === undefined) {
      /*jshint laxbreak: true */
      return segment === undefined
        ? segments
        : segments[segment];
      /*jshint laxbreak: false */
    } else if (segment === null || segments[segment] === undefined) {
      if (isArray(v)) {
        segments = [];
        // collapse empty elements within array
        for (var i=0, l=v.length; i < l; i++) {
          if (!v[i].length && (!segments.length || !segments[segments.length -1].length)) {
            continue;
          }

          if (segments.length && !segments[segments.length -1].length) {
            segments.pop();
          }

          segments.push(trimSlashes(v[i]));
        }
      } else if (v || typeof v === 'string') {
        v = trimSlashes(v);
        if (segments[segments.length -1] === '') {
          // empty trailing elements have to be overwritten
          // to prevent results such as /foo//bar
          segments[segments.length -1] = v;
        } else {
          segments.push(v);
        }
      }
    } else {
      if (v) {
        segments[segment] = trimSlashes(v);
      } else {
        segments.splice(segment, 1);
      }
    }

    if (absolute) {
      segments.unshift('');
    }

    return this.path(segments.join(separator), build);
  };
  p.segmentCoded = function(segment, v, build) {
    var segments, i, l;

    if (typeof segment !== 'number') {
      build = v;
      v = segment;
      segment = undefined;
    }

    if (v === undefined) {
      segments = this.segment(segment, v, build);
      if (!isArray(segments)) {
        segments = segments !== undefined ? URI.decode(segments) : undefined;
      } else {
        for (i = 0, l = segments.length; i < l; i++) {
          segments[i] = URI.decode(segments[i]);
        }
      }

      return segments;
    }

    if (!isArray(v)) {
      v = (typeof v === 'string' || v instanceof String) ? URI.encode(v) : v;
    } else {
      for (i = 0, l = v.length; i < l; i++) {
        v[i] = URI.encode(v[i]);
      }
    }

    return this.segment(segment, v, build);
  };

  // mutating query string
  var q = p.query;
  p.query = function(v, build) {
    if (v === true) {
      return URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    } else if (typeof v === 'function') {
      var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
      var result = v.call(this, data);
      this._parts.query = URI.buildQuery(result || data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else if (v !== undefined && typeof v !== 'string') {
      this._parts.query = URI.buildQuery(v, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
      this.build(!build);
      return this;
    } else {
      return q.call(this, v, build);
    }
  };
  p.setQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);

    if (typeof name === 'string' || name instanceof String) {
      data[name] = value !== undefined ? value : null;
    } else if (typeof name === 'object') {
      for (var key in name) {
        if (hasOwn.call(name, key)) {
          data[key] = name[key];
        }
      }
    } else {
      throw new TypeError('URI.addQuery() accepts an object, string as the name parameter');
    }

    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.addQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.addQuery(data, name, value === undefined ? null : value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.removeQuery = function(name, value, build) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    URI.removeQuery(data, name, value);
    this._parts.query = URI.buildQuery(data, this._parts.duplicateQueryParameters, this._parts.escapeQuerySpace);
    if (typeof name !== 'string') {
      build = value;
    }

    this.build(!build);
    return this;
  };
  p.hasQuery = function(name, value, withinArray) {
    var data = URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace);
    return URI.hasQuery(data, name, value, withinArray);
  };
  p.setSearch = p.setQuery;
  p.addSearch = p.addQuery;
  p.removeSearch = p.removeQuery;
  p.hasSearch = p.hasQuery;

  // sanitizing URLs
  p.normalize = function() {
    if (this._parts.urn) {
      return this
        .normalizeProtocol(false)
        .normalizePath(false)
        .normalizeQuery(false)
        .normalizeFragment(false)
        .build();
    }

    return this
      .normalizeProtocol(false)
      .normalizeHostname(false)
      .normalizePort(false)
      .normalizePath(false)
      .normalizeQuery(false)
      .normalizeFragment(false)
      .build();
  };
  p.normalizeProtocol = function(build) {
    if (typeof this._parts.protocol === 'string') {
      this._parts.protocol = this._parts.protocol.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizeHostname = function(build) {
    if (this._parts.hostname) {
      if (this.is('IDN') && punycode) {
        this._parts.hostname = punycode.toASCII(this._parts.hostname);
      } else if (this.is('IPv6') && IPv6) {
        this._parts.hostname = IPv6.best(this._parts.hostname);
      }

      this._parts.hostname = this._parts.hostname.toLowerCase();
      this.build(!build);
    }

    return this;
  };
  p.normalizePort = function(build) {
    // remove port of it's the protocol's default
    if (typeof this._parts.protocol === 'string' && this._parts.port === URI.defaultPorts[this._parts.protocol]) {
      this._parts.port = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizePath = function(build) {
    var _path = this._parts.path;
    if (!_path) {
      return this;
    }

    if (this._parts.urn) {
      this._parts.path = URI.recodeUrnPath(this._parts.path);
      this.build(!build);
      return this;
    }

    if (this._parts.path === '/') {
      return this;
    }

    _path = URI.recodePath(_path);

    var _was_relative;
    var _leadingParents = '';
    var _parent, _pos;

    // handle relative paths
    if (_path.charAt(0) !== '/') {
      _was_relative = true;
      _path = '/' + _path;
    }

    // handle relative files (as opposed to directories)
    if (_path.slice(-3) === '/..' || _path.slice(-2) === '/.') {
      _path += '/';
    }

    // resolve simples
    _path = _path
      .replace(/(\/(\.\/)+)|(\/\.$)/g, '/')
      .replace(/\/{2,}/g, '/');

    // remember leading parents
    if (_was_relative) {
      _leadingParents = _path.substring(1).match(/^(\.\.\/)+/) || '';
      if (_leadingParents) {
        _leadingParents = _leadingParents[0];
      }
    }

    // resolve parents
    while (true) {
      _parent = _path.search(/\/\.\.(\/|$)/);
      if (_parent === -1) {
        // no more ../ to resolve
        break;
      } else if (_parent === 0) {
        // top level cannot be relative, skip it
        _path = _path.substring(3);
        continue;
      }

      _pos = _path.substring(0, _parent).lastIndexOf('/');
      if (_pos === -1) {
        _pos = _parent;
      }
      _path = _path.substring(0, _pos) + _path.substring(_parent + 3);
    }

    // revert to relative
    if (_was_relative && this.is('relative')) {
      _path = _leadingParents + _path.substring(1);
    }

    this._parts.path = _path;
    this.build(!build);
    return this;
  };
  p.normalizePathname = p.normalizePath;
  p.normalizeQuery = function(build) {
    if (typeof this._parts.query === 'string') {
      if (!this._parts.query.length) {
        this._parts.query = null;
      } else {
        this.query(URI.parseQuery(this._parts.query, this._parts.escapeQuerySpace));
      }

      this.build(!build);
    }

    return this;
  };
  p.normalizeFragment = function(build) {
    if (!this._parts.fragment) {
      this._parts.fragment = null;
      this.build(!build);
    }

    return this;
  };
  p.normalizeSearch = p.normalizeQuery;
  p.normalizeHash = p.normalizeFragment;

  p.iso8859 = function() {
    // expect unicode input, iso8859 output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = escape;
    URI.decode = decodeURIComponent;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.unicode = function() {
    // expect iso8859 input, unicode output
    var e = URI.encode;
    var d = URI.decode;

    URI.encode = strictEncodeURIComponent;
    URI.decode = unescape;
    try {
      this.normalize();
    } finally {
      URI.encode = e;
      URI.decode = d;
    }
    return this;
  };

  p.readable = function() {
    var uri = this.clone();
    // removing username, password, because they shouldn't be displayed according to RFC 3986
    uri.username('').password('').normalize();
    var t = '';
    if (uri._parts.protocol) {
      t += uri._parts.protocol + '://';
    }

    if (uri._parts.hostname) {
      if (uri.is('punycode') && punycode) {
        t += punycode.toUnicode(uri._parts.hostname);
        if (uri._parts.port) {
          t += ':' + uri._parts.port;
        }
      } else {
        t += uri.host();
      }
    }

    if (uri._parts.hostname && uri._parts.path && uri._parts.path.charAt(0) !== '/') {
      t += '/';
    }

    t += uri.path(true);
    if (uri._parts.query) {
      var q = '';
      for (var i = 0, qp = uri._parts.query.split('&'), l = qp.length; i < l; i++) {
        var kv = (qp[i] || '').split('=');
        q += '&' + URI.decodeQuery(kv[0], this._parts.escapeQuerySpace)
          .replace(/&/g, '%26');

        if (kv[1] !== undefined) {
          q += '=' + URI.decodeQuery(kv[1], this._parts.escapeQuerySpace)
            .replace(/&/g, '%26');
        }
      }
      t += '?' + q.substring(1);
    }

    t += URI.decodeQuery(uri.hash(), true);
    return t;
  };

  // resolving relative and absolute URLs
  p.absoluteTo = function(base) {
    var resolved = this.clone();
    var properties = ['protocol', 'username', 'password', 'hostname', 'port'];
    var basedir, i, p;

    if (this._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    if (!(base instanceof URI)) {
      base = new URI(base);
    }

    if (resolved._parts.protocol) {
      // Directly returns even if this._parts.hostname is empty.
      return resolved;
    } else {
      resolved._parts.protocol = base._parts.protocol;
    }

    if (this._parts.hostname) {
      return resolved;
    }

    for (i = 0; (p = properties[i]); i++) {
      resolved._parts[p] = base._parts[p];
    }

    if (!resolved._parts.path) {
      resolved._parts.path = base._parts.path;
      if (!resolved._parts.query) {
        resolved._parts.query = base._parts.query;
      }
    } else {
      if (resolved._parts.path.substring(-2) === '..') {
        resolved._parts.path += '/';
      }

      if (resolved.path().charAt(0) !== '/') {
        basedir = base.directory();
        basedir = basedir ? basedir : base.path().indexOf('/') === 0 ? '/' : '';
        resolved._parts.path = (basedir ? (basedir + '/') : '') + resolved._parts.path;
        resolved.normalizePath();
      }
    }

    resolved.build();
    return resolved;
  };
  p.relativeTo = function(base) {
    var relative = this.clone().normalize();
    var relativeParts, baseParts, common, relativePath, basePath;

    if (relative._parts.urn) {
      throw new Error('URNs do not have any generally defined hierarchical components');
    }

    base = new URI(base).normalize();
    relativeParts = relative._parts;
    baseParts = base._parts;
    relativePath = relative.path();
    basePath = base.path();

    if (relativePath.charAt(0) !== '/') {
      throw new Error('URI is already relative');
    }

    if (basePath.charAt(0) !== '/') {
      throw new Error('Cannot calculate a URI relative to another relative URI');
    }

    if (relativeParts.protocol === baseParts.protocol) {
      relativeParts.protocol = null;
    }

    if (relativeParts.username !== baseParts.username || relativeParts.password !== baseParts.password) {
      return relative.build();
    }

    if (relativeParts.protocol !== null || relativeParts.username !== null || relativeParts.password !== null) {
      return relative.build();
    }

    if (relativeParts.hostname === baseParts.hostname && relativeParts.port === baseParts.port) {
      relativeParts.hostname = null;
      relativeParts.port = null;
    } else {
      return relative.build();
    }

    if (relativePath === basePath) {
      relativeParts.path = '';
      return relative.build();
    }

    // determine common sub path
    common = URI.commonPath(relativePath, basePath);

    // If the paths have nothing in common, return a relative URL with the absolute path.
    if (!common) {
      return relative.build();
    }

    var parents = baseParts.path
      .substring(common.length)
      .replace(/[^\/]*$/, '')
      .replace(/.*?\//g, '../');

    relativeParts.path = (parents + relativeParts.path.substring(common.length)) || './';

    return relative.build();
  };

  // comparing URIs
  p.equals = function(uri) {
    var one = this.clone();
    var two = new URI(uri);
    var one_map = {};
    var two_map = {};
    var checked = {};
    var one_query, two_query, key;

    one.normalize();
    two.normalize();

    // exact match
    if (one.toString() === two.toString()) {
      return true;
    }

    // extract query string
    one_query = one.query();
    two_query = two.query();
    one.query('');
    two.query('');

    // definitely not equal if not even non-query parts match
    if (one.toString() !== two.toString()) {
      return false;
    }

    // query parameters have the same length, even if they're permuted
    if (one_query.length !== two_query.length) {
      return false;
    }

    one_map = URI.parseQuery(one_query, this._parts.escapeQuerySpace);
    two_map = URI.parseQuery(two_query, this._parts.escapeQuerySpace);

    for (key in one_map) {
      if (hasOwn.call(one_map, key)) {
        if (!isArray(one_map[key])) {
          if (one_map[key] !== two_map[key]) {
            return false;
          }
        } else if (!arraysEqual(one_map[key], two_map[key])) {
          return false;
        }

        checked[key] = true;
      }
    }

    for (key in two_map) {
      if (hasOwn.call(two_map, key)) {
        if (!checked[key]) {
          // two contains a parameter not present in one
          return false;
        }
      }
    }

    return true;
  };

  // state
  p.preventInvalidHostname = function(v) {
    this._parts.preventInvalidHostname = !!v;
    return this;
  };

  p.duplicateQueryParameters = function(v) {
    this._parts.duplicateQueryParameters = !!v;
    return this;
  };

  p.escapeQuerySpace = function(v) {
    this._parts.escapeQuerySpace = !!v;
    return this;
  };

  return URI;
}));

},{"./IPv6":143,"./SecondLevelDomains":144,"./punycode":146}],146:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.4.0 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],147:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":148,"punycode":139,"querystring":142}],148:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}]},{},[3]);
